<template>
  <div class="loading-container">
    <svg
      cache-id="30b7efd064374a6298ac8ee55b6eec91"
      id="exIqo09Fmte1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 1920 1079.37"
      shape-rendering="geometricPrecision"
      text-rendering="geometricPrecision"
    >
      <defs>
        <radialGradient
          id="exIqo09Fmte199-fill"
          cx="0"
          cy="0"
          r="55.6"
          spreadMethod="pad"
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(0.1 0 0 1.77 -11.342 -0.6015)"
        >
          <stop id="exIqo09Fmte199-fill-0" offset="0%" stop-color="#6d6e71" />
          <stop id="exIqo09Fmte199-fill-1" offset="24%" stop-color="#9e9fa1" />
          <stop id="exIqo09Fmte199-fill-2" offset="47%" stop-color="#c8c8c9" />
          <stop id="exIqo09Fmte199-fill-3" offset="69%" stop-color="#e6e6e6" />
          <stop id="exIqo09Fmte199-fill-4" offset="87%" stop-color="#f8f8f8" />
          <stop id="exIqo09Fmte199-fill-5" offset="100%" stop-color="#fff" />
        </radialGradient>
        <radialGradient
          id="exIqo09Fmte200-fill"
          cx="0"
          cy="0"
          r="55.6"
          spreadMethod="pad"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(17310.29 127.1)"
        >
          <stop id="exIqo09Fmte200-fill-0" offset="0%" stop-color="#6d6e71" />
          <stop id="exIqo09Fmte200-fill-1" offset="24%" stop-color="#9e9fa1" />
          <stop id="exIqo09Fmte200-fill-2" offset="47%" stop-color="#c8c8c9" />
          <stop id="exIqo09Fmte200-fill-3" offset="69%" stop-color="#e6e6e6" />
          <stop id="exIqo09Fmte200-fill-4" offset="87%" stop-color="#f8f8f8" />
          <stop id="exIqo09Fmte200-fill-5" offset="100%" stop-color="#fff" />
        </radialGradient>
        <linearGradient
          id="exIqo09Fmte201-fill"
          x1="733.42"
          y1="628.86"
          x2="733.42"
          y2="522.72"
          spreadMethod="pad"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(0 0)"
        >
          <stop id="exIqo09Fmte201-fill-0" offset="0%" stop-color="#151515" />
          <stop id="exIqo09Fmte201-fill-1" offset="100%" stop-color="#363636" />
        </linearGradient>
        <linearGradient
          id="exIqo09Fmte202-fill"
          x1="733.72"
          y1="522.72"
          x2="733.72"
          y2="416.57"
          spreadMethod="pad"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(0 0)"
        >
          <stop id="exIqo09Fmte202-fill-0" offset="0%" stop-color="#1b1c1c" />
          <stop id="exIqo09Fmte202-fill-1" offset="45%" stop-color="#222323" />
          <stop id="exIqo09Fmte202-fill-2" offset="100%" stop-color="#333" />
        </linearGradient>
        <linearGradient
          id="exIqo09Fmte203-fill"
          x1="732.5"
          y1="614.13"
          x2="732.5"
          y2="628.86"
          spreadMethod="pad"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(0 0)"
        >
          <stop id="exIqo09Fmte203-fill-0" offset="0%" stop-color="#fff" />
          <stop id="exIqo09Fmte203-fill-1" offset="14%" stop-color="#f3f3f3" />
          <stop id="exIqo09Fmte203-fill-2" offset="38%" stop-color="#d5d6d6" />
          <stop id="exIqo09Fmte203-fill-3" offset="69%" stop-color="#a5a6a6" />
          <stop id="exIqo09Fmte203-fill-4" offset="100%" stop-color="#707171" />
        </linearGradient>
        <linearGradient
          id="exIqo09Fmte204-fill"
          x1="734.94"
          y1="431.68"
          x2="734.94"
          y2="416.94"
          spreadMethod="pad"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(0 0)"
        >
          <stop id="exIqo09Fmte204-fill-0" offset="0%" stop-color="#000" />
          <stop id="exIqo09Fmte204-fill-1" offset="14%" stop-color="#040404" />
          <stop id="exIqo09Fmte204-fill-2" offset="29%" stop-color="#111" />
          <stop id="exIqo09Fmte204-fill-3" offset="45%" stop-color="#262627" />
          <stop id="exIqo09Fmte204-fill-4" offset="62%" stop-color="#444546" />
          <stop id="exIqo09Fmte204-fill-5" offset="79%" stop-color="#6b6b6d" />
          <stop id="exIqo09Fmte204-fill-6" offset="96%" stop-color="#999a9d" />
          <stop id="exIqo09Fmte204-fill-7" offset="100%" stop-color="#a7a8ab" />
        </linearGradient>
        <linearGradient
          id="exIqo09Fmte206-fill"
          x1="69.42"
          y1="9.32"
          x2="69.42"
          y2="0.07"
          spreadMethod="pad"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(0 0)"
        >
          <stop id="exIqo09Fmte206-fill-0" offset="0%" stop-color="#000" />
          <stop id="exIqo09Fmte206-fill-1" offset="43%" stop-color="#010101" />
          <stop id="exIqo09Fmte206-fill-2" offset="58%" stop-color="#080808" />
          <stop id="exIqo09Fmte206-fill-3" offset="69%" stop-color="#131414" />
          <stop id="exIqo09Fmte206-fill-4" offset="78%" stop-color="#242425" />
          <stop id="exIqo09Fmte206-fill-5" offset="85%" stop-color="#393a3b" />
          <stop id="exIqo09Fmte206-fill-6" offset="92%" stop-color="#535456" />
          <stop id="exIqo09Fmte206-fill-7" offset="98%" stop-color="#727376" />
          <stop id="exIqo09Fmte206-fill-8" offset="100%" stop-color="#808184" />
        </linearGradient>
        <linearGradient
          id="exIqo09Fmte207-fill"
          x1="69.42"
          y1="9.2"
          x2="69.42"
          y2="-0.06"
          spreadMethod="pad"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(0 0)"
        >
          <stop id="exIqo09Fmte207-fill-0" offset="0%" stop-color="#1a1a1a" />
          <stop id="exIqo09Fmte207-fill-1" offset="2%" stop-color="#292929" />
          <stop id="exIqo09Fmte207-fill-2" offset="7%" stop-color="#565656" />
          <stop id="exIqo09Fmte207-fill-3" offset="14%" stop-color="#7e7e7e" />
          <stop id="exIqo09Fmte207-fill-4" offset="20%" stop-color="#a1a1a1" />
          <stop id="exIqo09Fmte207-fill-5" offset="28%" stop-color="#bebebe" />
          <stop id="exIqo09Fmte207-fill-6" offset="36%" stop-color="#d6d6d6" />
          <stop id="exIqo09Fmte207-fill-7" offset="45%" stop-color="#e8e8e8" />
          <stop id="exIqo09Fmte207-fill-8" offset="55%" stop-color="#f5f5f5" />
          <stop id="exIqo09Fmte207-fill-9" offset="69%" stop-color="#fcfcfc" />
          <stop id="exIqo09Fmte207-fill-10" offset="100%" stop-color="#fff" />
        </linearGradient>
        <linearGradient
          id="exIqo09Fmte211-fill"
          x1="7.92"
          y1="6.46"
          x2="7.92"
          y2="0.18"
          spreadMethod="pad"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(0 0)"
        >
          <stop id="exIqo09Fmte211-fill-0" offset="0%" stop-color="#000" />
          <stop id="exIqo09Fmte211-fill-1" offset="17%" stop-color="#020202" />
          <stop id="exIqo09Fmte211-fill-2" offset="27%" stop-color="#0a0a0a" />
          <stop id="exIqo09Fmte211-fill-3" offset="35%" stop-color="#171818" />
          <stop id="exIqo09Fmte211-fill-4" offset="42%" stop-color="#2a2b2c" />
          <stop id="exIqo09Fmte211-fill-5" offset="49%" stop-color="#434445" />
          <stop id="exIqo09Fmte211-fill-6" offset="51%" stop-color="#4c4e4f" />
          <stop id="exIqo09Fmte211-fill-7" offset="52%" stop-color="#383a3b" />
          <stop id="exIqo09Fmte211-fill-8" offset="54%" stop-color="#232425" />
          <stop id="exIqo09Fmte211-fill-9" offset="57%" stop-color="#131414" />
          <stop id="exIqo09Fmte211-fill-10" offset="60%" stop-color="#080808" />
          <stop id="exIqo09Fmte211-fill-11" offset="65%" stop-color="#010101" />
          <stop id="exIqo09Fmte211-fill-12" offset="77%" stop-color="#000" />
        </linearGradient>
        <linearGradient
          id="exIqo09Fmte212-fill"
          x1="7"
          y1="31.67"
          x2="7"
          y2="0.18"
          spreadMethod="pad"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(0 0)"
        >
          <stop id="exIqo09Fmte212-fill-0" offset="0%" stop-color="#221f1f" />
          <stop id="exIqo09Fmte212-fill-1" offset="8%" stop-color="#353433" />
          <stop id="exIqo09Fmte212-fill-2" offset="14%" stop-color="#3e3e3d" />
          <stop id="exIqo09Fmte212-fill-3" offset="32%" stop-color="#575859" />
          <stop id="exIqo09Fmte212-fill-4" offset="48%" stop-color="#67686a" />
          <stop id="exIqo09Fmte212-fill-5" offset="60%" stop-color="#6d6e71" />
          <stop id="exIqo09Fmte212-fill-6" offset="66%" stop-color="#848588" />
          <stop id="exIqo09Fmte212-fill-7" offset="73%" stop-color="#9d9ea1" />
          <stop id="exIqo09Fmte212-fill-8" offset="77%" stop-color="#a7a8ab" />
          <stop id="exIqo09Fmte212-fill-9" offset="100%" stop-color="#292929" />
        </linearGradient>
        <linearGradient
          id="exIqo09Fmte213-fill"
          x1="7.92"
          y1="4.51"
          x2="7.92"
          y2="-0.3"
          spreadMethod="pad"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(0 0)"
        >
          <stop id="exIqo09Fmte213-fill-0" offset="0%" stop-color="#30302f" />
          <stop id="exIqo09Fmte213-fill-1" offset="6%" stop-color="#494948" />
          <stop id="exIqo09Fmte213-fill-2" offset="18%" stop-color="#797978" />
          <stop id="exIqo09Fmte213-fill-3" offset="31%" stop-color="#a2a2a2" />
          <stop id="exIqo09Fmte213-fill-4" offset="44%" stop-color="#c3c3c3" />
          <stop id="exIqo09Fmte213-fill-5" offset="57%" stop-color="#ddd" />
          <stop id="exIqo09Fmte213-fill-6" offset="71%" stop-color="#f0f0f0" />
          <stop id="exIqo09Fmte213-fill-7" offset="85%" stop-color="#fbfbfb" />
          <stop id="exIqo09Fmte213-fill-8" offset="100%" stop-color="#fff" />
        </linearGradient>
        <linearGradient
          id="exIqo09Fmte215-fill"
          x1="7"
          y1="31.67"
          x2="7"
          y2="0.18"
          spreadMethod="pad"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(0 0)"
        >
          <stop id="exIqo09Fmte215-fill-0" offset="0%" stop-color="#221f1f" />
          <stop id="exIqo09Fmte215-fill-1" offset="8%" stop-color="#353433" />
          <stop id="exIqo09Fmte215-fill-2" offset="14%" stop-color="#3e3e3d" />
          <stop id="exIqo09Fmte215-fill-3" offset="32%" stop-color="#575859" />
          <stop id="exIqo09Fmte215-fill-4" offset="48%" stop-color="#67686a" />
          <stop id="exIqo09Fmte215-fill-5" offset="60%" stop-color="#6d6e71" />
          <stop id="exIqo09Fmte215-fill-6" offset="66%" stop-color="#848588" />
          <stop id="exIqo09Fmte215-fill-7" offset="73%" stop-color="#9d9ea1" />
          <stop id="exIqo09Fmte215-fill-8" offset="77%" stop-color="#a7a8ab" />
          <stop id="exIqo09Fmte215-fill-9" offset="100%" stop-color="#292929" />
        </linearGradient>
        <linearGradient
          id="exIqo09Fmte216-fill"
          x1="7.91"
          y1="6.46"
          x2="7.91"
          y2="0.18"
          spreadMethod="pad"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(0 0)"
        >
          <stop id="exIqo09Fmte216-fill-0" offset="0%" stop-color="#000" />
          <stop id="exIqo09Fmte216-fill-1" offset="17%" stop-color="#020202" />
          <stop id="exIqo09Fmte216-fill-2" offset="27%" stop-color="#0a0a0a" />
          <stop id="exIqo09Fmte216-fill-3" offset="35%" stop-color="#171818" />
          <stop id="exIqo09Fmte216-fill-4" offset="42%" stop-color="#2a2b2c" />
          <stop id="exIqo09Fmte216-fill-5" offset="49%" stop-color="#434445" />
          <stop id="exIqo09Fmte216-fill-6" offset="51%" stop-color="#4c4e4f" />
          <stop id="exIqo09Fmte216-fill-7" offset="52%" stop-color="#383a3b" />
          <stop id="exIqo09Fmte216-fill-8" offset="54%" stop-color="#232425" />
          <stop id="exIqo09Fmte216-fill-9" offset="57%" stop-color="#131414" />
          <stop id="exIqo09Fmte216-fill-10" offset="60%" stop-color="#080808" />
          <stop id="exIqo09Fmte216-fill-11" offset="65%" stop-color="#010101" />
          <stop id="exIqo09Fmte216-fill-12" offset="77%" stop-color="#000" />
        </linearGradient>
        <linearGradient
          id="exIqo09Fmte217-fill"
          x1="7.91"
          y1="4.51"
          x2="7.91"
          y2="-0.3"
          spreadMethod="pad"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(0 0)"
        >
          <stop id="exIqo09Fmte217-fill-0" offset="0%" stop-color="#30302f" />
          <stop id="exIqo09Fmte217-fill-1" offset="6%" stop-color="#494948" />
          <stop id="exIqo09Fmte217-fill-2" offset="18%" stop-color="#797978" />
          <stop id="exIqo09Fmte217-fill-3" offset="31%" stop-color="#a2a2a2" />
          <stop id="exIqo09Fmte217-fill-4" offset="44%" stop-color="#c3c3c3" />
          <stop id="exIqo09Fmte217-fill-5" offset="57%" stop-color="#ddd" />
          <stop id="exIqo09Fmte217-fill-6" offset="71%" stop-color="#f0f0f0" />
          <stop id="exIqo09Fmte217-fill-7" offset="85%" stop-color="#fbfbfb" />
          <stop id="exIqo09Fmte217-fill-8" offset="100%" stop-color="#fff" />
        </linearGradient>
        <radialGradient
          id="exIqo09Fmte218-fill"
          cx="0"
          cy="0"
          r="39.89"
          spreadMethod="pad"
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(1.47 0 0 0.03 -0.2655 116.6262)"
        >
          <stop id="exIqo09Fmte218-fill-0" offset="0%" stop-color="#fff" />
          <stop id="exIqo09Fmte218-fill-1" offset="4%" stop-color="#efefef" />
          <stop id="exIqo09Fmte218-fill-2" offset="19%" stop-color="#b1b1b1" />
          <stop id="exIqo09Fmte218-fill-3" offset="35%" stop-color="#7b7b7b" />
          <stop id="exIqo09Fmte218-fill-4" offset="50%" stop-color="#4e4e4e" />
          <stop id="exIqo09Fmte218-fill-5" offset="64%" stop-color="#2c2c2c" />
          <stop id="exIqo09Fmte218-fill-6" offset="77%" stop-color="#141414" />
          <stop id="exIqo09Fmte218-fill-7" offset="90%" stop-color="#050505" />
          <stop id="exIqo09Fmte218-fill-8" offset="100%" stop-color="#000" />
        </radialGradient>
        <radialGradient
          id="exIqo09Fmte220-fill"
          cx="0"
          cy="0"
          r="55.6"
          spreadMethod="pad"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(22583.81 649.69)"
        >
          <stop id="exIqo09Fmte220-fill-0" offset="0%" stop-color="#6d6e71" />
          <stop id="exIqo09Fmte220-fill-1" offset="24%" stop-color="#9e9fa1" />
          <stop id="exIqo09Fmte220-fill-2" offset="47%" stop-color="#c8c8c9" />
          <stop id="exIqo09Fmte220-fill-3" offset="69%" stop-color="#e6e6e6" />
          <stop id="exIqo09Fmte220-fill-4" offset="87%" stop-color="#f8f8f8" />
          <stop id="exIqo09Fmte220-fill-5" offset="100%" stop-color="#fff" />
        </radialGradient>
        <linearGradient
          id="exIqo09Fmte221-fill"
          x1="1183.45"
          y1="628.86"
          x2="1183.45"
          y2="522.72"
          spreadMethod="pad"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(0 0)"
        >
          <stop id="exIqo09Fmte221-fill-0" offset="0%" stop-color="#151515" />
          <stop id="exIqo09Fmte221-fill-1" offset="100%" stop-color="#363636" />
        </linearGradient>
        <linearGradient
          id="exIqo09Fmte222-fill"
          x1="1184.36"
          y1="522.72"
          x2="1184.36"
          y2="416.57"
          spreadMethod="pad"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(0 0)"
        >
          <stop id="exIqo09Fmte222-fill-0" offset="0%" stop-color="#1b1c1c" />
          <stop id="exIqo09Fmte222-fill-1" offset="45%" stop-color="#222323" />
          <stop id="exIqo09Fmte222-fill-2" offset="100%" stop-color="#333" />
        </linearGradient>
        <linearGradient
          id="exIqo09Fmte223-fill"
          x1="1182.54"
          y1="614.13"
          x2="1182.54"
          y2="628.86"
          spreadMethod="pad"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(0 0)"
        >
          <stop id="exIqo09Fmte223-fill-0" offset="0%" stop-color="#fff" />
          <stop id="exIqo09Fmte223-fill-1" offset="14%" stop-color="#f3f3f3" />
          <stop id="exIqo09Fmte223-fill-2" offset="38%" stop-color="#d5d6d6" />
          <stop id="exIqo09Fmte223-fill-3" offset="69%" stop-color="#a5a6a6" />
          <stop id="exIqo09Fmte223-fill-4" offset="100%" stop-color="#707171" />
        </linearGradient>
        <linearGradient
          id="exIqo09Fmte227-fill"
          x1="69.42"
          y1="9.32"
          x2="69.42"
          y2="0.07"
          spreadMethod="pad"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(0 0)"
        >
          <stop id="exIqo09Fmte227-fill-0" offset="0%" stop-color="#000" />
          <stop id="exIqo09Fmte227-fill-1" offset="43%" stop-color="#010101" />
          <stop id="exIqo09Fmte227-fill-2" offset="58%" stop-color="#080808" />
          <stop id="exIqo09Fmte227-fill-3" offset="69%" stop-color="#131414" />
          <stop id="exIqo09Fmte227-fill-4" offset="78%" stop-color="#242425" />
          <stop id="exIqo09Fmte227-fill-5" offset="85%" stop-color="#393a3b" />
          <stop id="exIqo09Fmte227-fill-6" offset="92%" stop-color="#535456" />
          <stop id="exIqo09Fmte227-fill-7" offset="98%" stop-color="#727376" />
          <stop id="exIqo09Fmte227-fill-8" offset="100%" stop-color="#808184" />
        </linearGradient>
        <linearGradient
          id="exIqo09Fmte228-fill"
          x1="69.42"
          y1="9.2"
          x2="69.42"
          y2="-0.06"
          spreadMethod="pad"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(0 0)"
        >
          <stop id="exIqo09Fmte228-fill-0" offset="0%" stop-color="#1a1a1a" />
          <stop id="exIqo09Fmte228-fill-1" offset="2%" stop-color="#292929" />
          <stop id="exIqo09Fmte228-fill-2" offset="7%" stop-color="#565656" />
          <stop id="exIqo09Fmte228-fill-3" offset="14%" stop-color="#7e7e7e" />
          <stop id="exIqo09Fmte228-fill-4" offset="20%" stop-color="#a1a1a1" />
          <stop id="exIqo09Fmte228-fill-5" offset="28%" stop-color="#bebebe" />
          <stop id="exIqo09Fmte228-fill-6" offset="36%" stop-color="#d6d6d6" />
          <stop id="exIqo09Fmte228-fill-7" offset="45%" stop-color="#e8e8e8" />
          <stop id="exIqo09Fmte228-fill-8" offset="55%" stop-color="#f5f5f5" />
          <stop id="exIqo09Fmte228-fill-9" offset="69%" stop-color="#fcfcfc" />
          <stop id="exIqo09Fmte228-fill-10" offset="100%" stop-color="#fff" />
        </linearGradient>
        <linearGradient
          id="exIqo09Fmte232-fill"
          x1="7.92"
          y1="6.46"
          x2="7.92"
          y2="0.18"
          spreadMethod="pad"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(0 0)"
        >
          <stop id="exIqo09Fmte232-fill-0" offset="0%" stop-color="#000" />
          <stop id="exIqo09Fmte232-fill-1" offset="17%" stop-color="#020202" />
          <stop id="exIqo09Fmte232-fill-2" offset="27%" stop-color="#0a0a0a" />
          <stop id="exIqo09Fmte232-fill-3" offset="35%" stop-color="#171818" />
          <stop id="exIqo09Fmte232-fill-4" offset="42%" stop-color="#2a2b2c" />
          <stop id="exIqo09Fmte232-fill-5" offset="49%" stop-color="#434445" />
          <stop id="exIqo09Fmte232-fill-6" offset="51%" stop-color="#4c4e4f" />
          <stop id="exIqo09Fmte232-fill-7" offset="52%" stop-color="#383a3b" />
          <stop id="exIqo09Fmte232-fill-8" offset="54%" stop-color="#232425" />
          <stop id="exIqo09Fmte232-fill-9" offset="57%" stop-color="#131414" />
          <stop id="exIqo09Fmte232-fill-10" offset="60%" stop-color="#080808" />
          <stop id="exIqo09Fmte232-fill-11" offset="65%" stop-color="#010101" />
          <stop id="exIqo09Fmte232-fill-12" offset="77%" stop-color="#000" />
        </linearGradient>
        <linearGradient
          id="exIqo09Fmte233-fill"
          x1="7"
          y1="31.67"
          x2="7"
          y2="0.18"
          spreadMethod="pad"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(0 0)"
        >
          <stop id="exIqo09Fmte233-fill-0" offset="0%" stop-color="#221f1f" />
          <stop id="exIqo09Fmte233-fill-1" offset="8%" stop-color="#353433" />
          <stop id="exIqo09Fmte233-fill-2" offset="14%" stop-color="#3e3e3d" />
          <stop id="exIqo09Fmte233-fill-3" offset="32%" stop-color="#575859" />
          <stop id="exIqo09Fmte233-fill-4" offset="48%" stop-color="#67686a" />
          <stop id="exIqo09Fmte233-fill-5" offset="60%" stop-color="#6d6e71" />
          <stop id="exIqo09Fmte233-fill-6" offset="66%" stop-color="#848588" />
          <stop id="exIqo09Fmte233-fill-7" offset="73%" stop-color="#9d9ea1" />
          <stop id="exIqo09Fmte233-fill-8" offset="77%" stop-color="#a7a8ab" />
          <stop id="exIqo09Fmte233-fill-9" offset="100%" stop-color="#292929" />
        </linearGradient>
        <linearGradient
          id="exIqo09Fmte234-fill"
          x1="7.92"
          y1="4.51"
          x2="7.92"
          y2="-0.3"
          spreadMethod="pad"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(0 0)"
        >
          <stop id="exIqo09Fmte234-fill-0" offset="0%" stop-color="#30302f" />
          <stop id="exIqo09Fmte234-fill-1" offset="6%" stop-color="#494948" />
          <stop id="exIqo09Fmte234-fill-2" offset="18%" stop-color="#797978" />
          <stop id="exIqo09Fmte234-fill-3" offset="31%" stop-color="#a2a2a2" />
          <stop id="exIqo09Fmte234-fill-4" offset="44%" stop-color="#c3c3c3" />
          <stop id="exIqo09Fmte234-fill-5" offset="57%" stop-color="#ddd" />
          <stop id="exIqo09Fmte234-fill-6" offset="71%" stop-color="#f0f0f0" />
          <stop id="exIqo09Fmte234-fill-7" offset="85%" stop-color="#fbfbfb" />
          <stop id="exIqo09Fmte234-fill-8" offset="100%" stop-color="#fff" />
        </linearGradient>
        <linearGradient
          id="exIqo09Fmte236-fill"
          x1="7"
          y1="31.67"
          x2="7"
          y2="0.18"
          spreadMethod="pad"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(0 0)"
        >
          <stop id="exIqo09Fmte236-fill-0" offset="0%" stop-color="#221f1f" />
          <stop id="exIqo09Fmte236-fill-1" offset="8%" stop-color="#353433" />
          <stop id="exIqo09Fmte236-fill-2" offset="14%" stop-color="#3e3e3d" />
          <stop id="exIqo09Fmte236-fill-3" offset="32%" stop-color="#575859" />
          <stop id="exIqo09Fmte236-fill-4" offset="48%" stop-color="#67686a" />
          <stop id="exIqo09Fmte236-fill-5" offset="60%" stop-color="#6d6e71" />
          <stop id="exIqo09Fmte236-fill-6" offset="66%" stop-color="#848588" />
          <stop id="exIqo09Fmte236-fill-7" offset="73%" stop-color="#9d9ea1" />
          <stop id="exIqo09Fmte236-fill-8" offset="77%" stop-color="#a7a8ab" />
          <stop id="exIqo09Fmte236-fill-9" offset="100%" stop-color="#292929" />
        </linearGradient>
        <linearGradient
          id="exIqo09Fmte237-fill"
          x1="7.92"
          y1="6.46"
          x2="7.92"
          y2="0.18"
          spreadMethod="pad"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(0 0)"
        >
          <stop id="exIqo09Fmte237-fill-0" offset="0%" stop-color="#000" />
          <stop id="exIqo09Fmte237-fill-1" offset="17%" stop-color="#020202" />
          <stop id="exIqo09Fmte237-fill-2" offset="27%" stop-color="#0a0a0a" />
          <stop id="exIqo09Fmte237-fill-3" offset="35%" stop-color="#171818" />
          <stop id="exIqo09Fmte237-fill-4" offset="42%" stop-color="#2a2b2c" />
          <stop id="exIqo09Fmte237-fill-5" offset="49%" stop-color="#434445" />
          <stop id="exIqo09Fmte237-fill-6" offset="51%" stop-color="#4c4e4f" />
          <stop id="exIqo09Fmte237-fill-7" offset="52%" stop-color="#383a3b" />
          <stop id="exIqo09Fmte237-fill-8" offset="54%" stop-color="#232425" />
          <stop id="exIqo09Fmte237-fill-9" offset="57%" stop-color="#131414" />
          <stop id="exIqo09Fmte237-fill-10" offset="60%" stop-color="#080808" />
          <stop id="exIqo09Fmte237-fill-11" offset="65%" stop-color="#010101" />
          <stop id="exIqo09Fmte237-fill-12" offset="77%" stop-color="#000" />
        </linearGradient>
        <linearGradient
          id="exIqo09Fmte238-fill"
          x1="7.92"
          y1="4.51"
          x2="7.92"
          y2="-0.3"
          spreadMethod="pad"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(0 0)"
        >
          <stop id="exIqo09Fmte238-fill-0" offset="0%" stop-color="#30302f" />
          <stop id="exIqo09Fmte238-fill-1" offset="6%" stop-color="#494948" />
          <stop id="exIqo09Fmte238-fill-2" offset="18%" stop-color="#797978" />
          <stop id="exIqo09Fmte238-fill-3" offset="31%" stop-color="#a2a2a2" />
          <stop id="exIqo09Fmte238-fill-4" offset="44%" stop-color="#c3c3c3" />
          <stop id="exIqo09Fmte238-fill-5" offset="57%" stop-color="#ddd" />
          <stop id="exIqo09Fmte238-fill-6" offset="71%" stop-color="#f0f0f0" />
          <stop id="exIqo09Fmte238-fill-7" offset="85%" stop-color="#fbfbfb" />
          <stop id="exIqo09Fmte238-fill-8" offset="100%" stop-color="#fff" />
        </linearGradient>
        <linearGradient
          id="exIqo09Fmte239-fill"
          x1="1033.64"
          y1="628.86"
          x2="1033.64"
          y2="522.72"
          spreadMethod="pad"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(0 0)"
        >
          <stop id="exIqo09Fmte239-fill-0" offset="0%" stop-color="#151515" />
          <stop id="exIqo09Fmte239-fill-1" offset="100%" stop-color="#363636" />
        </linearGradient>
        <linearGradient
          id="exIqo09Fmte240-fill"
          x1="1033.95"
          y1="522.72"
          x2="1033.95"
          y2="416.57"
          spreadMethod="pad"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(0 0)"
        >
          <stop id="exIqo09Fmte240-fill-0" offset="0%" stop-color="#1b1c1c" />
          <stop id="exIqo09Fmte240-fill-1" offset="45%" stop-color="#222323" />
          <stop id="exIqo09Fmte240-fill-2" offset="100%" stop-color="#333" />
        </linearGradient>
        <linearGradient
          id="exIqo09Fmte241-fill"
          x1="1033.03"
          y1="614.13"
          x2="1033.03"
          y2="628.86"
          spreadMethod="pad"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(0 0)"
        >
          <stop id="exIqo09Fmte241-fill-0" offset="0%" stop-color="#fff" />
          <stop id="exIqo09Fmte241-fill-1" offset="14%" stop-color="#f3f3f3" />
          <stop id="exIqo09Fmte241-fill-2" offset="38%" stop-color="#d5d6d6" />
          <stop id="exIqo09Fmte241-fill-3" offset="69%" stop-color="#a5a6a6" />
          <stop id="exIqo09Fmte241-fill-4" offset="100%" stop-color="#707171" />
        </linearGradient>
        <linearGradient
          id="exIqo09Fmte242-fill"
          x1="1035.16"
          y1="431.68"
          x2="1035.16"
          y2="416.94"
          spreadMethod="pad"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(0 0)"
        >
          <stop id="exIqo09Fmte242-fill-0" offset="0%" stop-color="#000" />
          <stop id="exIqo09Fmte242-fill-1" offset="14%" stop-color="#040404" />
          <stop id="exIqo09Fmte242-fill-2" offset="29%" stop-color="#111" />
          <stop id="exIqo09Fmte242-fill-3" offset="45%" stop-color="#262627" />
          <stop id="exIqo09Fmte242-fill-4" offset="62%" stop-color="#444546" />
          <stop id="exIqo09Fmte242-fill-5" offset="79%" stop-color="#6b6b6d" />
          <stop id="exIqo09Fmte242-fill-6" offset="96%" stop-color="#999a9d" />
          <stop id="exIqo09Fmte242-fill-7" offset="100%" stop-color="#a7a8ab" />
        </linearGradient>
        <linearGradient
          id="exIqo09Fmte245-fill"
          x1="69.43"
          y1="9.32"
          x2="69.43"
          y2="0.07"
          spreadMethod="pad"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(0 0)"
        >
          <stop id="exIqo09Fmte245-fill-0" offset="0%" stop-color="#000" />
          <stop id="exIqo09Fmte245-fill-1" offset="43%" stop-color="#010101" />
          <stop id="exIqo09Fmte245-fill-2" offset="58%" stop-color="#080808" />
          <stop id="exIqo09Fmte245-fill-3" offset="69%" stop-color="#131414" />
          <stop id="exIqo09Fmte245-fill-4" offset="78%" stop-color="#242425" />
          <stop id="exIqo09Fmte245-fill-5" offset="85%" stop-color="#393a3b" />
          <stop id="exIqo09Fmte245-fill-6" offset="92%" stop-color="#535456" />
          <stop id="exIqo09Fmte245-fill-7" offset="98%" stop-color="#727376" />
          <stop id="exIqo09Fmte245-fill-8" offset="100%" stop-color="#808184" />
        </linearGradient>
        <linearGradient
          id="exIqo09Fmte246-fill"
          x1="69.43"
          y1="9.2"
          x2="69.43"
          y2="-0.06"
          spreadMethod="pad"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(0 0)"
        >
          <stop id="exIqo09Fmte246-fill-0" offset="0%" stop-color="#1a1a1a" />
          <stop id="exIqo09Fmte246-fill-1" offset="2%" stop-color="#292929" />
          <stop id="exIqo09Fmte246-fill-2" offset="7%" stop-color="#565656" />
          <stop id="exIqo09Fmte246-fill-3" offset="14%" stop-color="#7e7e7e" />
          <stop id="exIqo09Fmte246-fill-4" offset="20%" stop-color="#a1a1a1" />
          <stop id="exIqo09Fmte246-fill-5" offset="28%" stop-color="#bebebe" />
          <stop id="exIqo09Fmte246-fill-6" offset="36%" stop-color="#d6d6d6" />
          <stop id="exIqo09Fmte246-fill-7" offset="45%" stop-color="#e8e8e8" />
          <stop id="exIqo09Fmte246-fill-8" offset="55%" stop-color="#f5f5f5" />
          <stop id="exIqo09Fmte246-fill-9" offset="69%" stop-color="#fcfcfc" />
          <stop id="exIqo09Fmte246-fill-10" offset="100%" stop-color="#fff" />
        </linearGradient>
        <linearGradient
          id="exIqo09Fmte250-fill"
          x1="7.91"
          y1="6.46"
          x2="7.91"
          y2="0.18"
          spreadMethod="pad"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(0 0)"
        >
          <stop id="exIqo09Fmte250-fill-0" offset="0%" stop-color="#000" />
          <stop id="exIqo09Fmte250-fill-1" offset="17%" stop-color="#020202" />
          <stop id="exIqo09Fmte250-fill-2" offset="27%" stop-color="#0a0a0a" />
          <stop id="exIqo09Fmte250-fill-3" offset="35%" stop-color="#171818" />
          <stop id="exIqo09Fmte250-fill-4" offset="42%" stop-color="#2a2b2c" />
          <stop id="exIqo09Fmte250-fill-5" offset="49%" stop-color="#434445" />
          <stop id="exIqo09Fmte250-fill-6" offset="51%" stop-color="#4c4e4f" />
          <stop id="exIqo09Fmte250-fill-7" offset="52%" stop-color="#383a3b" />
          <stop id="exIqo09Fmte250-fill-8" offset="54%" stop-color="#232425" />
          <stop id="exIqo09Fmte250-fill-9" offset="57%" stop-color="#131414" />
          <stop id="exIqo09Fmte250-fill-10" offset="60%" stop-color="#080808" />
          <stop id="exIqo09Fmte250-fill-11" offset="65%" stop-color="#010101" />
          <stop id="exIqo09Fmte250-fill-12" offset="77%" stop-color="#000" />
        </linearGradient>
        <linearGradient
          id="exIqo09Fmte252-fill"
          x1="7.91"
          y1="4.51"
          x2="7.91"
          y2="-0.3"
          spreadMethod="pad"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(0 0)"
        >
          <stop id="exIqo09Fmte252-fill-0" offset="0%" stop-color="#30302f" />
          <stop id="exIqo09Fmte252-fill-1" offset="6%" stop-color="#494948" />
          <stop id="exIqo09Fmte252-fill-2" offset="18%" stop-color="#797978" />
          <stop id="exIqo09Fmte252-fill-3" offset="31%" stop-color="#a2a2a2" />
          <stop id="exIqo09Fmte252-fill-4" offset="44%" stop-color="#c3c3c3" />
          <stop id="exIqo09Fmte252-fill-5" offset="57%" stop-color="#ddd" />
          <stop id="exIqo09Fmte252-fill-6" offset="71%" stop-color="#f0f0f0" />
          <stop id="exIqo09Fmte252-fill-7" offset="85%" stop-color="#fbfbfb" />
          <stop id="exIqo09Fmte252-fill-8" offset="100%" stop-color="#fff" />
        </linearGradient>
        <linearGradient
          id="exIqo09Fmte254-fill"
          x1="7.01"
          y1="31.67"
          x2="7.01"
          y2="0.18"
          spreadMethod="pad"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(0 0)"
        >
          <stop id="exIqo09Fmte254-fill-0" offset="0%" stop-color="#221f1f" />
          <stop id="exIqo09Fmte254-fill-1" offset="8%" stop-color="#353433" />
          <stop id="exIqo09Fmte254-fill-2" offset="14%" stop-color="#3e3e3d" />
          <stop id="exIqo09Fmte254-fill-3" offset="32%" stop-color="#575859" />
          <stop id="exIqo09Fmte254-fill-4" offset="48%" stop-color="#67686a" />
          <stop id="exIqo09Fmte254-fill-5" offset="60%" stop-color="#6d6e71" />
          <stop id="exIqo09Fmte254-fill-6" offset="66%" stop-color="#848588" />
          <stop id="exIqo09Fmte254-fill-7" offset="73%" stop-color="#9d9ea1" />
          <stop id="exIqo09Fmte254-fill-8" offset="77%" stop-color="#a7a8ab" />
          <stop id="exIqo09Fmte254-fill-9" offset="100%" stop-color="#292929" />
        </linearGradient>
        <linearGradient
          id="exIqo09Fmte255-fill"
          x1="7.92"
          y1="6.46"
          x2="7.92"
          y2="0.18"
          spreadMethod="pad"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(0 0)"
        >
          <stop id="exIqo09Fmte255-fill-0" offset="0%" stop-color="#000" />
          <stop id="exIqo09Fmte255-fill-1" offset="17%" stop-color="#020202" />
          <stop id="exIqo09Fmte255-fill-2" offset="27%" stop-color="#0a0a0a" />
          <stop id="exIqo09Fmte255-fill-3" offset="35%" stop-color="#171818" />
          <stop id="exIqo09Fmte255-fill-4" offset="42%" stop-color="#2a2b2c" />
          <stop id="exIqo09Fmte255-fill-5" offset="49%" stop-color="#434445" />
          <stop id="exIqo09Fmte255-fill-6" offset="51%" stop-color="#4c4e4f" />
          <stop id="exIqo09Fmte255-fill-7" offset="52%" stop-color="#383a3b" />
          <stop id="exIqo09Fmte255-fill-8" offset="54%" stop-color="#232425" />
          <stop id="exIqo09Fmte255-fill-9" offset="57%" stop-color="#131414" />
          <stop id="exIqo09Fmte255-fill-10" offset="60%" stop-color="#080808" />
          <stop id="exIqo09Fmte255-fill-11" offset="65%" stop-color="#010101" />
          <stop id="exIqo09Fmte255-fill-12" offset="77%" stop-color="#000" />
        </linearGradient>
        <linearGradient
          id="exIqo09Fmte256-fill"
          x1="7.92"
          y1="4.51"
          x2="7.92"
          y2="-0.3"
          spreadMethod="pad"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(0 0)"
        >
          <stop id="exIqo09Fmte256-fill-0" offset="0%" stop-color="#30302f" />
          <stop id="exIqo09Fmte256-fill-1" offset="6%" stop-color="#494948" />
          <stop id="exIqo09Fmte256-fill-2" offset="18%" stop-color="#797978" />
          <stop id="exIqo09Fmte256-fill-3" offset="31%" stop-color="#a2a2a2" />
          <stop id="exIqo09Fmte256-fill-4" offset="44%" stop-color="#c3c3c3" />
          <stop id="exIqo09Fmte256-fill-5" offset="57%" stop-color="#ddd" />
          <stop id="exIqo09Fmte256-fill-6" offset="71%" stop-color="#f0f0f0" />
          <stop id="exIqo09Fmte256-fill-7" offset="85%" stop-color="#fbfbfb" />
          <stop id="exIqo09Fmte256-fill-8" offset="100%" stop-color="#fff" />
        </linearGradient>
        <radialGradient
          id="exIqo09Fmte257-fill"
          cx="0"
          cy="0"
          r="41.35"
          spreadMethod="pad"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(-0.17 -0.24)"
        >
          <stop id="exIqo09Fmte257-fill-0" offset="0%" stop-color="#fff" />
          <stop id="exIqo09Fmte257-fill-1" offset="4%" stop-color="#efefef" />
          <stop id="exIqo09Fmte257-fill-2" offset="19%" stop-color="#b1b1b1" />
          <stop id="exIqo09Fmte257-fill-3" offset="35%" stop-color="#7b7b7b" />
          <stop id="exIqo09Fmte257-fill-4" offset="50%" stop-color="#4e4e4e" />
          <stop id="exIqo09Fmte257-fill-5" offset="64%" stop-color="#2c2c2c" />
          <stop id="exIqo09Fmte257-fill-6" offset="77%" stop-color="#141414" />
          <stop id="exIqo09Fmte257-fill-7" offset="90%" stop-color="#050505" />
          <stop id="exIqo09Fmte257-fill-8" offset="100%" stop-color="#000" />
        </radialGradient>
        <linearGradient
          id="exIqo09Fmte258-fill"
          x1="883.22"
          y1="628.86"
          x2="883.22"
          y2="522.72"
          spreadMethod="pad"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(0 0)"
        >
          <stop id="exIqo09Fmte258-fill-0" offset="0%" stop-color="#151515" />
          <stop id="exIqo09Fmte258-fill-1" offset="100%" stop-color="#363636" />
        </linearGradient>
        <linearGradient
          id="exIqo09Fmte259-fill"
          x1="884.14"
          y1="522.72"
          x2="884.14"
          y2="416.57"
          spreadMethod="pad"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(0 0)"
        >
          <stop id="exIqo09Fmte259-fill-0" offset="0%" stop-color="#1b1c1c" />
          <stop id="exIqo09Fmte259-fill-1" offset="45%" stop-color="#222323" />
          <stop id="exIqo09Fmte259-fill-2" offset="100%" stop-color="#333" />
        </linearGradient>
        <linearGradient
          id="exIqo09Fmte260-fill"
          x1="882.31"
          y1="614.13"
          x2="882.31"
          y2="628.86"
          spreadMethod="pad"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(0 0)"
        >
          <stop id="exIqo09Fmte260-fill-0" offset="0%" stop-color="#fff" />
          <stop id="exIqo09Fmte260-fill-1" offset="14%" stop-color="#f3f3f3" />
          <stop id="exIqo09Fmte260-fill-2" offset="38%" stop-color="#d5d6d6" />
          <stop id="exIqo09Fmte260-fill-3" offset="69%" stop-color="#a5a6a6" />
          <stop id="exIqo09Fmte260-fill-4" offset="100%" stop-color="#707171" />
        </linearGradient>
        <linearGradient
          id="exIqo09Fmte261-fill"
          x1="884.75"
          y1="431.68"
          x2="884.75"
          y2="416.94"
          spreadMethod="pad"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(0 0)"
        >
          <stop id="exIqo09Fmte261-fill-0" offset="0%" stop-color="#000" />
          <stop id="exIqo09Fmte261-fill-1" offset="14%" stop-color="#040404" />
          <stop id="exIqo09Fmte261-fill-2" offset="29%" stop-color="#111" />
          <stop id="exIqo09Fmte261-fill-3" offset="45%" stop-color="#262627" />
          <stop id="exIqo09Fmte261-fill-4" offset="62%" stop-color="#444546" />
          <stop id="exIqo09Fmte261-fill-5" offset="79%" stop-color="#6b6b6d" />
          <stop id="exIqo09Fmte261-fill-6" offset="96%" stop-color="#999a9d" />
          <stop id="exIqo09Fmte261-fill-7" offset="100%" stop-color="#a7a8ab" />
        </linearGradient>
        <linearGradient
          id="exIqo09Fmte263-fill"
          x1="69.42"
          y1="9.32"
          x2="69.42"
          y2="0.07"
          spreadMethod="pad"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(0 0)"
        >
          <stop id="exIqo09Fmte263-fill-0" offset="0%" stop-color="#000" />
          <stop id="exIqo09Fmte263-fill-1" offset="43%" stop-color="#010101" />
          <stop id="exIqo09Fmte263-fill-2" offset="58%" stop-color="#080808" />
          <stop id="exIqo09Fmte263-fill-3" offset="69%" stop-color="#131414" />
          <stop id="exIqo09Fmte263-fill-4" offset="78%" stop-color="#242425" />
          <stop id="exIqo09Fmte263-fill-5" offset="85%" stop-color="#393a3b" />
          <stop id="exIqo09Fmte263-fill-6" offset="92%" stop-color="#535456" />
          <stop id="exIqo09Fmte263-fill-7" offset="98%" stop-color="#727376" />
          <stop id="exIqo09Fmte263-fill-8" offset="100%" stop-color="#808184" />
        </linearGradient>
        <linearGradient
          id="exIqo09Fmte264-fill"
          x1="69.42"
          y1="9.2"
          x2="69.42"
          y2="-0.06"
          spreadMethod="pad"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(0 0)"
        >
          <stop id="exIqo09Fmte264-fill-0" offset="0%" stop-color="#1a1a1a" />
          <stop id="exIqo09Fmte264-fill-1" offset="2%" stop-color="#292929" />
          <stop id="exIqo09Fmte264-fill-2" offset="7%" stop-color="#565656" />
          <stop id="exIqo09Fmte264-fill-3" offset="14%" stop-color="#7e7e7e" />
          <stop id="exIqo09Fmte264-fill-4" offset="20%" stop-color="#a1a1a1" />
          <stop id="exIqo09Fmte264-fill-5" offset="28%" stop-color="#bebebe" />
          <stop id="exIqo09Fmte264-fill-6" offset="36%" stop-color="#d6d6d6" />
          <stop id="exIqo09Fmte264-fill-7" offset="45%" stop-color="#e8e8e8" />
          <stop id="exIqo09Fmte264-fill-8" offset="55%" stop-color="#f5f5f5" />
          <stop id="exIqo09Fmte264-fill-9" offset="69%" stop-color="#fcfcfc" />
          <stop id="exIqo09Fmte264-fill-10" offset="100%" stop-color="#fff" />
        </linearGradient>
        <linearGradient
          id="exIqo09Fmte268-fill"
          x1="7.91"
          y1="6.46"
          x2="7.91"
          y2="0.18"
          spreadMethod="pad"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(0 0)"
        >
          <stop id="exIqo09Fmte268-fill-0" offset="0%" stop-color="#000" />
          <stop id="exIqo09Fmte268-fill-1" offset="17%" stop-color="#020202" />
          <stop id="exIqo09Fmte268-fill-2" offset="27%" stop-color="#0a0a0a" />
          <stop id="exIqo09Fmte268-fill-3" offset="35%" stop-color="#171818" />
          <stop id="exIqo09Fmte268-fill-4" offset="42%" stop-color="#2a2b2c" />
          <stop id="exIqo09Fmte268-fill-5" offset="49%" stop-color="#434445" />
          <stop id="exIqo09Fmte268-fill-6" offset="51%" stop-color="#4c4e4f" />
          <stop id="exIqo09Fmte268-fill-7" offset="52%" stop-color="#383a3b" />
          <stop id="exIqo09Fmte268-fill-8" offset="54%" stop-color="#232425" />
          <stop id="exIqo09Fmte268-fill-9" offset="57%" stop-color="#131414" />
          <stop id="exIqo09Fmte268-fill-10" offset="60%" stop-color="#080808" />
          <stop id="exIqo09Fmte268-fill-11" offset="65%" stop-color="#010101" />
          <stop id="exIqo09Fmte268-fill-12" offset="77%" stop-color="#000" />
        </linearGradient>
        <linearGradient
          id="exIqo09Fmte269-fill"
          x1="7.01"
          y1="31.67"
          x2="7.01"
          y2="0.18"
          spreadMethod="pad"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(0 0)"
        >
          <stop id="exIqo09Fmte269-fill-0" offset="0%" stop-color="#221f1f" />
          <stop id="exIqo09Fmte269-fill-1" offset="8%" stop-color="#353433" />
          <stop id="exIqo09Fmte269-fill-2" offset="14%" stop-color="#3e3e3d" />
          <stop id="exIqo09Fmte269-fill-3" offset="32%" stop-color="#575859" />
          <stop id="exIqo09Fmte269-fill-4" offset="48%" stop-color="#67686a" />
          <stop id="exIqo09Fmte269-fill-5" offset="60%" stop-color="#6d6e71" />
          <stop id="exIqo09Fmte269-fill-6" offset="66%" stop-color="#848588" />
          <stop id="exIqo09Fmte269-fill-7" offset="73%" stop-color="#9d9ea1" />
          <stop id="exIqo09Fmte269-fill-8" offset="77%" stop-color="#a7a8ab" />
          <stop id="exIqo09Fmte269-fill-9" offset="100%" stop-color="#292929" />
        </linearGradient>
        <linearGradient
          id="exIqo09Fmte270-fill"
          x1="7.91"
          y1="4.51"
          x2="7.91"
          y2="-0.3"
          spreadMethod="pad"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(0 0)"
        >
          <stop id="exIqo09Fmte270-fill-0" offset="0%" stop-color="#30302f" />
          <stop id="exIqo09Fmte270-fill-1" offset="6%" stop-color="#494948" />
          <stop id="exIqo09Fmte270-fill-2" offset="18%" stop-color="#797978" />
          <stop id="exIqo09Fmte270-fill-3" offset="31%" stop-color="#a2a2a2" />
          <stop id="exIqo09Fmte270-fill-4" offset="44%" stop-color="#c3c3c3" />
          <stop id="exIqo09Fmte270-fill-5" offset="57%" stop-color="#ddd" />
          <stop id="exIqo09Fmte270-fill-6" offset="71%" stop-color="#f0f0f0" />
          <stop id="exIqo09Fmte270-fill-7" offset="85%" stop-color="#fbfbfb" />
          <stop id="exIqo09Fmte270-fill-8" offset="100%" stop-color="#fff" />
        </linearGradient>
        <linearGradient
          id="exIqo09Fmte272-fill"
          x1="7"
          y1="31.67"
          x2="7"
          y2="0.18"
          spreadMethod="pad"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(0 0)"
        >
          <stop id="exIqo09Fmte272-fill-0" offset="0%" stop-color="#221f1f" />
          <stop id="exIqo09Fmte272-fill-1" offset="8%" stop-color="#353433" />
          <stop id="exIqo09Fmte272-fill-2" offset="14%" stop-color="#3e3e3d" />
          <stop id="exIqo09Fmte272-fill-3" offset="32%" stop-color="#575859" />
          <stop id="exIqo09Fmte272-fill-4" offset="48%" stop-color="#67686a" />
          <stop id="exIqo09Fmte272-fill-5" offset="60%" stop-color="#6d6e71" />
          <stop id="exIqo09Fmte272-fill-6" offset="66%" stop-color="#848588" />
          <stop id="exIqo09Fmte272-fill-7" offset="73%" stop-color="#9d9ea1" />
          <stop id="exIqo09Fmte272-fill-8" offset="77%" stop-color="#a7a8ab" />
          <stop id="exIqo09Fmte272-fill-9" offset="100%" stop-color="#292929" />
        </linearGradient>
        <linearGradient
          id="exIqo09Fmte273-fill"
          x1="7.91"
          y1="6.46"
          x2="7.91"
          y2="0.18"
          spreadMethod="pad"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(0 0)"
        >
          <stop id="exIqo09Fmte273-fill-0" offset="0%" stop-color="#000" />
          <stop id="exIqo09Fmte273-fill-1" offset="17%" stop-color="#020202" />
          <stop id="exIqo09Fmte273-fill-2" offset="27%" stop-color="#0a0a0a" />
          <stop id="exIqo09Fmte273-fill-3" offset="35%" stop-color="#171818" />
          <stop id="exIqo09Fmte273-fill-4" offset="42%" stop-color="#2a2b2c" />
          <stop id="exIqo09Fmte273-fill-5" offset="49%" stop-color="#434445" />
          <stop id="exIqo09Fmte273-fill-6" offset="51%" stop-color="#4c4e4f" />
          <stop id="exIqo09Fmte273-fill-7" offset="52%" stop-color="#383a3b" />
          <stop id="exIqo09Fmte273-fill-8" offset="54%" stop-color="#232425" />
          <stop id="exIqo09Fmte273-fill-9" offset="57%" stop-color="#131414" />
          <stop id="exIqo09Fmte273-fill-10" offset="60%" stop-color="#080808" />
          <stop id="exIqo09Fmte273-fill-11" offset="65%" stop-color="#010101" />
          <stop id="exIqo09Fmte273-fill-12" offset="77%" stop-color="#000" />
        </linearGradient>
        <linearGradient
          id="exIqo09Fmte274-fill"
          x1="7.91"
          y1="4.51"
          x2="7.91"
          y2="-0.3"
          spreadMethod="pad"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(0 0)"
        >
          <stop id="exIqo09Fmte274-fill-0" offset="0%" stop-color="#30302f" />
          <stop id="exIqo09Fmte274-fill-1" offset="6%" stop-color="#494948" />
          <stop id="exIqo09Fmte274-fill-2" offset="18%" stop-color="#797978" />
          <stop id="exIqo09Fmte274-fill-3" offset="31%" stop-color="#a2a2a2" />
          <stop id="exIqo09Fmte274-fill-4" offset="44%" stop-color="#c3c3c3" />
          <stop id="exIqo09Fmte274-fill-5" offset="57%" stop-color="#ddd" />
          <stop id="exIqo09Fmte274-fill-6" offset="71%" stop-color="#f0f0f0" />
          <stop id="exIqo09Fmte274-fill-7" offset="85%" stop-color="#fbfbfb" />
          <stop id="exIqo09Fmte274-fill-8" offset="100%" stop-color="#fff" />
        </linearGradient>
        <radialGradient
          id="exIqo09Fmte275-fill"
          cx="0"
          cy="0"
          r="41.35"
          spreadMethod="pad"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(0.2 -0.24)"
        >
          <stop id="exIqo09Fmte275-fill-0" offset="0%" stop-color="#fff" />
          <stop id="exIqo09Fmte275-fill-1" offset="4%" stop-color="#efefef" />
          <stop id="exIqo09Fmte275-fill-2" offset="19%" stop-color="#b1b1b1" />
          <stop id="exIqo09Fmte275-fill-3" offset="35%" stop-color="#7b7b7b" />
          <stop id="exIqo09Fmte275-fill-4" offset="50%" stop-color="#4e4e4e" />
          <stop id="exIqo09Fmte275-fill-5" offset="64%" stop-color="#2c2c2c" />
          <stop id="exIqo09Fmte275-fill-6" offset="77%" stop-color="#141414" />
          <stop id="exIqo09Fmte275-fill-7" offset="90%" stop-color="#050505" />
          <stop id="exIqo09Fmte275-fill-8" offset="100%" stop-color="#000" />
        </radialGradient>
      </defs>
      <g transform="matrix(1.210289 0 0 1-201.87744 0)">
        <rect width="1920" height="1079.37" rx="0" ry="0" />
      </g>
      <g id="exIqo09Fmte4">
        <path
          d="M968.75,644.72c-.95.29-1.53.44-2.33.44-3.6,0-4.55-1.24-4.55-6.22v-1.47c-2.92,5.86-7.17,8.5-13.69,8.5-7.33,0-11.65-3.66-11.65-9.82c0-4.62,2.34-7.9,6.88-9.52c2.65-.95,3.01-.95,13.33-1.83c3.88-.36,4.98-1.32,4.98-4.62s-.59-5.05-2.12-6.44c-1.69-1.6-4.54-2.48-7.84-2.48-6.59,0-10.03,3-10.61,9.37h-2.72c.51-7.61,5.35-11.79,13.7-11.79c5.63,0,10.04,2.12,11.57,5.56.73,1.76.81,2.2.81,8.78v15.97c0,2.71.58,3.58,2.42,3.58.59,0,1.03-.06,1.82-.29v2.27Zm-7.02-19.69c-.95,1.17-3.08,1.83-7.91,2.26-6.23.67-8.05,1.03-10.4,2.05-2.63,1.17-4.17,3.58-4.17,6.45c0,4.75,3.58,7.83,9.15,7.83c7.76,0,13.33-5.2,13.33-12.37v-6.22Z"
          fill="#fff"
        />
        <path
          d="M1004.42,644.94h-2.71v-8.57c-1.68,6.07-6.59,9.6-13.33,9.6-9.67,0-15.68-7.03-15.68-18.39s6.15-18.74,15.68-18.74c6.44,0,10.69,2.93,13.24,9.08v-21.82h2.79v48.84Zm-28.93-17.43c0,9.88,4.98,16.04,13.04,16.04s13.18-6.16,13.18-16.12-5.06-16.18-13.33-16.18c-7.84,0-12.9,6.37-12.9,16.26Z"
          fill="#fff"
        />
        <path
          d="M1027.34,644.94h-3.23l-14.28-35.08h3.08l12.88,31.71l11.94-31.71h2.85l-13.25,35.08Z"
          fill="#fff"
        />
        <path
          d="M1074.36,632.93c-1.47,8.21-6.95,13.05-14.93,13.05-9.74,0-16.05-7.18-16.05-18.31s6.52-18.82,15.98-18.82c6,0,10.98,3.15,13.54,8.64c1.33,2.85,1.84,5.79,1.84,10.32h-28.48c.07,9.89,4.98,15.75,13.18,15.75c6.45,0,10.83-3.89,12.15-10.63h2.78Zm-2.48-7.53c-.15-3.96-.74-6.07-2.27-8.5-2.26-3.58-6-5.63-10.25-5.63-4.47,0-8.57,2.27-10.78,5.99-1.38,2.35-1.9,4.33-2.32,8.14h25.62Z"
          fill="#fff"
        />
        <path
          d="M1099.11,612.35h-1.17c-3.82,0-7.25,1.69-9.52,4.76-2.2,3.01-2.86,5.79-2.86,12.67v15.16h-2.86v-35.08h2.79v9.23c2.05-6.37,6.74-9.67,13.62-9.53v2.79Z"
          fill="#fff"
        />
        <path
          d="M1118.22,612.28h-7.61v23.72c0,3.02.15,4.17.66,5.05.66,1.1,1.97,1.76,3.87,1.76.88,0,1.75-.14,3.08-.44v2.49c-1.4.22-2.2.29-3.36.29-3.23,0-5.28-.95-6.31-2.85-.58-1.33-.72-2.42-.72-7.39v-22.63h-6.38v-2.42h6.38v-10.98h2.78v10.98h7.61v2.42Z"
          fill="#fff"
        />
        <path
          d="M1127.73,602.98h-2.77v-6.88h2.77v6.88Zm0,41.96h-2.77v-35.08h2.77v35.08Z"
          fill="#fff"
        />
        <path
          d="M1159.37,620.04c-.5-6.07-3.8-8.78-10.76-8.78-5.93,0-9.59,2.63-9.59,6.87c0,2.56,1.09,4.1,3.66,5.28c1.17.51,3.66,1.24,7.54,2.12c4.75,1.09,6.96,1.75,9.01,2.93c2.56,1.47,4.09,4.1,4.09,7.18c0,6.15-5.57,10.33-13.83,10.33-9.23,0-14.29-4.48-14.43-12.82h2.78c.07,3.08.52,4.61,1.69,6.22c1.9,2.64,5.57,4.18,9.96,4.18c6.66,0,11.06-3.16,11.06-7.84c0-2.56-1.39-4.39-4.32-5.71-1.09-.51-3.36-1.18-6.59-1.91-5.86-1.39-7.62-1.91-9.52-2.93-2.41-1.32-3.89-3.81-3.89-6.73c0-5.93,4.77-9.59,12.6-9.59c4.91,0,8.57,1.31,10.92,3.96c1.61,1.82,2.2,3.66,2.5,7.24h-2.87Z"
          fill="#fff"
        />
        <path
          d="M1174.39,602.98h-2.78v-6.88h2.78v6.88Zm0,41.96h-2.78v-35.08h2.78v35.08Z"
          fill="#fff"
        />
        <path
          d="M1187.35,617.48c2.42-5.86,6.6-8.64,12.89-8.64c4.25,0,7.83,1.61,10.04,4.47c1.75,2.26,2.27,4.46,2.27,9.22v22.41h-2.78v-21.76c0-3.58-.3-5.34-1.11-7.02-1.46-3-4.9-4.9-8.99-4.9-4.47,0-8.35,2.12-10.34,5.71-1.4,2.48-1.9,5.12-1.9,9.74v18.23h-2.85v-35.08h2.78v7.61Z"
          fill="#fff"
        />
        <path
          d="M1251.57,642.09c0,4.83-.52,7.54-2.06,10.1-2.33,4.02-6.88,6.15-13.25,6.15-8.49,0-13.4-3.81-13.92-10.84h2.79c.72,5.72,4.32,8.42,11.13,8.42c8.78,0,12.52-4.1,12.52-13.77v-7.32c-.8,1.9-1.25,2.78-2.04,3.81-2.57,3.22-6.53,5.05-11.06,5.05-9.08,0-14.94-6.66-14.94-16.98s6.08-17.87,15.38-17.87c6.01,0,10.69,3.3,12.74,9.08v-8.05h2.71v32.22Zm-28.04-15.75c0,9.16,4.82,14.94,12.37,14.94s12.81-5.94,12.81-15.09-4.98-14.93-12.81-14.93c-7.4,0-12.37,6.08-12.37,15.08Z"
          fill="#fff"
        />
        <path
          d="M1284.24,602.98h-2.78v-6.88h2.78v6.88Zm0,41.96h-2.78v-35.08h2.78v35.08Z"
          fill="#fff"
        />
        <path
          d="M1297.19,617.48c2.42-5.86,6.6-8.64,12.9-8.64c4.24,0,7.83,1.61,10.03,4.47c1.76,2.26,2.27,4.46,2.27,9.22v22.41h-2.78v-21.76c0-3.58-.3-5.34-1.11-7.02-1.45-3-4.89-4.9-9-4.9-4.46,0-8.34,2.12-10.32,5.71-1.39,2.48-1.9,5.12-1.9,9.74v18.23h-2.86v-35.08h2.78v7.61Z"
          fill="#fff"
        />
        <path
          d="M1361.72,632.57c-1.17,8.49-6.67,13.41-14.94,13.41-5.94,0-10.18-2.28-13.18-6.95-1.98-3.16-3.01-7.11-3.01-11.5c0-11.35,6.44-18.67,16.47-18.67c8.14,0,13.41,4.4,14.36,11.79h-2.85c-1.17-6.08-5.2-9.37-11.51-9.37-8.33,0-13.68,6.29-13.68,16.11s5.27,16.18,13.25,16.18c6.74,0,11.36-4.18,12.31-10.99h2.78Z"
          fill="#fff"
        />
        <path d="M1370.72,644.94h-3.44v-6.96h3.44v6.96Z" fill="#fff" />
        <path
          d="M770.12,442.78h8.81v-21.75h-8.81v21.75ZM883.1,490.02c-8.09-19.46-21.54-28.72-41.91-28.72-30.08,0-49.53,23.16-49.53,59.28s18.99,58.11,49.53,58.11c14.35,0,26.06-5.07,33.82-14.24v-11.09c-7.17,11.31-18.66,17.68-33.34,17.68-25.47,0-41.22-19.45-41.22-50.7s15.98-51.4,40.74-51.4c26.17,0,42.15,19.45,42.15,51.17c0,1.11-.07,2.18-.11,3.25h.04v25.18c.03-.07.04-.13.07-.18v27.08h8.56v-153.16h-8.79v67.73Zm30.31,31.52c.02.22.03.41.04.63.03.44-.04-.63-.04-.63Zm-170.13,3.21c0,28.47-14.58,46.53-37.73,46.53-12.97,0-24.07-6.26-28.47-15.98-3.03-6.03-3.7-11.58-3.7-24.54v-66.21h-8.81v71.53c0,27.55,13.89,42.61,39.13,42.61c18.99,0,31.95-8.8,39.82-26.63v23.38h8.56v-110.89h-8.79v60.2Zm26.84,50.69h8.81v-110.89h-8.81v110.89ZM638.19,490.02c-6.48-18.3-21.3-28.72-40.29-28.72-29.4,0-48.62,22.47-48.62,56.5s18.52,53.7,47.23,53.7c13.23,0,24.85-4.97,32.93-13.72v-10.53c-7.01,10.55-18.16,16.62-32.25,16.62-23.84,0-39.11-18.29-39.11-47.22s15.74-47.7,39.11-47.7c24.78,0,40.53,18.29,40.53,47.23l.23,50.48c0,30.55-11.8,43.51-39.59,43.51-21.53,0-32.87-8.56-35.19-26.62h-8.8c1.63,22.23,17.14,34.26,43.99,34.26c20.14,0,34.5-6.71,41.91-19.45c4.85-8.11,6.48-16.66,6.48-31.95v-101.86h-8.57v25.47Zm284.32,31.25h80.95c0-14.36-1.62-23.61-5.79-32.64-8.09-17.36-23.83-27.33-42.82-27.33-29.88,0-50.47,24.31-50.47,59.5s19.91,57.89,50.69,57.89c25.23,0,42.59-15.28,47.23-41.21h-8.8c-4.16,21.3-18.05,33.56-38.43,33.56-25.67,0-41.11-18.17-41.63-48.88c0-.1-.02-.29-.05-.63-.11-1.73,0-7.93,0-7.93c1.4-12.03,3.01-18.28,7.41-25.69c6.94-11.8,19.92-18.98,34.04-18.98s25.22,6.48,32.41,17.83c4.85,7.64,6.71,14.36,7.17,26.86h-71.92v7.64Zm252.93.27c0,.22.01.41.03.63.03.44-.03-.63-.03-.63Zm-56.92-60.24c-19.92,0-33.1,8.8-40.74,27.33v-24.08h-8.82v110.89h9.05v-57.64c0-14.59,1.62-22.92,6.01-30.8c6.25-11.35,18.52-18.06,32.63-18.06c12.97,0,23.86,6.03,28.48,15.51c2.54,5.33,3.47,10.88,3.47,22.23v68.75h8.79v-70.84c0-15.04-1.61-21.99-7.17-29.17-6.94-9.03-18.28-14.13-31.71-14.13ZM1014.8,575.44h8.8v-153.16h-8.8v153.16Zm332.41-52.09c-6.46-3.7-13.42-5.79-28.47-9.26-12.27-2.78-20.13-5.09-23.85-6.71-8.11-3.7-11.58-8.57-11.58-16.67c0-13.43,11.58-21.76,30.34-21.76c22,0,32.4,8.57,34.03,27.78h9.04c-.93-11.35-2.78-17.13-7.87-22.92-7.41-8.33-18.98-12.5-34.5-12.5-24.77,0-39.82,11.58-39.82,30.34c0,9.25,4.63,17.14,12.27,21.3c6.02,3.24,11.58,4.87,30.1,9.26c10.19,2.33,17.36,4.4,20.84,6.03c9.26,4.17,13.66,9.96,13.66,18.05c0,14.83-13.9,24.78-34.96,24.78-13.89,0-25.46-4.87-31.48-13.2-3.72-5.09-5.09-9.95-5.33-19.67h-8.79c.47,26.39,16.43,40.52,45.61,40.52c26.16,0,43.75-13.2,43.75-32.65c0-9.72-4.86-18.05-12.97-22.69Zm-162.69-2.08h80.96c0-14.36-1.63-23.61-5.8-32.64-8.1-17.36-23.84-27.33-42.83-27.33-29.86,0-50.46,24.31-50.46,59.5s19.91,57.89,50.7,57.89c25.23,0,42.59-15.28,47.22-41.21h-8.8c-4.15,21.3-18.06,33.56-38.43,33.56-25.67,0-41.11-18.17-41.63-48.88-.01-.1-.03-.29-.05-.63-.1-1.73.01-7.93.01-7.93c1.4-12.03,3.01-18.28,7.41-25.69c6.94-11.8,19.89-18.98,34.03-18.98s25.25,6.48,32.41,17.83c4.86,7.64,6.71,14.36,7.19,26.86h-71.94v7.64Zm-142.64,54.17h8.81v-110.89h-8.81v110.89Zm0-132.66h8.81v-21.75h-8.81v21.75Z"
          fill="#fff"
        />
      </g>
      <g id="exIqo09Fmte21" opacity="0">
        <g>
          <g>
            <polygon
              points="1142.83,456.21 1128.06,456.21 1128.06,470.99 1142.83,470.99 1142.83,609.12 1128.06,609.12 1128.06,623.16 1186.41,623.16 1186.41,609.12 1171.64,609.12 1171.64,470.99 1186.41,470.99 1186.41,456.21 1171.64,456.21 1142.83,456.21"
              fill="#fff"
            />
            <polygon
              points="1207.84,456.21 1193.06,456.21 1193.06,470.99 1207.84,470.99 1207.84,609.12 1193.06,609.12 1193.06,623.16 1251.42,623.16 1251.42,609.12 1236.64,609.12 1236.64,470.99 1251.42,470.99 1251.42,456.21 1236.64,456.21 1207.84,456.21"
              fill="#fff"
            />
            <polygon
              points="1316.43,470.99 1316.43,456.21 1302.39,456.21 1272.84,456.21 1258.81,456.21 1258.81,470.99 1272.84,470.99 1272.84,609.12 1258.81,609.12 1258.81,623.16 1316.43,623.16 1316.43,609.12 1302.39,609.12 1302.39,470.99 1316.43,470.99"
              fill="#fff"
            />
            <polygon
              points="748.36,470.99 748.36,456.21 690.74,456.21 690.74,470.99 713.64,470.99 681.88,519 652.33,470.99 661.19,470.99 661.19,456.21 603.57,456.21 603.57,470.99 613.92,470.99 661.93,548.55 622.04,609.12 603.57,609.12 603.57,623.16 661.19,623.16 661.19,609.12 639.03,609.12 670.8,561.85 699.61,609.12 690.74,609.12 690.74,623.16 748.36,623.16 748.36,609.12 738.02,609.12 690,532.3 731.37,470.99 748.36,470.99"
              fill="#fff"
            />
            <polygon
              points="1043.84,470.99 1043.84,456.21 1029.07,456.21 1000.26,456.21 985.49,456.21 985.49,470.99 1000.26,470.99 1000.26,609.12 985.49,609.12 985.49,623.16 1043.84,623.16 1043.84,609.12 1029.07,609.12 1029.07,470.99 1043.84,470.99"
              fill="#fff"
            />
            <polygon
              points="927.13,470.99 946.33,470.99 907.18,575.14 872.46,470.99 883.54,470.99 883.54,456.21 833.31,456.21 833.31,470.99 841.44,470.99 887.24,623.16 904.97,623.16 961.85,470.99 978.1,470.99 978.1,456.21 927.13,456.21 927.13,470.99"
              fill="#fff"
            />
          </g>
        </g>
      </g>
      <g id="exIqo09Fmte30" opacity="0">
        <g>
          <g>
            <rect
              width="5.09"
              height="135.41"
              rx="0"
              ry="0"
              transform="translate(728.29 449.48)"
              fill="#fff"
            />
            <rect
              width="5.09"
              height="135.41"
              rx="0"
              ry="0"
              transform="translate(880.22 449.48)"
              fill="#fff"
            />
            <rect
              width="5.09"
              height="58.49"
              rx="0"
              ry="0"
              transform="translate(743.54 449.48)"
              fill="#fff"
            />
            <rect
              width="5.09"
              height="58.49"
              rx="0"
              ry="0"
              transform="translate(758.8 449.48)"
              fill="#fff"
            />
            <rect
              width="5.09"
              height="58.49"
              rx="0"
              ry="0"
              transform="translate(774.06 449.48)"
              fill="#fff"
            />
            <rect
              width="5.09"
              height="58.49"
              rx="0"
              ry="0"
              transform="translate(789.32 449.48)"
              fill="#fff"
            />
            <rect
              width="5.09"
              height="95.99"
              rx="0"
              ry="0"
              transform="translate(803.94 449.48)"
              fill="#fff"
            />
            <rect
              width="5.09"
              height="58.49"
              rx="0"
              ry="0"
              transform="translate(819.19 449.48)"
              fill="#fff"
            />
            <rect
              width="5.09"
              height="58.49"
              rx="0"
              ry="0"
              transform="translate(834.45 449.48)"
              fill="#fff"
            />
            <rect
              width="5.09"
              height="58.49"
              rx="0"
              ry="0"
              transform="translate(849.71 449.48)"
              fill="#fff"
            />
            <rect
              width="5.09"
              height="58.49"
              rx="0"
              ry="0"
              transform="translate(864.97 449.48)"
              fill="#fff"
            />
            <rect
              width="5.09"
              height="95.99"
              rx="0"
              ry="0"
              transform="translate(652 449.48)"
              fill="#fff"
            />
            <rect
              width="5.09"
              height="58.49"
              rx="0"
              ry="0"
              transform="translate(667.26 449.48)"
              fill="#fff"
            />
            <rect
              width="5.09"
              height="58.49"
              rx="0"
              ry="0"
              transform="translate(682.51 449.48)"
              fill="#fff"
            />
            <rect
              width="5.09"
              height="58.49"
              rx="0"
              ry="0"
              transform="translate(697.77 449.48)"
              fill="#fff"
            />
            <rect
              width="5.09"
              height="58.49"
              rx="0"
              ry="0"
              transform="translate(713.03 449.48)"
              fill="#fff"
            />
            <rect
              width="5.09"
              height="135.41"
              rx="0"
              ry="0"
              transform="translate(1032.16 449.48)"
              fill="#fff"
            />
            <rect
              width="5.09"
              height="58.49"
              rx="0"
              ry="0"
              transform="translate(895.48 449.48)"
              fill="#fff"
            />
            <rect
              width="5.09"
              height="58.49"
              rx="0"
              ry="0"
              transform="translate(910.74 449.48)"
              fill="#fff"
            />
            <rect
              width="5.09"
              height="58.49"
              rx="0"
              ry="0"
              transform="translate(926 449.48)"
              fill="#fff"
            />
            <rect
              width="5.09"
              height="58.49"
              rx="0"
              ry="0"
              transform="translate(941.25 449.48)"
              fill="#fff"
            />
            <rect
              width="5.09"
              height="95.99"
              rx="0"
              ry="0"
              transform="translate(956.51 449.48)"
              fill="#fff"
            />
            <rect
              width="5.09"
              height="58.49"
              rx="0"
              ry="0"
              transform="translate(971.13 449.48)"
              fill="#fff"
            />
            <rect
              width="5.09"
              height="58.49"
              rx="0"
              ry="0"
              transform="translate(986.39 449.48)"
              fill="#fff"
            />
            <rect
              width="5.09"
              height="58.49"
              rx="0"
              ry="0"
              transform="translate(1001.65 449.48)"
              fill="#fff"
            />
            <rect
              width="5.09"
              height="58.49"
              rx="0"
              ry="0"
              transform="translate(1016.91 449.48)"
              fill="#fff"
            />
            <rect
              width="5.09"
              height="135.41"
              rx="0"
              ry="0"
              transform="translate(1184.1 449.48)"
              fill="#fff"
            />
            <rect
              width="5.09"
              height="58.49"
              rx="0"
              ry="0"
              transform="translate(1047.42 449.48)"
              fill="#fff"
            />
            <rect
              width="5.09"
              height="58.49"
              rx="0"
              ry="0"
              transform="translate(1062.68 449.48)"
              fill="#fff"
            />
            <rect
              width="5.09"
              height="58.49"
              rx="0"
              ry="0"
              transform="translate(1077.94 449.48)"
              fill="#fff"
            />
            <rect
              width="5.09"
              height="58.49"
              rx="0"
              ry="0"
              transform="translate(1093.19 449.48)"
              fill="#fff"
            />
            <rect
              width="5.09"
              height="95.99"
              rx="0"
              ry="0"
              transform="translate(1108.45 449.48)"
              fill="#fff"
            />
            <rect
              width="5.09"
              height="58.49"
              rx="0"
              ry="0"
              transform="translate(1123.71 449.48)"
              fill="#fff"
            />
            <rect
              width="5.09"
              height="58.49"
              rx="0"
              ry="0"
              transform="translate(1138.97 449.48)"
              fill="#fff"
            />
            <rect
              width="5.09"
              height="58.49"
              rx="0"
              ry="0"
              transform="translate(1153.59 449.48)"
              fill="#fff"
            />
            <rect
              width="5.09"
              height="58.49"
              rx="0"
              ry="0"
              transform="translate(1168.85 449.48)"
              fill="#fff"
            />
            <rect
              width="5.09"
              height="58.49"
              rx="0"
              ry="0"
              transform="translate(1199.36 449.48)"
              fill="#fff"
            />
            <rect
              width="5.09"
              height="58.49"
              rx="0"
              ry="0"
              transform="translate(1214.62 449.48)"
              fill="#fff"
            />
            <rect
              width="5.09"
              height="58.49"
              rx="0"
              ry="0"
              transform="translate(1229.88 449.48)"
              fill="#fff"
            />
            <rect
              width="5.09"
              height="58.49"
              rx="0"
              ry="0"
              transform="translate(1245.13 449.48)"
              fill="#fff"
            />
            <rect
              width="5.09"
              height="95.99"
              rx="0"
              ry="0"
              transform="translate(1260.39 449.48)"
              fill="#fff"
            />
            <path
              d="M863.7,630.66c0-6.36.64-11.44,1.91-15.26c1.27-3.81,3.18-6.99,5.72-8.9s5.72-3.18,9.54-3.18c3.18,0,5.72.64,7.63,1.91s3.81,3.18,5.72,5.09s2.54,5.09,3.18,8.26s1.27,7.63,1.27,12.71c0,6.36-.64,11.44-1.91,15.26-1.27,3.81-3.18,6.99-5.72,8.9s-5.72,3.18-9.54,3.18c-5.09,0-9.54-1.91-12.08-5.72-3.81-4.45-5.72-12.08-5.72-22.25v0Zm6.99,0c0,8.9,1.27,14.62,3.18,17.8s4.45,4.45,7.63,4.45s5.72-1.27,7.63-4.45s3.18-8.9,3.18-17.8-.64-14.62-3.18-17.8-4.45-4.45-7.63-4.45-5.72,1.27-7.63,3.81c-1.91,3.18-3.18,9.54-3.18,18.44Z"
              fill="#fff"
            />
            <path
              d="M732.74,658h-6.36v-42.59c-1.27,1.27-3.81,3.18-6.36,4.45s-5.09,2.54-6.99,3.18v-6.36c3.81-1.91,6.99-3.81,9.54-6.36s5.09-5.09,5.72-6.99h4.45v54.67v0Z"
              fill="#fff"
            />
            <path
              d="M1168.85,643.38l6.99-.64c.64,3.81,1.91,6.36,3.81,8.26s3.81,2.54,6.99,2.54s5.72-1.27,7.63-3.18s3.18-5.09,3.18-8.26-1.27-5.72-3.18-7.63-4.45-3.18-7.63-3.18c-1.27,0-2.54,0-4.45.64l.64-5.72h1.27c2.54,0,5.09-.64,7.63-1.91s3.18-3.81,3.18-6.99c0-2.54-.64-4.45-2.54-6.36-1.91-1.27-3.81-2.54-6.36-2.54s-5.09.64-6.36,2.54c-1.91,1.91-2.54,3.81-3.18,7.63l-6.99-1.27c.64-4.45,2.54-7.63,5.72-10.17c2.54-2.54,6.36-3.81,10.81-3.81c3.18,0,5.72.64,8.26,1.91s4.45,3.18,5.72,5.09s1.91,4.45,1.91,6.99-.64,4.45-1.91,6.36-3.18,3.18-5.72,4.45c3.18.64,5.72,2.54,7.63,4.45c1.91,2.54,2.54,5.09,2.54,8.9c0,5.09-1.91,8.9-5.09,12.08s-7.63,5.09-13.35,5.09c-5.09,0-8.9-1.27-12.08-4.45-2.54-3.18-4.45-6.99-5.09-10.81v0Z"
              fill="#fff"
            />
            <path
              d="M1051.87,616.68l-6.36.64c-.64-2.54-1.27-4.45-2.54-5.72-1.91-1.91-3.81-3.18-6.99-3.18-1.91,0-3.81.64-5.72,1.91s-3.81,3.81-5.09,6.36-1.91,6.99-1.91,12.71c1.27-2.54,3.81-4.45,5.72-5.72c2.54-1.27,5.09-1.91,7.63-1.91c4.45,0,8.26,1.91,11.44,5.09s4.45,7.63,4.45,12.71c0,3.18-.64,6.36-1.91,9.54s-3.81,5.09-5.72,6.99c-2.54,1.27-5.72,2.54-8.9,2.54-5.72,0-10.17-1.91-13.35-6.36s-5.09-10.81-5.09-20.34c0-10.81,1.91-17.8,5.72-22.89c3.18-4.45,7.63-6.36,13.99-6.36c4.45,0,7.63,1.27,10.81,3.81s3.18,5.72,3.81,10.17v0Zm-27.34,22.89c0,2.54.64,4.45,1.27,6.36s2.54,3.81,3.81,5.09c1.91,1.27,3.81,1.91,5.72,1.91c2.54,0,5.09-1.27,6.99-3.18s3.18-5.09,3.18-9.54-1.27-6.99-3.18-8.9-4.45-3.18-7.63-3.18-5.72,1.27-7.63,3.18-2.54,5.09-2.54,8.26v0Z"
              fill="#fff"
            />
          </g>
        </g>
      </g>
      <g id="exIqo09Fmte78" opacity="0">
        <g>
          <g>
            <path
              d="M1121.65,521.51l-4.11-13.69c-.68-2.05-1.37-3.42-3.42-4.79l-65.74-54.78c-3.42-2.74-8.9-2.74-11.64.68l-56.15,65.74c-1.37,1.37-1.37,2.74-1.37,4.79l.68,17.12c0,2.05.68,4.11,2.74,4.79l68.47,56.83c3.42,2.74,8.9,2.74,11.64-.68l56.83-65.74c2.05-3.42,2.74-6.85,2.05-10.27v0Zm-16.43-16.43c4.11,3.42,6.85,6.85,6.85,6.85-.68.68-4.11-2.05-8.22-5.48s-6.85-6.85-6.85-6.85c.68-.68,4.11,2.05,8.22,5.48Zm-41.08-40.4c4.11,3.42,6.85,6.85,6.85,6.85-.68.68-4.11-2.05-8.22-5.48s-6.85-6.85-6.85-6.85c.68-.68,4.11,2.05,8.22,5.48Zm-6.16,34.24c0,5.48-4.79,10.27-10.27,10.27s-10.27-4.79-10.27-10.27s4.79-10.27,10.27-10.27s10.27,4.79,10.27,10.27ZM1043.6,450.3c.68,0,1.37,0,1.37.68l1.37,8.22c0,.68,0,1.37-.68,1.37v0q-.68,0-.68-.68l-1.37-8.22c-1.37-.68-.68-1.37,0-1.37ZM1027.85,477c-3.42,4.11-6.85,7.53-7.53,6.85s2.05-4.11,5.48-8.22s6.85-7.53,7.53-6.85-2.05,4.11-5.48,8.22Zm-2.74-9.59c3.42-4.11,6.85-6.85,7.53-6.85.68.68-2.05,4.11-5.48,8.22-3.42,4.11-6.85,6.85-7.53,6.85s2.05-4.11,5.48-8.22Zm-30.13,47.93c-3.42,4.11-6.85,6.85-6.85,6.85-.68-.68,2.05-4.11,5.48-8.22c3.42-4.11,6.85-6.85,7.53-6.85c0,.68-2.74,4.11-6.16,8.22Zm-2.05-10.27c3.42-4.11,6.85-6.85,7.53-6.85.68.68-2.05,4.11-5.48,8.22-3.42,4.11-6.85,6.85-6.85,6.85-1.37,0,1.37-3.42,4.79-8.22Zm-6.85,30.13c0,0-.68-.68,0,0-1.37-.68-1.37-1.37-.68-1.37l54.78-63q.68-.68,1.37,0c.68,0,.68.68,0,1.37l-54.78,63c0-.68-.68,0-.68,0v0Zm28.76,12.33c-5.48,0-10.27-4.79-10.27-10.27s4.79-10.27,10.27-10.27s10.27,4.79,10.27,10.27-4.11,10.27-10.27,10.27Zm16.43-19.17c-5.48,0-10.27-4.79-10.27-10.27s4.79-10.27,10.27-10.27s10.27,4.79,10.27,10.27-4.79,10.27-10.27,10.27Zm23.28,52.04c-5.48,0-10.27-4.79-10.27-10.27s4.79-10.27,10.27-10.27s10.27,4.79,10.27,10.27-4.79,10.27-10.27,10.27Zm16.43-19.17c-5.48,0-10.27-4.79-10.27-10.27s4.79-10.27,10.27-10.27s10.27,4.79,10.27,10.27-4.79,10.27-10.27,10.27Zm16.43-19.17c-5.48,0-10.27-4.79-10.27-10.27s4.79-10.27,10.27-10.27s10.27,4.79,10.27,10.27-4.79,10.27-10.27,10.27Zm30.13-18.49h-1.37l-65.05-53.41c-.68,0-.68-.68,0-1.37s.68-.68,1.37,0l64.37,53.41c.68.68.68,1.37.68,1.37Z"
              fill="#fff"
            />
            <path
              d="M1289.41,468.79c0-2.74-1.37-5.48-4.11-6.85l-20.54-13.69c-1.37-1.37-4.11-1.37-6.16-1.37l-84.22,8.22c-4.11.68-7.53,4.11-7.53,8.9l5.48,85.59c0,2.05,1.37,4.11,2.74,5.48l18.49,17.12c2.05,2.05,4.79,2.74,6.85,2.05l86.28-8.9c4.79-.68,8.22-4.79,8.22-9.59l-5.48-86.96v0Zm-21.23-8.22c0,.68-4.11,2.05-9.59,2.05s-10.27,0-10.27-1.37s4.11-2.05,9.59-2.05c6.16,0,10.27.68,10.27,1.37Zm-21.23-8.9c5.48,0,10.27,0,10.27,1.37c0,.68-4.11,2.05-9.59,2.74-5.48,0-10.27,0-10.27-1.37s4.11-2.74,9.59-2.74Zm-19.17,6.16c5.48,0,10.27,0,10.27,1.37s-4.11,2.05-9.59,2.05-10.27,0-10.27-1.37s4.11-1.37,9.59-2.05Zm-8.9,8.22c0,.68-4.79,2.05-10.27,2.05s-10.27,0-10.27-1.37s4.79-2.05,10.27-2.05c6.16,0,10.27,0,10.27,1.37Zm-37.66,59.57c-1.37,0-2.05-4.11-2.74-10.27-.68-5.48,0-10.27.68-10.27c1.37,0,2.05,4.11,2.74,10.27c1.37,5.48.68,10.27-.68,10.27Zm6.16-52.73h-1.37l-14.38-11.64c-.68,0-.68-.68,0-1.37s.68-.68,1.37,0l14.38,11.64v1.37Zm.68-14.38c0-.68,4.11-2.05,9.59-2.74c5.48,0,10.27,0,10.27,1.37s-4.11,2.05-9.59,2.05-10.27.68-10.27-.68Zm8.22,107.5v0c-.68,0-1.37,0-1.37-.68l-5.48-80.8c0-.68.68-1.37.68-1.37.68,0,1.37,0,1.37.68l5.48,80.8q0,1.37-.68,1.37v0Zm27.39-63c-3.42,4.79-9.59,5.48-14.38,2.05-4.79-3.42-4.79-9.59-1.37-13.69c3.42-4.79,9.59-5.48,14.38-2.05c4.79,3.42,4.79,8.9,1.37,13.69Zm26.02,21.91c-3.42,4.79-9.59,5.48-13.69,2.05s-4.79-9.59-1.37-13.69c3.42-4.11,9.59-5.48,13.69-2.05c4.11,2.74,4.79,8.9,1.37,13.69Zm26.02,22.6c-3.42,4.79-9.59,5.48-13.69,2.05s-4.79-9.59-1.37-13.69c3.42-4.11,9.59-5.48,13.69-2.05s4.79,9.59,1.37,13.69Zm6.16-79.43l-82.85,8.9v0q-.68,0-.68-.68c0-.68.68-1.37.68-1.37l82.85-8.9c.68,0,1.37,0,1.37.68-.68.68-.68,1.37-1.37,1.37Z"
              fill="#fff"
            />
            <path
              d="M931.29,461.26c0-4.79-4.11-8.22-8.22-8.22l-84.91-4.11c-3.42,0-6.16,1.37-8.22,3.42l-22.6,30.81c-1.37,1.37-2.05,4.11-2.05,6.16l4.11,82.85c0,4.79,4.11,8.22,8.22,8.22l84.22,3.42c2.74,0,4.79-.68,6.85-2.74L934.03,553c2.05-2.05,2.74-4.79,2.74-7.53l-5.48-84.22v0Zm-97.92-4.79c.68,0,1.37.68,1.37.68l4.11,79.43c0,.68-.68,1.37-.68,1.37v0c-.68,0-.68-.68-.68-.68l-4.79-79.43q0-1.37.68-1.37v0Zm-2.74,71.9c0,5.48-1.37,10.27-3.42,10.27-1.37,0-2.05-4.79-2.05-10.27s1.37-10.27,3.42-10.27c1.37,0,2.74,4.79,2.05,10.27Zm-7.53-47.93c0-5.48,1.37-10.27,3.42-10.27c1.37,0,2.05,4.79,2.05,10.27s-2.05,10.27-3.42,10.27-2.74-4.79-2.05-10.27Zm-11.64,27.39c-1.37,0-2.05-4.79-2.05-10.27s1.37-9.59,3.42-9.59s2.05,4.79,2.05,10.27c-.68,5.48-2.05,9.59-3.42,9.59Zm2.74,47.93c-1.37,0-2.05-4.79-2.05-10.27s1.37-10.27,3.42-10.27s2.05,4.79,2.05,10.27c-.68,6.16-2.05,10.27-3.42,10.27Zm2.74,16.43v0c-1.37-.68-1.37-1.37-.68-1.37l18.49-22.6c0-.68.68-.68,1.37,0s.68.68,0,1.37l-17.8,22.6h-1.37Zm25.34,2.74c-5.48,0-10.27-1.37-10.27-2.74c0-2.05,4.11-3.42,10.27-3.42s10.27,1.37,10.27,2.74-4.79,3.42-10.27,3.42Zm6.85-8.22c-5.48,0-10.27-.68-10.27-2.74s4.11-3.42,9.59-3.42s10.27.68,10.27,2.74-4.11,3.42-9.59,3.42Zm6.85-8.22c-5.48,0-10.27-.68-10.27-2.74s4.11-3.42,9.59-3.42s10.27.68,10.27,2.74-4.11,3.42-9.59,3.42Zm35.61,19.17c-5.48,0-10.27-.68-10.27-2.74s4.11-3.42,9.59-3.42s10.27.68,10.27,2.74c0,1.37-4.11,2.74-9.59,3.42Zm6.85-8.22c-5.48,0-10.27-.68-10.27-2.74s4.11-3.42,9.59-3.42s10.27.68,10.27,2.74c.68,1.37-4.11,2.74-9.59,3.42Zm7.53-8.9c-5.48,0-10.27-.68-10.27-2.74s4.11-3.42,9.59-3.42s10.27.68,10.27,2.74c.68,1.37-4.11,3.42-9.59,3.42Zm22.6-10.96v0l-81.48-4.79c-.68,0-.68-.68-.68-1.37s.68-.68,1.37-.68l81.48,4.79c.68,0,.68.68.68,1.37s-.68.68-1.37.68v0Z"
              fill="#fff"
            />
            <path
              d="M749.15,457.83l-84.22-8.9c-1.37,0-3.42,0-4.79.68L630.01,468.1c-2.74,1.37-4.11,4.79-4.11,7.53l-2.05,87.65c0,4.79,3.42,8.22,7.53,8.9l86.28,10.27c2.05,0,4.11,0,6.16-1.37l27.39-21.23c2.05-1.37,3.42-4.11,3.42-6.85l3.42-85.59c0-4.79-3.42-8.9-8.9-9.59v0Zm-73.95-3.42c5.48,0,10.27,1.37,10.27,2.74s-4.79,2.05-10.27,2.05-10.27-1.37-10.27-2.74s4.11-2.05,10.27-2.05Zm-17.12,10.96c5.48,0,10.27,1.37,10.27,2.74s-4.79,2.05-10.27,2.05-10.27-1.37-10.27-2.74s4.79-2.05,10.27-2.05Zm19.17,71.21c-4.79,2.74-10.96,1.37-13.69-3.42s-2.05-10.96,2.74-13.69s10.96-1.37,13.69,3.42s2.05,10.96-2.74,13.69Zm35.61-52.73v0l-78.75-8.9c-.68,0-.68-.68-.68-1.37s.68-.68,1.37-.68l78.06,8.9c.68,0,.68.68.68,1.37q0,.68-.68.68Zm-4.79-8.22c-5.48,0-10.27-1.37-10.27-2.74s4.79-2.05,10.27-2.05s10.27,1.37,10.27,2.74-4.79,2.05-10.27,2.05ZM720.4,575.6c0,.68-.68.68-.68.68v0c-.68,0-.68-.68-.68-.68l.68-83.54c0-.68.68-1.37.68-.68.68,0,.68.68.68.68l-.68,83.54Zm-6.16-113.67c0-1.37,4.79-2.05,10.27-2.05s10.27,1.37,10.27,2.74-4.79,2.05-10.27,2.05-10.27-1.37-10.27-2.74Zm10.96,19.86c0,0-.68,0-.68-.68v-1.37l24.65-16.43h1.37v1.37L725.2,481.8c.68,0,0,0,0,0Zm8.22,70.53c-.68,5.48-2.74,10.27-4.11,10.27s-2.74-4.79-2.05-10.27s2.74-10.27,4.11-10.27c2.05,0,2.74,4.79,2.05,10.27Zm2.05-49.99c-.68,5.48-2.74,10.27-4.11,10.27s-2.74-4.79-2.05-10.27s2.74-10.27,4.11-10.27c1.37-.68,2.74,4.11,2.05,10.27Zm6.85,19.17c-.68,5.48-2.74,10.27-4.11,10.27s-2.74-4.79-2.05-10.27s2.74-10.27,4.11-10.27c2.05-.68,2.74,4.11,2.05,10.27Zm6.85,19.17c-.68,5.48-2.74,10.27-4.11,10.27s-2.74-4.79-2.05-10.27s2.74-10.27,4.11-10.27c2.05,0,2.74,4.79,2.05,10.27Zm2.05-49.99c-.68,5.48-2.74,10.27-4.11,10.27s-2.74-4.79-2.05-10.27s2.74-10.27,4.11-10.27s2.74,4.79,2.05,10.27Z"
              fill="#fff"
            />
          </g>
        </g>
      </g>
      <g id="exIqo09Fmte85" opacity="0">
        <g>
          <path
            d="M1010.4,599.51c-3.09,0-14.82-3.09-24.09-16.06-3.09-4.32-6.18-9.88-8.65-15.44-2.47-4.32-4.32-9.27-7.41-12.97-4.32-6.18-9.27-11.12-13.59-14.82-4.94-4.32-8.03-7.41-6.18-11.12c3.71-4.94,11.12-6.18,17.91-1.85c5.56,3.09,10.5,8.03,15.44,12.97c4.94,5.56,11.12,11.12,13.59,9.88.62-.62,1.85,0,2.47.62s0,1.85-.62,2.47c-4.94,3.09-11.12-3.09-17.91-10.5-4.32-4.94-9.27-9.88-14.21-12.35-5.56-3.09-10.5-2.47-13.59,1.24-.62.62,3.09,3.71,5.56,6.18c4.32,3.71,9.27,8.65,14.21,15.44c3.09,4.32,4.94,9.27,7.41,13.59c2.47,5.56,4.94,10.5,8.03,14.82c9.27,12.35,19.77,14.82,21,14.21c1.24,0,1.85.62,1.85,1.24c1.24,1.24,0,1.85-1.24,2.47.62,0,0,0,0,0v0Zm0-3.71v0Z"
            fill="#fff"
          />
          <path
            d="M991.87,471.65v0c0,0,0-.62,0,0c2.47-1.24,4.32-1.85,7.41-2.47h1.24-.62c-3.09,1.24-5.56,1.85-8.03,2.47v0Z"
            fill="#fff"
          />
          <path
            d="M1062.91,469.18h-.62c-1.85-.62-4.32-1.24-6.79-1.24v0c2.47,0,4.94.62,7.41,1.24v0c0-.62.62-.62,0,0c.62,0,0,0,0,0v0Z"
            fill="#fff"
          />
          <path
            d="M995.58,493.27v0c0,0,0-.62,0,0c2.47-1.24,4.94-1.85,8.65-2.47h.62c-3.71,1.24-6.79,1.85-9.27,2.47v0Z"
            fill="#fff"
          />
          <path
            d="M1059.2,490.18v0c-3.09-1.24-6.18-1.85-8.65-1.85h.62c1.85-.62,4.94-.62,8.03,1.85c0-.62.62-.62,0,0v0Z"
            fill="#fff"
          />
          <path
            d="M1027.7,462.38c-1.85,0-3.09,0-4.32-.62h.62c1.85.62,5.56.62,8.03,0h.62c-1.85.62-3.71.62-4.94.62Z"
            fill="#fff"
          />
          <path
            d="M1026.46,488.33c0,0-.62,0,0,0q-.62-.62,0,0c1.85-.62,3.71-1.24,4.94-1.24-2.47.62-5.56.62-8.03,0h.62c3.09.62,6.79.62,9.27-.62h.62c.62,0,0,0,0,0-.62-.62-3.09,1.85-7.41,1.85v0Z"
            fill="#fff"
          />
          <path
            d="M1000.52,518.59v0q0-.62,0,0c1.85-1.85,7.41-3.71,11.12-4.32h.62c-4.94,1.24-9.88,3.09-11.74,4.32v0Z"
            fill="#fff"
          />
          <path
            d="M1054.88,516.74c0,0-.62,0,0,0-3.71-1.85-6.18-2.47-9.88-3.09h.62c3.09.62,4.94,1.24,9.27,3.09c0-.62,0,0,0,0v0Z"
            fill="#fff"
          />
          <path
            d="M1033.88,512.42v0c-3.71-.62-5.56,0-7.41,0h-.62c2.47-.62,4.32-.62,8.03,0c0-.62.62,0,0,0c.62,0,0,0,0,0v0Z"
            fill="#fff"
          />
          <path
            d="M1062.29,524.15v0c-4.32-1.24-5.56-6.18-5.56-9.88c0-8.03,6.18-38.91,8.03-48.8c0-1.24.62-1.85.62-2.47.62-3.09,1.85-9.27,0-12.35-.62-.62-1.24-1.24-1.85-1.24-4.94-1.24-7.41,4.94-8.03,10.5-.62,3.09-1.85,7.41-2.47,11.74-1.85,8.65-4.32,18.53-6.18,26.56v.62c-1.24,7.41-3.09,14.82-7.41,14.82v0c-3.71,0-3.71-6.18-4.32-14.82v-1.24c-.62-6.18-1.24-37.06-1.85-46.94v-.62c-.62-7.41-1.24-11.74-5.56-11.74s-4.94,6.79-4.94,13.59v.62l-.62,57.44c0,.62-.62,1.24-1.24,1.24s-1.24-.62-1.24-1.24l.62-58.06c0-6.18,0-16.06,7.41-16.06s7.41,9.27,8.03,13.59v.62c0,9.27,1.24,40.15,1.24,46.33v1.24c.62,4.94.62,12.97,2.47,12.97v0c1.24,0,3.09-1.85,4.94-12.97v-.62c1.24-8.03,3.71-17.91,6.18-26.56c1.24-4.32,1.85-8.65,2.47-11.74.62-3.71,3.09-13.59,11.12-12.35c1.24,0,2.47,1.24,3.71,2.47c2.47,3.71,1.24,10.5.62,14.21c0,.62,0,1.24-.62,2.47-1.85,9.88-8.03,40.15-8.03,48.8c0,2.47,1.24,6.79,3.71,7.41.62,0,1.24.62.62,1.24-.62,1.24-1.24,1.24-1.85,1.24Z"
            fill="#fff"
          />
          <path
            d="M1104.91,505.62v0c-1.85-1.85-3.71-3.09-5.56-4.32h.62c1.85,1.24,3.71,2.47,4.94,3.71v.62v0c0,0,0,.62,0,0Z"
            fill="#fff"
          />
          <path
            d="M1090.08,527.24v0c-1.85-2.47-4.32-3.71-6.18-4.94h.62c1.24.62,3.71,2.47,5.56,4.94v0Z"
            fill="#fff"
          />
          <path
            d="M1080.82,490.18c-1.24-.62-2.47-1.24-3.09-1.85v-.62h.62c1.24,1.24,4.32,2.47,6.79,3.09h-.62c-1.24.62-2.47,0-3.71-.62v0Z"
            fill="#fff"
          />
          <path
            d="M1075.26,499.44c0,0-.62,0,0,0-.62,0,0-.62,0,0c1.85,0,3.71.62,4.32.62-2.47-.62-4.32-1.24-6.18-3.09h.62c2.47,1.85,4.94,3.09,8.03,3.09v0c-1.24.62-3.71,1.24-6.79-.62v0Z"
            fill="#fff"
          />
          <path
            d="M1090.7,542.06v0c-3.09-2.47-2.47-7.41-1.24-9.88c3.09-6.79,12.35-21,17.91-28.41.62-.62,1.24-1.24,1.24-1.85c1.85-2.47,4.94-6.79,4.32-9.88c0-.62-.62-1.24-1.24-1.85-3.71-2.47-7.41,1.24-10.5,5.56-1.85,2.47-8.03,11.12-10.5,14.82-4.94,6.18,0-.62-3.71,4.94v.62c-4.32,5.56-8.03,10.5-11.12,9.27v0c-2.47-1.24-.62-6.18,1.85-13.59l.62-1.24c1.85-4.94,8.03-19.77,11.12-27.18v0c2.47-6.18,3.09-9.88,0-11.74s-6.79,3.71-9.27,9.27v.62l-17.29,35.21c0,.62-.62.62-1.24.62s-.62-.62-.62-1.24l17.29-35.82c2.47-4.94,6.18-12.97,11.74-9.88s3.09,9.88,1.24,14.21v0c-3.09,7.41-9.27,22.24-11.12,27.18l-.62.62c-1.24,3.71-4.32,10.5-3.09,11.12v0c.62.62,3.09,0,8.65-8.65v-.62c4.32-6.18-1.24,1.24,3.71-4.94c2.47-3.09,8.65-12.35,10.5-14.82s7.41-9.88,13.59-6.18c1.24.62,1.85,1.85,1.85,3.09.62,3.71-3.09,8.65-4.94,11.12-.62.62-.62,1.24-1.24,1.85-4.94,8.03-14.21,22.24-17.29,28.41-1.24,1.85-1.85,5.56.62,7.41.62.62.62,1.24,0,1.24-.62.62-1.24.62-1.24.62v0Z"
            fill="#fff"
          />
          <path
            d="M998.05,545.15v0c-.62,0-1.24-.62-1.24-1.24v-15.44c-1.24-14.82-7.41-51.88-9.27-63v-.62c-.62-4.32-2.47-15.44,3.71-16.68c6.79-1.24,9.27,8.03,10.5,12.97v.62c.62,2.47,1.24,6.18,2.47,9.88c2.47,11.74,6.18,27.18,7.41,31.5c1.24,4.32,3.09,8.03,5.56,9.27c1.24.62,3.09,0,4.94-1.24.62,0,1.24,0,1.24.62.62.62,0,1.24-.62,1.24-2.47,1.24-4.94,1.85-6.79,1.24-3.71-1.24-4.94-5.56-6.79-10.5-1.85-4.32-4.94-20.38-8.03-32.12-1.24-4.32-1.85-7.41-2.47-9.88v-.62c-1.24-6.18-3.71-11.74-8.03-11.12s-3.09,10.5-2.47,14.21v.62c1.85,11.12,8.03,48.18,9.27,63c.62,3.71.62,10.5.62,15.44c1.24,1.24.62,1.85,0,1.85v0Z"
            fill="#fff"
          />
          <path
            d="M1080.82,636.57c-.62,0-1.24-.62-1.24-1.24l-1.24-27.8c-.62-11.74,2.47-17.29,5.56-23.47c1.24-2.47,2.47-4.94,3.71-8.65c3.09-8.03,3.09-12.97,3.71-19.77c0-1.85.62-4.94.62-7.41c0-.62.62-1.24,1.24-1.24s1.24.62,1.24,1.24c0,2.47-.62,4.94-.62,7.41-.62,6.79-.62,12.35-3.71,20.38-1.24,3.09-2.47,6.18-3.71,8.65-3.09,6.18-5.56,11.74-5.56,22.85l1.24,27.8c0,.62-.62,1.24-1.24,1.24v0Z"
            fill="#fff"
          />
          <path
            d="M1033.26,587.77v0c1.24-16.06-2.47-29.03-11.12-38.3v-.62c0-.62,0,0,.62,0c8.65,9.27,12.35,22.85,10.5,38.91.62,0,0,0,0,0Z"
            fill="#fff"
          />
          <path
            d="M1008.55,634.71v0c-.62,0-1.24-.62-1.24-1.24s4.94-27.8,1.24-36.44c0-.62,0-1.24.62-1.24s1.24,0,1.24.62c4.32,9.27-.62,35.82-1.24,37.68c0,0-.62.62-.62.62Z"
            fill="#fff"
          />
          <path
            d="M1011.64,597.04c-3.71,0-14.21-3.71-23.47-15.44-3.09-4.32-6.18-9.88-8.65-15.44-2.47-4.32-4.32-9.27-7.41-13.59-4.32-6.79-9.27-11.12-13.59-14.82-4.94-4.32-8.03-6.79-5.56-9.88c3.71-4.94,10.5-5.56,17.29-1.85c4.94,3.09,10.5,8.03,14.82,12.97c5.56,6.18,11.12,11.74,14.21,9.88.62,0,1.24,0,1.24.62.62.62,0,1.24-.62,1.24-4.32,3.09-10.5-3.09-17.29-10.5-4.32-4.94-9.88-9.88-14.21-12.35-5.56-3.09-11.74-2.47-14.21,1.24-1.24,1.24,1.85,3.71,5.56,6.79c3.71,3.71,9.27,8.65,13.59,15.44c2.47,4.32,4.94,9.27,7.41,13.59c2.47,5.56,4.94,10.5,8.65,14.82c9.27,12.97,20.38,14.82,21.62,14.82.62,0,1.24,0,1.24.62s0,1.24-.62,1.24v.62v0Z"
            fill="#fff"
          />
          <path
            d="M1240.79,514.89c-3.71-3.71-4.94-9.27-4.94-12.97c0-8.65,5.56-36.44,9.27-56.21c0-1.24.62-2.47.62-2.47c1.24-7.41,1.24-9.27.62-9.88c0,0,.62.62,1.24.62l2.47-12.35c3.09.62,5.56,2.47,6.79,4.94c3.71,5.56,2.47,12.97,1.24,19.77c0,.62-.62,1.24-.62,3.09-6.18,30.27-9.27,48.18-9.27,53.74c0,1.24.62,3.09,1.24,3.71l-8.65,8.03v0Z"
            fill="#fff"
          />
          <path
            d="M1221.03,506.86c-3.09,0-7.41-1.85-8.65-9.88-.62-3.09-.62-7.41-1.24-11.74v-1.24c-.62-7.41-1.24-42.62-1.85-53.12v-.62c0-6.18-1.24-8.03-1.24-8.65v0-12.35c12.97,0,13.59,14.82,13.59,20.38v.62c.62,21.62,1.24,46.94,1.85,52.5v1.24c.62,4.32.62,10.5,1.24,11.74c0-.62-1.85-1.85-3.71-1.85v12.97v0Zm-12.97-84.62v0Z"
            fill="#fff"
          />
          <path
            d="M1198.17,507.47c-1.24,0-3.09,0-4.32-.62-6.18-2.47-8.65-9.27-10.5-14.82-1.85-4.94-4.94-19.77-8.65-37.06-1.24-4.94-1.85-8.65-2.47-11.12v-.62c-1.24-6.18-2.47-8.65-3.09-8.65h.62l-2.47-12.35c12.97-2.47,16.06,12.97,17.29,17.91v.62c.62,2.47,1.24,6.79,2.47,11.74c2.47,12.35,6.79,30.88,8.65,35.21c1.24,4.32,2.47,6.79,3.71,7.41c0,0,.62,0,1.85-.62l5.56,11.12c-3.09,1.24-6.18,1.85-8.65,1.85v0Z"
            fill="#fff"
          />
          <path
            d="M1240.79,550.71v0c-.62,0-.62-.62,0,0l3.09-7.41c0,0,.62-1.85-3.09-3.71c0,0-.62,0,0-.62h.62c4.94,1.85,3.71,4.32,3.71,4.94l-4.32,6.79c.62,0,0,0,0,0Z"
            fill="#fff"
          />
          <path
            d="M1242.65,634.71c-.62,0-1.24-.62-1.24-1.24l-1.85-31.5c-.62-12.97,2.47-18.53,5.56-24.71c1.24-3.09,3.09-5.56,4.32-9.27c4.32-11.74,9.27-26.56,11.12-46.94.62-4.94-3.09-9.27-7.41-10.5-1.24-.62-6.18-1.85-8.65,2.47-.62,1.24-6.18,16.06-9.27,25.94-1.85,6.18-2.47,9.27-1.85,11.12c1.85,4.32,4.94,3.09,6.18,3.09c1.24-.62,4.94-4.94,7.41-10.5c1.85-3.71,4.94-9.88,7.41-16.06.62-1.24,1.24-1.85,2.47-1.85.62,0,1.24.62,1.24,1.24s-.62,1.24-1.24,1.24v0c-2.47,6.18-5.56,12.35-7.41,16.06-1.24,1.85-5.56,10.5-8.65,11.74s-7.41,0-9.27-4.32c-1.24-2.47-.62-5.56,1.85-12.35c3.09-9.88,9.27-25.94,9.27-25.94v0c1.85-4.32,6.79-5.56,11.74-3.71c4.94,1.85,10.5,6.79,9.27,12.97-1.85,16.06-4.94,30.27-11.74,47.56-1.24,3.71-3.09,6.79-4.32,9.88-3.09,6.18-5.56,11.12-5.56,23.47l1.85,31.5c0,0,0,.62-1.24.62v0Z"
            fill="#fff"
          />
          <path
            d="M1216.09,522.92c-2.47,0-4.94-6.18-4.94-6.79v-.62h.62c.62,2.47,2.47,6.18,4.32,6.18c2.47,0,9.88-4.94,9.88-4.94h.62v.62c-.62.62-8.03,4.94-10.5,5.56v0Z"
            fill="#fff"
          />
          <path
            d="M1196.32,595.8h-3.09c-8.03-1.24-12.97-1.24-19.15-15.44-3.71-8.65-7.41-23.47-8.03-27.8-1.24-6.18.62-11.12,4.94-16.68l.62-.62v0c.62-1.24,1.85-1.85,2.47-3.09c3.09-3.09,6.79-8.03,10.5-12.97c1.24-1.24,3.71-3.71,9.88-4.32c7.41,0,13.59-1.85,18.53-3.71c2.47-.62,4.32-1.24,6.79-1.85c1.24,0,2.47-.62,3.09-.62c1.24,0,3.09.62,4.32,1.85c1.85,1.24,2.47,3.71,2.47,4.94c0,3.71-3.09,8.65-7.41,11.74-1.85,1.24-3.71,3.09-6.79,4.32-4.94,2.47-9.88,3.09-14.21,1.85-.62,0-1.24-.62-1.24-1.24s.62-1.24,1.24-1.24c4.32.62,8.65,0,12.97-1.85c2.47-1.24,4.94-3.09,6.18-4.32c3.71-2.47,6.18-6.79,6.18-9.88c0-1.24-.62-1.85-1.85-3.09-1.24-1.24-1.85-1.24-2.47-1.24-1.24,0-1.85,0-3.09.62-1.85.62-4.32,1.24-6.79,1.85-5.56,1.85-11.74,3.71-19.15,3.71-4.94,0-7.41,2.47-8.03,3.09-3.71,4.94-8.03,9.88-10.5,12.97-1.24,1.24-1.85,1.85-2.47,3.09v0l-.62.62-.62.62c-3.71,4.94-5.56,9.27-4.32,14.82.62,4.32,4.32,18.53,8.03,27.18c5.56,12.97,9.27,13.59,17.29,14.21h2.47c.62,0,1.24.62,1.24,1.24c1.24.62.62.62.62,1.24v0Z"
            fill="#fff"
          />
          <path
            d="M1190.76,555.03q-.62,0-1.24-.62c-.62-.62,0-1.24.62-1.85c4.32-2.47,12.35-15.44,12.35-19.77c0-.62.62-1.24,1.24-1.24s1.24.62,1.24,1.24c0,5.56-8.65,19.15-14.21,22.24c0-.62,0,0,0,0v0Z"
            fill="#fff"
          />
          <path
            d="M1167.91,453.74v0q-.62-.62,0-.62c2.47-.62,4.94-1.24,8.03-1.85h1.24v.62h-.62c-3.71.62-6.18,1.24-8.65,1.85v0Z"
            fill="#fff"
          />
          <path
            d="M1248.21,450.65h-1.24c-2.47-.62-4.94-1.85-8.03-1.85h-.62.62c3.09,0,5.56.62,8.03,1.85h1.24c0-.62,0,0,0,0v0Z"
            fill="#fff"
          />
          <path
            d="M1172.23,478.44c0,0,0-.62,0,0q-.62-.62,0-.62c3.09-.62,6.79-1.85,9.88-2.47h.62v.62c-3.71.62-7.41,1.24-10.5,2.47v0Z"
            fill="#fff"
          />
          <path
            d="M1243.88,474.12v0c-3.71-1.24-7.41-1.85-9.27-2.47h-.62.62c1.85,0,5.56.62,9.27,2.47c0-.62,0,0,0,0v0Z"
            fill="#fff"
          />
          <path
            d="M1208.06,443.24c-1.85,0-3.71,0-4.94-.62v-.62h.62c1.85.62,6.18.62,9.27,0h.62v.62c-1.85.62-3.71.62-5.56.62Z"
            fill="#fff"
          />
          <path
            d="M1206.82,472.27c0,0-.62,0,0,0q-.62-.62,0,0c2.47-.62,4.32-1.24,5.56-1.85-3.09.62-6.18.62-8.65,0v-.62h.62c3.71,1.24,7.41.62,10.5-.62h.62v.62c-1.24,0-3.71,2.47-8.65,2.47v0Z"
            fill="#fff"
          />
          <path
            d="M1177.79,506.86c0,0-.62,0,0,0q-.62-.62,0,0c1.85-1.85,8.03-4.32,12.97-4.94h.62v.62c-5.56.62-11.74,3.09-13.59,4.32q0-.62,0,0v0Z"
            fill="#fff"
          />
          <path
            d="M1238.32,505v0c-4.32-1.85-6.79-2.47-11.12-3.09c0,0-.62,0,0-.62h.62c3.71,0,6.79,1.24,10.5,3.71q.62-.62,0,0q.62,0,0,0v0Z"
            fill="#fff"
          />
          <path
            d="M1215.47,500.06v0c-3.71-.62-6.18,0-8.65,0h-.62v-.62c1.85,0,4.94-.62,8.65,0q.62,0,.62.62v0Z"
            fill="#fff"
          />
          <path
            d="M1245.12,511.8q-.62,0-.62-.62c-2.47-2.47-3.09-6.18-3.09-9.27c0-9.27,6.79-43.85,9.27-55.59c0-1.24.62-2.47.62-3.09.62-3.71,1.85-10.5,0-13.59-.62-.62-1.24-1.24-2.47-1.24-5.56-1.24-8.03,6.18-9.27,12.35-.62,3.71-1.85,8.65-3.09,13.59-2.47,9.88-4.94,21-6.79,30.27v.62c-1.85,8.65-3.71,16.68-8.03,16.68v0c-3.71,0-4.32-7.41-4.94-16.68v-1.24c-.62-7.41-1.24-42-1.85-52.5v-.62c-.62-8.03-1.24-12.97-6.18-12.97s-6.18,7.41-6.18,14.82v.62l-.62,64.86c0,.62-.62,1.24-1.24,1.24v0c-.62,0-1.24-.62-1.24-1.24l.62-65.47c0-6.79,0-17.91,8.03-17.91s8.65,9.88,8.65,15.44v.62c.62,10.5,1.24,45.71,1.85,52.5v1.24c.62,5.56,1.24,14.21,2.47,14.21v0c1.24,0,3.09-1.85,5.56-14.82v-.62c1.85-9.27,4.32-20.38,6.79-30.27c1.24-4.94,2.47-9.88,3.09-13.59c1.24-4.32,3.71-15.44,12.35-14.21c1.85,0,3.09,1.24,3.71,2.47c2.47,3.71,1.24,11.74.62,15.44c0,.62-.62,1.24-.62,3.09-2.47,11.12-9.27,45.71-9.27,54.97c0,2.47.62,5.56,2.47,7.41.62.62.62,1.24,0,1.85.62,1.24,0,1.24-.62,1.24v0Z"
            fill="#fff"
          />
          <path
            d="M1174.7,532.8v0c-.62,0-1.24-.62-1.24-1.24v-13.59c-1.24-16.68-8.65-58.68-10.5-71.03v-.62c-1.24-4.94-3.09-17.29,4.32-18.53c8.03-1.85,10.5,9.27,11.74,14.21v.62c.62,2.47,1.24,6.79,2.47,11.12c3.09,12.97,6.79,30.88,8.65,35.82s3.71,9.27,6.18,10.5c1.24.62,3.71,0,6.18-1.24.62,0,1.24,0,1.85.62.62.62,0,1.24-.62,1.85-3.09,1.85-5.56,1.85-8.03,1.24-3.71-1.24-5.56-6.18-8.03-11.74-1.85-4.94-5.56-22.85-8.65-36.44-1.24-4.94-1.85-8.65-2.47-11.12v-.62c-1.85-6.79-3.71-13.59-8.65-12.35s-3.09,11.74-2.47,15.44v.62c1.85,12.35,9.27,54.35,10.5,71.03.62,4.32.62,8.65,0,14.21c0,.62-.62,1.24-1.24,1.24Z"
            fill="#fff"
          />
          <path
            d="M1214.85,584.68v0c0,0-.62,0,0,0c1.24-15.44-1.24-27.8-8.03-37.68v-.62h.62c6.79,10.5,9.27,22.85,7.41,38.3v0Z"
            fill="#fff"
          />
          <path
            d="M1186.44,646.45v0c-.62,0-1.24-.62-1.24-1.24s5.56-40.15,1.24-49.41c-.62-.62,0-1.24.62-1.85s1.24,0,1.85.62c4.94,10.5-1.24,49.41-1.24,51.27c0,0-.62.62-1.24.62v0Z"
            fill="#fff"
          />
          <polygon
            points="710.83,663.13 705.28,657.57 714.54,648.92 702.19,637.8 714.54,626.68 702.19,614.95 714.54,603.83 702.19,592.71 717.63,578.51 723.19,584.07 713.92,592.71 726.28,603.83 713.92,614.95 726.28,626.68 713.92,637.8 726.28,648.92 710.83,663.13"
            fill="#fff"
          />
          <path
            d="M726.89,540.21v0c0,0-.62,0,0,0l1.85-9.27c0,0,0-3.09-4.94-3.09c0,0-.62,0-.62-.62c0,0,0-.62.62-.62c6.18.62,5.56,4.32,5.56,4.32l-2.47,9.27c.62,0,0,0,0,0v0Z"
            fill="#fff"
          />
          <path
            d="M741.72,625.45c-.62,0-1.24-.62-1.24-1.24l-1.24-33.35c-.62-13.59,2.47-19.15,6.18-25.94c1.24-3.09,3.09-6.18,4.32-9.88c4.32-12.35,9.27-27.8,11.74-49.41.62-4.94-3.09-9.27-7.41-10.5-1.24-.62-6.18-1.85-8.65,3.09-.62,1.85-6.79,21.62-9.88,30.88v.62c-.62,1.85-1.24,4.94-1.24,6.18.62,1.24,1.24,2.47,2.47,3.09c1.85.62,3.71.62,4.94,0c0,0,3.09-1.85,13.59-28.41v-.62c.62-1.24,1.85-1.85,3.09-1.85.62,0,1.24.62,1.24,1.24s-.62,1.24-1.24,1.24v0v.62c-11.12,28.41-13.59,29.03-14.82,29.65-2.47.62-4.94.62-6.79-.62s-3.09-2.47-3.71-4.94c-.62-1.85,0-4.32,1.24-8.03v-.62c3.09-9.88,9.88-30.88,9.88-31.5v0c2.47-4.32,6.79-6.18,11.74-4.32s9.88,6.79,9.27,13.59c-1.85,17.29-5.56,32.12-12.35,49.41-1.24,4.32-3.09,7.41-4.94,10.5-3.71,6.79-6.18,11.74-5.56,24.71l1.85,33.35c-.62,1.85-1.24,2.47-2.47,3.09v0Z"
            transform="translate(.000001 0)"
            fill="#fff"
          />
          <path
            d="M741.72,625.45c-.62,0-1.24-.62-1.24-1.24l-1.24-33.35c-.62-13.59,2.47-19.15,6.18-25.94c1.24-3.09,3.09-6.18,4.32-9.88c4.32-12.35,9.27-27.8,11.74-49.41.62-4.94-3.09-9.27-7.41-10.5-1.24-.62-6.18-1.85-8.65,3.09c0,.62-1.24.62-1.85.62s-.62-1.24-.62-1.85c2.47-4.32,6.79-6.18,11.74-4.32s9.88,6.79,9.27,13.59c-1.85,17.29-5.56,32.12-12.35,49.41-1.24,4.32-3.09,7.41-4.94,10.5-3.71,6.79-6.18,11.74-5.56,24.71l1.85,33.35c.62,0,0,.62-1.24,1.24v0Z"
            fill="#fff"
          />
          <path
            d="M712.07,572.95v0c0,0-.62-.62,0,0c1.24-16.06-1.24-29.03-8.65-39.53v-.62c0-.62,0,0,.62,0c7.41,10.5,9.88,24.09,8.03,40.15.62,0,0,0,0,0v0Z"
            fill="#fff"
          />
          <path
            d="M741.72,537.12v0l2.47-8.03c0,0,.62-2.47-3.71-3.09c0,0-.62,0,0-.62c0,0,0-.62.62,0c5.56,1.24,4.94,4.32,4.32,4.32l-3.71,7.41q.62,0,0,0v0Z"
            fill="#fff"
          />
          <path
            d="M713.92,507.47c-3.09,0-4.94-6.18-4.94-6.79v-.62h.62c.62,2.47,3.09,6.18,4.32,6.18c2.47,0,10.5-4.94,10.5-4.94h.62v.62c-.62.62-8.03,5.56-11.12,5.56v0Z"
            fill="#fff"
          />
          <path
            d="M675.63,432.12c0,0-.62,0,0,0-.62-.62,0-.62,0-.62c3.09,0,5.56-.62,9.27-.62h1.24l-.62.62h-.62c-3.71.62-6.79.62-9.27.62v0Z"
            fill="#fff"
          />
          <path
            d="M675.01,457.44v0c-.62-.62,0-.62,0-.62c3.09-.62,6.79-.62,10.5-1.24h.62l-.62.62c-3.09.62-6.79,1.24-10.5,1.24v0Z"
            fill="#fff"
          />
          <path
            d="M676.86,489.56c0,0-.62,0,0,0-.62,0-.62-.62,0,0c2.47-1.85,9.27-3.09,13.59-3.09h.62-.62c-4.94.62-11.74,2.47-13.59,3.09v0Z"
            fill="#fff"
          />
          <path
            d="M670.69,517.97c-.62,0-1.24-.62-1.24-1.24c0-3.09.62-9.88.62-16.06.62-4.94.62-9.88.62-11.74c0-9.88-.62-43.85,0-59.91v-1.24c0-6.79.62-21.62,9.27-21.62c8.03,0,8.65,11.74,9.27,17.91v1.24c.62,11.74,3.09,43.24,4.94,50.03c1.24,8.03,3.09,9.88,8.65,10.5.62,0,1.24.62,1.24,1.24s-.62,1.24-1.24,1.24c-7.41,0-9.27-4.32-11.12-12.35-1.85-6.79-4.32-38.3-4.94-50.03v-1.24c0-5.56-.62-15.44-6.18-15.44s-6.18,13.59-6.18,19.15v1.24c-.62,16.06,0,49.41,0,59.91c0,1.85,0,6.18-.62,11.74-.62,6.18-.62,12.35-.62,15.44-1.24.62-1.85,1.24-2.47,1.24v0Z"
            fill="#fff"
          />
          <path
            d="M683.66,626.07v0c-.62,0-1.24-.62-1.24-1.24s4.94-30.88.62-40.77c-.62-.62,0-1.24.62-1.85s1.24,0,1.85.62c4.94,11.12,0,40.77-.62,42.62c0,0-.62.62-1.24.62v0Z"
            fill="#fff"
          />
          <path
            d="M745.42,494.5c-1.24,4.32-3.71,12.35-5.56,19.77-1.24,4.94-2.47,9.27-3.71,13.59-3.71,13.59-7.41,18.53-12.35,18.53h-2.47c-5.56-1.24-7.41-6.18-6.18-14.82v0c0-.62,1.24-11.12,2.47-17.29.62,0,1.24-.62,1.24-1.24.62,0,.62-.62,1.24-1.24v.62c-1.85,16.06-2.47,18.53-2.47,19.15v0c-1.24,9.27,1.85,11.12,4.32,11.74c3.71.62,6.18,0,11.12-16.68c1.24-3.71,2.47-8.65,3.71-13.59c2.47-8.03,4.32-16.06,6.18-19.77c1.24-4.32,2.47-8.03,1.85-10.5c0-1.24-1.85-3.09-4.32-4.32-3.71-2.47-9.27-3.09-11.74-2.47-3.71,1.24-3.71,3.09-5.56,14.82h-2.47c1.85-12.35,2.47-15.44,7.41-17.29c3.71-1.24,9.88,0,14.21,2.47c2.47,1.24,4.94,3.09,5.56,6.18c0,4.32-1.24,9.27-2.47,12.35v0Z"
            fill="#fff"
          />
          <path
            d="M713.3,528.48c0,0-.62,0,0,0l-.62-9.88c0,0-.62-2.47-5.56-1.85c0,0-.62,0-.62-.62c0,0,0-.62.62-.62c6.18-1.24,6.79,2.47,6.79,2.47l-.62,10.5c.62-.62,0,0,0,0v0Z"
            fill="#fff"
          />
          <path
            d="M703.42,524.77v0c0,0-.62-.62,0,0l-.62-6.18c0,0,.62-3.71,6.79-2.47c0,0,.62,0,.62.62s0,.62-.62.62c-4.94-1.24-5.56,1.85-5.56,1.85l-.62,5.56q.62-.62,0,0v0Z"
            fill="#fff"
          />
          <path
            d="M716.39,511.8c1.24-.62,1.85-1.24,3.09-1.85c0,1.24,0,2.47-.62,3.71c0,2.47-.62,4.32-.62,6.79-.62,14.82-7.41,16.68-9.88,16.68-4.32,0-9.27-3.71-9.88-12.35c0-.62.62-1.24,1.24-1.24s1.24.62,1.24,1.24c.62,6.79,4.32,10.5,7.41,10.5c4.32,0,6.79-5.56,7.41-14.82v-4.32c.62-2.47.62-3.09.62-4.32v0Z"
            fill="#fff"
          />
          <path
            d="M722.57,479.68v.62c-.62,4.32-.62,7.41-1.24,10.5v2.47c-.62,0-1.24,0-2.47.62h-.62v-3.09c.62-3.09.62-7.41,1.24-11.12v-.62c.62-4.94,1.24-10.5-2.47-12.97-3.09-2.47-12.35-2.47-16.06,0-3.09,2.47-2.47,8.03-1.85,12.97v3.71c0,.62-.62,1.24-1.24,1.24s-1.24-.62-1.24-1.24v-3.71c-.62-5.56-1.24-11.74,3.09-15.44c3.71-3.09,15.44-3.71,19.15-.62c4.94,4.94,4.32,11.74,3.71,16.68v0Z"
            fill="#fff"
          />
          <path
            d="M663.89,427.8c-.62,0-1.85,0-2.47-.62-1.24-1.24-1.24-3.09,0-4.94l7.41-7.41c1.24-1.24,3.09-1.24,4.94,0s1.24,3.09,0,4.94l-7.41,7.41c-.62.62-1.85.62-2.47.62v0Zm24.71-24.71c-.62,0-1.85,0-2.47-.62-1.24-1.24-1.24-3.09,0-4.94l7.41-7.41c1.24-1.24,3.09-1.24,4.94,0s1.24,3.09,0,4.94l-7.41,7.41c-.62.62-1.85.62-2.47.62v0Z"
            fill="#fff"
          />
          <path
            d="M696.63,427.8c-.62,0-1.85,0-2.47-.62l-7.41-7.41c-1.24-1.24-1.24-3.09,0-4.94s3.09-1.24,4.94,0l7.41,7.41c1.24,1.24,1.24,3.09,0,4.94-.62.62-1.85.62-2.47.62v0Zm-24.71-24.71c-.62,0-1.85,0-2.47-.62l-7.41-7.41c-1.24-1.24-1.24-3.09,0-4.94s3.09-1.24,4.94,0l7.41,7.41c1.24,1.24,1.24,3.09,0,4.94-.62.62-1.85.62-2.47.62v0Z"
            fill="#fff"
          />
          <path
            d="M696.63,427.8c-.62,0-1.85,0-2.47-.62l-7.41-7.41c-1.24-1.24-1.24-3.09,0-4.94s3.09-1.24,4.94,0l7.41,7.41c1.24,1.24,1.24,3.09,0,4.94-.62.62-1.85.62-2.47.62v0Zm-24.71-24.71c-.62,0-1.85,0-2.47-.62l-7.41-7.41c-1.24-1.24-1.24-3.09,0-4.94s3.09-1.24,4.94,0l7.41,7.41c1.24,1.24,1.24,3.09,0,4.94-.62.62-1.85.62-2.47.62v0Z"
            fill="#fff"
          />
          <path
            d="M702.8,411.74h-10.5c-1.85,0-3.09-1.24-3.09-3.09s1.24-3.09,3.09-3.09h10.5c1.85,0,3.09,1.24,3.09,3.09s-1.24,3.09-3.09,3.09Zm-35.21,0h-10.5c-1.85,0-3.09-1.24-3.09-3.09s1.24-3.09,3.09-3.09h10.5c1.85,0,3.09,1.24,3.09,3.09s-1.24,3.09-3.09,3.09Z"
            fill="#fff"
          />
          <path
            d="M679.95,434.59c-1.85,0-3.09-1.24-3.09-3.09v-10.5c0-1.85,1.24-3.09,3.09-3.09s3.09,1.24,3.09,3.09v10.5c.62,1.85-1.24,3.09-3.09,3.09Zm0-34.59c-1.85,0-3.09-1.24-3.09-3.09v-10.5c0-1.85,1.24-3.09,3.09-3.09s3.09,1.24,3.09,3.09v10.5c.62,1.24-1.24,3.09-3.09,3.09Z"
            fill="#fff"
          />
          <path
            d="M679.95,434.59c-1.85,0-3.09-1.24-3.09-3.09v-10.5c0-1.85,1.24-3.09,3.09-3.09s3.09,1.24,3.09,3.09v10.5c.62,1.85-1.24,3.09-3.09,3.09Zm0-34.59c-1.85,0-3.09-1.24-3.09-3.09v-10.5c0-1.85,1.24-3.09,3.09-3.09s3.09,1.24,3.09,3.09v10.5c.62,1.24-1.24,3.09-3.09,3.09Z"
            fill="#fff"
          />
          <path
            d="M729.36,498.83c0,3.71-3.09,9.27-7.41,12.35-.62,0-.62.62-1.24.62s-.62.62-1.24,1.24c-.62,0-.62.62-1.24,1.24-.62,0-.62.62-1.24.62-.62.62-1.24.62-1.85,1.24-4.94,2.47-9.88,3.09-15.44,2.47-.62,0-1.24-.62-1.24-1.24s.62-1.24,1.24-1.24c4.32.62,9.27,0,13.59-1.85c1.24-.62,2.47-1.24,3.09-1.85c1.24-.62,1.85-1.24,3.09-1.85l.62-.62c3.71-3.09,6.18-7.41,6.79-10.5c0-1.24-.62-2.47-1.85-3.09-.62-.62-1.24-1.24-1.85-1.24h-1.24c-.62,0-1.24,0-1.85.62h-.62c-1.85.62-4.32,1.24-6.18,1.85-5.56,1.85-12.35,3.71-20.38,3.71-5.56,0-8.03,2.47-8.03,3.09-4.32,5.56-8.03,10.5-11.12,13.59-1.24,1.24-1.85,1.85-2.47,3.09v0l-.62.62c0,0-.62.62-.62,1.24-4.32,4.94-5.56,9.88-4.94,15.44.62,4.32,4.32,19.77,8.65,29.03c6.18,13.59,9.88,14.21,17.91,14.82h3.09c.62,0,1.24.62,1.24,1.24s-.62,1.24-1.24,1.24h-3.09c-8.65-1.24-13.59-1.24-19.77-16.68-3.71-9.27-8.03-24.71-8.65-29.65-1.24-6.18.62-12.35,4.94-17.91l.62-.62v0c.62-1.24,1.85-1.85,3.09-3.71c3.09-3.71,6.79-8.65,11.12-13.59c1.24-1.24,3.71-4.32,10.5-4.32c7.41,0,14.21-1.85,19.77-3.71c2.47-.62,4.94-1.24,6.79-1.85h.62c.62,0,1.24,0,1.85-.62h2.47c1.24,0,1.85,1.24,3.09,1.85c0,1.24,1.24,3.09,1.24,4.94v0Z"
            fill="#fff"
          />
          <path
            d="M687.36,541.45q-.62,0-1.24-.62c-.62-.62,0-1.24.62-1.85c4.94-2.47,12.97-16.06,12.97-21c0-.62.62-1.24,1.24-1.24s1.24.62,1.24,1.24c0,5.56-8.65,20.38-14.82,23.47v0Z"
            fill="#fff"
          />
          <path
            d="M900.46,550.71h-.62c-1.85-.62-3.09-1.85-2.47-3.71c1.24-6.18,4.94-16.68,8.03-23.47-.62,0-1.24.62-2.47.62-3.71,1.24-9.27,9.88-11.74,15.44l-.62,1.24-1.85.62c-8.65,4.32-15.44,8.03-21.62,7.41-1.85,0-3.09-1.85-2.47-3.71c0-1.85,1.85-3.09,3.71-2.47c3.71.62,9.88-2.47,17.29-6.18c1.85-3.71,8.03-14.82,14.82-17.29c4.32-1.85,7.41-1.85,9.88-.62c1.85,1.24,2.47,2.47,3.09,3.09l.62,1.24-.62,1.24c-3.09,5.56-7.41,19.15-8.65,25.32-1.24,0-2.47,1.24-4.32,1.24v0Z"
            fill="#fff"
          />
          <path
            d="M908.49,522.3c-8.03,0-12.97-6.18-16.06-10.5-.62-.62-1.24-1.85-1.85-1.85-4.94-4.32-15.44-7.41-17.91-7.41-1.85,0-3.09-1.24-3.09-3.09s1.24-3.09,3.09-3.09c4.32,0,16.68,3.71,22.24,9.27.62.62,1.85,1.85,2.47,3.09c2.47,3.09,5.56,6.79,9.88,7.41-3.09-6.18-6.18-13.59-6.79-15.44-.62-1.24-1.24-2.47-2.47-3.09-1.24-1.24-1.85-3.09-.62-4.32s3.09-1.85,4.32-.62c1.85,1.24,3.71,3.71,4.94,6.18v0c.62,1.24,3.09,7.41,7.41,16.68.62,1.85.62,3.71,0,4.94s-2.47,2.47-4.32,2.47c-.62-.62-1.24-.62-1.24-.62v0Z"
            fill="#fff"
          />
          <path
            d="M883.78,532.8c-1.24,0-2.47-.62-3.09-1.85-1.85-3.09-3.09-6.79-3.09-10.5s.62-7.41,1.85-11.12c.62-1.85,3.09-3.09,4.94-1.85s3.09,3.09,1.85,4.94c-1.24,2.47-1.24,4.94-1.24,8.03c0,2.47,1.24,4.94,2.47,7.41c1.24,1.85,0,4.32-1.24,4.94h-2.47Z"
            fill="#fff"
          />
          <path
            d="M904.16,534.65c0,0-.62,0,0,0c0,0-1.85-1.24-3.09-1.85q-.62,0-.62-.62c-.62-1.85,1.85-5.56,4.94-9.27h.62c.62,0,0,0,0,.62-4.32,4.32-5.56,7.41-4.94,8.65v0c1.24.62,3.09,1.85,3.09,2.47c0-.62,0,0,0,0v0Z"
            fill="#fff"
          />
          <path
            d="M906.64,516.12c0,0-.62,0,0,0-.62-.62-5.56-7.41-1.85-11.12h.62c.62,0,0,0,0,.62-3.71,3.09,1.24,9.88,1.24,10.5c0-.62,0,0,0,0v0Z"
            fill="#fff"
          />
          <path
            d="M889.96,506.86v0c1.24-3.09,2.47-4.94,3.71-6.18h.62v.62c-1.24.62-2.47,3.09-4.32,5.56.62,0,0,0,0,0v0Z"
            fill="#fff"
          />
          <path
            d="M821.4,634.71c0,0-.62,0,0,0-1.24-.62-1.24-1.24-1.24-1.85c1.85-4.94,3.71-9.88,5.56-14.82c4.32-11.12,8.03-21.62,13.59-27.8c3.09-3.71,9.27-6.79,17.29-11.12c11.12-5.56,24.71-12.97,38.3-25.32c2.47-2.47,4.32-4.32,4.94-6.79c1.24-6.79,5.56-19.77,8.65-25.94-.62-.62-2.47-.62-6.79.62-4.94,1.85-11.12,12.35-12.97,16.06v.62l-1.24.62c-8.65,4.32-15.44,7.41-20.38,6.79-3.71-.62-14.82-8.65-18.53-15.44c0-.62,0-1.24.62-1.85.62,0,1.24,0,1.85.62c3.09,6.18,13.59,13.59,16.68,14.21c4.94.62,11.12-2.47,19.15-6.79v0c1.24-2.47,7.41-14.21,14.21-16.68c3.71-1.24,6.18-1.85,8.03-.62c1.24.62,1.85,1.85,1.85,1.85v1.24c-3.09,6.18-7.41,19.15-9.27,25.94-.62,3.71-3.71,6.18-5.56,8.03-14.21,12.35-27.8,19.77-38.3,25.32-7.41,3.71-13.59,6.79-16.68,10.5-4.94,5.56-9.27,16.06-12.97,27.18-1.85,4.94-3.71,10.5-5.56,14.82-.62,0-1.24.62-1.24.62v0Z"
            fill="#fff"
          />
          <path
            d="M811.51,540.21c0,0-.62,0,0,0-1.24,0-1.24-1.24-1.24-1.85l9.88-29.03v-.62c1.24-3.71,4.32-9.88,12.97-13.59c1.85-.62,3.71-1.85,6.18-3.09c8.03-3.71,19.77-9.27,31.5-12.97c3.71-1.24,8.03,0,11.74,2.47l17.91,11.74c1.85,1.24,3.09,3.09,4.32,4.94.62,2.47,5.56,12.35,7.41,17.29.62,1.24.62,2.47,0,3.09-.62,1.24-1.85,1.24-2.47,1.85-7.41.62-12.35-5.56-15.44-9.27-.62-1.24-1.24-1.85-1.85-2.47-4.94-4.94-16.68-8.03-19.15-8.03-1.85,0-8.03,5.56-12.35,9.88-1.85,1.85-4.32,3.71-6.18,5.56-3.09,3.09-4.94,8.65-3.09,12.97c0,.62,0,1.24-.62,1.85-.62,0-1.24,0-1.85-.62-3.09-5.56-.62-12.35,3.71-16.06c1.85-1.85,3.71-3.71,6.18-5.56c6.79-6.18,11.12-10.5,14.21-10.5c3.71,0,15.44,3.71,21,8.65l2.47,2.47c2.47,3.71,6.79,8.65,12.97,8.65c0,0,.62,0,.62-.62v-.62c-2.47-5.56-6.79-14.82-7.41-17.29-.62-1.24-1.85-3.09-3.09-3.71l-17.91-11.74c-3.09-1.85-6.79-3.09-9.27-1.85-11.74,3.09-23.47,9.27-30.88,12.97-2.47,1.24-4.32,2.47-6.18,3.09-8.03,3.71-9.88,8.65-11.74,12.35v.62l-9.88,29.03q-1.85,0-2.47,0v0Z"
            fill="#fff"
          />
          <path
            d="M872.66,499.44c0,0-.62,0,0,0-1.85-2.47-1.24-6.18-.62-9.27h.62v.62c-1.24,2.47-1.24,6.18,0,8.65v0Z"
            fill="#fff"
          />
        </g>
      </g>
      <g id="exIqo09Fmte163" opacity="0">
        <g>
          <g>
            <path
              d="M1206.74,423.78c2.89-2.17,5.06-2.89,5.06-3.61c0,0,2.17,0,5.06.72s6.5,1.45,9.39,2.17s5.06,1.45,6.5,2.17c1.45.72,2.89,1.45,3.61,2.17s2.17,1.45,2.89,2.17s1.45,1.45,1.45,2.17-.72,1.45-2.17,2.89-2.17,2.89-2.89,3.61-1.45,1.45-2.17,2.17-.72,1.45-.72,1.45v2.17c0,.72-1.45,2.17-3.61,5.06-2.89,2.89-5.06,5.78-7.95,7.95s-5.06,5.06-7.95,7.95-3.61,4.34-3.61,4.34s1.45.72,3.61,1.45s5.06,1.45,6.5,2.17s4.34,1.45,6.5,3.61c2.17,1.45,3.61,2.89,3.61,3.61s.72,1.45.72,2.17s0,.72-.72,1.45-1.45,1.45-2.89,2.17-2.89,1.45-3.61,2.17-2.89,1.45-5.06,3.61c-2.89,1.45-5.06,3.61-6.5,5.06s-4.34,3.61-6.5,5.06-4.34,3.61-6.5,5.06-3.61,2.89-5.06,3.61c-.72,0-3.61,1.45-7.23,4.34-3.61,2.89-6.5,4.34-7.23,5.06-.72.72-.72,1.45.72,2.17c1.45,0,2.89.72,2.89.72s.72,0,2.17.72c.72,0,2.17.72,2.89.72s2.17.72,3.61.72s2.89.72,3.61.72s2.17,0,5.06-.72c2.89,0,5.06-.72,6.5-.72s3.61,0,6.5-.72c2.89,0,5.06-.72,6.5-.72s3.61-.72,6.5-.72s5.78,0,8.67-.72s3.61-1.45,3.61-2.17v-2.17c0-.72-.72-1.45-2.89-2.17s-3.61-1.45-5.78-1.45-5.78-.72-12.28-1.45c-6.5-.72-8.67-1.45-6.5-3.61c2.17-1.45,6.5-2.17,13.01-2.17s11.56.72,14.45.72s5.06.72,6.5.72s5.06.72,10.12,2.17c5.06.72,7.95,1.45,8.67,2.17.72,0,2.17.72,4.34.72h7.95l8.67.72c5.06,5.06,10.12,9.39,14.45,13.73s7.23,6.5,8.67,8.67c1.45,1.45,2.17,2.89,2.89,4.34s1.45,2.89,2.17,5.06c-1.45,2.17-2.89,3.61-3.61,4.34s-2.89,1.45-5.78,1.45-5.06-.72-6.5-1.45c-2.17-.72-3.61-2.17-5.06-2.89s-4.34-1.45-8.67-2.17c-4.34,0-9.39-.72-16.62-.72h-14.45c-2.89,0-5.06,0-7.23-.72-2.17,0-3.61-.72-5.06-.72-.72,0-2.17-.72-3.61-.72s-2.89,0-5.06-.72-4.34-.72-5.06-.72h-4.34c-1.45,0-2.89,0-5.06-.72-1.45,0-2.89-.72-2.89-.72s-.72,0-.72-.72h-.72c-.72,0-.72,1.45-.72,2.17s0,2.89-.72,5.06-.72,4.34-2.17,7.23c-.72,2.17-2.89,5.06-5.06,7.23s-5.06,5.06-7.23,7.95-2.17,6.5-2.17,6.5s1.45.72,3.61.72s4.34.72,6.5.72s3.61.72,5.06,2.17c1.45.72,2.89,2.17,3.61,3.61s1.45,2.89,2.17,4.34s1.45,2.89,1.45,3.61s0,2.17-.72,3.61-1.45,2.17-2.17,3.61c-.72.72-.72,1.45-.72,2.17s-.72.72,0,.72.72,0,.72.72h3.61c2.17,0,5.78-.72,10.12-1.45s8.67-1.45,11.56-2.17s6.5,0,9.39.72s6.5,2.89,8.67,5.06s3.61,4.34,5.78,6.5s2.89,3.61,2.17,3.61c-.72.72-3.61,1.45-8.67,1.45s-8.67.72-10.12.72-4.34.72-6.5.72-4.34,0-5.06.72c-.72,0-1.45.72-2.89.72s-2.17.72-2.17.72q-.72,0-2.17-.72c-.72,0-1.45-.72-2.17-.72s-1.45,0-2.17-.72c-.72,0-1.45-.72-2.17-.72h-2.17c-1.45,0-3.61.72-6.5,2.17s-6.5,2.89-9.39,4.34-5.06,2.89-6.5,2.89-2.17.72-3.61,1.45c-.72.72-1.45.72-2.17.72h-1.45c-.72,0-1.45-.72-2.17-2.17s-.72,0-.72-2.17s0-3.61-.72-3.61-.72-1.45-.72-2.89s0-2.17-.72-2.89-.72-2.17-1.45-3.61-.72-3.61-.72-3.61s1.45-2.17,3.61-3.61c2.17-2.17,3.61-3.61,4.34-4.34s2.17-2.89,3.61-5.06c-.72-.72-1.45-1.45-2.17-1.45s-2.89-2.17-4.34-2.17h-8.67c-3.61,0-5.78,0-5.78-.72-.72,0-.72-1.45-1.45-4.34s-1.45-5.78-2.17-8.67c1.45-2.89,2.17-4.34,2.17-4.34l2.17-2.17c1.45,0,4.34-4.34,9.39-13.01c5.06-8.67,7.23-13.01,7.23-14.45v-2.89c0,0-.72-.72-1.45-1.45-.72-.72-2.17-.72-3.61-.72h-2.17c0,0-1.45,0-2.89-.72-1.45,0-2.89-.72-3.61-1.45-.72-.72-2.17-1.45-3.61-2.17s-2.89-1.45-5.78-2.17c-1.45,0-2.89.72-5.06,2.89s-2.89,2.89-2.89,3.61v.72c0,0-.72,1.45-1.45,3.61l-2.89,5.78c-.72,2.17-2.17,4.34-3.61,7.95s-2.89,5.06-2.89,6.5-.72,1.45-.72,2.17s0,1.45.72,2.17v2.17c-.72.72-1.45,2.89-2.17,5.06-1.45,2.17-2.17,4.34-3.61,5.78-.72,1.45-1.45,3.61-2.17,5.06s-.72,2.89-.72,3.61s0,1.45-.72,2.89-2.17,4.34-5.06,8.67-5.78,7.23-8.67,9.39c-2.17,2.17-4.34,4.34-6.5,7.23s-5.06,4.34-7.23,5.78c-2.89,1.45-4.34,2.17-5.06,2.17s-2.17-.72-3.61-.72-2.17-1.45-2.89-3.61-.72-4.34,0-5.06s1.45-2.17,2.17-2.89.72-1.45.72-1.45s0-1.45-.72-2.89-.72-2.89-.72-3.61-1.45-1.45-1.45-3.61-.72-2.89-.72-4.34l-.72-5.06c2.89,0,4.34,0,5.06.72.72,0,1.45.72,2.17.72s1.45-.72,2.17-2.17c1.45-1.45,2.89-3.61,5.06-5.78s5.06-5.78,8.67-10.84s7.23-10.84,11.56-17.34c3.61-7.23,7.23-12.28,9.39-17.34c2.89-4.34,4.34-7.23,4.34-7.95s0-2.17-.72-3.61-1.45-3.61-2.17-4.34-1.45-2.17-1.45-2.89c-.72-.72-.72-1.45-.72-2.17v-2.17c0-.72.72-2.17,1.45-3.61s2.17-2.89,3.61-3.61s2.17-1.45,3.61-1.45c.72,0,3.61-2.89,8.67-7.95c4.34-5.06,7.23-7.95,8.67-9.39s2.17-2.89,2.89-4.34c-.72-1.45-1.45-2.17-1.45-2.17s-.72,0-1.45-.72c-.72,0-2.89-2.17-7.23-7.23s-7.23-7.95-8.67-9.39-2.89-4.34-5.06-7.23c-2.17-3.61-3.61-6.5-5.06-9.39s-.72-5.06,0-7.23c.72-1.45,1.45-2.89,2.17-3.61s1.45-1.45,2.17-2.17q.72,0,.72.72v3.61c0,1.45,1.45,4.34,5.06,8.67s5.78,6.5,6.5,6.5h2.17c0,0,.72,0,1.45-.72.72,0,1.45-.72,1.45-1.45s.72-1.45,2.17-2.17c.72-.72,4.34-2.89,9.39-7.23c5.78-4.34,9.39-7.23,10.84-7.95s2.89-1.45,3.61-2.17s1.45-1.45,2.89-2.17c1.45-.72,2.17-1.45,3.61-2.17.72-.72,2.17-1.45,2.89-1.45s2.17-.72,3.61-2.17c1.45,0,2.89-.72,4.34-.72v0Zm-19.51,67.92v-.72h-.72q-.72,0-.72.72t-.72.72c-.72,0,0,.72.72.72h.72c0,0,.72-.72.72-1.45v0Zm15.17-12.28c-.72-2.17-2.17-2.17-4.34-.72s-2.89,2.17-2.89,3.61c0,.72.72,1.45.72,2.17l.72.72c0,0,0,.72.72.72h.72c0,0,1.45-.72,2.89-2.17c1.45-2.89,2.17-3.61,1.45-4.34v0Z"
              fill="#fff"
            />
            <path
              d="M640.94,418.72c8.67-2.17,15.17-2.17,18.07,0c3.61,2.17,6.5,5.06,8.67,9.39c2.17,4.34,3.61,7.23,4.34,8.67s.72,2.89,1.45,4.34c0,1.45.72,2.89.72,3.61s0,2.89.72,4.34c0,2.17.72,3.61,1.45,4.34s1.45,1.45,2.89,1.45h2.89c.72,0,1.45,0,2.17.72.72,0,1.45.72,2.17.72s.72.72,1.45,1.45s1.45,1.45,2.17,2.17s2.17,1.45,2.89,1.45s2.17.72,3.61,1.45c1.45.72,2.17,1.45,3.61,2.17s.72,1.45.72,2.17c-.72,0-.72.72-1.45.72c0,0-.72.72-1.45,2.17-.72.72-1.45,2.17-2.17,3.61-.72,1.45-1.45,2.17-2.17,3.61-.72,1.45-2.17,2.89-2.89,4.34s-1.45,2.89-2.17,3.61-.72,1.45-1.45,2.17-.72,1.45-1.45,2.17c0,.72-.72,1.45-.72,2.17c0,0-.72,2.17-2.17,5.06-.72,2.89-2.89,6.5-5.06,10.84-2.89,4.34-4.34,7.23-6.5,8.67-1.45,1.45-2.89,2.17-2.89,2.89s-.72,1.45-.72,2.17-.72,1.45-.72,2.89v5.06c0,2.17,0,2.89.72,3.61c0,0,2.89.72,7.23,1.45h4.34c2.89-4.34,5.06-7.23,6.5-7.95s2.89-2.17,3.61-5.06c1.45-2.17,2.17-3.61,2.89-5.06s1.45-2.17,2.17-3.61c.72-1.45,1.45-2.89,2.89-5.06c1.45-2.17,2.17-3.61,2.89-5.06s2.17-3.61,3.61-6.5s3.61-5.78,4.34-7.95c1.45-2.17,2.89-4.34,3.61-7.23s2.89-5.06,4.34-7.95s2.89-5.06,3.61-5.78s1.45-2.17,2.89-3.61c1.45-1.45,2.17-2.17,2.17-2.89s.72-1.45,1.45-2.17.72-1.45.72-2.17s0-1.45.72-2.17c0-.72.72-1.45.72-2.17s.72-1.45.72-2.17s1.45-2.17,2.89-4.34c1.45-2.17,1.45-3.61.72-4.34-1.45-.72-3.61,0-6.5,1.45s-5.78,2.89-7.95,4.34-3.61,2.17-4.34,2.17-1.45-.72-2.17-2.17-.72-2.17-.72-2.17s0-.72.72-.72c0,0,1.45-.72,3.61-2.17c2.17-1.45,6.5-2.89,11.56-5.78c4.34,0,7.95,0,10.84.72c2.89,0,4.34.72,5.06.72s.72,1.45,0,2.89c-.72,1.45-.72,2.89-1.45,3.61c0,.72-.72,1.45-.72,3.61c0,1.45-.72,2.89-1.45,3.61s-.72,2.17-1.45,3.61c0,1.45-.72,2.17-1.45,3.61l-1.45,2.89c0,.72-.72,1.45-.72,1.45s-.72.72-1.45,2.17c-.72.72-.72,1.45-1.45,2.17c0,.72-.72,1.45-.72,2.89s-1.45,3.61-2.89,5.78c-1.45,2.89-4.34,7.95-8.67,15.9s-7.95,14.45-11.56,20.96-5.78,10.84-6.5,13.01s0,3.61.72,3.61s2.17.72,3.61.72s3.61-1.45,7.95-3.61s7.23-4.34,8.67-5.78s2.89-2.89,3.61-3.61s2.17-1.45,2.89-2.17s1.45-.72,2.17-.72h.72c.72,0,2.89.72,7.23,1.45c4.34.72,6.5,1.45,7.95,2.17s2.17.72,2.17.72.72.72,2.17,1.45c.72.72,1.45,1.45,2.17,2.17s1.45,2.17,2.89,5.06l-2.89.72-2.17,2.17c-.72.72-2.17,1.45-2.89,2.17-.72,0-2.17.72-3.61,1.45-1.45.72-2.89,1.45-4.34,2.17s-2.89,1.45-3.61,1.45-1.45.72-2.17,1.45c-.72.72-1.45,1.45-3.61,2.17-1.45.72-2.89,1.45-3.61,1.45s-2.17.72-3.61,1.45c-1.45.72-2.89,1.45-3.61,2.17s-2.89,2.17-4.34,4.34c-2.17,2.17-4.34,4.34-5.78,5.78s-3.61,2.89-5.06,5.06c-2.17,1.45-2.89,2.89-3.61,3.61l-2.17,2.17c-.72.72-2.17,1.45-2.89,2.17s-.72-1.45-.72-.72l-1.45,1.45c-.72.72-1.45,1.45-2.17,1.45s-1.45,0-1.45-1.45c1.45-2.17,2.17-2.89,2.89-3.61s1.45-1.45,2.17-2.17s2.17-1.45,3.61-3.61c1.45-1.45,2.17-2.89,3.61-4.34.72-1.45,2.17-2.89,2.89-4.34s1.45-2.89,2.17-3.61s0-1.45,0-2.17-.72-1.45-.72-2.17-1.45-2.17-4.34-5.06-4.34-4.34-4.34-4.34h-.72c0,0-.72.72-2.17,2.17-.72,1.45-2.89,3.61-5.06,7.23-2.89,3.61-4.34,7.23-6.5,10.84s-2.89,5.06-3.61,5.78c0,0-.72,1.45-.72,3.61s0,5.06-.72,7.95c0,2.89-.72,5.78-1.45,8.67s-1.45,4.34-2.17,5.06c-.72,0-1.45.72-2.89,2.17-1.45.72-2.17,1.45-2.17,2.17v2.89c0,1.45.72,2.89.72,3.61v4.34c0,2.17,0,4.34-.72,5.78c0,1.45-.72,3.61-.72,5.78s-.72,4.34-.72,5.06s0,2.17-.72,2.89-1.45,2.17-2.17,2.89-1.45,1.45-2.17,2.17c0,0-.72.72-1.45.72h-3.61c-2.17,0-5.78-1.45-10.84-5.06s-9.39-7.23-12.28-10.12c-2.89-3.61-5.78-7.23-8.67-10.12-2.89-3.61-6.5-7.23-8.67-11.56-2.89-4.34-4.34-6.5-4.34-7.95v-3.61c0-1.45.72-1.45,1.45-.72s2.89,2.17,5.78,5.06s5.06,5.06,7.23,7.23s3.61,3.61,5.06,5.06s2.89,2.17,3.61,2.17c1.45,0,3.61,1.45,7.95,3.61s6.5,2.89,7.23,2.17c.72,0,.72-2.89,1.45-7.23c0-4.34.72-7.95.72-10.84v-5.06h-2.17c-1.45,0-2.89.72-3.61.72s-2.17,0-4.34-.72c-2.17,0-5.06-1.45-10.12-2.89s-8.67-2.89-10.12-3.61c-2.17-.72-3.61-1.45-5.78-1.45s-2.89-.72-3.61-.72-1.45-.72-2.17-.72-1.45-.72-2.17-1.45-.72-1.45-.72-2.17.72-1.45.72-2.17.72-.72.72-.72h8.67c1.45,0,2.89,0,3.61-.72.72,0,2.17-.72,2.89-.72s2.17-.72,4.34-2.17c2.17-.72,5.78-4.34,10.84-10.84s7.95-10.12,7.95-10.84v-2.17c0-.72,0-1.45.72-2.17c0-.72.72-1.45.72-1.45s.72-.72,2.17-2.17c1.45-.72,1.45-1.45,1.45-2.17c0,0-1.45-.72-3.61-.72h-7.23c-.72,0-1.45,0-2.17-.72-1.45-.72-2.17-.72-2.89-.72s-2.17,0-4.34-.72c-2.89,0-7.95-3.61-15.9-10.12-7.95-6.5-11.56-10.12-10.84-11.56s1.45-1.45,1.45-2.17.72,0,1.45,0s2.17.72,3.61.72s2.89.72,3.61,1.45c1.45.72,2.17,1.45,3.61,1.45.72,0,1.45.72,2.17.72h2.17c.72,0,2.17-.72,4.34-2.89s3.61-3.61,5.06-5.78s2.89-3.61,3.61-5.06s1.45-2.89,3.61-5.06c1.45-2.17,2.89-3.61,4.34-5.06s3.61-3.61,7.23-7.95s6.5-7.95,7.23-11.56s1.45-7.23.72-11.56-1.45-7.95-2.17-10.12-1.45-5.06-3.61-7.95c-1.45-2.89-2.89-4.34-2.89-4.34s-1.45,0-2.89-.72c-1.45,0-2.89-.72-4.34-.72s-2.89,0-4.34.72c-1.45,0-3.61.72-5.78,1.45s-3.61.72-3.61,0s0-1.45.72-2.89s1.45-2.17,2.17-3.61s1.45-2.17,2.89-2.89.72,0,3.61-.72v0Zm118.51,134.4c3.61-.72,6.5-.72,7.23-.72s2.17,0,4.34.72c2.17,0,4.34.72,7.95,1.45s5.78,2.89,7.23,5.78c1.45,3.61,1.45,6.5,0,10.12-1.45,2.89-2.89,5.78-3.61,7.23s-2.89,3.61-5.78,7.23-5.78,5.78-7.95,7.23c-2.17,2.17-4.34,3.61-5.78,4.34s-2.17,2.17-3.61,2.89c-.72.72-1.45,1.45-1.45,2.17c1.45,0,3.61,0,6.5-.72c2.89,0,5.06-.72,6.5-.72h3.61c.72,0,1.45.72,3.61,1.45c1.45.72,3.61,2.17,5.78,2.89s4.34,2.17,7.23,4.34s3.61,3.61,3.61,4.34v2.17c0,.72-.72,1.45-2.17,2.17s-2.17.72-2.89.72-1.45-.72-2.17-1.45c-.72-.72-2.89-.72-7.23-.72s-7.23,0-7.23.72c-.72,0-1.45.72-1.45.72s-1.45.72-2.17.72-2.17,0-3.61.72c-.72,0-2.17.72-3.61.72h-4.34c-1.45,0-2.89,0-3.61.72-.72,0-2.17.72-5.06,1.45s-5.06.72-6.5,0-2.89-2.89-4.34-5.78-3.61-5.78-4.34-7.23-1.45-2.89-1.45-3.61.72-1.45,2.17-2.89s2.89-2.17,2.89-2.89s1.45-1.45,2.89-3.61s2.89-2.89,4.34-4.34s2.17-2.89,3.61-4.34s2.17-2.89,3.61-4.34l2.17-2.17l2.89-2.89c1.45-1.45,2.89-3.61,3.61-7.23.72-2.89.72-5.06-.72-5.78-1.45-.72-2.17-.72-2.89-.72s-2.17.72-4.34,1.45c-2.89.72-5.06,2.17-8.67,5.06-2.89,2.17-5.78,4.34-8.67,5.78-2.89,1.45-6.5,5.06-12.28,10.84s-8.67,9.39-9.39,10.12c-.72,1.45-1.45,2.89-2.17,5.06s-.72,3.61-.72,5.06.72,2.17,2.17,3.61c1.45,1.45,2.89,2.89,3.61,5.06c1.45,2.17,2.17,2.89,2.17,3.61s-1.45-2.17-3.61-2.17-4.34,0-7.23-.72c-2.89,0-5.78-1.45-7.95-2.89-2.89-1.45-4.34-3.61-5.78-5.06-1.45-2.17-2.17-2.89-2.89-3.61s-1.45-1.45-2.17-2.89-1.45-2.17-2.17-2.89-1.45-2.17-3.61-3.61c-1.45-2.17-2.89-3.61-2.89-5.06v-3.61c0-.72.72-1.45,1.45-2.17l.72-.72c0,0,.72,1.45,2.17,2.17s2.89,2.17,3.61,2.17s1.45.72,2.17,1.45s1.45.72,2.17.72h.72c0,0,1.45-.72,3.61-2.17s3.61-2.17,5.06-3.61s5.78-5.06,13.01-10.12c7.23-5.78,13.01-10.12,18.07-13.01c4.34-1.45,13.73-4.34,26.01-8.67v0Zm-18.07-65.03c.72-1.45,2.89-1.45,6.5-.72s6.5,1.45,7.95,2.17s3.61,1.45,4.34,2.17c.72.72,2.17,1.45,4.34,2.89s3.61,2.17,5.06,2.89s2.89,1.45,5.06,2.17c1.45.72,2.89,1.45,5.06,2.17s2.17,1.45,2.89,2.17.72,1.45,1.45,1.45s1.45.72,2.89,1.45c2.17,0,5.78,2.17,11.56,7.23s10.12,8.67,13.01,11.56c2.17,2.89,5.78,5.78,8.67,9.39c3.61,3.61,5.78,5.78,6.5,7.23s0,3.61-2.17,5.78l-2.17,2.17c-3.61-2.17-6.5-2.89-7.23-3.61-1.45,0-2.17-.72-3.61-1.45-1.45-.72-2.17-1.45-2.17-2.17s-1.45-1.45-2.89-2.89-3.61-2.17-7.23-3.61c-2.89-1.45-5.78-2.17-7.23-2.17-2.17,0-3.61-.72-5.06-.72s-2.89,0-3.61-.72-1.45-1.45-1.45-2.89v-2.17c0,0,.72-.72,1.45-2.17.72-.72,1.45-1.45,2.17-1.45s.72,0,.72.72c0,0,.72,0,1.45-.72s.72-1.45.72-2.17s0-.72-.72-1.45c0-.72-1.45-1.45-2.17-2.17s-2.89-2.17-5.06-3.61-2.89-2.17-3.61-2.17-.72-.72-2.17-1.45c-.72-.72-2.17-1.45-3.61-2.17s-2.17-1.45-3.61-2.17-2.89-1.45-3.61-2.17c-1.45-.72-2.17-1.45-2.89-2.17-.72,0-1.45-.72-2.17-.72s-1.45-1.45-3.61-2.17c-1.45-1.45-2.89-2.17-4.34-3.61-1.45-.72-3.61-2.17-5.78-3.61s-3.61-2.89-4.34-3.61-.72,0,.72-.72v0Z"
              fill="#fff"
            />
            <path
              d="M890.96,598.65c-1.45-1.45-.72-2.89-.72-5.06q.72-7.23-5.06-6.5c0-7.95.72-15.9,1.45-23.85.72-8.67,2.17-16.62.72-25.29c0-.72.72-1.45.72-2.17.72-2.17-1.45-5.06,0-6.5c2.17-1.45,3.61,1.45,5.78,2.89c7.23,2.89,14.45,3.61,21.68,7.23c2.17,1.45,5.06,0,7.23-2.17s2.89-5.06.72-7.95c-2.89-4.34-5.78-9.39-9.39-13.01-2.89-5.78-6.5-11.56-11.56-15.9-2.89-2.89-2.89-4.34,0-7.23c5.06-3.61,8.67-7.95,12.28-12.28c5.06-5.78,10.12-10.84,13.01-18.07c1.45-1.45,2.89-2.17,4.34-2.89c3.61-2.17,5.06-5.78,3.61-9.39-1.45-2.17-6.5-4.34-9.39-3.61-4.34,1.45-8.67,2.89-12.28-1.45-2.17-2.17-5.06-2.89-8.67-1.45-10.84,3.61-21.68,8.67-32.52,12.28-5.78,2.17-10.84,4.34-17.34,2.89-1.45,0-2.17,0-2.89,1.45-1.45,4.34,2.89,2.17,3.61,4.34v1.45c5.78,5.78,10.84,10.84,16.62,15.9c2.89,2.89,6.5,1.45,7.95-2.89.72-1.45,1.45-2.89,2.17-4.34c5.78-5.06,13.01-7.23,20.23-10.12-1.45,2.89-2.89,3.61-3.61,5.78-4.34,7.23-7.95,15.17-13.01,22.4-3.61,6.5-.72,12.28,5.78,13.01c5.06,0,12.28,7.23,13.01,13.01-5.06.72-9.39,2.17-13.73,2.89-7.23,1.45-7.23.72-10.84-5.78-1.45-3.61-4.34-6.5-7.95-9.39-1.45-.72-1.45,0-2.17,0-2.17.72,0,1.45,0,2.17c1.45,3.61,3.61,7.23,5.06,10.84c2.17,10.84,2.17,21.68,1.45,32.52-1.45,9.39-2.89,18.79-3.61,28.18c0,4.34-.72,8.67,0,13.01c2.17,7.23,6.5,13.01,7.95,20.23.72,2.17.72,5.78,3.61,5.78c3.61.72,2.89-3.61,3.61-5.06c2.89-6.5,5.06-10.84,2.17-15.9v0Zm-5.06,17.34v0Z"
              fill="#fff"
            />
            <path
              d="M984.9,472.92c-2.17,2.89-5.78,2.17-7.95,3.61-12.28,6.5-24.57,11.56-37.58,13.73-4.34.72-8.67,2.17-12.28-2.17-.72-1.45-2.17,0-3.61.72s-.72,2.17,0,2.17c1.45.72,1.45,2.89,1.45,4.34c2.89,10.84,8.67,13.73,18.79,10.12c5.06-1.45,9.39-2.89,14.45-4.34.72,0,1.45,0,1.45.72-6.5,8.67-12.28,17.34-19.51,25.29-4.34,4.34-7.23,7.95-6.5,14.45.72,5.78,2.89,8.67,7.95,5.78c7.23-3.61,13.01-8.67,18.07-14.45c3.61-4.34,8.67-7.95,10.12-13.73c0-.72,1.45-1.45,2.17-2.17c5.06-2.89,5.78-7.23,2.89-12.28-1.45-2.17-1.45-4.34-2.89-6.5-.72-1.45,0-2.17.72-2.89c7.95-2.17,14.45-7.23,20.96-10.12c13.73-5.78,28.18-11.56,43.36-10.12c1.45,0,1.45-.72,1.45-1.45.72-1.45,1.45-2.17.72-3.61-1.45-2.17-3.61-2.17-5.78-2.17-1.45,0-3.61.72-4.34,0-3.61-5.06-11.56-.72-15.17-6.5h-.72c-5.78,2.89-12.28,3.61-18.07,7.23v-4.34c.72-1.45.72-2.17,1.45-3.61c1.45-.72.72-2.17.72-3.61q2.17-9.39,12.28-10.12c2.17,0,4.34,0,6.5-1.45c2.17-.72,3.61-3.61,3.61-5.06c0-2.17-5.78-4.34-7.95-3.61-4.34,2.17-12.28-1.45-15.17-5.78-4.34-6.5-7.95-13.73-15.9-15.9-1.45-.72-1.45-2.89-3.61-1.45-2.17,2.17,0,3.61.72,4.34c3.61,5.06,4.34,10.84,5.06,17.34c0,1.45-.72,1.45-1.45,2.17-3.61,2.89-7.23,3.61-10.84,5.78-5.06,2.89-11.56,5.06-17.34,5.78-2.17,0-4.34.72-4.34,2.17-.72,2.17,2.17,2.17,3.61,2.17c0,2.89,2.89,2.89,4.34,4.34c3.61,5.78,10.84,5.78,15.9,7.23c1.45.72,2.89-.72,3.61-1.45.72-.72,1.45-2.17,1.45-3.61.72-2.89,2.89-4.34,5.06-3.61s.72,3.61.72,5.06c1.45,5.06,1.45,7.95,1.45,11.56v0ZM982.73,418v0q-.72,0,0,0c-.72,0,0,0,0,0v0Z"
              fill="#fff"
            />
            <path
              d="M1037.65,511.94c-.72-5.78-5.78-5.06-9.39-5.06-.72,0-1.45-.72-2.17-.72-2.89-.72-5.06-2.89-7.95-3.61-7.95-1.45-15.9-1.45-23.85-5.78-1.45-.72-.72.72-1.45.72s-1.45.72-.72,1.45c2.17,2.17,2.89,5.78,5.78,7.23c7.95,4.34,15.17,8.67,23.12,13.01c2.89,1.45,5.78,2.17,8.67.72c1.45-1.45,3.61-1.45,5.78-1.45-2.89-2.17-2.17-3.61,2.17-6.5v0Z"
              fill="#fff"
            />
            <path
              d="M1057.16,584.2c-8.67-1.45-15.9-5.06-23.12-7.95-2.17-.72-4.34-2.89-7.23-2.17-5.06,1.45-10.84,1.45-15.9,2.17-6.5.72-13.01,2.89-19.51,2.17-1.45,0-2.89,0-2.17-2.17c2.17-5.78,1.45-11.56,3.61-17.34c2.17-.72,2.17-2.89,2.17-4.34.72-2.89,2.89-5.06,5.06-5.78c5.06-1.45,7.23-5.78,10.84-8.67-3.61,0-5.78-3.61-9.39-3.61-5.06,0-10.12-5.06-10.84-10.84-.72-4.34-2.89-7.95-5.78-10.84-1.45-1.45-2.17-.72-2.89,1.45-.72,2.89-.72,5.78.72,7.95c2.17,5.06,1.45,10.12.72,15.17c0,1.45-1.45,2.17-2.17,2.89-5.06,2.89-10.12,5.78-15.17,7.95-5.06,1.45-9.39,6.5-15.17,4.34-.72,0-2.89,0-4.34,1.45-.72.72,0,1.45,0,2.17c5.78,2.89,8.67,10.12,15.9,10.12c2.89,0,6.5,2.89,9.39,0c2.17-2.17,5.06-3.61,7.23-5.78v2.17c-2.17,5.06-4.34,10.12-6.5,15.9-.72,1.45-1.45,2.89-3.61,2.89-9.39.72-18.79,2.17-27.46,3.61s-18.07,5.78-27.46.72c-.72,0-2.17-.72-2.89.72-.72,1.45,0,2.17.72,2.89c1.45,1.45,2.89,2.89,3.61,5.06c1.45,4.34,4.34,5.78,7.95,8.67c7.95,5.78,15.9,1.45,23.85.72h2.17c5.78-1.45,11.56-3.61,17.34-5.06c8.67-1.45,17.34-1.45,26.01-2.17c10.12-.72,20.23-2.17,30.35-3.61c2.89-.72,5.78-1.45,7.95,0s5.06,1.45,7.23,2.17c1.45,0,2.89,0,4.34.72c3.61,1.45,7.23,2.89,11.56,2.17c4.34-.72,7.23-2.89,9.39-6.5v0c1.45-1.45,2.89-2.17,4.34-3.61-2.89-2.89-7.23-5.06-10.84-5.78v0Z"
              fill="#fff"
            />
          </g>
        </g>
      </g>
      <g id="exIqo09Fmte172" opacity="0">
        <g>
          <path
            d="M1249.94,429.23l-30.49,27.95h-52.08l-25.4-27.95h107.97Zm-16.51,186.72h-107.97L1155.95,588h52.08l25.4,27.95v0Zm-79.39-70.5l-3.18,37.47-30.49,27.95l6.35-72.4l11.43-10.16l15.88,17.15v0Zm-24.13-38.74l6.35-72.4l25.4,27.95-3.18,37.47-19.05,17.78-9.53-10.8Zm115.59,31.76l-6.35,72.4-25.4-27.95l3.18-37.47l19.05-17.15l9.53,10.16v0Zm-24.77-38.74l3.18-37.47l30.49-27.95-6.35,72.4-11.43,10.8-15.88-17.78v0Z"
            fill="#fff"
          />
          <path
            d="M1098.14,429.23l-30.49,27.95h-52.08l-25.4-27.95h107.97Zm-16.51,186.72h-107.97L1004.15,588h52.08l25.4,27.95v0Zm-79.39-70.5l-3.18,37.47-30.49,27.95l6.35-72.4l11.43-10.16l15.88,17.15v0Zm-24.13-38.74l6.35-72.4l25.4,27.95-3.81,37.47L987,517.51c0,0-8.89-10.8-8.89-10.8Zm114.96,31.76l-6.35,72.4-25.4-27.95l3.18-37.47l19.05-17.15l9.53,10.16v0Zm-24.13-38.74l3.18-37.47l30.49-27.95-6.35,72.4-11.43,10.8-15.88-17.78v0Z"
            fill="#fff"
          />
          <path
            d="M792.02,429.23l-29.85,27.95h-52.08l-25.4-27.95h107.33ZM776.14,615.95h-107.97L698.66,588h52.08l25.4,27.95v0Zm-79.39-70.5l-3.18,37.47-30.49,27.94l6.35-72.4l11.43-10.16l15.88,17.15v0Zm-24.77-38.74l6.35-72.4l25.4,27.95-3.18,37.47-19.05,17.78-9.53-10.8Zm115.59,31.76l-6.35,72.4-25.4-27.95L759,545.45l19.05-17.15l9.53,10.16v0Zm-24.13-38.74l3.18-37.47l29.85-27.95-6.35,72.4-11.43,10.8-15.24-17.78v0Z"
            fill="#fff"
          />
          <path
            d="M1249.94,429.23l-30.49,27.95h-52.08l-25.4-27.95h107.97Zm-16.51,186.72h-107.97L1155.95,588h52.08l25.4,27.95v0Zm12.07-77.48l-6.35,72.4-25.4-27.95l3.18-37.47l19.05-17.15l9.53,10.16v0Zm-24.77-38.74l3.18-37.47l30.49-27.95-6.35,72.4-11.43,10.8-15.88-17.78v0Zm-1.91,8.89l12.7,13.97-15.24,13.97h-59.07l-12.7-13.97l14.61-13.97h59.7Z"
            fill="#fff"
          />
          <path
            d="M1098.14,429.23l-30.49,27.95h-52.08l-25.4-27.95h107.97Zm-16.51,186.72h-107.97L1004.15,588h52.08l25.4,27.95v0Zm-79.39-70.5l-3.18,37.47-30.49,27.95l6.35-72.4l11.43-10.16l15.88,17.15v0Zm-24.13-38.74l6.35-72.4l25.4,27.95-3.81,37.47L987,517.51c0,0-8.89-10.8-8.89-10.8Zm114.96,31.76l-6.35,72.4-25.4-27.95l3.18-37.47l19.05-17.15l9.53,10.16v0Zm-26.67-29.85l12.7,13.97-15.24,13.97h-59.07l-12.7-13.97l14.61-13.97h59.7Z"
            fill="#fff"
          />
          <path
            d="M948.26,429.23l-30.49,27.95h-52.08l-25.4-27.95h107.97ZM931.75,615.95h-107.97L854.27,588h52.08l25.4,27.95v0Zm-79.39-70.5l-3.18,37.47-30.49,27.95l6.35-72.4l11.43-10.16l15.88,17.15v0Zm-24.13-38.74l6.35-72.4l25.4,27.95-3.18,37.47-19.05,17.78-9.53-10.8Zm114.96,31.76l-6.35,72.4-25.4-27.95l3.18-37.47l19.05-17.15l9.53,10.16v0Zm-24.13-38.74l3.18-37.47l30.49-27.95-6.35,72.4-11.43,10.8-15.88-17.78v0Z"
            fill="#fff"
          />
          <polygon
            points="787.57,538.47 781.22,610.87 755.82,582.93 758.99,545.46 778.05,528.31 787.57,538.47"
            fill="#fff"
          />
          <polygon
            points="763.44,499.73 766.62,462.26 796.47,434.31 790.75,506.72 779.32,517.51 763.44,499.73"
            fill="#fff"
          />
        </g>
      </g>
      <g id="exIqo09Fmte182" opacity="0">
        <g>
          <g>
            <path
              d="M922.42,590.56c-3.38,0-7.33.56-10.71.56-1.69-23.12-3.38-46.8-2.26-69.91c0-3.38.56-7.33.56-10.71c4.51-10.71,7.89-21.42,7.33-32.7c0-3.95-5.64-3.95-8.46-3.38-4.51,1.13-7.89,3.95-9.58,7.89-4.51,9.58-6.77,20.3-7.89,31.01-1.13,2.82-2.26,5.64-3.38,7.89-2.26,5.64-5.07,10.71-7.89,15.79-.56,1.13-1.13,1.69-1.69,2.82c0,0-.56.56-.56,1.13s-.56.56-.56,1.13c-1.69,3.38-2.82,8.46,2.26,9.58c3.38.56,7.89-1.13,10.71-3.38c0,15.22,1.13,31.01,2.26,46.23-8.46,2.82-15.79,7.33-21.42,14.1-2.26,2.82-2.26,7.89,2.26,9.02c5.07,1.13,9.58-2.26,12.4-5.64q-.56.56-.56,1.13v0c-1.13,1.13-.56.56.56-.56l1.13-1.13h.56l1.69-1.13c3.95-2.26,5.64-2.26,10.15-3.38c5.64-1.13,11.28-1.69,16.91-1.69c4.51,0,9.58-3.95,11.28-7.89c1.69-3.95-1.13-7.33-5.07-6.77v0Z"
              fill="#fff"
            />
            <path
              d="M1186.85,521.21c-2.26-5.64-10.71-6.77-15.79-7.33-16.35-1.69-33.26,1.13-49.62,2.26h-3.95c-4.51,0-9.02,3.38-10.71,7.33s.56,6.77,4.51,6.77c14.1,0,28.19-2.82,42.29-2.82c3.38,0,6.2,0,9.58.56c2.82.56,5.07,1.13,6.77,1.69-1.13.56-1.69,1.13-2.82,1.13-1.13.56-2.26,1.13-3.38,1.13.56,0-2.82,1.13-3.38,1.13-6.2,2.26-12.97,3.38-19.17,5.07-5.07,1.13-10.15,2.26-15.79,2.82-3.95.56-7.89,1.13-11.84,1.69-3.38.56-7.33,3.95-8.46,7.33-1.69,3.95.56,6.77,4.51,6.77c5.07,0,10.15-.56,15.22-1.69c8.46-.56,17.48,0,25.94.56c6.77.56,12.4,2.26,13.53,8.46c1.13,6.77-1.69,15.22-2.82,21.99s-2.26,12.97-3.38,19.73c-1.69,7.33-3.38,15.22-6.2,21.99-1.13,1.69-1.69,3.38-2.26,4.51-4.51-2.26-7.33-8.46-9.58-12.97-3.38-7.33-6.2-14.66-8.46-22.55-2.26-7.33-3.95-14.1-6.77-21.42-2.82-8.46-18.61.56-16.35,7.33c4.51,12.97,7.89,26.5,12.97,39.47c5.07,12.4,13.53,29.32,29.32,23.12s20.3-26.5,23.12-41.16c1.69-6.77,2.26-13.53,3.95-20.86c1.13-7.33,3.38-14.66,3.38-22.55c0-9.02-4.51-15.22-11.84-18.04c3.95-1.69,7.33-3.95,10.15-6.2c5.64-3.38,10.71-9.02,7.33-15.22v0Zm-36.08,111.64v0Zm-1.69.56v0Zm23.68-104.87v0c0,0,0-.56,0,0c0-.56,0,0,0,0v0Z"
              fill="#fff"
            />
            <path
              d="M1105.66,472.16c-10.71-7.89-26.5-4.51-36.65,1.69-19.17,11.84-26.5,34.96-29.32,56.38-1.13,9.58-1.13,19.73-1.13,29.32c0,9.02,0,18.61,2.26,27.63-.56,5.64,1.13,11.28,4.51,16.91c2.26,3.38,6.77,3.38,10.71,1.69c3.38,1.13,7.33,2.26,11.84,2.26c14.1.56,27.63-9.58,33.83-21.99c4.51-9.58,5.64-21.42-2.82-29.32-6.77-6.2-18.61-5.07-26.5-2.82-4.51,1.13-9.02,3.38-12.97,5.64v-10.15c0-10.15.56-19.73,1.69-29.88c1.13-6.77,2.82-13.53,5.64-19.73c1.13-2.82,2.26-4.51,4.51-7.33l.56-.56q.56-.56,1.13-1.13c.56,0,.56-.56,1.13-1.13-.56.56,1.13-1.13,1.69-1.13s.56-.56.56-.56h1.13c1.69-.56,3.38-.56,5.07-.56c2.26,0,5.07,1.69,7.33,3.38c5.07,3.95,6.77,11.84,6.77,17.48c0,2.82.56,4.51,2.26,5.64v11.28c0,2.26-.56,5.07.56,7.89.56,1.69,2.26,3.38,3.38,1.13c1.13-1.69.56-3.95,1.13-5.64v-13.53c6.2-.56,14.66-6.2,14.66-12.4c0-12.4-3.38-23.68-12.97-30.45v0Zm-36.08,99.79c1.13-.56,2.26-.56,3.38-1.13h3.95c.56,0,1.69.56,2.26.56-.56,0,1.69,1.13,2.26,1.13h.56c0,0,0,.56.56,1.13c0,0,0,.56.56.56c0,0,.56,1.13.56,1.69s0,1.13.56,1.69v0v.56c0,1.13-.56,2.82-.56,3.95c0-1.13-.56,1.69-.56,1.69-.56,1.13-.56,1.69-1.13,2.82.56-.56-.56,1.13-.56,1.13h-.56c-2.26,1.13-7.33,1.13-10.71-.56-3.95-1.69-5.64-5.64-6.77-9.58v-.56c0,0,0-.56.56-.56c0,0,.56-.56.56-1.13v0q.56-.56,1.13-1.13v0q.56-.56,1.13-1.13h.56c.56,0,1.13-.56,1.69-1.13-.56.56,0,.56.56,0v0Zm-5.07,3.38v0Zm1.13-1.13c.56-.56,1.13-.56,0,0v0Zm-1.13.56v0c0,0,.56,0,0,0Z"
              fill="#fff"
            />
            <path
              d="M1124.27,656.53c-3.95-3.38-8.46-5.07-13.53-6.77-6.2-2.26-12.4-3.95-18.61-5.07-8.46-1.69-16.91-2.82-25.37-3.38-13.53-6.77-27.06-15.79-36.65-27.63-5.07-6.2-20.3,4.51-15.22,10.71c2.82,3.38,5.64,6.2,9.02,9.58-33.83-4.51-67.66-7.89-102.05-8.46-20.86-.56-41.72.56-62.02,3.38-20.86,2.82-41.72,7.33-62.58,11.28-3.38.56-6.77,3.95-7.33,7.33-.56,3.95,3.38,4.51,6.2,3.95c19.73-3.95,38.9-7.89,59.2-10.71s40.59-3.95,60.89-3.38c21.99,0,43.41,1.69,65.4,4.51-10.15,1.13-19.73,2.82-29.88,5.07-3.95,1.13-8.46,4.51-9.02,9.02s3.95,5.64,7.33,4.51c31.01-7.89,63.71-6.2,94.72-5.07c3.95,0,7.89,0,11.84.56c1.69,1.13,3.38,1.69,5.07,2.82c16.91,7.89,36.08,15.22,54.69,12.4.56,1.69.56,3.95,0,6.2c0,1.69-.56,3.95.56,5.64.56,1.13,2.26,1.13,2.82,0c.56-.56.56-1.69.56-2.26c0-1.69.56-3.95.56-5.64.56-1.69.56-3.95,1.13-5.64.56-.56.56-1.13,1.13-1.69c2.82-4.51,4.51-8.46,1.13-11.28v0Z"
              fill="#fff"
            />
            <path
              d="M740.31,649.2c-4.51,0-9.02,3.38-10.15,7.33-1.13,2.82,0,5.07,2.26,6.2c0,1.13.56,2.26.56,3.38c0,1.69.56,3.38.56,5.07s2.26,2.82,2.82,1.13.56-3.95,0-5.64c0-1.13,0-2.26.56-3.38c3.38-1.13,6.77-3.95,8.46-6.77c1.13-4.51-1.13-7.33-5.07-7.33Z"
              fill="#fff"
            />
            <path
              d="M767.37,644.69c-3.38,0-7.33,2.82-8.46,6.2s.56,5.64,3.95,5.64s7.33-2.82,8.46-6.2c1.13-2.82-.56-5.64-3.95-5.64Z"
              fill="#fff"
            />
            <path
              d="M1025.6,458.06c-4.51-2.26-10.15-2.82-15.22-2.82-6.77-.56-12.97,0-19.73.56-1.69,0-3.95,0-5.64.56c1.13-1.13,1.69-2.26,2.26-3.38c0-1.69-.56-2.82-2.26-2.82v0c4.51-6.77,9.02-14.1,12.97-21.99c1.13,7.33,2.82,14.66,4.51,21.99c1.13,4.51,10.15,0,9.02-3.95-2.26-6.77-3.38-13.53-4.51-20.86-.56-4.51-1.13-9.58-1.13-14.1.56-1.13,1.13-2.82,1.69-4.51c1.13-3.95,2.82-7.89,2.82-11.84c0-4.51-5.64-2.26-7.33-.56-5.07,5.07-6.2,12.4-6.2,19.73-1.13,2.82-2.82,5.64-3.95,8.46-2.82,6.2-6.2,12.4-10.15,18.04-3.38-9.02-5.07-19.17-6.77-28.75-.56-3.38-1.13-7.33-1.13-11.28.56-1.69.56-2.82,1.13-4.51c1.13-4.51,1.69-9.58.56-14.1-.56-1.69-2.26-2.26-3.95-1.69-2.26.56-3.95,2.26-4.51,3.95-1.13,2.82-1.13,7.33-1.13,11.28v6.2c-1.13,3.95-2.26,7.89-3.95,11.28-2.82,7.89-6.77,15.79-10.15,23.68-2.82-4.51-4.51-9.58-5.64-15.22c1.13-7.33,2.26-15.22,1.13-22.55c0-1.69-2.82-2.26-3.95-1.69-1.69.56-3.95,2.26-4.51,3.95-2.82,7.33-2.82,15.79-1.69,23.68-.56,2.26-1.13,4.51-1.13,6.77-1.69,10.15-3.95,20.86-6.77,31.01-.56,2.26,2.26,2.82,3.95,2.82c2.26-.56,4.51-2.26,5.07-5.07c1.69-6.2,2.82-12.97,4.51-19.73c1.69,2.82,2.82,5.64,5.07,7.89v0c0,.56.56,1.13.56,2.26q0,.56.56.56v2.82c0,1.13,1.69,1.13,1.69,0v0c0-1.69.56-3.38.56-5.07c2.26-.56,3.95-2.82,4.51-3.95c3.95-8.46,7.89-17.48,11.84-25.94c1.69,10.71,4.51,21.42,9.02,31.01-12.4,2.82-24.81,6.2-36.08,11.84-5.64,2.82-14.1,7.89-14.66,15.22-.56,4.51,3.95,6.77,7.89,7.89c6.2,1.69,13.53,1.13,20.3.56c11.84,0,23.68-1.13,35.52-2.82c8.46-1.13,16.91-2.82,24.81-5.64c5.07-1.69,10.15-4.51,13.53-8.46c2.82-3.95,1.69-8.46-3.38-10.71v0Zm-10.15,11.84c0,0,0,.56,0,0-.56,0-1.13.56-1.13.56-1.13,0-1.69.56-2.82,1.13-8.46,2.82-16.91,3.95-25.37,4.51-12.97,1.13-25.94,1.69-38.9,1.69-2.82,0-5.07,0-7.89-1.13-.56,0-1.13-.56-1.69-1.13v0-.56v0-1.13l.56-.56v0c.56-.56,1.13-1.13,2.26-1.69.56,0,.56-.56,1.13-.56c0,0,.56,0,.56-.56c1.69-1.13,3.95-1.69,5.64-2.82c1.13-.56,2.26-1.13,3.38-1.13.56,0,1.13-.56,1.13-.56v0c0,2.26,2.26,2.82,4.51,2.82c2.26-.56,4.51-1.13,6.77-1.13.56,0,1.13,0,2.26-.56h1.13c1.69,0,3.95-.56,5.64-.56c2.82-.56,5.64-.56,7.89-1.13.56,1.69,1.13,2.82,1.13,4.51v0v2.82c.56,1.69,1.69,0,1.69-1.13v-5.07v0c0,0,.56-.56.56-1.13v-.56c3.95-.56,7.89-.56,11.84-.56h15.22c1.13,0,2.82.56,4.51,1.13h1.13c.56,0,1.13.56,1.13.56s.56,0,.56.56l.56.56v0c-.56,0-.56.56-1.13.56c0,0-.56,0-.56.56.56,1.13-.56,1.69-1.69,1.69v0Z"
              fill="#fff"
            />
            <path
              d="M941.59,391.53c2.82,0,5.64-2.26,6.77-4.51s-.56-3.95-2.82-3.95c-2.82,0-5.64,2.26-6.77,4.51-.56,2.26.56,3.95,2.82,3.95Z"
              fill="#fff"
            />
            <path
              d="M972.6,372.93c2.26,0,5.07-2.26,6.2-4.51s-.56-3.95-2.82-3.95-5.07,2.26-6.2,4.51.56,3.95,2.82,3.95Z"
              fill="#fff"
            />
            <path
              d="M1009.25,386.46c0,0,.56,0,0,0c.56,1.13.56,2.26.56,2.82c0,1.13,0,2.82,1.13,2.26.56,0,.56-1.13.56-1.69s0-1.69.56-2.26c0-.56.56-1.13.56-1.69c1.13-.56,2.26-2.26,2.82-3.38c1.13-2.26-.56-3.95-2.82-3.95s-5.07,2.26-6.2,3.95c0,2.26,1.13,3.38,2.82,3.95v0Z"
              fill="#fff"
            />
            <path
              d="M1027.29,507.12c-12.97-14.66-35.52-11.84-49.62,0-2.26,1.69-4.51,3.95-6.2,6.2-6.2-3.38-14.66-3.95-22.55-1.69-15.79,3.95-29.32,16.91-31.01,33.83-1.69,14.66,8.46,25.94,19.17,34.39c9.58,7.89,19.73,13.53,29.88,20.86-.56,2.26,0,3.95,1.69,5.07s2.82,1.13,4.51,1.13c0,.56.56,1.13.56,1.13c1.13,1.69,1.13,3.38,1.13,5.64v0c0,3.38,0,7.33,1.13,8.46.56,1.13,2.26,0,2.82-.56c2.26-3.95,1.13-10.71,1.69-14.66v-1.13c.56-1.13,1.13-2.26,1.13-3.38c0,0,0-.56.56-1.13c14.1-11.84,29.32-23.68,40.59-39.47c11.28-15.22,18.04-38.9,4.51-54.69v0Zm-23.12,56.95c-6.77,7.89-15.22,15.22-23.12,21.42-7.33-5.64-15.79-10.15-23.12-15.79-7.89-5.64-17.48-12.97-20.3-23.12-1.69-4.51-1.13-9.02,1.13-13.53c1.69-3.95,3.38-4.51,7.33-6.2c2.26-1.13,6.77-1.69,10.71,0c2.26.56,4.51,2.82,5.64,5.07-2.82,9.02-2.82,19.17-1.69,28.75c1.13,9.02,18.61,0,17.48-8.46-.56-5.64-1.13-10.71,0-16.35c2.82-2.26,5.07-5.64,4.51-9.02c0-1.13-.56-2.26-1.13-3.38.56-1.13,1.13-2.26,2.26-3.38c1.13-1.69.56-1.13,1.69-1.69.56-.56,1.13-1.13,1.13-1.13l.56-.56.56-.56c0,0,2.26-1.13,2.26-1.69.56-.56,1.69-1.13,2.26-1.13c2.26-1.13,4.51-1.13,7.33-1.13c7.33.56,13.53,5.64,16.91,12.4c5.64,13.53-3.95,29.88-12.4,39.47v0Z"
              fill="#fff"
            />
          </g>
        </g>
      </g>
      <g id="exIqo09Fmte196" opacity="0">
        <g>
          <g>
            <ellipse
              rx="5.48"
              ry="98.65"
              transform="translate(664.3 522.59)"
              fill="url(#exIqo09Fmte199-fill)"
            />
            <ellipse
              rx="5.48"
              ry="98.65"
              transform="translate(803.14 522.59)"
              fill="url(#exIqo09Fmte200-fill)"
            />
            <path
              d="M664.3,522.59v91.96c0,7.92,6.7,14.01,14.01,14.01h110.22c7.92,0,14.01-6.09,14.01-14.01v-91.96h-138.24Z"
              fill="url(#exIqo09Fmte201-fill)"
            />
            <path
              d="M803.14,430.64c0-7.92-6.09-14.01-14.01-14.01h-110.83c-7.92,0-14.01,6.09-14.01,14.01v91.96h138.85v-91.96Z"
              fill="url(#exIqo09Fmte202-fill)"
            />
            <path
              d="M664.3,613.94v0v1.83c0,1.22.61,3.04,1.22,4.87c1.22,1.83,2.44,4.26,4.87,5.48c1.22.61,2.44,1.22,4.26,1.83s3.04.61,4.87.61h107.18c1.83,0,3.65,0,4.87-.61c1.83-.61,3.04-1.22,4.26-1.83c2.44-1.83,4.26-3.65,4.87-5.48c1.22-1.83,1.22-3.65,1.22-4.87v-1.22v0v1.22c0,1.22-.61,3.04-1.22,4.87-1.22,1.83-2.44,4.26-4.87,5.48-1.22.61-3.04,1.22-4.26,1.83-1.83.61-3.65.61-5.48.61h-107.18c-1.83,0-3.65,0-5.48-.61s-3.04-1.22-4.26-1.83c-2.44-1.83-4.26-3.65-4.87-5.48s-1.22-3.65-1.22-4.87q1.22-.61,1.22-1.83c0,.61,0,0,0,0Z"
              fill="url(#exIqo09Fmte203-fill)"
            />
            <path
              d="M803.14,431.86v0-1.83c0-1.22-.61-3.04-1.22-4.87s-2.44-3.65-4.87-5.48c-1.22-.61-2.44-1.22-4.26-1.83-1.83-.61-3.04-.61-4.87-.61h-107.18c-1.83,0-3.65,0-4.87.61s-3.04,1.22-4.26,1.83c-2.44,1.83-4.26,3.65-4.87,5.48-1.22,1.83-1.22,3.65-1.22,4.87v1.22v0-1.22c0-1.22.61-3.04,1.22-4.87s2.44-4.26,4.87-5.48c1.22-.61,2.44-1.22,4.26-1.83c1.83-.61,3.65-.61,5.48-.61h107.18c1.83,0,3.65,0,5.48.61s3.04,1.22,4.26,1.83c2.44,1.83,4.26,3.65,4.87,5.48s1.22,3.65,1.22,4.87c-1.22.61-1.22,1.22-1.22,1.83c0-.61,0,0,0,0Z"
              fill="url(#exIqo09Fmte204-fill)"
            />
            <path
              d="M709.97,458.04c20.71,0,25.58-10.35,29.84-21.92h18.27v172.34h-27.4v-130.93h-20.71v-19.49v0Z"
              fill="#f1f1f1"
            />
            <rect
              width="138.85"
              height="9.13"
              rx="0"
              ry="0"
              transform="translate(664.3 522.59)"
              fill="url(#exIqo09Fmte206-fill)"
            />
            <rect
              width="138.85"
              height="9.13"
              rx="0"
              ry="0"
              transform="translate(664.3 513.46)"
              fill="url(#exIqo09Fmte207-fill)"
            />
            <rect
              style="isolation: isolate"
              width="138.85"
              height="1.83"
              rx="0"
              ry="0"
              transform="translate(664.3 522.59)"
              opacity="0.2"
              fill="#fff"
            />
            <rect
              width="138.85"
              height="1.83"
              rx="0"
              ry="0"
              transform="translate(664.3 520.77)"
            />
            <rect
              width="15.83"
              height="35.32"
              rx="0"
              ry="0"
              transform="translate(787.31 504.93)"
              fill="#191818"
            />
            <rect
              width="15.83"
              height="6.09"
              rx="0"
              ry="0"
              transform="translate(787.31 537.21)"
              fill="url(#exIqo09Fmte211-fill)"
            />
            <rect
              width="14.01"
              height="31.67"
              rx="0"
              ry="0"
              transform="translate(789.14 506.76)"
              fill="url(#exIqo09Fmte212-fill)"
            />
            <rect
              width="15.83"
              height="4.87"
              rx="0"
              ry="0"
              transform="translate(787.31 500.67)"
              fill="url(#exIqo09Fmte213-fill)"
            />
            <rect
              width="15.83"
              height="35.32"
              rx="0"
              ry="0"
              transform="translate(664.3 504.93)"
              fill="#191818"
            />
            <rect
              width="14.01"
              height="31.67"
              rx="0"
              ry="0"
              transform="translate(664.3 506.76)"
              fill="url(#exIqo09Fmte215-fill)"
            />
            <rect
              width="15.83"
              height="6.09"
              rx="0"
              ry="0"
              transform="translate(664.3 537.21)"
              fill="url(#exIqo09Fmte216-fill)"
            />
            <rect
              width="15.83"
              height="4.87"
              rx="0"
              ry="0"
              transform="translate(664.3 500.67)"
              fill="url(#exIqo09Fmte217-fill)"
            />
            <ellipse
              rx="58.46"
              ry="1.22"
              transform="translate(733.72 417.85)"
              fill="url(#exIqo09Fmte218-fill)"
            />
            <ellipse
              rx="5.48"
              ry="98.65"
              transform="translate(1114.33 522.59)"
            />
            <path
              d="M1258.66,522.59c0,54.2-2.44,98.65-5.48,98.65s-5.48-43.85-5.48-98.65s2.44-98.65,5.48-98.65s5.48,44.46,5.48,98.65Z"
              fill="url(#exIqo09Fmte220-fill)"
            />
            <path
              d="M1114.33,522.59v91.96c0,7.92,6.7,14.01,14.01,14.01h110.22c7.92,0,14.01-6.09,14.01-14.01v-91.96h-138.24Z"
              fill="url(#exIqo09Fmte221-fill)"
            />
            <path
              d="M1253.18,430.64c0-7.92-6.7-14.01-14.01-14.01h-110.22c-7.92,0-14.01,6.09-14.01,14.01v91.96h138.85l-.61-91.96v0Z"
              fill="url(#exIqo09Fmte222-fill)"
            />
            <path
              d="M1114.33,613.94v0v1.83c0,1.22.61,3.04,1.22,4.87c1.22,1.83,2.44,4.26,4.87,5.48c1.22.61,2.44,1.22,4.26,1.83c1.83.61,3.04.61,4.87.61h107.18c1.83,0,3.65,0,4.87-.61c1.83-.61,3.04-1.22,4.26-1.83c2.44-1.83,4.26-3.65,4.87-5.48c1.22-1.83,1.22-3.65,1.22-4.87v-1.22v0v1.22c0,1.22-.61,3.04-1.22,4.87-1.22,1.83-2.44,4.26-4.87,5.48-1.22.61-2.44,1.22-4.26,1.83-1.83.61-3.65.61-5.48.61h-107.18c-1.83,0-3.65,0-5.48-.61s-3.04-1.22-4.26-1.83c-2.44-1.83-4.26-3.65-4.87-5.48s-1.22-3.65-1.22-4.87q1.22-.61,1.22-1.83v0Z"
              fill="url(#exIqo09Fmte223-fill)"
            />
            <path
              d="M1253.18,431.86v0-1.83c0-1.22-.61-3.04-1.22-4.87-1.22-1.83-2.44-3.65-4.87-5.48-1.22-.61-2.44-1.22-4.26-1.83-1.83-.61-3.04-.61-4.87-.61h-107.18c-1.83,0-3.65,0-4.87.61-1.83.61-3.04,1.22-4.26,1.83-2.44,1.83-4.26,3.65-4.87,5.48-1.22,1.83-1.22,3.65-1.22,4.87v1.22v0-1.22c0-1.22.61-3.04,1.22-4.87c1.22-1.83,2.44-4.26,4.87-5.48c1.22-.61,2.44-1.22,4.26-1.83c1.83-.61,3.65-.61,5.48-.61h107.18c1.83,0,3.65,0,5.48.61s3.04,1.22,4.26,1.83c2.44,1.83,4.26,3.65,4.87,5.48s1.22,3.65,1.22,4.87c-1.22.61-1.22,1.22-1.22,1.83v0Z"
            />
            <path
              d="M1205.07,520.77c12.79-5.48,18.88-17.05,18.88-35.32v-4.26c0-27.4-14.01-43.24-40.19-43.24s-40.19,15.83-40.19,43.24v9.13h25.58v-10.96c0-12.18,5.48-17.05,14.01-17.05s14.01,4.26,14.01,19.49v9.74c0,14.01-6.09,18.27-16.44,18.27h-10.35v16.44h43.24c-2.44-1.83-4.87-3.65-8.53-5.48v0Z"
              fill="#f1f1f1"
            />
            <path
              d="M1205.07,521.38c12.79,5.48,18.88,17.05,18.88,35.32v4.26c0,27.4-14.01,43.24-40.19,43.24s-40.19-15.83-40.19-43.24v-9.13h25.58v10.96c0,12.18,5.48,17.05,14.01,17.05s14.01-4.26,14.01-19.49v-9.74c0-14.01-6.09-18.27-16.44-18.27h-10.35v-16.44h43.24c-2.44,2.44-4.87,4.26-8.53,5.48v0Z"
              fill="#f1f1f1"
            />
            <rect
              width="138.85"
              height="9.13"
              rx="0"
              ry="0"
              transform="translate(1114.33 522.59)"
              fill="url(#exIqo09Fmte227-fill)"
            />
            <rect
              width="138.85"
              height="9.13"
              rx="0"
              ry="0"
              transform="translate(1114.33 513.46)"
              fill="url(#exIqo09Fmte228-fill)"
            />
            <rect
              style="isolation: isolate"
              width="138.85"
              height="1.83"
              rx="0"
              ry="0"
              transform="translate(1114.33 522.59)"
              opacity="0.2"
              fill="#fff"
            />
            <rect
              width="138.85"
              height="1.83"
              rx="0"
              ry="0"
              transform="translate(1114.33 520.77)"
            />
            <rect
              width="15.83"
              height="35.32"
              rx="0"
              ry="0"
              transform="translate(1237.95 504.93)"
              fill="#191818"
            />
            <rect
              width="15.83"
              height="6.09"
              rx="0"
              ry="0"
              transform="translate(1237.95 537.21)"
              fill="url(#exIqo09Fmte232-fill)"
            />
            <rect
              width="14.01"
              height="31.67"
              rx="0"
              ry="0"
              transform="translate(1239.17 506.76)"
              fill="url(#exIqo09Fmte233-fill)"
            />
            <rect
              width="15.83"
              height="4.87"
              rx="0"
              ry="0"
              transform="translate(1237.95 500.67)"
              fill="url(#exIqo09Fmte234-fill)"
            />
            <rect
              width="15.83"
              height="35.32"
              rx="0"
              ry="0"
              transform="translate(1114.33 504.93)"
              fill="#191818"
            />
            <rect
              width="14.01"
              height="31.67"
              rx="0"
              ry="0"
              transform="translate(1114.33 506.76)"
              fill="url(#exIqo09Fmte236-fill)"
            />
            <rect
              width="15.83"
              height="6.09"
              rx="0"
              ry="0"
              transform="translate(1114.33 537.21)"
              fill="url(#exIqo09Fmte237-fill)"
            />
            <rect
              width="15.83"
              height="4.87"
              rx="0"
              ry="0"
              transform="translate(1114.33 500.67)"
              fill="url(#exIqo09Fmte238-fill)"
            />
            <path
              d="M964.52,522.59v91.96c0,7.92,6.7,14.01,14.01,14.01h110.22c7.92,0,14.01-6.09,14.01-14.01v-91.96h-138.24Z"
              fill="url(#exIqo09Fmte239-fill)"
            />
            <path
              d="M1103.37,430.64c0-7.92-6.7-14.01-14.01-14.01h-110.83c-7.92,0-14.01,6.09-14.01,14.01v91.96h138.85v-91.96v0Z"
              fill="url(#exIqo09Fmte240-fill)"
            />
            <path
              d="M964.52,613.94v0v1.83c0,1.22.61,3.04,1.22,4.87c1.22,1.83,2.44,4.26,4.87,5.48c1.22.61,2.44,1.22,4.26,1.83s3.04.61,4.87.61h107.18c1.83,0,3.65,0,4.87-.61c1.83-.61,3.04-1.22,4.26-1.83c2.44-1.83,4.26-3.65,4.87-5.48c1.22-1.83,1.22-3.65,1.22-4.87v-1.22v0v1.22c0,1.22-.61,3.04-1.22,4.87-1.22,1.83-2.44,4.26-4.87,5.48-.61,1.22-1.83,1.83-3.65,1.83-1.83.61-3.65.61-5.48.61h-107.18c-1.83,0-3.65,0-5.48-.61s-3.04-1.22-4.26-1.83c-2.44-1.83-4.26-3.65-4.87-5.48s-1.22-3.65-1.22-4.87q.61-.61.61-1.83v0Z"
              fill="url(#exIqo09Fmte241-fill)"
            />
            <path
              d="M1103.37,431.86v0-1.83c0-1.22-.61-3.04-1.22-4.87-1.22-1.83-2.44-3.65-4.87-5.48-1.22-.61-2.44-1.22-4.26-1.83-1.83-.61-3.04-.61-4.87-.61h-107.18c-1.83,0-3.65,0-4.87.61s-3.04,1.22-4.26,1.83c-2.44,1.83-4.26,3.65-4.87,5.48-1.22,1.83-1.22,3.65-1.22,4.87v1.22v0-1.22c0-1.22.61-3.04,1.22-4.87c1.22-1.83,2.44-4.26,4.87-5.48c1.22-.61,3.04-1.22,4.26-1.83c1.83-.61,3.65-.61,5.48-.61h107.18c1.83,0,3.65,0,5.48.61s3.04,1.22,4.26,1.83c2.44,1.83,4.26,3.65,4.87,5.48s1.22,3.65,1.22,4.87c-1.22.61-1.22,1.22-1.22,1.83v0Z"
              fill="url(#exIqo09Fmte242-fill)"
            />
            <path
              d="M1033.95,521.38c2.44,0,4.26,0,6.09,1.22h34.1c-3.04-16.44-12.79-25.58-28.62-25.58-12.18,0-20.71,5.48-24.97,15.22v-31.67c0-16.44,5.48-21.31,15.22-21.31c8.53,0,14.01,4.87,14.01,17.05v6.09h25.58v-4.26c0-27.4-14.01-43.24-40.19-43.24-28.01,0-41.41,15.83-41.41,45.06v42.63h35.32c.61-1.22,2.44-1.22,4.87-1.22v0Z"
              fill="#f1f1f1"
            />
            <path
              d="M1040.04,521.98c4.87,1.83,7.92,6.7,7.92,15.83v31.06c0,12.18-5.48,17.05-14.01,17.05s-14.01-4.26-14.01-17.05v-31.06c0-9.13,3.04-14.01,7.92-15.83h-35.32v45.06c0,27.4,14.62,43.24,41.41,43.24s41.41-15.83,41.41-43.24v-31.67c0-4.87-.61-9.74-1.22-14.01h-34.1v.61Z"
              fill="#f1f1f1"
            />
            <rect
              width="138.85"
              height="9.13"
              rx="0"
              ry="0"
              transform="translate(964.52 522.59)"
              fill="url(#exIqo09Fmte245-fill)"
            />
            <rect
              width="138.85"
              height="9.13"
              rx="0"
              ry="0"
              transform="translate(964.52 513.46)"
              fill="url(#exIqo09Fmte246-fill)"
            />
            <rect
              style="isolation: isolate"
              width="138.85"
              height="1.83"
              rx="0"
              ry="0"
              transform="translate(964.52 522.59)"
              opacity="0.2"
              fill="#fff"
            />
            <rect
              width="138.85"
              height="1.83"
              rx="0"
              ry="0"
              transform="translate(964.52 520.77)"
            />
            <rect
              width="15.83"
              height="35.32"
              rx="0"
              ry="0"
              transform="translate(1087.54 504.93)"
              fill="#191818"
            />
            <rect
              width="15.83"
              height="6.09"
              rx="0"
              ry="0"
              transform="translate(1087.54 537.21)"
              fill="url(#exIqo09Fmte250-fill)"
            />
            <rect
              width="14.01"
              height="31.67"
              rx="0"
              ry="0"
              transform="translate(1089.36 506.76)"
            />
            <rect
              width="15.83"
              height="4.87"
              rx="0"
              ry="0"
              transform="translate(1087.54 500.67)"
              fill="url(#exIqo09Fmte252-fill)"
            />
            <rect
              width="15.83"
              height="35.32"
              rx="0"
              ry="0"
              transform="translate(964.52 504.93)"
              fill="#191818"
            />
            <rect
              width="14.01"
              height="31.67"
              rx="0"
              ry="0"
              transform="translate(964.52 506.76)"
              fill="url(#exIqo09Fmte254-fill)"
            />
            <rect
              width="15.83"
              height="6.09"
              rx="0"
              ry="0"
              transform="translate(964.52 537.21)"
              fill="url(#exIqo09Fmte255-fill)"
            />
            <rect
              width="15.83"
              height="4.87"
              rx="0"
              ry="0"
              transform="translate(964.52 500.67)"
              fill="url(#exIqo09Fmte256-fill)"
            />
            <ellipse
              rx="58.46"
              ry="1.22"
              transform="translate(1033.95 417.85)"
              fill="url(#exIqo09Fmte257-fill)"
            />
            <path
              d="M814.11,522.59v91.96c0,7.92,6.09,14.01,14.01,14.01h110.22c7.92,0,14.01-6.09,14.01-14.01v-91.96h-138.24Z"
              fill="url(#exIqo09Fmte258-fill)"
            />
            <path
              d="M952.95,430.64c0-7.92-6.09-14.01-14.01-14.01h-110.22c-7.92,0-14.01,6.09-14.01,14.01v91.96h138.85l-.61-91.96v0Z"
              fill="url(#exIqo09Fmte259-fill)"
            />
            <path
              d="M814.11,613.94v0v1.83c0,1.22.61,3.04,1.22,4.87c1.22,1.83,2.44,4.26,4.87,5.48c1.22.61,2.44,1.22,4.26,1.83s3.04.61,4.87.61h107.18c1.83,0,3.65,0,4.87-.61s3.04-1.22,4.26-1.83c2.44-1.83,4.26-3.65,4.87-5.48c1.22-1.83,1.22-3.65,1.22-4.87v-1.22v0v1.22c0,1.22-.61,3.04-1.22,4.87-1.22,1.83-2.44,4.26-4.87,5.48-1.22.61-3.04,1.22-4.26,1.83-1.83.61-3.65.61-5.48.61h-107.18c-1.83,0-3.65,0-5.48-.61s-3.04-1.22-4.26-1.83c-2.44-1.83-4.26-3.65-4.87-5.48s-1.22-3.65-1.22-4.87q1.22-.61,1.22-1.83v0Z"
              fill="url(#exIqo09Fmte260-fill)"
            />
            <path
              d="M952.95,431.86v0-1.83c0-1.22-.61-3.04-1.22-4.87s-2.44-3.65-4.87-5.48c-1.22-.61-2.44-1.22-4.26-1.83-1.83-.61-3.04-.61-4.87-.61h-107.18c-1.83,0-3.65,0-4.87.61s-3.04,1.22-4.26,1.83c-2.44,1.83-4.26,3.65-4.87,5.48-1.22,1.83-1.22,3.65-1.22,4.87v1.22v0-1.22c0-1.22.61-3.04,1.22-4.87c1.22-1.83,2.44-4.26,4.87-5.48c1.22-.61,3.04-1.22,4.26-1.83c1.83-.61,3.65-.61,5.48-.61h107.18c1.83,0,3.65,0,5.48.61s3.04,1.22,4.26,1.83c2.44,1.83,4.26,3.65,4.87,5.48s1.22,3.65,1.22,4.87c-1.22.61-1.22,1.22-1.22,1.83c0-.61,0,0,0,0Z"
              fill="url(#exIqo09Fmte261-fill)"
            />
            <path
              d="M842.73,478.14c0-27.4,14.62-43.24,41.41-43.24s41.41,15.83,41.41,43.24v89.52c0,27.4-14.62,43.24-41.41,43.24s-41.41-15.83-41.41-43.24v-89.52Zm26.79,91.35c0,12.18,5.48,17.05,14.01,17.05s14.01-4.87,14.01-17.05v-93.17c0-12.18-5.48-17.05-14.01-17.05s-14.01,4.87-14.01,17.05v93.17Z"
              fill="#f1f1f1"
            />
            <rect
              width="138.85"
              height="9.13"
              rx="0"
              ry="0"
              transform="translate(814.11 522.59)"
              fill="url(#exIqo09Fmte263-fill)"
            />
            <rect
              width="138.85"
              height="9.13"
              rx="0"
              ry="0"
              transform="translate(814.11 513.46)"
              fill="url(#exIqo09Fmte264-fill)"
            />
            <rect
              style="isolation: isolate"
              width="138.85"
              height="1.83"
              rx="0"
              ry="0"
              transform="translate(814.11 522.59)"
              opacity="0.2"
              fill="#fff"
            />
            <rect
              width="138.85"
              height="1.83"
              rx="0"
              ry="0"
              transform="translate(814.11 520.77)"
            />
            <rect
              width="15.83"
              height="35.32"
              rx="0"
              ry="0"
              transform="translate(937.73 504.93)"
              fill="#191818"
            />
            <rect
              width="15.83"
              height="6.09"
              rx="0"
              ry="0"
              transform="translate(937.73 537.21)"
              fill="url(#exIqo09Fmte268-fill)"
            />
            <rect
              width="14.01"
              height="31.67"
              rx="0"
              ry="0"
              transform="translate(939.55 506.76)"
              fill="url(#exIqo09Fmte269-fill)"
            />
            <rect
              width="15.83"
              height="4.87"
              rx="0"
              ry="0"
              transform="translate(937.73 500.67)"
              fill="url(#exIqo09Fmte270-fill)"
            />
            <rect
              width="15.83"
              height="35.32"
              rx="0"
              ry="0"
              transform="translate(814.11 504.93)"
              fill="#191818"
            />
            <rect
              width="14.01"
              height="31.67"
              rx="0"
              ry="0"
              transform="translate(814.11 506.76)"
              fill="url(#exIqo09Fmte272-fill)"
            />
            <rect
              width="15.83"
              height="6.09"
              rx="0"
              ry="0"
              transform="translate(814.11 537.21)"
              fill="url(#exIqo09Fmte273-fill)"
            />
            <rect
              width="15.83"
              height="4.87"
              rx="0"
              ry="0"
              transform="translate(814.11 500.67)"
              fill="url(#exIqo09Fmte274-fill)"
            />
            <ellipse
              rx="58.46"
              ry="1.22"
              transform="translate(883.53 417.85)"
              fill="url(#exIqo09Fmte275-fill)"
            />
          </g>
        </g>
      </g>
      <g id="exIqo09Fmte276" opacity="0">
        <path
          d="M817.25,377.2v54.39l11.01,1.3v3.89h-31.08c-.65-1.3-.65-2.59,0-3.24l11.01-.65c0-3.24.65-7.12.65-11.66v-49.86l-11.66,1.94v-4.53l20.72-6.48c.65.65.65,1.3.65,1.94c0,1.3-.65,4.53-.65,8.42l-.65,4.53v0Z"
          fill="#fff"
        />
        <path
          d="M844.44,426.42c1.3,0,3.24.65,3.89,1.3c1.3,1.3,1.94,2.59,1.94,3.89s-.65,3.24-1.94,3.89-2.59,1.94-3.89,1.94-3.24-.65-3.89-1.94-1.94-1.94-1.94-3.24.65-2.59,1.3-3.89c1.94-1.3,3.24-1.94,4.53-1.94Z"
          fill="#fff"
        />
        <path
          d="M807.53,513.84h33.67l4.53-16.19h3.24v20.72h-52.45c-.65-1.94-.65-3.24,0-4.53l40.8-62.81h-31.08l-4.53,16.19h-3.24v-20.72h49.21c.65,1.3.65,2.59,0,4.53c0,0-40.15,62.81-40.15,62.81Z"
          fill="#fff"
        />
        <path
          d="M867.76,503.47v-53.75l-7.12-.65c-.65-1.3-.65-1.94,0-3.24h48.57v20.72h-3.24l-4.53-16.19h-23.96v27.2h14.25l1.94-9.07h3.24c0,3.24-.65,7.12-.65,11.66v11.66c-1.3.65-1.94.65-3.24,0l-1.94-9.71h-14.25v31.08h27.2l4.53-16.19h3.24v21.37h-52.45c-.65-1.3-.65-1.94,0-3.24l7.77-1.3c.65-2.59.65-6.48.65-10.36Z"
          fill="#fff"
        />
        <path
          d="M923.45,445.84c2.59,0,6.48,0,11.66-.65c5.18,0,10.36-.65,14.89-.65c9.07,0,15.54,1.94,19.43,5.18c3.89,3.89,5.83,8.42,5.83,14.89c0,3.89-1.3,7.77-3.89,10.36-2.59,3.24-6.48,5.18-11.01,7.12c2.59,4.53,5.18,8.42,7.12,12.3c1.94,3.89,3.89,6.48,5.18,8.42s1.94,3.24,2.59,5.18c.65,1.3,1.3,2.59,1.94,3.24s.65,1.3,1.3,1.3l6.48.65v3.24h-15.54l-13.6-24.61c-1.94-3.24-3.24-5.83-5.18-7.77h-1.3c-3.24,0-6.48,0-9.07-.65v29.14l8.42.65v3.24h-25.9c-.65-1.3-.65-1.94,0-3.24l7.77-1.3c0-1.94.65-5.83.65-10.36v-53.1l-7.12-.65c-.65.65-.65-.65-.65-1.94v0Zm16.84,14.89v20.07c1.94,0,4.53.65,8.42.65c3.24,0,5.83-.65,7.77-1.3c1.94-1.3,3.89-2.59,5.18-3.89s1.94-3.24,2.59-5.18.65-3.89.65-5.18c0-5.18-1.3-9.07-3.89-12.3s-7.12-4.53-12.95-4.53c-1.94,0-4.53,0-6.48.65-.65,3.24-1.3,7.12-1.3,11.01Z"
          fill="#fff"
        />
        <path
          d="M1025.76,444.55c5.83,0,11.01,1.3,16.19,3.24c4.53,1.94,8.42,5.18,11.66,8.42c2.59,3.24,5.18,7.12,6.48,11.66s2.59,9.07,2.59,13.6c0,11.01-3.24,20.07-10.36,27.2-7.12,7.12-15.54,11.01-25.9,11.01-5.83,0-11.01-1.3-15.54-3.24s-8.42-5.18-11.66-8.42-5.18-7.77-6.48-11.66c-1.3-4.53-2.59-8.42-2.59-13.6c0-7.12,1.3-13.6,4.53-19.43c3.24-5.83,7.12-10.36,12.95-14.25c5.18-3.24,11.01-4.53,18.13-4.53v0Zm0,70.58c5.83,0,10.36-1.3,14.25-5.18s7.12-7.77,8.42-12.3s2.59-10.36,2.59-16.84-.65-11.01-2.59-15.54-4.53-8.42-8.42-11.66-8.42-4.53-14.25-4.53c-8.42,0-14.25,3.24-18.78,9.07s-6.48,13.6-6.48,22.66c0,6.48.65,11.66,2.59,16.84s4.53,9.07,8.42,12.3c3.89,3.24,8.42,5.18,14.25,5.18v0Z"
          fill="#fff"
        />
        <path
          d="M807.53,593.48c3.24,2.59,8.42,3.89,14.89,3.89c4.53,0,7.77-1.3,9.71-3.89s3.24-5.18,3.24-9.07c0-1.94,0-3.24-.65-4.53c0-1.3-1.3-2.59-1.94-4.53-1.3-1.3-2.59-3.24-4.53-4.53s-5.18-3.24-8.42-5.18c-3.89-1.94-7.12-3.89-9.71-5.83s-4.53-3.89-5.83-5.83-1.94-3.89-2.59-5.18c-.65-1.94-.65-3.89-.65-6.48c0-5.18,1.94-9.71,6.48-12.3c4.53-3.24,9.07-4.53,14.89-4.53c7.12,0,14.25,1.94,20.72,5.18v17.48c-1.94.65-3.89.65-5.18,0l-3.24-15.54c-3.89-1.94-8.42-3.24-12.95-3.24-3.24,0-5.83,1.3-7.77,2.59-1.94,1.94-3.24,4.53-3.24,7.77c0,1.94,0,3.24.65,4.53c0,1.3.65,2.59,1.94,3.89c1.3,1.3,2.59,3.24,4.53,4.53s5.18,3.24,9.07,5.18c12.95,6.48,19.43,13.6,19.43,22.66c0,6.48-2.59,11.01-7.12,14.89-4.53,3.89-11.01,5.83-18.13,5.83s-14.25-1.94-20.72-5.18v-17.48c1.94-.65,3.89-.65,5.18,0l1.94,14.89v0Z"
          fill="#fff"
        />
        <path
          d="M874.88,542.33v53.1l7.12.65v3.24h-24.61c-.65-1.3-.65-1.94,0-3.24l7.77-1.3c0-1.94.65-5.83.65-10.36v-53.1l-7.77-.65v-3.24c3.24,0,7.77.65,12.3.65h12.3c.65,1.3.65,1.94,0,3.24l-7.77,1.3c.65,1.3,0,5.18,0,9.71Z"
          fill="#fff"
        />
        <path
          d="M954.53,595.43l7.77.65v3.24h-18.78c-5.18,0-9.07,0-11.66.65-.65-1.3-.65-1.94,0-3.24l9.07-1.3c-1.3-1.94-3.24-5.18-6.48-9.71l-11.66-17.48-20.72,27.2l7.12.65v3.24h-20.72c-.65-1.3-.65-1.94,0-3.24l6.48-1.3c3.24-3.24,5.83-5.83,7.12-7.77l17.48-23.31-22.66-32.38-6.48-.65v-3.24c3.24,0,8.42.65,14.25.65h14.89c.65,1.3.65,1.94,0,3.24l-9.07,1.94c1.3,1.94,1.94,3.89,3.24,5.18l12.3,17.48l18.13-23.96-7.12-.65v-3.24c3.24,0,6.48.65,10.36.65h10.36c.65,1.3.65,1.94,0,3.24l-5.83,1.3c-3.24,1.94-5.83,4.53-8.42,7.77l-14.89,19.43l25.9,34.97v0Z"
          fill="#fff"
        />
        <path
          d="M795.23,609.03h62.16v20.72h-3.24l-4.53-16.19h-18.78v63.46l9.07.65v3.24h-27.2c-.65-1.3-.65-1.94,0-3.24l8.42-1.3c0-1.94.65-5.83.65-10.36v-52.45h-18.78l-4.53,16.19h-3.24v-20.72v0Z"
          fill="#fff"
        />
        <path
          d="M918.91,642.05v-28.49l-7.12-.65v-3.24c3.24,0,7.77.65,12.3.65h12.3c.65,1.3.65,1.94,0,3.24h-7.12c0,1.94-.65,5.83-.65,10.36v53.1l7.12.65v3.24h-24.61c-.65-1.3-.65-1.94,0-3.24l7.77-1.3c0-1.94.65-5.83.65-10.36v-20.07h-35.62v31.08l7.12.65v3.24h-24.61c-.65-1.3-.65-1.94,0-3.24l7.77-1.3c0-1.94.65-5.83.65-10.36v-53.1l-7.12-.65v-3.24c3.24,0,7.77.65,12.3.65h12.3c.65,1.3.65,1.94,0,3.24l-8.42.65c0,1.94-.65,5.83-.65,10.36v17.48l35.62.65v0Z"
          fill="#fff"
        />
        <path
          d="M947.41,609.03c2.59,0,6.48,0,11.66-.65c5.18,0,10.36-.65,14.89-.65c9.07,0,15.54,1.94,19.43,5.18c3.89,3.89,5.83,8.42,5.83,14.89c0,3.89-1.3,7.77-3.89,10.36s-6.48,5.18-11.01,7.12c2.59,4.53,5.18,8.42,7.12,12.3c1.94,3.89,3.89,6.48,5.18,8.42s1.94,3.89,2.59,5.18s1.3,2.59,1.94,3.24c.65.65.65,1.3,1.3,1.3l6.48.65v3.24h-15.54L979.79,655c-1.94-3.24-3.24-5.83-5.18-7.77h-1.3c-3.24,0-6.48,0-9.07-.65v29.14l8.42.65v3.24h-25.9c-.65-1.3-.65-1.94,0-3.24l7.77-1.3c0-1.94.65-5.83.65-10.36v-53.1l-7.12-.65c-1.3.65-1.3-.65-.65-1.94v0Zm16.84,14.89v20.07c1.94,0,4.53.65,8.42.65c3.24,0,5.83-.65,7.77-1.3c1.94-1.3,3.89-2.59,5.18-3.89s1.94-3.24,2.59-5.18.65-3.89.65-5.18c0-5.18-1.3-9.07-3.89-12.3s-7.12-4.53-12.95-4.53c-1.94,0-4.53,0-6.48.65-1.3,3.24-1.3,7.12-1.3,11.01Z"
          fill="#fff"
        />
        <path
          d="M1021.87,666.66v-53.75l-7.12-1.3c-.65-1.3-.65-1.94,0-3.24h48.57v20.72h-3.24l-4.53-16.19h-24.61v27.2h14.25l1.94-9.07h3.24c0,3.24-.65,7.12-.65,11.66v11.66c-1.3.65-1.94.65-3.24,0l-.65-8.42h-14.25v31.08h27.2l4.53-16.19h3.24v20.72h-53.1v-3.24l7.77-1.3c0-2.59.65-6.48.65-10.36v0Z"
          fill="#fff"
        />
        <path
          d="M1084.69,666.66v-53.75l-7.12-1.3c-.65-1.3-.65-1.94,0-3.24h48.57v20.72h-3.24l-4.53-16.19h-24.61v27.2h14.25l1.94-9.07h3.24c0,3.24-.65,7.12-.65,11.66v11.66c-1.3.65-1.94.65-3.24,0l-1.94-9.71h-14.25v31.08h27.2l4.53-16.19h3.24v20.72h-52.45c-.65-1.3-.65-1.94,0-3.24l7.77-1.3c1.3-1.3,1.3-5.18,1.3-9.07v0Z"
          fill="#fff"
        />
        <path
          d="M1162.37,707.43h-407.26v-368.4h407.26v368.4ZM760.24,702.3h397v-358.15h-397v358.15Z"
          fill="#fff"
        />
      </g>
      <g id="exIqo09Fmte292" opacity="0">
        <g>
          <path
            d="M766.87,625.34c0-.75-1.5-1.5-2.25-1.5s-1.5.75-1.5,1.5h-3c0,0,.75-.75.75-1.5c0-15.01-.75-29.27-.75-44.28l.75-.75v-1.5q0-.75-.75-1.5v-33.02c0-16.51.75-32.27.75-48.78v-1.5c0-9.76.75-18.76.75-28.52c0-.75.75-1.5,1.5-1.5.75-.75,0-2.25-.75-2.25v0-1.5c.75-.75.75-1.5,0-2.25.75-12.76,1.5-25.52,2.25-38.27c0-.75-.75-1.5-2.25-2.25-12.01-1.5-24.02,0-36.02,3.75-6,1.5-11.26,3.75-16.51,6.75-4.5,2.25-9.01,6-13.51,9.01l-.75-.75c-.75,0-2.25,0-2.25,1.5v2.25c-3,1.5-6,3.75-9.76,4.5v-2.25c0-2.25-3.75-2.25-3.75,0v3h-1.5c-.75,0-2.25.75-2.25,2.25c0,.75.75,1.5,2.25,2.25h1.5c.75,9.01,3,18.01,7.5,26.27.75,1.5,2.25,1.5,3,0c9.76-9.76,20.26-18.01,31.52-26.27c2.25-1.5,4.5-3,6.75-4.5-.75,15.76-.75,31.52-.75,48.03v0v38.27c-.75.75-1.5,1.5-2.25,2.25s-.75,2.25,0,3s1.5.75,2.25,0c0,17.26,0,35.27.75,52.53v2.25l-.75.75c-.75.75-.75,2.25,0,3c0,0,.75,0,.75.75c0,6,0,12.76.75,18.76l-.75.75c-.75.75-.75,2.25,0,3h.75v8.26v0c-.75,0-1.5.75-2.25,1.5v1.5h-.75c-.75,0-2.25.75-2.25,2.25s.75,2.25,2.25,2.25l17.26-.75c0,0,0,.75.75.75.75.75,2.25,0,3-.75v0l15.76-.75c1.5,0,3,0,3.75-.75-.75-3,0-4.5,0-5.25v0Zm-12.01-29.27l.75-.75v0v8.26c-.75,0-.75.75-1.5.75-2.25,3-4.5,6-6.75,8.26c3-4.5,5.25-9.01,7.5-13.51.75-1.5.75-2.25,0-3Zm.75-3.75v0c-.75-.75-2.25-1.5-3,0-7.5,8.26-15.01,17.26-21.01,26.27v0-4.5h1.5c4.5-3,7.5-7.5,11.26-11.26c3.75-4.5,6.75-9.01,10.51-14.26l1.5-2.25c-.75,2.25-.75,3.75-.75,6Zm-21.76-.75c-.75.75-1.5,2.25-2.25,3l-.75.75v-4.5c1.5-1.5,3-3.75,4.5-6c.75-1.5,2.25-2.25,3-3.75s1.5-2.25,3-3.75c2.25-2.25,4.5-4.5,6-6.75c2.25-2.25,3.75-4.5,5.25-7.5c1.5-1.5,2.25-3.75,3-5.25v3.75c-.75,0-.75.75-1.5.75-4.5,6-9.01,12.76-12.76,19.51-2.25,3-4.5,6.75-7.5,9.76Zm23.26-171.86h3v3.75c-.75,0-1.5,0-1.5.75-6.75,7.5-14.26,15.01-21.01,21.76l-6,6c0,0,0,.75-.75.75v-8.26q.75,0,1.5-.75l24.02-23.26c.75,0,1.5-.75.75-.75v0Zm.75,36.77l-.75.75c-3,2.25-5.25,4.5-8.26,7.5q-.75.75-1.5,1.5l7.5-9.76l3.75-5.25c0,1.5,0,3-.75,5.25v0ZM730.09,480.5c0-9.01,0-18.01.75-27.02c0,1.5,2.25,2.25,3,.75c6.75-7.5,14.26-14.26,21.01-21.76l4.5-4.5v4.5c-7.5,8.26-14.26,17.26-21.01,26.27-1.5,2.25-3.75,5.25-5.25,7.5-.75.75,0,2.25.75,2.25.75.75,2.25,0,3-.75c6-9.01,12.76-18.01,20.26-26.27.75-.75,2.25-2.25,3-3.75v6.75c-.75,0-1.5,0-1.5.75l-21.01,28.52-7.5,8.26v-1.5v0Zm23.26-15.76c1.5-1.5,2.25-2.25,3.75-3l.75-.75v2.25c-6,8.26-12.76,15.76-19.51,23.26-2.25,2.25-4.5,4.5-6.75,6.75-.75.75-.75,2.25,0,3s2.25.75,3,0l.75-.75-5.25,6v-9.76c6.75-9.76,15.01-18.76,23.26-27.02v0Zm-23.26,48.78h2.25c0,0,0,.75.75.75.75.75,2.25.75,3,0c7.5-9.01,14.26-18.76,20.26-27.77.75-.75,0-1.5-.75-2.25.75-.75.75-1.5,1.5-2.25v6c-4.5,5.25-8.26,11.26-12.01,17.26s-7.5,12.01-12.01,17.26c-.75.75-1.5,2.25-3,3c0-4.5,0-8.26,0-12.01v0Zm9.01,44.28c-1.5,2.25-3,4.5-4.5,6s-3,3-3.75,5.25v-5.25c.75,0,1.5,0,2.25-.75c6.75-9.01,12.76-18.76,19.51-27.77l4.5-6v4.5c-.75,0-1.5,0-2.25.75l-9.76,15.01c-3,3-4.5,6-6,8.26v0Zm16.51-33.02c-.75,0-1.5,0-2.25.75l-.75.75c-.75,0-1.5,0-1.5.75-6,8.26-12.01,16.51-18.01,25.52-.75,1.5-2.25,3-3,4.5v-8.26c0,0,.75,0,.75-.75c8.26-8.26,15.76-17.26,22.51-27.77.75-1.5,1.5-2.25,2.25-3.75.75,3,0,5.25,0,8.26v0ZM733.1,539.04c1.5-.75,2.25-2.25,3-3c1.5-2.25,3.75-4.5,5.25-7.5c3.75-5.25,7.5-9.76,10.51-15.01c1.5-2.25,3-4.5,4.5-6v3c0,0-.75,0-.75.75-6,9.76-12.76,19.51-20.26,27.77-1.5,1.5-3,3.75-5.25,5.25v-3c0,0,.75,0,.75-.75s0-.75.75-1.5h1.5Zm21.01-36.02c-6,9.01-12.01,18.01-18.76,26.27c4.5-9.76,10.51-18.76,17.26-27.02l3.75-3.75v3c-.75.75-1.5.75-2.25,1.5Zm-21.76,30.77v0c0,.75-.75,1.5-1.5,1.5h-.75v-5.25c.75-.75,1.5-1.5,2.25-2.25-.75.75-.75,2.25-1.5,3s.75,3,1.5,3v0Zm18.76,12.01l4.5-6.75v4.5c-.75-.75-2.25,0-2.25.75-2.25,3.75-4.5,6.75-7.5,9.76c2.25-3,3.75-6,5.25-8.26v0Zm4.5,21.76v2.25h-1.5c.75-.75.75-1.5,1.5-2.25Zm1.5-93.06c0,0-.75,0-.75.75-6,9.76-12.01,19.51-19.51,27.77-.75,1.5-2.25,2.25-3,3.75-.75.75-.75,1.5-1.5,1.5h-.75v-3c.75,0,1.5,0,2.25-.75l23.26-29.27c.75-.75.75-2.25,0-3v0c.75-.75.75-1.5,1.5-2.25v-.75c-.75,2.25-1.5,3.75-1.5,5.25v0Zm-3.75-54.78L731.6,440.73v-1.5c0-1.5-1.5-2.25-3-1.5c0,0-.75,0-.75.75c0-.75.75-.75.75-1.5.75.75,1.5.75,2.25,0c5.25-5.25,10.51-10.51,16.51-15.76.75,0,.75-.75.75-1.5c1.5,0,3,0,5.25,0v0Zm-51.03,15.76v0Zm-4.5,3.75c0,0,0-.75,0,0q0-.75.75-.75c0,0-.75.75-.75.75Zm-12.76,17.26v0Zm9.76-15.01v3l-2.25,5.25c-2.25,2.25-4.5,4.5-6.75,6c4.5-3.75,7.5-9.01,9.01-14.26Zm2.25,18.76c.75-.75.75-1.5,1.5-2.25v0c1.5-.75,1.5-1.5,2.25-2.25l2.25-3l3.75-6c.75-.75,2.25-1.5,3-3l-.75.75c-.75.75-.75,2.25,0,3s2.25.75,3,0l8.26-9.76c0,.75,0,2.25,1.5,2.25l-.75.75c-.75.75-.75,2.25,0,3-8.26,6-17.26,12.01-24.77,18.76c0-.75,0-1.5.75-2.25v0Zm24.77-35.27c1.5-.75,3-.75,4.5-1.5l-8.26,10.51c1.5-2.25,3-4.5,3.75-6.75v-2.25v0Zm6.75,1.5v1.5l-.75,1.5c-.75,1.5-1.5,3-3,3.75-.75.75-2.25,2.25-3,2.25v0l6.75-9.01v0Zm2.25-1.5h-.75v-2.25h-.75c1.5,0,3-.75,3.75-.75l-2.25,3Zm12.01-5.25c-3.75,3.75-7.5,6.75-11.26,10.51v-.75l5.25-7.5v-1.5c1.5,0,3-.75,4.5-.75.75.75,1.5.75,1.5,0v0Zm-25.52,7.5c-.75.75-1.5,2.25-1.5,3v0c-.75-.75-2.25,0-3,.75l-8.26,12.01v.75l-.75.75c.75-.75.75-2.25,1.5-3.75.75-2.25,1.5-4.5,2.25-6.75v-1.5c.75,0,1.5-.75,2.25-.75c1.5-1.5,4.5-3.75,7.5-4.5v0Zm-30.02,17.26l-3,6v1.5l-.75.75c0-2.25-.75-4.5-.75-6.75c1.5,0,3-.75,4.5-1.5v0Zm-3,12.76v0c0,0,.75,0,0,0c0,0,0,1.5.75,1.5.75.75,2.25.75,3,0s1.5-1.5,2.25-2.25c-.75.75-1.5,1.5-3,3s0,3,1.5,3c-.75.75-.75,2.25-.75,3s.75.75,1.5.75c-.75.75-1.5,1.5-1.5,1.5-1.5-3-3-6.75-3.75-10.51v0Zm46.53,120.83c7.5-7.5,14.26-15.76,21.01-24.02c1.5-2.25,3-3.75,4.5-6v4.5c-.75,0-1.5,0-1.5.75-2.25,5.25-6,9.76-9.76,15.01-1.5,2.25-3.75,4.5-6,6.75s-3.75,5.25-6,7.5c-.75.75-1.5,2.25-2.25,3c0-3,0-5.25,0-7.5v0Zm0,22.51c.75,0,.75-.75,1.5-1.5.75-1.5,1.5-2.25,3-3.75c0,.75,0,1.5.75,1.5.75.75,2.25,0,3-.75c2.25-4.5,4.5-8.26,6.75-12.76c1.5-1.5,3-3,3.75-4.5c2.25-2.25,4.5-4.5,6.75-6.75v4.5l-21.76,26.27-2.25,3c-.75-.75-1.5-3-1.5-5.25Zm.75,26.27v-1.5c1.5-2.25,3-4.5,4.5-6.75c3.75-5.25,7.5-9.76,11.26-15.01-3,6-6.75,12.01-11.26,17.26-.75,0-1.5,0-2.25,1.5c0,.75,0,2.25,1.5,2.25c3,0,4.5-.75,6.75-2.25c1.5-1.5,3.75-3,5.25-5.25l.75-.75c-2.25,3.75-3.75,6.75-6,10.51h-10.51Zm15.76,0c3-5.25,6-9.76,8.26-15.01v13.51q0,.75.75,1.5h-9.01Zm15.76-.75v0Zm0,0v0Z"
            fill="#fff"
          />
          <path
            d="M935.72,511.26c-.75-.75-1.5-.75-2.25,0-1.5.75-2.25,1.5-3.75,3c0-3.75-.75-7.5-.75-10.51v-1.5v0c0-3-.75-5.25-1.5-8.26-.75-3.75-1.5-7.5-2.25-11.26l1.5-1.5c.75-.75.75-1.5,0-2.25s-1.5-.75-2.25,0v0c-2.25-9.01-6-17.26-11.26-25.52-7.5-11.26-17.26-21.01-29.27-27.02-6-3-12.76-6-19.51-6.75c0-1.5-2.25-1.5-3-.75-5.25-.75-9.76-.75-15.01,0-12.76,1.5-24.77,7.5-33.77,16.51s-15.76,20.26-20.26,32.27c-.75,2.25-1.5,4.5-2.25,6.75l-.75.75c-1.5.75-.75,2.25,0,3-3,11.26-3.75,23.26-3.75,34.52v3.75c-.75.75-.75,2.25,0,2.25.75,13.51,3,27.02,6.75,39.77c2.25,7.5,4.5,15.01,6.75,22.51c2.25,6.75,4.5,14.26,9.01,21.01c8.26,12.76,23.26,16.51,37.52,17.26h9.76c1.5,0,3,.75,4.5.75c6.75.75,13.51-.75,20.26-3s13.51-6.75,18.76-11.26l3.75-3.75c.75-.75,1.5-.75,1.5-1.5l.75-.75c1.5-2.25,3.75-3.75,5.25-6c2.25-1.5,5.25-3,7.5-4.5.75-.75.75-1.5.75-2.25-.75-.75-1.5-.75-2.25-.75s-.75.75-1.5.75c2.25-4.5,5.25-9.01,6.75-13.51c5.25-12.76,8.26-25.52,9.01-39.02.75-5.25.75-11.26.75-16.51c2.25-1.5,3.75-3,6-4.5-.75-.75-.75-1.5-1.5-2.25v0Zm-9.01,17.26c-.75-.75-1.5-.75-2.25,0-2.25,1.5-4.5,3.75-6.75,5.25.75-1.5-.75-3-2.25-2.25-6.75,3.75-13.51,7.5-19.51,12.76v-.75c6.75-4.5,13.51-9.01,20.26-13.51c2.25-1.5,4.5-3,6.75-4.5.75-.75,1.5-1.5.75-2.25v0c1.5-.75,2.25-1.5,3-2.25c0,2.25,0,5.25,0,7.5v0Zm-1.5,15.01c-.75,0-1.5,0-1.5.75-6,6.75-13.51,12.76-20.26,17.26-3.75,3-7.5,5.25-11.26,7.5-.75.75-1.5.75-2.25,1.5.75-1.5,1.5-3,1.5-4.5l.75.75c.75,0,1.5,0,2.25-1.5c1.5-4.5,5.25-7.5,9.01-10.51c4.5-3,9.76-6,14.26-9.01c2.25-1.5,5.25-3.75,7.5-6c1.5-1.5-.75-3.75-2.25-2.25-3.75,3.75-8.26,7.5-13.51,9.76-.75.75-1.5.75-2.25,1.5c3.75-3.75,7.5-6.75,11.26-10.51c3-2.25,6-5.25,9.01-7.5v0c-1.5,4.5-1.5,8.26-2.25,12.76v0Zm-43.53,31.52c-3.75,2.25-7.5,6-9.01,9.76-.75,1.5.75,3,1.5,2.25-2.25,2.25-5.25,3.75-9.01,5.25v-.75c0-1.5-2.25-1.5-3-.75l-2.25,2.25h-1.5v-.75c-.75-.75-1.5-1.5-2.25-.75s-1.5.75-1.5,1.5c-1.5,0-3.75-.75-5.25-1.5.75,0,.75-.75,1.5-.75s1.5-1.5,1.5-2.25-1.5-1.5-2.25-1.5c-1.5.75-3,1.5-4.5,2.25-3-1.5-6-3.75-8.26-6.75.75-.75.75-1.5,0-2.25s-1.5-1.5-2.25-.75v0l-.75-.75c0,0,0-.75-.75-.75h-.75l-.75-.75c0-1.5-.75-2.25-1.5-2.25l1.5-2.25c1.5-2.25-1.5-3.75-3-1.5v.75c0,0-.75-.75-.75-1.5-1.5-2.25-2.25-3.75-3.75-6v0c.75-.75.75-1.5,0-2.25s-1.5-.75-1.5,0v0c-.75-.75-.75-2.25-1.5-3c0,0,.75-.75,1.5-.75.75-.75.75-1.5,0-2.25s-1.5-.75-2.25,0c0-1.5-.75-2.25-.75-3.75v-11.26c0-7.5,0-15.01.75-22.51.75-14.26,3-28.52,9.01-41.28c0-.75.75-1.5,1.5-2.25l.75-.75c.75-.75.75-1.5,0-1.5c5.25-9.01,12.01-16.51,20.26-21.76c1.5-1.5,3.75-2.25,6-3c4.5-.75,9.76.75,13.51,3.75v.75c0,0,.75.75,1.5.75c1.5.75,2.25,2.25,3.75,3l-3.75,3.75c-.75.75-.75,1.5,0,2.25s1.5.75,2.25,0c.75-1.5,2.25-2.25,3-3.75c1.5,2.25,3.75,5.25,4.5,7.5c3,6.75,4.5,13.51,5.25,20.26c1.5,7.5,2.25,14.26,3,21.76v3.75v0c.75,10.51.75,21.01,0,31.52-.75,0-.75.75-1.5.75-.75.75-1.5,1.5-.75,2.25c0,.75.75.75,1.5.75v1.5c-.75.75-1.5,1.5-3,2.25-.75.75-.75,1.5,0,2.25s1.5.75,1.5,0c-.75,3.75-1.5,7.5-3,10.51-.75.75-1.5,1.5-2.25,3-.75.75-.75,1.5,0,2.25v0q0,.75-.75,1.5c-.75.75-.75,2.25-1.5,3c1.5,0,.75.75,0,1.5v0Zm-1.5,6c-1.5,1.5-2.25,3-3.75,4.5l-.75.75c.75-2.25,2.25-3.75,4.5-5.25Zm-18.76,17.26v0q-.75,1.5-1.5,2.25c-1.5,3-3.75,6-4.5,9.01-.75,1.5-.75,3.75,0,6c0,0,0,.75.75.75h-.75c-2.25,0-5.25-.75-7.5-1.5l14.26-16.51c-.75-.75-.75,0-.75,0v0ZM829.9,614.07c0-1.5.75-2.25,1.5-3.75.75,0,.75.75,1.5.75c0,0,0,.75.75.75h1.5c.75,0,1.5.75,2.25,1.5c0,.75-.75.75-.75,1.5-3,0-5.25,0-6.75-.75Zm-9.01-9.76l-2.25-1.5c-.75-.75-1.5-.75-2.25,0v0c.75-.75.75-1.5,1.5-1.5c1.5,0,3,1.5,3,3v0Zm-9.76-19.51c0-.75-.75-1.5-.75-1.5l14.26-8.26c0,0,.75,0,.75-.75c0,0,.75.75.75,1.5l-2.25,3.75c-3.75,3-6.75,6-9.76,9.76-.75-1.5-2.25-3-3-4.5v0Zm-9.76-6c-.75-1.5-.75-2.25-1.5-3.75.75,0,.75-.75,1.5-.75.75,1.5,1.5,3,2.25,5.25l-1.5,1.5c0-.75,0-1.5-.75-2.25v0Zm-9.01-33.77c.75,2.25.75,4.5,1.5,6.75v0c0-2.25-.75-4.5-1.5-6.75Zm6-81.8h.75c0,.75-.75.75-.75,1.5l-.75.75c0-.75,0-1.5.75-2.25Zm27.77-26.27l19.51-9.76l8.26-3.75c.75,0,.75-.75.75-1.5c1.5,0,3.75,0,5.25.75l-5.25,5.25c-.75-.75-1.5-.75-2.25,0-.75,0-.75.75-1.5.75h-.75c-2.25,1.5-5.25,3.75-7.5,5.25-.75-.75-1.5-.75-2.25,0-9.01,4.5-18.76,9.76-27.02,15.76c4.5-5.25,8.26-9.01,12.76-12.76v0Zm31.52.75v0c.75,1.5,2.25,1.5,3,.75l5.25-6c1.5-1.5,3.75-2.25,5.25-3.75.75-.75,1.5-1.5.75-2.25l-.75-.75v-.75c2.25.75,4.5,1.5,7.5,3l-15.01,15.76h-3.75c-.75-.75-1.5-.75-1.5-.75-.75,0-1.5.75-1.5.75-4.5.75-8.26,2.25-12.01,4.5-6,4.5-10.51,9.76-13.51,16.51-1.5,2.25-3,5.25-3.75,7.5-.75,0-1.5.75-2.25.75-1.5.75-3,.75-4.5,1.5-3,1.5-6,3-8.26,4.5-5.25,3.75-9.76,8.26-14.26,12.76-1.5.75-3,2.25-3.75,3v0-2.25c9.01-6.75,18.01-14.26,27.02-21.01c3-2.25,6-4.5,8.26-6c.75-.75,1.5-1.5.75-2.25s-1.5-1.5-2.25-.75c-3,2.25-6,4.5-9.01,6.75l4.5-4.5l3-2.25l9.76-7.5c.75-.75.75-1.5,0-2.25c6-3.75,12.76-8.26,18.76-12.01c0-1.5.75-2.25,2.25-3v0ZM817.12,504.5l-20.26,18.01-3.75,3c0-1.5,0-3-.75-3.75v0c3.75-2.25,7.5-5.25,11.26-8.26c1.5-1.5,3.75-3,5.25-4.5s3-3,4.5-3.75c.75-.75,1.5-1.5,2.25-1.5s.75,0,1.5-.75v0c.75,0,0,.75,0,1.5Zm-3.75,54.78c.75-1.5,1.5-3,2.25-4.5c0,.75,0,1.5.75,2.25v0c-1.5.75-2.25,1.5-3,2.25v0Zm1.5-15.01c-1.5,1.5-3.75,3-5.25,3.75l3.75-3.75c1.5-1.5-.75-3.75-2.25-2.25l-7.5,7.5-3.75,3.75-.75.75c0-.75,0-1.5-.75-1.5c5.25-5.25,11.26-9.76,17.26-15.01v3.75c-.75,1.5-.75,2.25-.75,3v0Zm.75-25.52c-4.5,3-8.26,6-12.76,9.01c3-3,5.25-6,8.26-9.01c1.5-1.5,3-2.25,4.5-3.75.75,1.5,0,2.25,0,3.75v0Zm-21.01,16.51c0,0,0-.75,0,0q.75,0,1.5-.75c-.75,0-1.5.75-1.5.75v0Zm3-21.76c-1.5,1.5-3.75,2.25-5.25,3.75v-.75c3.75-2.25,7.5-4.5,10.51-7.5-2.25,1.5-3.75,3-5.25,4.5v0Zm18.01,9.76v5.25h-1.5c-6.75,3.75-12.76,8.26-18.01,14.26c0-1.5-.75-2.25-.75-3.75c6-5.25,12.76-10.51,20.26-15.76v0Zm-18.76,23.26v0c6-6,12.01-11.26,18.76-15.01v1.5c0,0-.75,0-.75.75-6,4.5-12.01,9.76-17.26,15.01-.75-.75-.75-1.5-.75-2.25v0Zm18.01,1.5v3c-.75,0-1.5,0-2.25.75-1.5,3-3.75,6-5.25,9.01-1.5,0-3.75.75-6,.75-.75,0-1.5,0-1.5.75v-.75c5.25-5.25,9.76-9.01,15.01-13.51Zm-12.76,16.51h3l-2.25,2.25v0c-.75,0-.75-1.5-.75-2.25v0Zm2.25,6c1.5-2.25,3.75-4.5,5.25-6.75.75,0,1.5-.75,2.25-.75-.75.75-1.5,2.25-1.5,3-.75,1.5-1.5,3.75-2.25,5.25s-1.5,3-2.25,3.75c-.75-1.5-.75-3-1.5-4.5v0Zm9.01-2.25c1.5-2.25,2.25-5.25,4.5-7.5.75.75.75,2.25,1.5,3-2.25,1.5-3.75,3.75-6,5.25v-.75Zm3-56.29h-1.5c-6.75,4.5-10.51,11.26-16.51,16.51-1.5,1.5-3,2.25-4.5,3v-1.5v0l21.01-18.01l2.25-2.25c-.75.75-.75,1.5-.75,2.25Zm1.5-13.51h-1.5c.75,0,.75-.75,1.5-.75s0,.75,0,.75Zm1.5-6c0,0-.75,0-.75.75-8.26,6.75-16.51,12.76-24.77,18.76-.75,0-1.5.75-1.5,1.5v-4.5c9.01-6.75,17.26-14.26,25.52-21.76c1.5-1.5,3.75-3,5.25-4.5-1.5,2.25-3,6-3.75,9.76v0Zm-6.75-21.01c0,0,0,.75,0,0-5.25,4.5-10.51,9.01-16.51,13.51-.75.75-1.5,1.5-2.25,1.5v0l18.76-15.01v0Zm-20.26,27.02c4.5-2.25,9.01-6,12.76-9.76c1.5-1.5,2.25-2.25,3.75-3c.75-.75,1.5-.75,1.5-1.5.75-.75,1.5-.75,1.5-1.5c2.25-1.5,5.25-3.75,7.5-4.5.75,0,1.5-.75,2.25-.75v0c-9.01,8.26-18.01,15.76-27.02,23.26-1.5.75-2.25,2.25-3.75,3c.75-2.25,1.5-3.75,1.5-5.25v0Zm32.27-21.76c0,0-.75,0,0,0v0Zm-3.75-22.51c6.75-5.25,14.26-11.26,21.01-15.76c1.5-.75,3-2.25,4.5-3l-4.5,4.5-10.51,10.51c-6.75,4.5-14.26,8.26-21.01,12.76c3.75-3,6.75-6,10.51-9.01v0Zm24.77-12.76v0l.75-.75c0,0-.75,0-.75.75Zm-24.77,6.75c-5.25,3.75-9.76,7.5-15.01,11.26c0,0,.75-.75.75-1.5c4.5-3.75,9.01-6.75,14.26-9.76Zm0,12.76v0l-21.76,17.26-3,2.25c.75-2.25,1.5-4.5,2.25-6.75c7.5-3.75,15.01-8.26,22.51-12.76v0Zm-25.52,94.56v.75v0c0,0-.75-.75,0-.75-.75,0,0,0,0,0Zm.75,3.75v0c.75,0,.75.75.75.75v.75q-.75-.75-.75-1.5Zm1.5,5.25v0c.75.75,1.5,2.25,2.25,3.75c0,.75.75,1.5.75,2.25v.75v0c-2.25-2.25-3-4.5-3-6.75v0Zm23.26,3c.75,1.5,1.5,3,2.25,4.5h-.75l-14.26,8.26v-.75c3.75-4.5,8.26-8.26,12.76-12.01Zm-3,22.51c0,1.5,2.25,2.25,3,.75l5.25-9.01c.75-.75,1.5-1.5,3-2.25l.75.75c-2.25,3-4.5,6.75-6.75,9.76l-4.5,4.5c-.75-.75-1.5-2.25-2.25-3c0,0,.75-.75,1.5-1.5v0Zm4.5,9.01v0q1.5-1.5.75-2.25c.75-1.5,1.5-3,2.25-3.75c3-2.25,5.25-5.25,8.26-7.5v0q-.75,0-1.5.75c-2.25,3.75-4.5,8.26-6,12.01l-2.25,2.25c0,0-.75-.75-1.5-1.5v0Zm28.52-3l-2.25,2.25v-.75c1.5-2.25-1.5-3.75-3-1.5-3,4.5-5.25,9.76-7.5,14.26-.75,0-1.5-.75-1.5-.75c2.25-4.5,3.75-9.01,5.25-13.51.75-.75,1.5-.75,2.25-1.5l.75-.75c2.25,1.5,3.75,2.25,6,2.25v0Zm6,1.5l-4.5,5.25c.75-1.5,1.5-3,1.5-4.5l.75-.75c.75,0,1.5,0,2.25,0Zm-24.77,9.76c.75-1.5,2.25-3.75,3.75-5.25-.75,2.25-1.5,3.75-2.25,6q-.75-.75-1.5-.75Zm-2.25-6c3-2.25,6-5.25,9.01-7.5v.75c-3.75,3-6.75,6.75-9.76,11.26c0,0-.75,0-.75-.75.75-1.5,1.5-3,1.5-3.75v0Zm3.75-7.5c.75-1.5,1.5-3.75,3-5.25v-.75c0,0,.75.75,1.5.75l.75.75c-2.25,1.5-3.75,3-5.25,4.5Zm15.01,9.76c-1.5,3.75-3,6.75-5.25,9.76v0c-.75,0-1.5-.75-2.25-.75c2.25-3.75,4.5-6.75,7.5-9.01v0Zm43.53-168.86c1.5,1.5,3,2.25,4.5,3.75-6,3.75-12.01,7.5-17.26,12.76-.75-.75-2.25-2.25-3.75-3c5.25-5.25,10.51-9.76,16.51-13.51v0Zm21.01,25.52c0,0,0,.75,0,0l-6.75,6.75c1.5-2.25,3-3.75,4.5-6c.75-.75,1.5-2.25,1.5-3c0,1.5.75,2.25.75,2.25Zm-8.26,3.75c-1.5,1.5-2.25,3-3,4.5s-1.5,3-3,4.5c-.75.75-.75,1.5-1.5,2.25l-.75.75h-.75c-.75,0-1.5.75-1.5,1.5v1.5l-2.25,2.25c-1.5,1.5.75,3.75,2.25,2.25l19.51-19.51c.75,2.25,2.25,4.5,3,6.75h-1.5c-7.5,6-15.01,12.76-21.01,19.51-.75.75-.75,1.5,0,2.25h.75c0,0-.75.75-1.5.75v-.75c-.75-6.75-2.25-12.76-3.75-19.51c0,0,0,.75.75.75.75.75,1.5,0,2.25-.75l8.26-12.01l3.75-6c.75-.75,1.5-1.5,2.25-3c0,0,0-.75.75-.75.75.75.75,1.5,1.5,2.25-.75,4.5-2.25,7.5-4.5,10.51v0Zm20.26,37.52c-8.26,5.25-15.76,11.26-22.51,18.01l-6,6v0-9.01h.75l22.51-16.51l5.25-3.75v5.25v0Zm-31.52,55.53c.75-2.25,1.5-5.25,1.5-7.5c6.75-5.25,13.51-9.76,21.01-14.26-8.26,6.75-15.76,14.26-22.51,21.76v0Zm3.75-29.27v0Zm27.02-34.52l-22.51,16.51-5.25,3.75v-3c7.5-5.25,15.01-10.51,22.51-16.51c1.5-1.5,3.75-3,5.25-4.5-.75,1.5,0,2.25,0,3.75ZM898.9,457.22c-1.5,4.5-3.75,8.26-6.75,12.01-.75.75-.75,1.5,0,2.25l-.75.75v.75c0-.75,0-1.5-.75-1.5c0-.75-.75-2.25-.75-3v0c3.75-1.5,6-5.25,7.5-8.26l1.5-3v0Zm6.75-6.75v0q0,.75,0,0-.75,1.5-1.5,2.25l-.75,1.5v-.75c0-.75,0-1.5-1.5-2.25.75-.75.75-1.5,1.5-2.25v-1.5c.75.75.75,1.5,1.5,2.25q.75,0,.75.75v0Zm-11.26,6.75c-.75,1.5-1.5,3-3,4.5c0,.75-.75,1.5-1.5,1.5c0,0-.75,0-.75.75c0,0-.75,0-.75.75h-.75v-.75l7.5-8.26-.75,1.5Zm-8.26,3v0c-1.5-2.25-3-4.5-4.5-6.75c3.75-3.75,8.26-7.5,13.51-10.51-2.25,5.25-5.25,9.76-8.26,14.26-.75,1.5-.75,2.25-.75,3Zm21.76,69.04c-2.25,1.5-5.25,3-7.5,4.5-.75.75-.75,1.5-.75,2.25s.75.75.75.75c-.75.75-1.5,1.5-2.25,1.5s-.75.75-1.5.75v-6.75l2.25-2.25c.75-.75,2.25-1.5,3-2.25s2.25-1.5,3-2.25s2.25-1.5,3-2.25l1.5-1.5l1.5-1.5c.75-.75,1.5-1.5,2.25-3l2.25-2.25c0,0,.75-.75,1.5-.75s1.5-.75,1.5-.75h3c1.5,0,2.25-.75,3-2.25c0-.75,0-1.5-1.5-2.25-.75,0-1.5,0-1.5.75h-3.75c.75-.75,2.25-1.5,3-2.25c1.5-.75,3-2.25,4.5-3c0,3,.75,6.75.75,9.76v.75c-5.25,6-11.26,10.51-18.01,14.26v0Zm-12.01-26.27c.75.75,1.5,1.5,2.25.75c7.5-5.25,15.01-11.26,22.51-17.26l1.5-1.5v1.5v0c-7.5,6-15.01,12.01-22.51,17.26-1.5.75-3,1.5-4.5,3c0-3-.75-6-.75-9.01h.75c3.75-2.25,7.5-5.25,10.51-8.26c1.5-1.5,3-3,5.25-4.5c1.5-1.5,3-2.25,4.5-3.75s3.75-2.25,5.25-2.25v0c0,.75,0,1.5.75,2.25-6,5.25-12.01,10.51-18.01,15.01-2.25,1.5-4.5,3-6.75,4.5-.75.75-.75,1.5-.75,2.25v0Zm24.02-27.77c-3.75.75-6.75,3-9.76,6s-6,5.25-9.01,7.5c5.25-5.25,11.26-10.51,17.26-15.76l.75-.75c0,.75.75,1.5.75,1.5v1.5v0Zm-17.26-30.77v0c-.75,0-1.5,0-1.5.75l-6,5.25c1.5-3,3-6,4.5-9.01.75.75,2.25,2.25,3,3v0Zm-13.51-12.01c-6,3.75-11.26,8.26-15.76,13.51-1.5-.75-3.75-1.5-5.25-2.25l13.51-14.26v-.75c3,.75,5.25,2.25,7.5,3.75v0Zm-20.26-9.01v0l-5.25,6c-4.5,3-8.26,6-12.76,8.26l7.5-7.5c2.25-2.25,3.75-4.5,5.25-6.75v0c0,0,0-.75.75-.75s1.5,0,2.25.75c.75-.75,1.5-.75,2.25,0v0Zm-38.27,3c6-3,12.01-4.5,18.76-5.25l-3,1.5c-.75,0-.75-.75-1.5,0-7.5,3-14.26,6.75-21.01,11.26h-.75l-8.26,3.75c-.75.75-.75,1.5-.75,2.25c0,0,0,.75.75.75-.75.75-1.5,1.5-3,3-3,3.75-6,7.5-9.01,11.26-1.5.75-2.25,1.5-3,2.25c1.5-2.25,2.25-4.5,3.75-6.75c7.5-9.76,15.76-18.76,27.02-24.02v0Zm-35.27,45.03v0Zm10.51,117.82c-.75-2.25-1.5-3.75-2.25-6q.75,0,1.5-.75t.75-1.5c1.5,3.75,3.75,6.75,6,9.76-1.5,1.5-2.25,3-3,5.25-1.5-1.5-2.25-4.5-3-6.75v0Zm4.5,10.51c0,0,.75,0,.75-.75.75-1.5,1.5-3,3-4.5.75.75,1.5,1.5,2.25,3-.75.75-.75,1.5-1.5,1.5-.75.75-.75,1.5,0,2.25s1.5.75,2.25,0v0c-.75.75-.75,1.5,0,2.25l3.75,3c.75.75,1.5.75,2.25,0s1.5-1.5,2.25-1.5c.75.75,2.25,1.5,3.75,2.25-.75,1.5-1.5,3-1.5,4.5-.75,0-1.5-.75-1.5-.75-7.5-1.5-12.01-5.25-15.76-11.26Zm29.27,15.76h2.25c-.75.75-1.5,0-2.25,0v0Zm48.03-10.51c-1.5.75-2.25,2.25-3.75,3c5.25-5.25,10.51-9.76,16.51-13.51c2.25-1.5,3.75-3,6-3.75c2.25-1.5,0-4.5-1.5-3-7.5,4.5-15.01,10.51-21.01,16.51l-5.25,5.25c-.75.75-.75,1.5,0,2.25-4.5,1.5-8.26,2.25-12.76,3.75-2.25,0-4.5.75-6.75.75v0c3.75-6,8.26-12.01,13.51-16.51c0,1.5-.75,2.25-.75,3.75l-7.5,4.5c-.75.75-.75,1.5,0,2.25s1.5.75,2.25,0l.75-.75c0,0,0,.75-.75,1.5-1.5,2.25,1.5,3.75,3,1.5c0-.75.75-1.5.75-2.25h2.25c9.76-10.51,20.26-20.26,32.27-27.77c3-2.25,6-3.75,9.76-6-2.25,4.5-4.5,8.26-7.5,12.76-.75.75-.75,1.5-1.5,1.5-6,4.5-12.01,9.01-18.01,14.26v0Zm-14.26,0l1.5-.75q-.75,0-1.5.75v0Zm43.53-30.77c-.75-.75-1.5-.75-2.25-.75-6,3.75-12.76,7.5-18.76,11.26l9.76-9.01l11.26-9.76c.75-.75.75-1.5,0-2.25s-1.5-.75-2.25,0l-39.02,33.77-.75.75v-3c10.51-9.76,21.01-18.76,32.27-27.77c3-2.25,6.75-5.25,9.76-7.5.75-.75,1.5-1.5.75-2.25s-1.5-1.5-2.25-.75c-12.01,9.01-23.26,18.76-34.52,28.52-2.25,2.25-5.25,4.5-7.5,6.75h-.75c-3.75,3-6.75,6-9.76,9.76.75-1.5,2.25-3.75,2.25-5.25v-1.5c2.25-.75,4.5-1.5,6-3c6.75-4.5,12.01-10.51,15.01-18.01c1.5-1.5,3.75-2.25,6-3.75c7.5-4.5,15.01-9.76,22.51-15.76c3-3,6.75-6,9.76-9.01c0,2.25-.75,4.5-1.5,6.75-1.5,8.26-3,15.01-6,21.76v0Z"
            fill="#fff"
          />
          <path
            d="M1234.41,536.03c-7.5-11.26-19.51-20.26-32.27-24.77v0c8.26-3.75,14.26-11.26,17.26-20.26c2.25-6,2.25-13.51,2.25-20.26s-.75-13.51-3-19.51c-.75-2.25-1.5-3.75-2.25-6v0c0-.75,0-1.5-1.5-2.25v0c-1.5-2.25-3-4.5-5.25-6.75-3.75-3.75-9.01-6.75-13.51-8.26-10.51-4.5-22.51-5.25-33.77-4.5-9.76.75-19.51,2.25-28.52,4.5v0c-.75-.75-2.25,0-2.25.75v0c-3,.75-6,2.25-9.01,3-.75-1.5-3.75-.75-3,1.5-.75,0-1.5.75-2.25.75s-.75,1.5-.75,2.25c.75.75,1.5.75,2.25.75s.75-.75,1.5-.75c3,9.01,6,18.01,9.01,27.02.75.75,1.5,1.5,2.25.75c6-3.75,12.01-7.5,18.76-9.76v0c.75.75,1.5.75,2.25,0q.75-.75,1.5-1.5c1.5-.75,3.75-1.5,6-1.5c2.25-.75,5.25-.75,7.5-1.5-.75.75-.75,1.5-1.5,2.25s0,2.25.75,2.25c.75.75,1.5,0,2.25-.75.75-1.5,1.5-2.25,2.25-3.75c2.25,0,4.5.75,6,.75h2.25c1.5.75,3.75,1.5,5.25,2.25l.75.75v0c1.5.75,2.25,1.5,3,3v0c-.75.75,0,2.25.75,2.25h1.5c1.5,2.25,3,4.5,3,7.5c0,.75-.75,1.5-.75,2.25s.75,1.5,1.5,2.25v0v3c0,.75-.75,2.25-.75,3l-.75.75c-.75.75-1.5,2.25-1.5,3-3.75,4.5-9.01,7.5-14.26,9.76-11.26,4.5-24.02,7.5-36.02,8.26-.75,0-1.5.75-1.5,1.5-.75,4.5-.75,8.26-.75,12.76v0c-.75.75-.75,1.5,0,2.25h.75c.75,3,1.5,6,2.25,9.01c0,.75.75,1.5,1.5,1.5c14.26-1.5,29.27-.75,43.53,2.25h1.5c3,.75,6,1.5,9.01,3v2.25c.75.75,1.5.75,2.25,0l.75-.75c1.5.75,2.25,1.5,3,2.25s.75.75,1.5,1.5c-.75.75-1.5,1.5-2.25,2.25-1.5,1.5.75,3.75,2.25,2.25.75-.75,1.5-1.5,1.5-1.5.75.75,1.5,2.25,1.5,3.75-.75,1.5-1.5,3-2.25,4.5c0,.75,0,1.5,1.5,2.25.75,0,2.25,0,2.25-1.5v-.75c0,.75.75,2.25.75,3v3c-.75,0-.75.75-1.5.75-.75.75-.75,1.5,0,2.25.75,0,.75.75,1.5.75v3c0,3,0,6.75-.75,9.76-1.5,6-6.75,9.76-12.01,13.51s-11.26,6-17.26,7.5v0c-.75-.75-1.5,0-2.25.75v0c-4.5,1.5-9.76,2.25-15.01,2.25h-5.25c0,0,0-.75-.75-.75-.75-.75-1.5-.75-2.25,0v0l-.75-.75c-.75-.75-2.25,0-2.25.75v0c-1.5,0-3,0-4.5-.75q0-.75-.75-1.5c-.75-.75-1.5-.75-2.25,0l-.75.75h-.75c0-.75-.75-.75-1.5-1.5-.75,0-1.5,0-1.5.75-4.5-.75-8.26-2.25-12.01-3.75-1.5-.75-3-1.5-3.75-2.25-1.5-.75-2.25,0-2.25,1.5-.75,5.25-1.5,9.76-2.25,15.01-1.5.75-2.25,1.5-3,3-.75.75-.75,1.5,0,2.25s1.5.75,2.25,0c0,.75-.75,1.5-.75,2.25s0,2.25,1.5,2.25c14.26,3.75,29.27,6.75,44.28,8.26.75,0,1.5.75,2.25,0h8.26c3.75,0,8.26,0,12.01-.75.75.75,1.5,1.5,2.25.75s1.5-.75,2.25-1.5c6.75-1.5,13.51-3,20.26-6c.75,0,1.5.75,1.5,0c4.5-2.25,8.26-5.25,12.01-9.01c7.5-6,13.51-14.26,16.51-24.02c0,0,0-.75.75-.75v-.75c0-.75.75-1.5.75-1.5.75-2.25.75-3.75,1.5-6v0c.75-.75,0-1.5,0-1.5c0-9.01-3-21.76-9.76-32.27v0Zm-12.76,68.29c-1.5.75-2.25,2.25-3.75,3-2.25,1.5-5.25,3.75-8.26,4.5l9.01-6.75c3-2.25,6-4.5,9.01-6.75-2.25,2.25-3.75,4.5-6,6Zm-38.27,15.01c0,0,.75,0,0,0c6.75-6,13.51-11.26,20.26-17.26c3-2.25,6-4.5,9.76-6c.75-.75,2.25-.75,3-1.5-3.75,3.75-8.26,7.5-12.76,10.51-1.5,1.5-3.75,3-5.25,3.75-.75.75-1.5,1.5-3,2.25v0c-.75-.75-1.5-.75-2.25,0s-1.5,2.25-.75,3l.75.75c-1.5.75-3,2.25-4.5,3v0c-.75-.75-2.25,0-2.25.75v0c-1.5.75-2.25.75-3,.75v0Zm-12.01.75h-3c.75-.75,1.5-2.25,2.25-3c.75.75,1.5,0,2.25,0c6.75-5.25,12.01-11.26,17.26-18.76c1.5-2.25,2.25-3.75,3.75-6c0,0,.75,0,.75-.75-2.25,3.75-5.25,7.5-7.5,11.26-3,3.75-6,8.26-9.01,11.26-3,2.25-4.5,3.75-6.75,6v0Zm-13.51-.75c1.5-1.5,3.75-3,5.25-4.5c5.25-3.75,9.76-8.26,14.26-13.51c1.5-1.5,2.25-3,3.75-4.5.75,0,1.5-.75,2.25-.75-.75,1.5-1.5,2.25-2.25,3-1.5,1.5-3,3-4.5,5.25l-9.01,10.51-4.5,5.25c-1.5-.75-3-.75-5.25-.75v0Zm10.51-19.51v0c1.5,0,3-.75,3.75-.75-3,4.5-6.75,9.01-11.26,13.51-1.5,1.5-3,2.25-5.25,3.75-.75,0-.75.75-.75,1.5-.75,0-.75.75-1.5,1.5v0c-1.5,0-3-.75-5.25-.75c7.5-6,14.26-12.01,20.26-18.76v0Zm18.76-4.5h.75c0,0-.75.75-.75,1.5v-1.5Zm-6,20.26v0Zm36.77-29.27c.75,0,1.5-.75,2.25-.75c3-1.5,6.75-3,9.76-4.5-2.25,3-4.5,6-7.5,9.01-3,1.5-6,2.25-9.76,3.75-1.5.75-3.75,1.5-5.25,3c3.75-4.5,7.5-7.5,10.51-10.51v0Zm14.26,1.5c.75-.75,1.5-1.5,2.25-2.25-2.25,4.5-6,8.26-9.76,11.26-2.25,1.5-5.25,3.75-7.5,6c5.25-5.25,9.76-10.51,15.01-15.01v0Zm7.5-15.76v0Zm0-1.5c0-.75-.75-.75-.75-1.5-.75-.75-2.25,0-2.25.75-.75,1.5-1.5,3-2.25,4.5-2.25,1.5-5.25,2.25-7.5,3.75.75-.75,1.5-1.5,2.25-2.25l11.26-11.26c-.75,2.25-.75,4.5-.75,6v0Zm-57.79,48.78v0Zm33.02-51.03c0,0,.75.75,0,0c.75.75,1.5.75,1.5.75-.75.75-1.5,1.5-2.25,2.25.75-.75.75-1.5.75-3v0Zm0-2.25v-8.26v0c5.25-4.5,9.01-10.51,11.26-17.26.75-2.25,1.5-3.75,2.25-6v0c1.5,2.25,3,3.75,4.5,6q-.75,0-1.5.75c-5.25,6-9.76,12.76-13.51,19.51-.75,1.5-2.25,3-3,5.25Zm-23.26-38.27c1.5-1.5,3-3.75,3.75-6l-2.25,6c-.75.75-.75,0-1.5,0Zm-9.76-2.25c3-3,6-6,8.26-9.76c2.25-.75,4.5-1.5,6-2.25q.75,0,1.5.75c-2.25,4.5-6,9.01-9.01,13.51-3-1.5-4.5-1.5-6.75-2.25v0Zm10.51-19.51c7.5-7.5,13.51-15.76,19.51-24.02-3,10.51-6.75,21.01-16.51,27.02h-1.5c-.75,0-1.5.75-1.5,1.5c0,0-.75,0-.75.75.75-.75.75-2.25,1.5-3c0-.75,0-1.5-.75-2.25v0Zm3.75,23.26l6-14.26h.75c-.75,0-.75.75-.75,1.5-.75,4.5-3,9.01-6,12.76v0Zm9.76-11.26v-.75c.75,0,1.5.75,1.5.75-1.5,3.75-3.75,6.75-6,9.76c2.25-3,3.75-6.75,4.5-9.76Zm11.26-33.77c-.75,6-3,11.26-6.75,16.51-2.25,2.25-4.5,4.5-7.5,6v0c4.5-5.25,7.5-11.26,9.76-17.26c1.5-3.75,2.25-7.5,3.75-11.26c0-.75,0-1.5-.75-2.25.75-1.5,1.5-3,3-5.25c0,4.5-.75,9.01-1.5,13.51Zm.75-18.01c-.75,0-1.5,0-1.5.75-6,11.26-12.76,21.01-21.01,30.77-2.25,2.25-4.5,5.25-7.5,7.5-.75.75,0,2.25.75,3-.75,1.5-1.5,3-1.5,3.75-.75,0-1.5,1.5-1.5,2.25-2.25,3.75-5.25,7.5-9.01,10.51h-.75c6.75-9.01,12.76-20.26,16.51-30.77.75-3,1.5-6,3-9.01.75-1.5,1.5-2.25,2.25-3.75.75-.75,2.25-2.25,3-3s1.5-1.5,1.5-2.25c-.75,1.5-1.5,2.25-1.5,3.75-1.5,2.25-2.25,5.25-3,7.5-.75.75,0,1.5.75,2.25s2.25,0,2.25-.75c3.75-9.01,8.26-17.26,12.76-25.52c1.5-2.25,2.25-4.5,3.75-7.5v0c.75,3,1.5,6,1.5,9.01-.75.75-.75,1.5-.75,1.5v0Zm-51.78,57.79c.75-1.5,2.25-3,3-3.75s1.5-1.5,1.5-2.25l.75,1.5c0,.75.75,1.5,1.5,1.5s1.5,0,1.5-.75c3-3.75,6-7.5,8.26-12.01-3,6-6.75,11.26-10.51,16.51-2.25-.75-4.5-.75-6-.75v0Zm16.51-29.27v0c1.5-1.5,3.75-2.25,5.25-3.75-3.75,6.75-7.5,13.51-12.01,20.26-.75,1.5-1.5,2.25-2.25,3.75v0l.75-.75c3-3.75,5.25-8.26,6.75-12.76.75-1.5.75-2.25.75-3.75q.75-.75.75-1.5c.75,0,.75-.75,0-1.5v0Zm-19.51,27.02v0c.75-.75,0,0,0,0v0Zm5.25-21.76v0Zm-6,11.26c-1.5,2.25-2.25,3.75-3.75,6-.75.75-.75,1.5-1.5,1.5-.75.75-1.5.75-2.25.75v0c3-2.25,5.25-5.25,7.5-8.26v0Zm-8.26,11.26c0,.75,1.5,1.5,2.25,1.5s1.5,0,1.5-.75v.75h-6.75c.75-.75,2.25-2.25,3-3v1.5v0Zm7.5.75v0Zm7.5-8.26c.75,0,.75-.75.75-1.5c0,.75-.75.75-.75,1.5Zm44.28-67.54c.75,1.5,1.5,3.75,2.25,6-.75-.75-1.5-.75-2.25.75-2.25,3.75-3.75,7.5-6,11.26c0-.75.75-1.5.75-2.25.75-3,1.5-6,3-9.01.75-1.5.75-3,1.5-4.5.75-.75.75-1.5.75-2.25v0Zm-42.03-20.26l-1.5,2.25c0-.75,0-1.5-.75-2.25h2.25Zm-22.51,24.02c.75-.75,2.25-2.25,3-3.75c1.5-2.25,2.25-3.75,3-6c.75-1.5,2.25-3.75,3-5.25c1.5-1.5,2.25-3,4.5-3c.75,0,1.5-1.5,1.5-2.25s-1.5-1.5-2.25-1.5l1.5-2.25h3.75q-.75,0-.75.75c-4.5,8.26-9.01,15.76-15.01,22.51-.75,0-1.5.75-2.25.75v0Zm-9.01-21.01c-5.25,5.25-9.76,12.01-12.01,19.51-.75,2.25,3,3,3,.75c2.25-8.26,6.75-15.01,13.51-20.26v0c-1.5,3-3.75,6-6,9.01-1.5,2.25-3,3.75-3.75,6-.75.75-1.5,2.25-1.5,3s-.75,2.25-.75,3.75c-.75,1.5-1.5,3-3,3.75l-3.75-12.01v0c.75.75,2.25,0,2.25-.75l5.25-12.01c2.25.75,4.5,0,6.75-.75Zm6-.75v0Zm-15.01,30.77c1.5-1.5,3-3,4.5-4.5c1.5-2.25,1.5-4.5,2.25-6.75c1.5-2.25,3-3.75,3.75-6c1.5-2.25,3-3.75,4.5-6s3-4.5,4.5-7.5v-.75h2.25c-5.25,6.75-9.76,14.26-13.51,22.51-.75,2.25-2.25,4.5-3,6.75v.75c-1.5.75-3,1.5-4.5,3l-.75-1.5v0Zm10.51-6.75c0,0,0,.75,0,0c0,.75.75.75.75,1.5-.75,0-.75.75-1.5.75c0-.75,0-1.5.75-2.25Zm18.01-26.27l-6.75,9.01c-1.5,1.5-2.25,3.75-3.75,5.25s-3,3-3.75,5.25c-.75.75-.75,2.25-.75,3-.75.75-1.5,1.5-1.5,2.25v0c2.25-5.25,6-11.26,9.01-16.51c1.5-2.25,3-3.75,4.5-6c.75-.75,0-1.5,0-1.5h1.5c0,0,.75-.75,1.5-.75v0Zm-30.02,6l-3.75,9.01v.75l-2.25-7.5c1.5-.75,3.75-1.5,6-2.25v0ZM1157.85,449c1.5-2.25,3-4.5,4.5-6.75c0,1.5,2.25,2.25,3,.75l9.76-15.76h.75q0,.75-.75,1.5c-.75.75-.75,1.5-1.5,2.25l-3,5.25-6.75,10.51v.75v0c-2.25.75-4.5.75-6,1.5v0Zm9.76-1.5l6-9.76l3-5.25c-2.25,5.25-4.5,9.76-7.5,15.01h-1.5Zm30.77,21.01c3-7.5,6.75-15.76,11.26-22.51.75-.75,0-2.25-.75-2.25-.75-.75-1.5,0-2.25.75-3.75,6-7.5,12.01-10.51,18.76-.75-1.5-1.5-3.75-3-5.25c4.5-6,7.5-12.76,10.51-19.51.75-.75-.75-1.5-1.5-2.25-.75,0-1.5,0-2.25,1.5-2.25,6-6,12.01-9.76,18.01v0c-.75-.75-2.25-1.5-3-2.25c2.25-6,5.25-11.26,9.01-15.76.75-.75.75-1.5,0-2.25s-1.5-.75-2.25,0c-4.5,4.5-7.5,10.51-9.76,16.51-1.5-.75-3-1.5-3.75-1.5c2.25-5.25,5.25-10.51,8.26-15.01.75-.75,0-2.25-.75-2.25-.75-.75-1.5,0-2.25.75-3,5.25-6,10.51-9.01,15.76-1.5,0-3-.75-4.5-.75c3-5.25,6-11.26,8.26-17.26.75-.75-.75-2.25-1.5-2.25h-1.5v-.75c3.75.75,7.5,1.5,11.26,2.25c8.26,2.25,16.51,7.5,21.76,14.26l-.75.75c-.75,1.5-1.5,3-1.5,3.75-.75,2.25-1.5,5.25-3,8.26-1.5,5.25-3,10.51-6,15.76l-.75.75c.75-2.25.75-3.75,0-6v0Zm-18.76,27.02v.75c-5.25,6-9.76,12.76-15.01,18.76.75-.75.75-1.5.75-1.5l8.26-14.26v-1.5c.75,0,2.25-.75,3-1.5.75,0,1.5,0,3-.75v0Zm-36.02,20.26c3-3.75,6-8.26,7.5-12.76h2.25c-3.75,4.5-6.75,9.01-9.76,14.26v-1.5Zm0-11.26h3.75c-1.5,2.25-2.25,4.5-3.75,6.75-.75-3-.75-4.5,0-6.75Zm.75,16.51h1.5c0,.75.75.75.75,1.5.75.75,1.5,0,2.25-.75c4.5-6,8.26-12.76,12.01-18.76v0c1.5,0,3-.75,4.5-.75-3.75,6.75-8.26,12.76-13.51,18.01-1.5,1.5-3,3-5.25,4.5-.75,0-.75.75-.75,1.5h-.75c0-3,0-4.5-.75-5.25v0Zm58.54,11.26c3-3.75,6-8.26,8.26-13.51h.75c-.75,0-.75.75-.75,1.5.75,5.25-.75,10.51-3,15.01-1.5-.75-3-2.25-5.25-3Zm9.76,9.76v0Zm9.76-13.51c-.75-2.25-3.75-1.5-3,.75.75,1.5,0,3.75-.75,5.25s-2.25,3.75-3.75,4.5c2.25-3.75,3.75-8.26,3.75-12.76c0-2.25-3.75-2.25-3.75,0c0,4.5-1.5,9.01-4.5,12.76v0c3-5.25,4.5-11.26,3.75-17.26c4.5,3,9.01,6.75,12.76,10.51-.75,0-1.5.75-1.5,1.5-1.5,7.5-5.25,14.26-9.76,19.51v0c0-2.25-.75-5.25-1.5-7.5c1.5-1.5,3-3,3.75-4.5c3-3.75,5.25-8.26,4.5-12.76v0Zm-12.76,53.28v0c.75.75,2.25,0,2.25-.75c6-8.26,12.01-15.76,18.01-23.26c1.5-2.25,3.75-4.5,5.25-6c.75-.75.75-1.5,0-2.25s-1.5-.75-2.25,0c-4.5,5.25-9.01,11.26-13.51,16.51c3-6,6.75-12.01,10.51-17.26c1.5-1.5,3-3.75,4.5-5.25v0c3,5.25,4.5,11.26,5.25,18.01h-.75c-3,3-6,6-9.01,9.01v0l6.75-7.5c.75-.75.75-1.5,0-2.25s-1.5-.75-2.25,0c-8.26,9.01-15.76,18.01-24.02,27.02.75-1.5-2.25-3-3-1.5-3,5.25-6.75,10.51-10.51,15.01-.75.75-2.25,1.5-3,2.25-2.25,1.5-4.5,3.75-6.75,5.25c2.25-3,3.75-6,6-8.26l5.25-7.5c.75-.75,0-1.5,0-2.25c4.5-3,8.26-5.25,11.26-9.01v0Zm-49.53,18.01v0c-3,6-9.01,11.26-15.01,15.01-.75,0-.75.75-.75,1.5c0,0-.75,0-.75.75h-1.5c3.75-3.75,7.5-8.26,10.51-12.76c1.5-1.5,3-3,4.5-3.75.75-.75,1.5-.75,3-.75v0Zm-21.01,16.51h-.75l.75-.75v.75v0Zm10.51-14.26c-4.5,4.5-9.01,8.26-14.26,11.26-.75,0-.75.75-.75,1.5h-.75c3-2.25,5.25-6,6.75-10.51c1.5-1.5,3.75-3.75,5.25-6c1.5,0,3,.75,5.25.75-.75,1.5-.75,2.25-1.5,3v0Zm-13.51-5.25q-.75,0-1.5.75c0,0,0-.75.75-.75h.75Zm3,3c0,.75-.75,2.25-.75,3-2.25,2.25-4.5,3.75-6,5.25q0-.75.75-1.5c.75-1.5.75-3.75,1.5-5.25.75-.75,2.25-1.5,4.5-1.5v0Zm-9.76,3.75c-.75,1.5-.75,3-1.5,4.5c0,.75-.75,1.5-.75,2.25l-.75.75v0c-.75,0-1.5.75-1.5,1.5v0c-.75,0-2.25,0-3-.75.75-1.5.75-3.75,1.5-5.25c1.5-.75,3.75-2.25,6-3v0Zm-3.75-11.26c2.25.75,4.5,2.25,6.75,3-.75,1.5-1.5,2.25-1.5,3.75-2.25.75-4.5,2.25-6,3.75c0-3.75,0-6.75.75-10.51v0Zm51.03,27.77c.75-.75,1.5-.75,1.5-1.5v1.5h-1.5Zm23.26-4.5c0,0,0,.75,0,0q-.75.75-1.5.75.75,0,1.5-.75v0Zm37.52-33.02c0,0,0,.75-.75.75h-1.5c0,0,.75-.75.75-1.5.75-.75,1.5-1.5,2.25-2.25c0,1.5-.75,2.25-.75,3v0Z"
            fill="#fff"
          />
          <path
            d="M1108.33,547.29c-1.5-6-3.75-12.76-7.5-18.01c0,0,0-.75-.75-.75-1.5-1.5-2.25-3-3.75-4.5-4.5-4.5-9.01-8.26-15.01-11.26l-.75-.75h-.75c-3-1.5-6-3-9.01-3.75-3-.75-6-1.5-9.01-2.25v0c-.75-.75-1.5-.75-2.25,0-6-1.5-12.76-2.25-18.76-2.25-10.51,0-21.01.75-30.77,4.5-3,.75-6,2.25-8.26,3.75v-2.25c0-2.25.75-3.75.75-6c.75-3.75,2.25-8.26,3.75-12.01c3.75-7.5,9.01-14.26,15.76-20.26c0,0,.75,0,.75-.75h1.5c1.5-1.5,3-2.25,3.75-3.75c1.5-.75,3-2.25,5.25-3-.75.75-.75,1.5-1.5,2.25s0,2.25.75,2.25c.75.75,1.5,0,2.25-.75c1.5-2.25,3-4.5,4.5-6.75c2.25-.75,4.5-1.5,6.75-3c2.25-.75,5.25-1.5,7.5-2.25c0,.75,0,1.5.75,1.5.75.75,1.5.75,2.25,0c1.5-.75,2.25-2.25,3.75-3c3-.75,6-.75,8.26-1.5c0,0,0,.75.75.75.75.75,1.5.75,2.25,0l.75-.75h5.25c1.5,0,2.25,0,3.75-.75c2.25-1.5,2.25-3.75,2.25-6.75v-4.5v0c.75-.75,0-1.5,0-1.5v-6l.75-.75c.75-.75,0-1.5-.75-2.25v-3h4.5c2.25,0,2.25-3.75,0-3.75h-4.5c0-.75-.75-.75-1.5-.75s-1.5.75-1.5.75h-7.5c-.75-.75-1.5-.75-2.25,0h-6c-6,.75-12.76.75-18.76,2.25l-.75-.75c-.75,0-1.5,0-2.25.75-3,.75-5.25.75-8.26,1.5v0c-.75,0-1.5,0-1.5.75-3.75.75-7.5,2.25-12.01,3.75-7.5,3-15.01,6.75-21.76,10.51c0-.75-.75-.75-1.5-.75s-1.5,0-2.25,1.5c0,.75-.75,1.5-.75,3-6.75,4.5-12.76,9.76-18.01,16.51c0-.75-.75-1.5-1.5-1.5s-1.5,0-2.25,1.5c-.75,2.25-1.5,4.5-1.5,6.75-3,3.75-6,8.26-8.26,12.01v-1.5c0-.75-.75-1.5-1.5-1.5s-1.5.75-1.5,1.5c0,2.25,0,4.5.75,6.75-4.5,8.26-7.5,17.26-9.01,26.27-3.75,19.51-2.25,39.77,4.5,58.54.75,1.5,1.5,3,1.5,4.5v6.75c0,1.5,2.25,2.25,3,.75v-.75c2.25,4.5,5.25,9.76,7.5,14.26v2.25c0,.75.75,1.5,1.5,1.5h1.5c5.25,7.5,11.26,13.51,18.01,18.76c3.75,3,8.26,6,12.76,7.5c5.25,2.25,10.51,3,16.51,3.75c10.51.75,21.01-.75,30.77-3.75h1.5c.75.75,1.5.75,3,.75.75,0,2.25-.75,2.25-2.25h.75c.75,0,.75-.75,1.5-.75c15.01-5.25,29.27-14.26,39.02-27.77c10.51-13.51,14.26-32.27,10.51-49.53v0Zm-2.25,11.26l-.75.75c-4.5,13.51-11.26,26.27-18.76,37.52-2.25,3-4.5,6-6.75,9.76-.75.75-.75,1.5,0,2.25c0,0,.75.75,1.5.75-4.5,3-9.01,6-13.51,8.26c1.5-.75,2.25-2.25,3.75-3c3.75-3.75,6.75-6.75,9.76-11.26.75,0,1.5,0,1.5-.75c6.75-12.76,12.76-25.52,17.26-39.77c1.5-3.75,2.25-7.5,3.75-11.26.75-2.25-3-3-3-.75-1.5,3.75-2.25,8.26-3.75,12.01-.75-.75-1.5-.75-2.25,0c1.5-3.75,3-6.75,3.75-10.51c1.5-3.75,2.25-6.75,3-10.51.75-2.25-3-3-3-.75-3.75,12.01-8.26,23.26-14.26,34.52-.75.75-1.5,1.5-1.5,2.25l2.25-9.01c6.75-9.01,9.01-19.51,12.76-30.02.75-1.5,1.5-3.75,2.25-5.25.75,1.5,1.5,2.25,2.25,3.75c2.25,6.75,3.75,13.51,3.75,21.01v0ZM986.76,611.08c3.75-5.25,6-11.26,7.5-16.51c0,.75,0,1.5-.75,2.25-.75,3-1.5,6-1.5,9.01c0,.75,0,1.5,1.5,2.25.75,0,1.5,0,1.5-.75-.75,1.5-1.5,2.25-1.5,3.75-.75.75-.75,2.25-1.5,3c0-.75,0-1.5-.75-2.25s-2.25,0-2.25.75-.75,1.5-.75,2.25c-.75-.75-2.25-1.5-3-3c0,0,.75,0,1.5-.75v0Zm26.27-101.31c1.5,0,2.25-.75,3.75-.75v0c-.75,0-.75.75-1.5,1.5l-3,9.76c-1.5,2.25-2.25,5.25-3.75,7.5.75-.75.75-2.25,1.5-3c1.5-4.5,3-9.01,4.5-13.51-.75-.75-.75-1.5-1.5-1.5Zm21.76-1.5c0,.75.75,1.5,1.5,1.5v0v.75v0v.75c0,0,0,.75,0,0v.75l-1.5,3-4.5,8.26h-3c2.25-5.25,4.5-10.51,7.5-15.01v0Zm18.01-.75c-.75.75-1.5,1.5-2.25,2.25s-1.5,2.25-2.25,3l2.25-5.25h2.25Zm11.26,2.25l-9.76,24.02c-.75,0-2.25-.75-3-.75v-.75c1.5-8.26,4.5-15.76,9.76-22.51.75-.75,2.25,0,3,0Zm-.75,27.02c.75.75,1.5.75,2.25,0c2.25-3,4.5-6,6-9.76-.75,3.75-2.25,7.5-4.5,10.51-.75.75,0,1.5.75,2.25s2.25,0,2.25-.75c4.5-7.5,6.75-16.51,6.75-24.77q.75,0,.75.75c-1.5,7.5-3,15.01-6,22.51-.75,0-1.5.75-1.5,1.5v3.75c-3-2.25-6-4.5-9.76-6.75c0,0-.75,0-.75-.75c4.5-5.25,5.25-12.01,8.26-18.76.75-1.5,1.5-3.75,2.25-5.25v0v.75c0,7.5-3,15.76-7.5,21.76c0,1.5,0,2.25.75,3v0Zm15.76,15.01l1.5-3.75c.75,0,1.5,0,2.25-1.5c3-7.5,4.5-15.01,5.25-23.26l.75-2.25v0c.75.75,1.5.75,2.25,1.5v6.75c-2.25,8.26-6,16.51-9.01,24.02-.75.75-.75,2.25-1.5,3c0-.75-.75-2.25-1.5-3v0c-1.5-.75-.75-.75,0-1.5v0Zm2.25,27.77c0,.75-.75,1.5-.75,1.5h-.75c0-.75.75-1.5.75-1.5c0,.75.75.75.75,0v0Zm.75-18.76c-.75,1.5-.75,2.25-1.5,3.75v-2.25v0c2.25-4.5,4.5-9.01,6-13.51-1.5,3-3,7.5-4.5,12.01v0Zm2.25,25.52c-.75,3.75-2.25,7.5-4.5,11.26-.75,0-1.5.75-1.5,1.5v2.25c-3.75,6-9.01,10.51-13.51,15.01-.75.75-1.5,1.5-2.25,2.25c3.75-5.25,8.26-10.51,12.01-15.76s6.75-11.26,9.76-16.51v0Zm3.75-3c0-.75-.75-.75-1.5-.75h-.75c.75-1.5,1.5-3,2.25-3.75c1.5-2.25,3-5.25,4.5-7.5-.75,3.75-3,8.26-4.5,12.01Zm3-36.02c0,0,0-.75-.75-.75.75-1.5.75-3,1.5-3.75s.75-3,1.5-3.75c0,3-1.5,6-2.25,8.26v0Zm-15.76,9.01c0,.75.75,1.5.75,2.25.75,3,1.5,6,.75,9.76v3v0v1.5c0,1.5-.75,3.75-1.5,5.25s-.75,3-1.5,4.5c-.75.75-.75,1.5-1.5,2.25l-.75-.75c-.75,0-1.5,0-2.25,1.5-.75,2.25-2.25,4.5-3,6.75-3,3-7.5,5.25-11.26,6.75v0l3.75-4.5c.75-.75.75-1.5,0-2.25s-1.5-.75-2.25,0l-6.75,8.26h-4.5c-.75-.75-1.5-.75-2.25,0h-.75c0-.75,0-1.5-.75-2.25s-2.25,0-2.25.75c0,0,0,.75-.75.75-1.5,0-3-.75-5.25-.75c0-.75-.75-.75-.75-.75h-2.25c-1.5,0-2.25-.75-3.75-1.5-3.75-1.5-7.5-3-11.26-5.25-2.25-1.5-4.5-3-6-4.5c0-.75-.75-.75-.75-.75h-.75c-.75-.75-1.5-1.5-1.5-2.25-2.25-3-3-6-3.75-9.76.75-3,1.5-6,2.25-8.26.75-1.5-1.5-3-3-1.5v-.75c.75-1.5.75-3,.75-3.75.75-3.75,1.5-7.5,1.5-10.51v-.75c.75-1.5,1.5-3.75,2.25-5.25.75-.75.75-1.5,1.5-3c.75-.75.75-1.5,1.5-2.25c2.25-3,5.25-5.25,8.26-6.75c1.5-.75,2.25-1.5,3.75-1.5l.75.75c.75.75,2.25,0,2.25-.75l.75-1.5v0c0,.75.75.75,1.5.75l2.25.75.75.75h1.5l5.25,1.5-.75.75c-1.5,2.25,1.5,3.75,3,1.5c0-.75.75-.75.75-1.5h.75c4.5,1.5,9.01,3,12.76,4.5s7.5,3,11.26,5.25c1.5.75,3,2.25,4.5,3.75s2.25,2.25,3,3.75s1.5,3,2.25,4.5c.75,0,1.5,0,1.5,1.5v0Zm-39.02,69.79v0Zm-.75-1.5c0,0,0-.75,0,0h-1.5l13.51-16.51c-3,4.5-6,9.01-9.01,12.76-.75.75-2.25,2.25-3,3.75v0Zm-11.26-25.52c.75,0,1.5.75,1.5.75l-6.75,12.01c.75-1.5,1.5-3,1.5-5.25.75-2.25,1.5-4.5,3-6.75q.75,0,.75-.75v0Zm-3.75,25.52v0c4.5-7.5,8.26-15.01,11.26-23.26c1.5,0,3,.75,4.5.75-3.75,6.75-8.26,12.76-12.76,18.76-.75,1.5-1.5,3-3,3.75v0Zm24.02-21.01h1.5l-8.26,10.51c.75-1.5,2.25-3,3-4.5c1.5-2.25,2.25-3.75,3.75-6v0Zm-6.75,3.75c.75-1.5,1.5-2.25,2.25-3.75h.75c-3,4.5-6,9.01-9.01,13.51c2.25-3,4.5-6.75,6-9.76Zm10.51,10.51c-1.5,1.5-3.75,3.75-6,5.25v0c0,0,0-.75-.75-.75c3-4.5,6.75-9.01,9.01-13.51.75-1.5,2.25-3,3-5.25c1.5,0,3-.75,4.5-1.5s2.25-.75,3-1.5c-2.25,4.5-5.25,8.26-9.01,12.01c0,1.5-2.25,3.75-3.75,5.25v0Zm21.01-22.51c0,0,0-.75,0,0l.75-.75c-.75,0-.75.75-.75.75v0Zm-60.79,18.76c-2.25,3-4.5,6-6.75,9.01c4.5-6.75,8.26-14.26,10.51-22.51.75-2.25.75-3.75,1.5-6c0,0,.75,0,.75.75-.75,6-3,12.76-6,18.76Zm-6-27.02c-.75,0-2.25,0-2.25,1.5-1.5,6-3,12.01-5.25,18.01c1.5-8.26,3-17.26,5.25-25.52.75,1.5,1.5,3,2.25,3.75s1.5,2.25,2.25,3c-1.5,3-1.5,6.75-2.25,10.51-.75,4.5-1.5,8.26-3.75,12.01-.75.75-1.5,2.25-1.5,3s-.75.75-.75,1.5h-.75c3-6,5.25-12.76,6.75-18.76.75-2.25,1.5-4.5,1.5-6.75c0-1.5,0-2.25-1.5-2.25v0Zm-9.76-9.76l-2.25-3c3-6.75,6-14.26,8.26-21.01-.75,3-.75,6-.75,9.01-1.5,5.25-3,9.76-5.25,15.01v0Zm11.26-40.53v0q.75,0,0,0c-.75,1.5-1.5,3-1.5,4.5q0-.75.75-1.5c0-.75.75-2.25.75-3Zm9.76-9.01v0c0,0-.75.75,0,0v0c-.75,0,0,0,0,0Zm-4.5,68.29c0-.75-.75-1.5-1.5-2.25h-.75c0-1.5.75-3,.75-3.75.75.75,2.25,1.5,3,2.25-.75,2.25-1.5,3.75-1.5,6-.75,2.25-1.5,4.5-2.25,6-1.5,3.75-3,8.26-5.25,12.01-.75,1.5-2.25,3-3,4.5c4.5-7.5,7.5-16.51,10.51-24.77v0Zm39.02-65.29c0,0,0,.75,0,0-2.25,0-3.75-.75-6-1.5v-.75c1.5-3,3-5.25,5.25-8.26c1.5-2.25,3-4.5,4.5-6.75.75-.75,1.5-1.5,2.25-2.25.75,0,.75-.75.75-.75h.75c-3.75,6-6.75,13.51-7.5,20.26v0Zm12.01,0c-.75,1.5-1.5,3-3,3.75l9.76-22.51v-.75h.75c-3.75,6-4.5,12.76-7.5,19.51v0Zm-18.01-12.01c.75-3.75,1.5-7.5,1.5-11.26v-.75h3.75l-5.25,12.01v0Zm-6,9.01h-1.5c.75,0,1.5-.75,1.5-1.5s-.75-1.5-1.5-1.5h-.75l4.5-8.26c0-.75.75-.75.75-1.5-.75,3.75-1.5,8.26-3,12.76v0Zm.75-18.01v0Zm-.75,0v0Zm-13.51,14.26c-1.5,0-3,.75-5.25,1.5c1.5-2.25,3-5.25,3.75-8.26c1.5-3.75,2.25-6.75,4.5-9.76c0,0,.75-.75.75-1.5h4.5l-8.26,18.01v0Zm-4.5-8.26c-1.5,3-2.25,6-4.5,9.01l1.5-3.75c.75-2.25,1.5-5.25,3-7.5.75-2.25,1.5-3.75,3-6h1.5c-2.25,3-3,5.25-4.5,8.26Zm-18.76,22.51c0,0,0,.75,0,0v-.75c0-.75.75-1.5.75-1.5c0,.75-.75,1.5-.75,2.25Zm-11.26,47.28c0-2.25.75-4.5,1.5-6.75l1.5,2.25c0,.75-.75,2.25-1.5,3l-2.25,6.75v-.75c0-2.25.75-3.75.75-4.5v0Zm8.26-3c0-.75-.75-1.5-.75-1.5v0c.75-1.5.75-2.25,1.5-3.75s1.5-3,1.5-5.25v1.5c-.75,3.75-1.5,8.26-3,12.01c0-1.5,0-2.25.75-3v0Zm-2.25,33.77v3c-.75,0-.75-.75-1.5-.75.75-.75,1.5-1.5,1.5-2.25Zm7.5,6.75v0Zm5.25.75c1.5-2.25,2.25-4.5,3.75-6.75c0-.75.75-1.5.75-2.25c3-5.25,6-10.51,8.26-16.51c0-.75-.75-1.5-1.5-2.25h.75c.75.75,1.5.75,3,1.5v0c-3,6.75-5.25,14.26-8.26,21.01-.75.75-.75,1.5-1.5,2.25c0,0-.75.75-.75,1.5v0c-1.5,0-2.25,1.5-1.5,3-.75,0-1.5-.75-2.25-.75-.75.75-.75,0-.75-.75v0Zm9.01,3c0,.75.75.75.75.75h-1.5q0-.75.75-.75v0Zm6.75.75v0Zm4.5,0c.75-.75,1.5-1.5,1.5-2.25v0c.75,1.5,2.25,1.5,3,.75l.75-.75v1.5c-1.5.75-3.75.75-5.25.75v0Zm12.01-2.25v1.5h-1.5q.75-.75,1.5-1.5Zm8.26-1.5c2.25-2.25,5.25-5.25,7.5-7.5q.75-.75.75-1.5c5.25-5.25,9.76-9.76,14.26-15.76c2.25-3,4.5-6,6.75-9.01.75-.75,0-2.25-.75-2.25-.75-.75-1.5,0-2.25.75.75-1.5,1.5-3,2.25-4.5h1.5v2.25c0,.75.75,1.5.75,1.5-.75,1.5-2.25,3-3,4.5-6,9.76-12.76,18.76-20.26,27.77q-.75.75-.75,1.5c-1.5-.75-2.25-.75-3.75,0s-2.25,2.25-2.25,3.75c-.75,0-2.25.75-3,.75c1.5-1.5,1.5-2.25,2.25-2.25v0Zm49.53-93.81c-.75,1.5-1.5,2.25-1.5,3.75c0-.75-.75-1.5-1.5-1.5h-.75c0-2.25.75-4.5,0-6.75c1.5,1.5,3,3,3.75,4.5v0Zm-11.26-10.51c-.75,0-.75.75-1.5,1.5v0c0,0-.75.75-.75,1.5v.75l-8.26,26.27c-1.5-1.5-2.25-3.75-3.75-5.25h.75c.75,0,1.5,0,1.5-1.5c3-8.26,5.25-17.26,6.75-26.27.75,0,1.5.75,2.25,1.5c1.5.75,2.25.75,3,1.5v0Zm-45.78-12.76l-.75.75v0c-.75-.75-1.5-1.5-2.25-1.5c1.5.75,2.25.75,3,.75Zm-3.75,0c-.75,0-1.5.75-1.5,1.5c0,0,0-.75-.75-.75c1.5-.75,2.25-.75,2.25-.75v0Zm-26.27,3.75c-1.5,6-3.75,12.01-6,18.01h-1.5c.75-3,2.25-6,3-8.26c0-.75-.75-1.5-1.5-2.25-.75,0-1.5,0-2.25,1.5-3.75,9.01-6.75,18.76-9.01,28.52-.75,1.5-.75,3-1.5,4.5s-1.5,2.25-2.25,3.75c-.75.75-1.5,1.5-2.25,3c2.25-8.26,5.25-16.51,8.26-24.77c2.25-6,4.5-12.01,6.75-17.26.75-.75,0-1.5-.75-2.25c4.5-2.25,6.75-3.75,9.01-4.5v0Zm-48.78,64.54c-1.5-3.75-3-8.26-4.5-12.76v-.75c1.5-8.26,3.75-15.76,7.5-23.26.75-2.25,2.25-4.5,3-6.75.75-.75,0-1.5-.75-2.25s-2.25,0-2.25.75v.75l3-9.01c0,0,.75,0,.75-.75c2.25-3,4.5-6,6-9.01-1.5,5.25-3,9.76-4.5,15.01-2.25,6.75-4.5,12.76-5.25,19.51v1.5c-2.25,4.5-4.5,9.76-4.5,15.01c0,1.5,0,3,.75,4.5c0,1.5.75,3,1.5,3.75v0c0,.75-.75.75-.75,1.5.75,1.5,0,1.5,0,2.25v0Zm14.26-105.07c0,.75-.75,2.25-.75,3c0-1.5,0-2.25.75-3v0Zm9.76-11.26v5.25c-.75,3.75-1.5,7.5-2.25,11.26v-2.25c.75-4.5,1.5-9.01,2.25-14.26c0,.75,0,0,0,0v0Zm12.76-10.51c0,0,.75,0,.75-.75-.75,3.75-1.5,7.5-2.25,11.26v0c.75-3.75.75-6.75,1.5-10.51v0Zm9.76-6c0,5.25-.75,10.51-1.5,15.01-.75,3.75-2.25,8.26-3,12.76c0,1.5-.75,2.25-.75,3.75-.75,1.5-.75,2.25-1.5,3.75c1.5-7.5,2.25-15.01,3.75-22.51.75-3.75,1.5-7.5,1.5-12.01.75,0,.75-.75,1.5-.75v0Zm18.01-7.5c1.5-.75,3.75-.75,5.25-1.5-.75,1.5-1.5,3.75-2.25,6-.75,3-1.5,5.25-2.25,7.5-1.5,4.5-3.75,9.01-6,13.51-.75,1.5-2.25,3-3,4.5-.75.75-1.5,1.5-2.25,3-.75,0-.75.75-.75.75s-.75.75-.75,1.5c3-7.5,6-14.26,8.26-21.76.75-5.25,2.25-9.01,3.75-13.51v0Zm15.76-4.5c-.75,2.25-1.5,3.75-3,6s-2.25,3.75-3,6.75c-2.25,3.75-4.5,7.5-6.75,11.26-.75,1.5-1.5,2.25-2.25,3.75-.75.75-.75,1.5-1.5,1.5l-.75.75h-.75c3.75-6,6.75-12.01,9.01-18.76.75-3,2.25-6,3-9.01c1.5-.75,3.75-1.5,6-2.25v0Zm9.01-1.5c-3,7.5-7.5,15.01-12.76,21.76-.75.75-1.5,2.25-2.25,3q-.75.75-1.5,1.5h-.75c.75-2.25,1.5-4.5,3-6.75.75-1.5.75-2.25,1.5-3.75c1.5-2.25,2.25-4.5,3-6.75.75-1.5,2.25-3,3.75-4.5.75-.75.75-2.25-.75-3c0,0,0-.75.75-.75c2.25,0,4.5,0,6-.75v0Zm21.01-1.5v0c-3,7.5-8.26,15.01-15.01,20.26c3.75-5.25,7.5-11.26,11.26-16.51c1.5-.75,3-2.25,3.75-3.75v0Zm.75,18.76c-.75,0-.75.75-1.5.75.75-.75,1.5-1.5,2.25-2.25c0,.75-.75,1.5-.75,1.5Zm-3,3v0c.75,0,0,0,0,0Zm-21.76,3.75c1.5-1.5,3.75-3.75,5.25-6l.75-.75c-1.5,1.5-2.25,3.75-3,5.25v1.5c-1.5,0-2.25.75-3.75.75c0,0,.75-.75.75-.75v0Zm7.5-2.25c0,0,0,.75,0,0q0,.75-.75.75.75,0,.75-.75Zm6-21.01q-.75,0-1.5.75c-4.5,7.5-9.76,14.26-15.01,20.26v0c2.25-4.5,4.5-8.26,6.75-12.76c1.5-3,3-5.25,3.75-8.26v-1.5c2.25,0,4.5-.75,6-.75.75.75.75,1.5,0,2.25v0Zm-61.54,87.05c-.75.75-.75,2.25-1.5,3v-3h1.5Zm-25.52-17.26c1.5-6,2.25-11.26,3-17.26.75-5.25.75-10.51,3-15.01-.75,6-1.5,11.26-2.25,17.26-1.5,8.26-3,16.51-6,24.02-.75,1.5-1.5,2.25-1.5,3.75c1.5-5.25,3-9.01,3.75-12.76v0Zm9.76-10.51c-.75,3-.75,6-1.5,9.01-.75,3.75-1.5,7.5-3,11.26c0,1.5.75,2.25,1.5,2.25l-9.01,21.01-.75,1.5c0-1.5.75-2.25,1.5-3.75c1.5-6,3.75-11.26,5.25-17.26c1.5-8.26,3.75-16.51,6-24.02v0Zm10.51,15.76v3c-.75,5.25-1.5,11.26-3,16.51v.75c-.75,1.5-.75,3-1.5,4.5-2.25,5.25-5.25,10.51-7.5,15.76-.75,1.5-1.5,3-2.25,4.5.75-2.25,1.5-3.75,1.5-6c.75-3.75,2.25-6.75,3-10.51v-1.5c1.5-3,2.25-6,3-9.01c1.5-3.75,2.25-7.5,3-11.26c1.5-2.25,3-4.5,3.75-6.75v0Zm-6.75,40.53c0-.75.75-1.5.75-2.25c2.25-5.25,4.5-11.26,6-16.51-.75,4.5-2.25,9.01-3.75,13.51-.75,2.25-1.5,4.5-3,6-.75,0,0,0,0-.75v0Zm0-37.52v3c-.75.75-1.5,1.5-1.5,2.25v0c0-1.5.75-3,1.5-5.25v0Zm-13.51,31.52v0c.75,0,0,0,0,0Zm-4.5,6.75l3-7.5h.75c-.75,0-.75.75-.75.75-.75,6-2.25,12.76-4.5,18.76-.75,1.5-.75,3-1.5,4.5v.75c-.75,1.5-.75,2.25-1.5,3.75c0-.75-.75-1.5-.75-2.25v-6c1.5-3.75,3-8.26,5.25-12.76v0Zm9.76-9.76c2.25-6.75,3.75-13.51,5.25-21.01c0-.75.75-1.5.75-1.5c0,.75,0,1.5.75,1.5v0c0,1.5-.75,3.75-1.5,5.25-1.5,4.5-3,9.01-5.25,13.51l-2.25,6.75c.75-1.5,1.5-3,2.25-4.5v0Zm31.52-60.79h1.5c-.75,1.5-2.25,2.25-3,3.75c0-.75.75-2.25,1.5-3.75v0Zm13.51-15.01v0Zm-15.01,6.75c0,.75-.75,1.5-.75,1.5s0,.75-.75.75-1.5,1.5-.75,2.25c0,0,0,.75.75.75-.75,1.5-1.5,3-2.25,4.5s-1.5,2.25-1.5,3.75c.75-2.25,1.5-4.5,2.25-7.5c1.5-5.25,3-10.51,3.75-15.76v-.75c1.5-6,2.25-11.26,4.5-16.51c0-.75,0-1.5-.75-1.5.75-.75,2.25-.75,3-1.5-.75,9.01-3,17.26-6,25.52-.75,2.25-.75,3.75-1.5,4.5v0Zm-15.76,21.76c2.25-7.5,3.75-15.01,6-22.51.75-3.75,1.5-7.5,2.25-11.26-1.5,9.76-3,19.51-5.25,29.27-.75,3.75-1.5,7.5-2.25,11.26c0,.75,0,1.5.75,1.5q0,.75-.75,1.5c-1.5,2.25-2.25,5.25-3.75,7.5-.75-.75-1.5-.75-2.25,0c0-.75.75-1.5.75-2.25v-.75c1.5-5.25,3-9.76,4.5-14.26v0Zm-39.02,59.29h.75l-.75,2.25v-2.25v0Zm.75,6v0v.75c0,0,0-.75,0-.75v0Zm14.26,18.76v0q0,.75-.75,1.5v0l.75-1.5v0Zm30.77-75.8v-2.25c0-.75.75-1.5.75-1.5v-.75h.75c-.75,1.5-1.5,3-1.5,4.5Zm18.76-28.52c1.5-2.25,3-4.5,3.75-6.75q0,.75.75,1.5c.75.75,1.5.75,2.25,0-1.5.75-3,2.25-4.5,3-.75,1.5-1.5,1.5-2.25,2.25v0Zm14.26-9.76c0,0,.75.75,1.5.75v0c-.75,0-1.5.75-2.25.75c0-.75,0-1.5.75-1.5v0Zm47.28-14.26v3h-4.5c1.5,0,3-1.5,4.5-3v0Zm0-6c0,0,0,.75,0,0-.75.75-1.5,1.5-1.5,2.25l-.75.75h-1.5c1.5-1.5,2.25-2.25,3-3.75.75,0,.75.75.75.75v0Zm0-7.5c-3.75,5.25-8.26,9.76-12.76,14.26.75-.75,1.5-2.25,2.25-3.75c1.5-2.25,3.75-4.5,5.25-6.75s3-3.75,4.5-6c.75-.75,0-1.5-.75-2.25h1.5v4.5v0Zm-16.51.75c.75-1.5,1.5-3,2.25-3.75h.75c-.75.75-2.25,2.25-3,3.75v0Zm-42.03,4.5c-.75,2.25-1.5,4.5-2.25,6.75c0-2.25.75-3.75.75-6c0-.75.75-.75,1.5-.75Zm-28.52,20.26c0,4.5-.75,8.26-.75,12.76-.75,6-1.5,12.76-3,18.76v1.5l-.75-.75h-1.5c.75-6.75,1.5-13.51,1.5-21.01v-2.25c.75-3,.75-5.25,1.5-8.26c0-.75,0-1.5-.75-1.5c1.5-1.5,3-2.25,3.75-3c0,.75,0,2.25,0,3.75v0Zm-22.51,19.51v0c0,5.25-.75,9.76-1.5,14.26-1.5,9.01-3,18.76-6,27.77-.75,3-1.5,6-3,9.01c0-2.25.75-3.75.75-6c1.5-9.01,2.25-17.26,2.25-26.27v-7.5c3-3.75,5.25-7.5,7.5-11.26v0Zm-17.26,50.28c.75-10.51,3.75-21.01,7.5-31.52v11.26c-.75,9.01-2.25,17.26-3.75,25.52-.75,3.75-2.25,7.5-3,10.51-1.5-5.25-1.5-10.51-.75-15.76Zm9.01,53.28c0-.75.75-1.5.75-2.25l-.75,1.5c0,.75,0,1.5,1.5,2.25.75,0,1.5,0,2.25-1.5l1.5-3c0,.75,0,1.5.75,1.5-.75,1.5-.75,2.25-1.5,3.75c0,.75,0,1.5,1.5,2.25.75,0,1.5,0,2.25-1.5q0-.75.75-1.5v0c.75,0,1.5,0,2.25-1.5.75-2.25,2.25-5.25,3-7.5-.75,3-1.5,6.75-3,9.76-.75,1.5-.75,2.25-1.5,3.75-1.5-.75-3,0-3,1.5l.75,3.75c0,0,0,.75.75.75q0,.75-.75,1.5c-2.25-3.75-5.25-8.26-6.75-12.76c0,.75,0,0-.75-.75v0Zm16.51,25.52c-2.25-2.25-3.75-5.25-6-7.5.75-2.25,1.5-4.5,2.25-6v0c.75,0,2.25,0,3-.75c0-.75.75-1.5.75-1.5c0-.75,0-1.5.75-2.25c0-1.5.75-3,.75-4.5.75-3.75,2.25-8.26,3-12.01.75,0,1.5-.75,1.5-1.5.75-2.25,2.25-5.25,3.75-6.75-.75,4.5-2.25,9.01-3,12.76-.75,1.5-1.5,2.25-1.5,3.75-1.5,3-3,6-4.5,8.26-.75.75,0,1.5.75,2.25h1.5v2.25c0,1.5-.75,3-1.5,3.75c0,.75-.75,1.5-1.5,2.25v0c-.75-1.5-.75-3,0-4.5.75-2.25-3-3-3.75-.75-.75,3,0,6.75,1.5,9.01.75.75,1.5,1.5,2.25.75c3.75-2.25,5.25-6,6-9.76c0,0,.75,0,.75-.75v0l-.75,2.25c0,.75,0,2.25,1.5,2.25.75,0,1.5,0,2.25-1.5.75-2.25,1.5-4.5,3-6.75-.75,5.25-3,10.51-5.25,15.76v-.75c0-.75-.75-1.5-1.5-1.5s-1.5.75-1.5,1.5v6.75c-1.5-.75-3-2.25-4.5-4.5v0Zm104.32,3c9.01-11.26,15.76-23.26,21.76-36.02.75-.75.75-1.5.75-2.25-.75,6-3,12.01-5.25,17.26-4.5,7.5-10.51,15.01-17.26,21.01v0Z"
            fill="#fff"
          />
        </g>
      </g>
      <g id="exIqo09Fmte298" opacity="0">
        <g>
          <g>
            <path
              d="M924.04,530.21c0,15.62-1.64,29.6-6.58,43.58-2.47,8.22-6.58,17.27-11.51,24.67-4.11,5.76-8.22,10.69-13.98,14.8-8.22,5.76-16.45,9.87-26.31,11.51-4.11.82-8.22.82-12.33.82-9.05,0-18.09-1.64-26.31-4.11-1.64-.82-2.47-.82-4.11-1.64-9.87-6.58-18.09-13.98-25.49-23.85-5.76-7.4-9.87-16.45-11.51-25.49-1.64-8.22-3.29-16.45-4.11-24.67c0-4.11-.82-7.4-.82-11.51c0-2.47-.82-10.69,0-11.51v-9.05c.82-8.22,1.64-16.45,3.29-23.85c1.64-9.87,7.4-33.71,19.73-48.52c7.4-8.22,15.62-15.62,25.49-19.73c5.76-1.64,10.69-3.29,16.45-3.29c7.4,0,14.8.82,22.2,2.47c8.22,2.47,15.62,6.58,22.2,12.33c2.47,1.64,4.93,4.11,6.58,6.58c8.22,7.4,16.45,30.42,19.73,41.94c1.64,6.58,4.11,13.98,4.93,20.56c1.64,9.05,2.47,18.91,2.47,27.96v0Zm-37.83,0c0-4.93,0-9.87-.82-13.98-.82-10.69-3.29-22.2-7.4-32.07-2.47-6.58-5.76-12.33-9.87-18.09-2.47-2.47-4.93-4.93-8.22-5.76-4.11-.82-8.22-1.64-12.33-.82-7.4.82-13.16,4.11-18.09,9.87-5.76,5.76-9.05,12.33-12.33,19.73-3.29,9.87-4.93,19.73-5.76,29.6v19.73c.82,7.4,2.47,13.98,4.93,20.56c3.29,7.4,7.4,13.98,13.98,19.73c4.93,4.11,9.87,6.58,15.62,7.4c10.69,2.47,22.2-1.64,29.6-12.33c4.11-6.58,6.58-13.16,8.22-20.56c2.47-7.4,3.29-14.8,2.47-23.02v0Z"
              fill="#fff"
            />
            <path
              d="M1072.05,559.82c0,9.87-.82,18.09-3.29,25.49-2.47,9.87-7.4,18.91-13.98,27.14-1.64,2.47-4.11,3.29-6.58,4.93-4.93,3.29-9.87,5.76-15.62,8.22-3.29,1.64-7.4,2.47-10.69,3.29-4.93,0-9.87,1.64-15.62,1.64-8.22,0-16.45-1.64-23.85-5.76s-13.16-8.22-18.09-14.8c-5.76-7.4-9.87-15.62-13.98-24.67-4.11-10.69-6.58-21.38-7.4-32.89-.82-8.22-.82-17.27,0-26.31c0-3.29,0-7.4.82-10.69c0-3.29.82-7.4.82-10.69.82-4.93.82-9.87,1.64-13.98c1.64-11.51,3.29-23.02,8.22-34.54c3.29-9.05,8.22-17.27,15.62-23.85c4.93-4.93,10.69-8.22,17.27-10.69s13.16-4.11,19.73-4.11h4.93c6.58,0,13.16.82,19.73,2.47c5.76,1.64,10.69,4.11,15.62,8.22c4.11,3.29,7.4,6.58,9.05,11.51c1.64,4.11,1.64,8.22.82,12.33-1.64,5.76-6.58,8.22-10.69,8.22-2.47,0-5.76,0-8.22-.82s-5.76-1.64-8.22-2.47c-4.11-.82-7.4-2.47-11.51-2.47-4.93-.82-9.05,0-13.16,1.64-2.47.82-4.93,2.47-6.58,4.11-2.47,1.64-4.11,3.29-6.58,5.76-4.11,5.76-7.4,11.51-9.87,18.09-3.29,9.05-5.76,18.91-5.76,28.78c0,3.29,0,4.11,3.29,1.64c7.4-4.11,14.8-6.58,22.2-9.05c5.76-1.64,12.33-2.47,18.09-2.47c10.69,0,20.56,3.29,28.78,10.69c8.22,6.58,13.98,14.8,17.27,23.85c1.64,4.11,2.47,9.05,3.29,13.16c2.47,2.47,3.29,6.58,2.47,9.05v0Zm-55.92-27.14c-3.29,0-6.58,0-9.87.82-.82,0-1.64,0-2.47.82-3.29,1.64-6.58,4.11-9.05,7.4-3.29,4.93-5.76,9.87-6.58,16.45v9.05c.82,4.93,1.64,9.87,4.11,14.8c1.64,3.29,4.11,6.58,6.58,9.87c6.58,6.58,14.8,8.22,23.02,4.93c2.47-.82,4.93-2.47,7.4-4.11c9.05-7.4,13.98-17.27,13.98-28.78c0-6.58-1.64-12.33-4.11-18.09-2.47-4.93-6.58-8.22-11.51-10.69-3.29-1.64-7.4-2.47-11.51-2.47Z"
              fill="#fff"
            />
            <path
              d="M1196.22,471.01c0,4.11,0,8.22-.82,12.33-.82,8.22-4.93,15.62-9.87,22.2q-.82.82-1.64,1.64t0,1.64c.82,0,.82.82,1.64,1.64c5.76,4.93,10.69,10.69,14.8,16.45c1.64,2.47,3.29,5.76,5.76,8.22c6.58,10.69,9.05,22.2,8.22,35.36c0,4.93-1.64,9.87-3.29,13.98-2.47,6.58-4.93,12.33-9.05,18.09-.82.82-1.64,1.64-2.47,2.47-6.58,5.76-13.98,10.69-22.2,14.8-5.76,2.47-12.33,4.93-18.91,5.76-6.58,1.64-13.98,2.47-21.38,3.29h-1.64c-4.11,0-8.22-.82-12.33-.82-9.87-.82-19.73-3.29-29.6-5.76-2.47-.82-4.93-1.64-7.4-3.29-5.76-4.11-8.22-9.87-6.58-17.27.82-4.11,2.47-8.22,5.76-12.33c2.47-4.11,6.58-4.93,10.69-4.11c1.64,0,2.47.82,4.11.82c4.93,1.64,9.87,3.29,13.98,4.93.82,0,1.64.82,2.47.82c11.51,2.47,23.02,2.47,33.71-.82c7.4-2.47,13.16-6.58,18.09-12.33c3.29-3.29,5.76-7.4,8.22-11.51.82-1.64,1.64-2.47,1.64-4.11c1.64-7.4.82-13.98-1.64-20.56-1.64-4.11-3.29-6.58-7.4-9.05-1.64-.82-3.29-1.64-4.93-.82-8.22,1.64-16.45,3.29-24.67,4.93-5.76,1.64-11.51.82-17.27-.82-3.29-.82-6.58-3.29-8.22-5.76-.82-1.64-1.64-3.29-1.64-4.93-.82-5.76.82-10.69,3.29-15.62.82-.82,1.64-1.64,2.47-2.47c2.47-1.64,4.93-3.29,7.4-4.11c3.29-1.64,5.76-2.47,9.05-3.29c4.11-1.64,7.4-3.29,10.69-5.76c2.47-1.64,4.93-3.29,6.58-5.76c4.93-5.76,7.4-12.33,9.05-19.73.82-4.11.82-9.05-1.64-13.16-3.29-5.76-7.4-8.22-13.98-9.05-3.29,0-6.58,0-9.87,1.64-5.76,2.47-10.69,4.93-15.62,7.4-.82,0-1.64.82-2.47,1.64-1.64.82-3.29,2.47-4.93,3.29-4.93,2.47-9.05,2.47-13.98,0-4.11-2.47-7.4-5.76-9.87-9.87-1.64-2.47-.82-4.93-.82-7.4.82-2.47,1.64-4.11,3.29-5.76c2.47-2.47,4.93-4.93,8.22-7.4c4.11-3.29,8.22-4.93,13.16-7.4c5.76-2.47,10.69-4.11,16.45-5.76c6.58-1.64,13.16-1.64,18.91-1.64.82,0,2.47,0,3.29.82c6.58,2.47,13.98,4.93,19.73,9.05c7.4,4.11,12.33,9.87,16.45,17.27c1.64,3.29,3.29,5.76,4.11,9.05c1.64,4.11,2.47,9.05,2.47,13.98c2.47,1.64,2.47,3.29,2.47,4.93v0Z"
              fill="#fff"
            />
            <path
              d="M757.94,510.48v44.4c0,9.05,0,18.09-.82,27.14-.82,10.69-1.64,21.38-3.29,32.07c0,1.64-.82,4.11-2.47,5.76-1.64,2.47-3.29,4.11-5.76,5.76-3.29,2.47-6.58,3.29-9.87,1.64-9.87-2.47-15.62-8.22-18.09-18.91-.82-5.76-1.64-12.33-1.64-18.09v-12.33c0-4.93.82-9.87.82-13.98.82-6.58,1.64-12.33,1.64-18.91.82-6.58.82-13.98,1.64-20.56v-22.2c0-.82,0-1.64-.82-2.47-.82,0-1.64.82-2.47.82l-8.22,8.22c-4.93,4.93-9.05,10.69-13.98,15.62-3.29,3.29-7.4,5.76-11.51,7.4-3.29.82-6.58.82-9.05-.82-5.76-2.47-9.87-7.4-11.51-13.98-.82-2.47-.82-4.93.82-7.4c4.93-12.33,11.51-24.67,19.73-35.36c5.76-7.4,11.51-14.8,17.27-21.38c9.87-10.69,20.56-20.56,32.07-29.6c0,0,.82,0,.82-.82c2.47-2.47,4.93-2.47,8.22-3.29c2.47,0,5.76.82,8.22,2.47c1.64.82,3.29,2.47,4.11,4.93.82,3.29,1.64,6.58,2.47,9.87.82,4.93.82,10.69,1.64,15.62v58.38v0Z"
              fill="#fff"
            />
          </g>
        </g>
      </g>
      <g id="exIqo09Fmte305" opacity="0">
        <path
          d="M740.26,361.7h28.44c.99,0,1.82.35,2.51,1.04s1.04,1.53,1.04,2.51v200.21c0,.99-.35,1.83-1.04,2.51-.69.69-1.53,1.04-2.51,1.04h-27.26c-.99,0-1.83-.35-2.51-1.04-.69-.69-1.04-1.53-1.04-2.51v-168.23c0-.4-.21-.74-.59-1.04-.4-.29-.79-.35-1.19-.15l-29.62,9.19c-.4.21-.88.29-1.49.29-.79,0-1.44-.29-1.92-.88-.5-.59-.74-1.38-.74-2.37l-.88-19.54c0-1.97.78-3.36,2.37-4.15l31.99-15.99c1.58-.59,3.06-.88,4.45-.88Z"
          fill="#fff"
        />
        <path
          d="M866.83,608.97c-23.72,0-42.75-6.77-56.55-20.12-13.78-13.33-20.76-31.62-20.76-54.39v-98.88c0-22.52,6.98-40.57,20.75-53.67c13.8-13.12,32.83-19.77,56.57-19.77s42.89,6.66,56.93,19.8c13.99,13.1,21.08,31.14,21.08,53.66v98.88c0,22.75-7.1,41.05-21.09,54.36-14.03,13.37-33.18,20.13-56.91,20.13v0Zm0-217.06c-12.6,0-22.84,3.86-30.45,11.47s-11.47,17.97-11.47,30.8v102.39c0,12.83,3.86,23.2,11.47,30.8c7.6,7.61,17.85,11.47,30.45,11.47s23.23-3.86,30.96-11.46c7.74-7.61,11.66-17.98,11.66-30.82v-102.37c0-12.83-3.92-23.2-11.66-30.81-7.73-7.6-18.15-11.46-30.96-11.46v0Z"
          fill="#fff"
        />
        <path
          d="M1037.56,736.52c-18.07,0-33.65-4.18-46.3-12.42-12.57-8.19-21.72-19.81-27.19-34.56-3.86-10.14-5.82-22.16-5.82-35.75v-116.07c0-12.75,3.22-24.11,9.55-33.73c6.37-9.66,15.42-17.26,26.9-22.59c11.66-5.41,25.31-8.15,40.57-8.15s28.01,2.68,39.43,7.96c11.24,5.2,20.09,12.62,26.34,22.03c6.2,9.37,9.36,20.34,9.36,32.58v8.45c0,0-.01.03-.04.04-.01.01-.04.03-.04.04h-35.17c0,0-.06-.06-.08-.08v-2.74c0-11.34-3.84-20.8-11.43-28.1-7.55-7.25-17.21-10.93-28.74-10.93s-21.71,3.81-29.5,11.32c-7.84,7.55-11.82,17.39-11.82,29.24v41.48c0,2.43,1.19,4.47,3.2,5.47.78.4,1.61.59,2.47.59c1.06,0,2.63-.31,4.11-1.78c9.75-9.51,23.57-14.33,41.05-14.33c14.12,0,26.66,3.01,37.23,8.95c10.5,5.9,18.94,14.53,25.11,25.66c6.47,12.23,9.74,27.4,9.74,45.08c0,14.79-2.43,27.9-7.24,38.96l-.03.08c-5.69,13.76-14.76,24.53-26.96,31.99-12.3,7.52-27.35,11.34-44.7,11.34v0Zm-38.63-53.09c6.83,15.57,19.7,23.46,38.24,23.46s30.45-7.74,37.82-23.02c4.09-8.19,6.16-17.93,6.16-28.96c0-12.08-2.35-22.63-6.98-31.37l-.04-.08-.04-.08c-7.92-13.57-20.34-20.45-36.91-20.45-17.43,0-30.01,7.2-37.39,21.4l-.03.06c-4.1,8.19-6.18,18.84-6.18,31.65c0,11,1.81,20.2,5.36,27.36h-.01Z"
          fill="#fff"
        />
        <path
          d="M1229.9,595.54c0,9.1-1.38,17.13-4.14,24.12-3.74,10.23-9.91,18.15-18.51,23.75-8.61,5.6-18.99,8.41-31.18,8.41s-22.45-3.05-31.29-9.14c-8.86-6.09-15.15-14.33-18.88-24.72-1.95-5.04-3.09-11.61-3.41-19.72c0-1.95.97-2.92,2.92-2.92h22.66c1.95,0,2.92.97,2.92,2.92.32,5.2,1.14,9.34,2.43,12.42c1.46,5.2,4.18,9.29,8.16,12.3c3.97,3.01,8.8,4.51,14.49,4.51c10.71,0,18.11-4.87,22.16-14.61c2.11-4.7,3.17-10.8,3.17-18.26c0-8.28-1.22-15.1-3.65-20.45-4.23-9.09-11.53-13.64-21.93-13.64-2.77,0-6.5,1.63-11.2,4.87-.65.33-1.22.49-1.7.49-.82,0-1.63-.49-2.43-1.46l-11.2-15.58c-.49-.81-.73-1.46-.73-1.95c0-.81.32-1.54.97-2.19l40.19-39.46c.32-.32.4-.64.24-.97-.17-.32-.49-.49-.97-.49h-60.89c-.82,0-1.5-.28-2.08-.86-.58-.56-.86-1.26-.86-2.08v-18.51c0-.81.28-1.5.86-2.08.56-.56,1.26-.86,2.08-.86h97.18c.81,0,1.5.28,2.08.86.56.58.85,1.26.85,2.08v21.18c0,1.46-.49,2.68-1.46,3.65l-34.83,35.08c-.65.65-.33,1.14.97,1.46c15.1,2.11,25.82,10.47,32.15,25.09c3.24,7.79,4.87,16.72,4.87,26.8v-.04Z"
          fill="#fff"
        />
        <rect
          width="96.02"
          height="4.88"
          rx="0"
          ry="0"
          transform="translate(1129.81 670.86)"
          fill="#fff"
        />
      </g>
      <g id="exIqo09Fmte311" opacity="0">
        <path
          d="M558.03,403.59h14.34c1.7,0,2.55.85,2.55,2.55v106.42c0,1.7-.85,2.55-2.55,2.55h-13.39c-1.7,0-2.55-.85-2.55-2.55v-90.33c0-.74-.37-1.01-1.12-.8l-14.82,4.15c-.22.11-.47.16-.8.16-.63,0-1.14-.21-1.52-.63-.37-.42-.56-1.01-.56-1.76v-9.24c0-1.27.64-2.23,1.92-2.87l15.46-7.02c.85-.42,1.86-.63,3.02-.63Z"
          fill="#fff"
        />
        <path
          d="M598.9,507.39c-6.53-6.32-9.8-14.84-9.8-25.57v-44.93c0-10.62,3.27-19.04,9.8-25.25s15.37-9.32,26.52-9.32s20.05,3.11,26.69,9.32c6.63,6.21,9.95,14.63,9.95,25.25v44.93c0,10.73-3.32,19.26-9.95,25.57-6.64,6.32-15.53,9.48-26.69,9.48s-19.99-3.16-26.53-9.48v0Zm39.75-11.47c3.3-3.24,4.94-7.62,4.94-13.14v-46.52c0-5.52-1.65-9.9-4.94-13.14s-7.7-4.86-13.23-4.86-9.75,1.62-12.99,4.86-4.86,7.62-4.86,13.14v46.52c0,5.52,1.62,9.9,4.86,13.14s7.57,4.86,12.99,4.86s9.93-1.62,13.23-4.86Z"
          fill="#fff"
        />
        <path
          d="M746.03,479.9c0,6.48-1.07,12.16-3.19,17.05-2.55,6.16-6.56,10.91-12.03,14.26s-12.03,5.02-19.68,5.02-14.77-1.83-20.39-5.5c-5.63-3.66-9.67-8.79-12.11-15.38-1.7-4.46-2.55-9.66-2.55-15.61v-48.59c0-5.74,1.43-10.78,4.31-15.13c2.87-4.36,6.87-7.73,12.03-10.12s11.07-3.58,17.77-3.58s12.24,1.17,17.28,3.51s8.98,5.63,11.79,9.88c2.82,4.25,4.22,9.14,4.22,14.66v2.87c0,1.7-.85,2.55-2.55,2.55h-13.39c-1.7,0-2.55-.53-2.55-1.59v-1.43c0-4.25-1.41-7.73-4.22-10.44-2.82-2.71-6.4-4.06-10.75-4.06s-8.15,1.41-11.08,4.22c-2.92,2.82-4.38,6.46-4.38,10.91v17.21c0,.42.11.67.32.72.22.06.47-.02.8-.24c4.56-4.25,10.67-6.37,18.32-6.37c6.26,0,11.76,1.32,16.49,3.98c4.72,2.66,8.47,6.48,11.23,11.47c2.87,5.41,4.3,12,4.3,19.76v0Zm-18.48.32c0-4.78-.91-8.87-2.71-12.27-2.97-5.1-7.6-7.65-13.86-7.65-6.59,0-11.26,2.66-14.02,7.96-1.59,3.19-2.39,7.33-2.39,12.43c0,4.36.69,7.91,2.07,10.68c2.55,5.84,7.33,8.76,14.34,8.76s11.42-2.87,14.18-8.6c1.59-3.19,2.39-6.95,2.39-11.31v0Z"
          fill="#fff"
        />
        <path
          d="M826.01,479.58c0,4.99-.95,10.25-2.87,15.78-2.45,6.69-6.48,11.87-12.11,15.53s-12.43,5.5-20.39,5.5-14.68-1.99-20.47-5.97-9.9-9.37-12.35-16.18c-1.06-3.51-1.81-7.59-2.23-12.27c0-1.7.85-2.55,2.55-2.55h13.54c1.7,0,2.6.85,2.71,2.55.22,2.77.64,5.26,1.27,7.49c1.07,3.4,2.9,6.08,5.5,8.05s5.76,2.95,9.48,2.95c7.11,0,11.89-3.19,14.34-9.56c1.59-3.4,2.39-7.33,2.39-11.79c0-5.21-.91-9.72-2.71-13.54-2.55-5.95-7.28-8.92-14.18-8.92-1.81,0-3.93.69-6.37,2.07-.64.32-1.17.47-1.59.47-.64,0-1.27-.37-1.92-1.12l-6.69-8.45c-.42-.53-.63-1.12-.63-1.75s.32-1.27.95-1.91l25.65-25.33c.32-.32.42-.58.32-.8-.11-.21-.37-.32-.8-.32h-39.51c-1.7,0-2.55-.85-2.55-2.55v-10.84c0-1.7.85-2.55,2.55-2.55h62.29c1.7,0,2.55.85,2.55,2.55v11.95c0,1.07-.42,2.12-1.27,3.19l-22.78,23.11c-.11.11-.16.27-.16.47c0,.32.32.58.95.8c10.1,1.49,17.21,6.95,21.35,16.41c2.12,5.1,3.18,10.94,3.18,17.52v0Z"
          fill="#fff"
        />
        <path
          d="M559.47,647.02c-6.06-3.13-10.73-7.57-14.02-13.3-3.3-5.74-4.94-12.32-4.94-19.76v-38.56c0-7.54,1.65-14.15,4.94-19.84c3.29-5.68,7.96-10.09,14.02-13.23c6.06-3.13,13.06-4.7,21.03-4.7s14.78,1.54,20.79,4.62c6,3.08,10.64,7.28,13.93,12.59c3.3,5.31,4.94,11.31,4.94,18v.63c0,1.7-.85,2.55-2.55,2.55h-13.23c-.74,0-1.35-.13-1.83-.4-.47-.27-.72-.61-.72-1.03v-1.27c0-5.74-1.94-10.46-5.81-14.18-3.88-3.71-9.06-5.57-15.53-5.57s-11.69,1.94-15.62,5.81c-3.93,3.88-5.9,9-5.9,15.38v39.83c0,6.37,2.07,11.49,6.21,15.38c4.14,3.88,9.5,5.81,16.09,5.81s11.39-1.67,15.06-5.02c3.66-3.35,5.5-7.94,5.5-13.78v-9.72c0-.64-.32-.95-.95-.95h-18.8c-1.7,0-2.55-.85-2.55-2.55v-10.51c0-1.7.85-2.55,2.55-2.55h35.52c1.7,0,2.55.85,2.55,2.55v19.76c0,12.21-3.58,21.72-10.75,28.52s-16.81,10.2-28.92,10.2c-7.97,0-14.98-1.57-21.03-4.7v0Z"
          fill="#fff"
        />
        <path
          d="M657.92,647.09c-6.06-3.08-10.75-7.46-14.1-13.14-3.34-5.68-5.02-12.24-5.02-19.67v-72.81c0-1.7.85-2.55,2.55-2.55h13.39c1.7,0,2.55.85,2.55,2.55v73.13c0,6.27,1.97,11.36,5.9,15.29s9.13,5.9,15.61,5.9s11.69-1.97,15.61-5.9c3.93-3.93,5.9-9.02,5.9-15.29v-73.13c0-1.7.85-2.55,2.55-2.55h13.39c1.7,0,2.55.85,2.55,2.55v72.81c0,7.44-1.65,13.99-4.94,19.67s-7.96,10.06-14.02,13.14-13.07,4.62-21.03,4.62-14.82-1.54-20.87-4.62v0Z"
          fill="#fff"
        />
        <path
          d="M741.09,647.89v-106.42c0-1.7.85-2.55,2.55-2.55h13.39c1.7,0,2.55.85,2.55,2.55v106.42c0,1.7-.85,2.55-2.55,2.55h-13.39c-1.7,0-2.55-.85-2.55-2.55v0Z"
          fill="#fff"
        />
        <path
          d="M782.84,647.89v-106.42c0-1.7.85-2.55,2.55-2.55h38.24c7.55,0,14.18,1.32,19.92,3.98s10.17,6.46,13.31,11.39c3.13,4.94,4.7,10.7,4.7,17.28v46.2c0,6.59-1.57,12.34-4.7,17.28s-7.57,8.74-13.31,11.39c-5.73,2.66-12.37,3.98-19.92,3.98h-38.24c-1.7,0-2.55-.85-2.55-2.55Zm19.43-13.39h22.15c5.63,0,10.11-1.77,13.46-5.33c3.34-3.56,5.06-8.31,5.18-14.26v-40.31c0-6.06-1.7-10.85-5.1-14.42-3.4-3.56-7.97-5.34-13.7-5.34h-21.99c-.63,0-.95.32-.95.96v77.75c0,.63.32.95.95.95v0Z"
          fill="#fff"
        />
        <path
          d="M954.26,554.85h-53.53c-.63,0-.95.32-.95.96v29.48c0,.63.32.96.95.96h35.69c1.7,0,2.55.85,2.55,2.55v10.84c0,1.7-.85,2.55-2.55,2.55h-35.69c-.63,0-.95.32-.95.96v30.44c0,.63.32.95.95.95h53.53c1.7,0,2.55.85,2.55,2.55v10.84c0,1.7-.85,2.55-2.55,2.55h-70.42c-1.7,0-2.55-.85-2.55-2.55v-106.42c0-1.7.85-2.55,2.55-2.55h70.42c1.7,0,2.55.85,2.55,2.55v10.84c0,1.7-.85,2.55-2.55,2.55v-.02Z"
          fill="#fff"
        />
        <path
          d="M975.61,647.89v-106.42c0-1.7.85-2.55,2.55-2.55h13.39c1.7,0,2.55.85,2.55,2.55v92.09c0,.63.32.95.95.95h52.57c1.7,0,2.55.85,2.55,2.55v10.84c0,1.7-.85,2.55-2.55,2.55h-69.46c-1.7,0-2.55-.85-2.55-2.55v0Z"
          fill="#fff"
        />
        <path
          d="M1066.58,647.89v-106.42c0-1.7.85-2.55,2.55-2.55h13.39c1.7,0,2.55.85,2.55,2.55v106.42c0,1.7-.85,2.55-2.55,2.55h-13.39c-1.7,0-2.55-.85-2.55-2.55Z"
          fill="#fff"
        />
        <path
          d="M1108.33,647.89v-106.42c0-1.7.85-2.55,2.55-2.55h12.74c1.48,0,2.55.58,3.19,1.75l44.61,72.97c.22.42.45.58.72.47.27-.1.4-.37.4-.8v-71.86c0-1.7.85-2.55,2.55-2.55h13.39c1.7,0,2.55.85,2.55,2.55v106.42c0,1.7-.85,2.55-2.55,2.55h-13.06c-1.49,0-2.55-.58-3.19-1.75l-44.61-73.45c-.22-.42-.45-.58-.72-.47s-.4.37-.4.8l.16,72.33c0,1.7-.85,2.55-2.55,2.55h-13.23c-1.7,0-2.55-.85-2.55-2.55v0Z"
          fill="#fff"
        />
        <path
          d="M1285.65,554.85h-53.53c-.63,0-.95.32-.95.96v29.48c0,.63.32.96.95.96h35.69c1.7,0,2.55.85,2.55,2.55v10.84c0,1.7-.85,2.55-2.55,2.55h-35.69c-.63,0-.95.32-.95.96v30.44c0,.63.32.95.95.95h53.53c1.7,0,2.55.85,2.55,2.55v10.84c0,1.7-.85,2.55-2.55,2.55h-70.42c-1.7,0-2.55-.85-2.55-2.55v-106.42c0-1.7.85-2.55,2.55-2.55h70.42c1.7,0,2.55.85,2.55,2.55v10.84c0,1.7-.85,2.55-2.55,2.55v-.02Z"
          fill="#fff"
        />
        <path
          d="M1321.57,647.73c-6.11-2.65-10.81-6.4-14.1-11.23-3.3-4.83-4.94-10.44-4.94-16.81v-3.35c0-1.7.85-2.55,2.55-2.55h13.06c1.7,0,2.55.8,2.55,2.39v2.55c0,4.89,2.15,8.95,6.46,12.19s10.01,4.86,17.13,4.86c6.47,0,11.36-1.38,14.65-4.15c3.29-2.76,4.94-6.31,4.94-10.67c0-2.97-.91-5.5-2.71-7.57-1.81-2.07-4.38-3.96-7.72-5.66-3.35-1.7-8.37-3.82-15.06-6.37-7.55-2.76-13.65-5.36-18.32-7.8s-8.58-5.76-11.71-9.96c-3.13-4.19-4.7-9.43-4.7-15.69c0-9.35,3.4-16.73,10.2-22.15s15.88-8.13,27.25-8.13c7.97,0,15,1.38,21.11,4.14c6.11,2.77,10.86,6.61,14.26,11.55s5.1,10.64,5.1,17.13v2.07c0,1.7-.85,2.55-2.55,2.55h-13.06c-.74,0-1.35-.18-1.83-.56-.47-.37-.72-.82-.72-1.35v-1.76c0-4.99-2.04-9.21-6.13-12.67-4.09-3.45-9.75-5.18-16.97-5.18-5.84,0-10.38,1.22-13.62,3.66s-4.86,5.9-4.86,10.35c0,3.19.85,5.79,2.55,7.8c1.7,2.02,4.25,3.85,7.65,5.5s8.65,3.75,15.78,6.29c7.55,2.87,13.57,5.47,18.08,7.8s8.39,5.61,11.63,9.8c3.24,4.2,4.86,9.43,4.86,15.69s-1.59,11.61-4.78,16.33-7.75,8.4-13.7,10.99c-5.95,2.61-12.96,3.91-21.03,3.91s-15.16-1.33-21.26-3.99l-.02.03Z"
          fill="#fff"
        />
        <rect
          width="521.4"
          height="10.16"
          rx="0"
          ry="0"
          transform="translate(858.39 499.78)"
          fill="#fff"
        />
      </g>
    </svg>
  </div>
</template>

<script>
export default {
  setup() {},
  mounted() {
    !(function (t, e) {
      "object" == typeof exports && "undefined" != typeof module
        ? (module.exports = e())
        : "function" == typeof __SVGATOR_DEFINE__ && __SVGATOR_DEFINE__.amd
        ? __SVGATOR_DEFINE__(e)
        : (((t =
            "undefined" != typeof globalThis
              ? globalThis
              : t || self).__SVGATOR_PLAYER__ = t.__SVGATOR_PLAYER__ || {}),
          (t.__SVGATOR_PLAYER__["91c80d77"] = e()));
    })(this, function () {
      "use strict";
      function t(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(t);
          e &&
            (r = r.filter(function (e) {
              return Object.getOwnPropertyDescriptor(t, e).enumerable;
            })),
            n.push.apply(n, r);
        }
        return n;
      }
      function e(e) {
        for (var n = 1; n < arguments.length; n++) {
          var r = null != arguments[n] ? arguments[n] : {};
          n % 2
            ? t(Object(r), !0).forEach(function (t) {
                u(e, t, r[t]);
              })
            : Object.getOwnPropertyDescriptors
            ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r))
            : t(Object(r)).forEach(function (t) {
                Object.defineProperty(
                  e,
                  t,
                  Object.getOwnPropertyDescriptor(r, t)
                );
              });
        }
        return e;
      }
      function n(t) {
        return (n =
          "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
            ? function (t) {
                return typeof t;
              }
            : function (t) {
                return t &&
                  "function" == typeof Symbol &&
                  t.constructor === Symbol &&
                  t !== Symbol.prototype
                  ? "symbol"
                  : typeof t;
              })(t);
      }
      function r(t, e) {
        if (!(t instanceof e))
          throw new TypeError("Cannot call a class as a function");
      }
      function i(t, e) {
        for (var n = 0; n < e.length; n++) {
          var r = e[n];
          (r.enumerable = r.enumerable || !1),
            (r.configurable = !0),
            "value" in r && (r.writable = !0),
            Object.defineProperty(t, r.key, r);
        }
      }
      function o(t, e, n) {
        return e && i(t.prototype, e), n && i(t, n), t;
      }
      function u(t, e, n) {
        return (
          e in t
            ? Object.defineProperty(t, e, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0,
              })
            : (t[e] = n),
          t
        );
      }
      function a(t) {
        return (a = Object.setPrototypeOf
          ? Object.getPrototypeOf
          : function (t) {
              return t.__proto__ || Object.getPrototypeOf(t);
            })(t);
      }
      function s(t, e) {
        return (s =
          Object.setPrototypeOf ||
          function (t, e) {
            return (t.__proto__ = e), t;
          })(t, e);
      }
      function l() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return (
            Boolean.prototype.valueOf.call(
              Reflect.construct(Boolean, [], function () {})
            ),
            !0
          );
        } catch (t) {
          return !1;
        }
      }
      function f(t, e, n) {
        return (f = l()
          ? Reflect.construct
          : function (t, e, n) {
              var r = [null];
              r.push.apply(r, e);
              var i = new (Function.bind.apply(t, r))();
              return n && s(i, n.prototype), i;
            }).apply(null, arguments);
      }
      function c(t, e) {
        if (e && ("object" == typeof e || "function" == typeof e)) return e;
        if (void 0 !== e)
          throw new TypeError(
            "Derived constructors may only return object or undefined"
          );
        return (function (t) {
          if (void 0 === t)
            throw new ReferenceError(
              "this hasn't been initialised - super() hasn't been called"
            );
          return t;
        })(t);
      }
      function h(t, e, n) {
        return (h =
          "undefined" != typeof Reflect && Reflect.get
            ? Reflect.get
            : function (t, e, n) {
                var r = (function (t, e) {
                  for (
                    ;
                    !Object.prototype.hasOwnProperty.call(t, e) &&
                    null !== (t = a(t));

                  );
                  return t;
                })(t, e);
                if (r) {
                  var i = Object.getOwnPropertyDescriptor(r, e);
                  return i.get ? i.get.call(n) : i.value;
                }
              })(t, e, n || t);
      }
      function v(t) {
        return (
          (function (t) {
            if (Array.isArray(t)) return d(t);
          })(t) ||
          (function (t) {
            if (
              ("undefined" != typeof Symbol && null != t[Symbol.iterator]) ||
              null != t["@@iterator"]
            )
              return Array.from(t);
          })(t) ||
          (function (t, e) {
            if (!t) return;
            if ("string" == typeof t) return d(t, e);
            var n = Object.prototype.toString.call(t).slice(8, -1);
            "Object" === n && t.constructor && (n = t.constructor.name);
            if ("Map" === n || "Set" === n) return Array.from(t);
            if (
              "Arguments" === n ||
              /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
            )
              return d(t, e);
          })(t) ||
          (function () {
            throw new TypeError(
              "Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
            );
          })()
        );
      }
      function d(t, e) {
        (null == e || e > t.length) && (e = t.length);
        for (var n = 0, r = new Array(e); n < e; n++) r[n] = t[n];
        return r;
      }
      Number.isInteger ||
        (Number.isInteger = function (t) {
          return "number" == typeof t && isFinite(t) && Math.floor(t) === t;
        }),
        Number.EPSILON || (Number.EPSILON = 2220446049250313e-31);
      var y = g(Math.pow(10, -6));
      function g(t) {
        var e =
          arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 6;
        if (Number.isInteger(t)) return t;
        var n = Math.pow(10, e);
        return Math.round((+t + Number.EPSILON) * n) / n;
      }
      function p(t, e) {
        var n =
          arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : y;
        return Math.abs(t - e) < n;
      }
      var m = Math.PI / 180;
      function b(t) {
        return t;
      }
      function w(t, e, n) {
        var r = 1 - n;
        return 3 * n * r * (t * r + e * n) + n * n * n;
      }
      function k() {
        var t =
            arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0,
          e =
            arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
          n =
            arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1,
          r =
            arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 1;
        return t < 0 || t > 1 || n < 0 || n > 1
          ? null
          : p(t, e) && p(n, r)
          ? b
          : function (i) {
              if (i <= 0)
                return t > 0 ? (i * e) / t : 0 === e && n > 0 ? (i * r) / n : 0;
              if (i >= 1)
                return n < 1
                  ? 1 + ((i - 1) * (r - 1)) / (n - 1)
                  : 1 === n && t < 1
                  ? 1 + ((i - 1) * (e - 1)) / (t - 1)
                  : 1;
              for (var o, u = 0, a = 1; u < a; ) {
                var s = w(t, n, (o = (u + a) / 2));
                if (p(i, s)) break;
                s < i ? (u = o) : (a = o);
              }
              return w(e, r, o);
            };
      }
      function _() {
        return 1;
      }
      function A(t) {
        return 1 === t ? 1 : 0;
      }
      function x() {
        var t =
            arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1,
          e =
            arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
        if (1 === t) {
          if (0 === e) return A;
          if (1 === e) return _;
        }
        var n = 1 / t;
        return function (t) {
          return t >= 1 ? 1 : (t += e * n) - (t % n);
        };
      }
      var O = Math.sin,
        S = Math.cos,
        E = Math.acos,
        P = Math.asin,
        j = Math.tan,
        M = Math.atan2,
        B = Math.PI / 180,
        I = 180 / Math.PI,
        T = Math.sqrt,
        R = (function () {
          function t() {
            var e =
                arguments.length > 0 && void 0 !== arguments[0]
                  ? arguments[0]
                  : 1,
              n =
                arguments.length > 1 && void 0 !== arguments[1]
                  ? arguments[1]
                  : 0,
              i =
                arguments.length > 2 && void 0 !== arguments[2]
                  ? arguments[2]
                  : 0,
              o =
                arguments.length > 3 && void 0 !== arguments[3]
                  ? arguments[3]
                  : 1,
              u =
                arguments.length > 4 && void 0 !== arguments[4]
                  ? arguments[4]
                  : 0,
              a =
                arguments.length > 5 && void 0 !== arguments[5]
                  ? arguments[5]
                  : 0;
            r(this, t),
              (this.m = [e, n, i, o, u, a]),
              (this.i = null),
              (this.w = null),
              (this.s = null);
          }
          return (
            o(
              t,
              [
                {
                  key: "determinant",
                  get: function () {
                    var t = this.m;
                    return t[0] * t[3] - t[1] * t[2];
                  },
                },
                {
                  key: "isIdentity",
                  get: function () {
                    if (null === this.i) {
                      var t = this.m;
                      this.i =
                        1 === t[0] &&
                        0 === t[1] &&
                        0 === t[2] &&
                        1 === t[3] &&
                        0 === t[4] &&
                        0 === t[5];
                    }
                    return this.i;
                  },
                },
                {
                  key: "point",
                  value: function (t, e) {
                    var n = this.m;
                    return {
                      x: n[0] * t + n[2] * e + n[4],
                      y: n[1] * t + n[3] * e + n[5],
                    };
                  },
                },
                {
                  key: "translateSelf",
                  value: function () {
                    var t =
                        arguments.length > 0 && void 0 !== arguments[0]
                          ? arguments[0]
                          : 0,
                      e =
                        arguments.length > 1 && void 0 !== arguments[1]
                          ? arguments[1]
                          : 0;
                    if (!t && !e) return this;
                    var n = this.m;
                    return (
                      (n[4] += n[0] * t + n[2] * e),
                      (n[5] += n[1] * t + n[3] * e),
                      (this.w = this.s = this.i = null),
                      this
                    );
                  },
                },
                {
                  key: "rotateSelf",
                  value: function () {
                    var t =
                      arguments.length > 0 && void 0 !== arguments[0]
                        ? arguments[0]
                        : 0;
                    if ((t %= 360)) {
                      var e = O((t *= B)),
                        n = S(t),
                        r = this.m,
                        i = r[0],
                        o = r[1];
                      (r[0] = i * n + r[2] * e),
                        (r[1] = o * n + r[3] * e),
                        (r[2] = r[2] * n - i * e),
                        (r[3] = r[3] * n - o * e),
                        (this.w = this.s = this.i = null);
                    }
                    return this;
                  },
                },
                {
                  key: "scaleSelf",
                  value: function () {
                    var t =
                        arguments.length > 0 && void 0 !== arguments[0]
                          ? arguments[0]
                          : 1,
                      e =
                        arguments.length > 1 && void 0 !== arguments[1]
                          ? arguments[1]
                          : 1;
                    if (1 !== t || 1 !== e) {
                      var n = this.m;
                      (n[0] *= t),
                        (n[1] *= t),
                        (n[2] *= e),
                        (n[3] *= e),
                        (this.w = this.s = this.i = null);
                    }
                    return this;
                  },
                },
                {
                  key: "skewSelf",
                  value: function (t, e) {
                    if (((e %= 360), (t %= 360) || e)) {
                      var n = this.m,
                        r = n[0],
                        i = n[1],
                        o = n[2],
                        u = n[3];
                      t && ((t = j(t * B)), (n[2] += r * t), (n[3] += i * t)),
                        e && ((e = j(e * B)), (n[0] += o * e), (n[1] += u * e)),
                        (this.w = this.s = this.i = null);
                    }
                    return this;
                  },
                },
                {
                  key: "resetSelf",
                  value: function () {
                    var t =
                        arguments.length > 0 && void 0 !== arguments[0]
                          ? arguments[0]
                          : 1,
                      e =
                        arguments.length > 1 && void 0 !== arguments[1]
                          ? arguments[1]
                          : 0,
                      n =
                        arguments.length > 2 && void 0 !== arguments[2]
                          ? arguments[2]
                          : 0,
                      r =
                        arguments.length > 3 && void 0 !== arguments[3]
                          ? arguments[3]
                          : 1,
                      i =
                        arguments.length > 4 && void 0 !== arguments[4]
                          ? arguments[4]
                          : 0,
                      o =
                        arguments.length > 5 && void 0 !== arguments[5]
                          ? arguments[5]
                          : 0,
                      u = this.m;
                    return (
                      (u[0] = t),
                      (u[1] = e),
                      (u[2] = n),
                      (u[3] = r),
                      (u[4] = i),
                      (u[5] = o),
                      (this.w = this.s = this.i = null),
                      this
                    );
                  },
                },
                {
                  key: "recomposeSelf",
                  value: function () {
                    var t =
                        arguments.length > 0 && void 0 !== arguments[0]
                          ? arguments[0]
                          : null,
                      e =
                        arguments.length > 1 && void 0 !== arguments[1]
                          ? arguments[1]
                          : null,
                      n =
                        arguments.length > 2 && void 0 !== arguments[2]
                          ? arguments[2]
                          : null,
                      r =
                        arguments.length > 3 && void 0 !== arguments[3]
                          ? arguments[3]
                          : null,
                      i =
                        arguments.length > 4 && void 0 !== arguments[4]
                          ? arguments[4]
                          : null;
                    return (
                      this.isIdentity || this.resetSelf(),
                      t && (t.x || t.y) && this.translateSelf(t.x, t.y),
                      e && this.rotateSelf(e),
                      n &&
                        (n.x && this.skewSelf(n.x, 0),
                        n.y && this.skewSelf(0, n.y)),
                      !r ||
                        (1 === r.x && 1 === r.y) ||
                        this.scaleSelf(r.x, r.y),
                      i && (i.x || i.y) && this.translateSelf(i.x, i.y),
                      this
                    );
                  },
                },
                {
                  key: "decompose",
                  value: function () {
                    var t =
                        arguments.length > 0 && void 0 !== arguments[0]
                          ? arguments[0]
                          : 0,
                      e =
                        arguments.length > 1 && void 0 !== arguments[1]
                          ? arguments[1]
                          : 0,
                      n = this.m,
                      r = n[0] * n[0] + n[1] * n[1],
                      i = [
                        [n[0], n[1]],
                        [n[2], n[3]],
                      ],
                      o = T(r);
                    if (0 === o)
                      return {
                        origin: { x: g(n[4]), y: g(n[5]) },
                        translate: { x: g(t), y: g(e) },
                        scale: { x: 0, y: 0 },
                        skew: { x: 0, y: 0 },
                        rotate: 0,
                      };
                    (i[0][0] /= o), (i[0][1] /= o);
                    var u = n[0] * n[3] - n[1] * n[2] < 0;
                    u && (o = -o);
                    var a = i[0][0] * i[1][0] + i[0][1] * i[1][1];
                    (i[1][0] -= i[0][0] * a), (i[1][1] -= i[0][1] * a);
                    var s = T(i[1][0] * i[1][0] + i[1][1] * i[1][1]);
                    if (0 === s)
                      return {
                        origin: { x: g(n[4]), y: g(n[5]) },
                        translate: { x: g(t), y: g(e) },
                        scale: { x: g(o), y: 0 },
                        skew: { x: 0, y: 0 },
                        rotate: 0,
                      };
                    (i[1][0] /= s), (i[1][1] /= s), (a /= s);
                    var l = 0;
                    return (
                      i[1][1] < 0
                        ? ((l = E(i[1][1]) * I), i[0][1] < 0 && (l = 360 - l))
                        : (l = P(i[0][1]) * I),
                      u && (l = -l),
                      (a = M(a, T(i[0][0] * i[0][0] + i[0][1] * i[0][1])) * I),
                      u && (a = -a),
                      {
                        origin: { x: g(n[4]), y: g(n[5]) },
                        translate: { x: g(t), y: g(e) },
                        scale: { x: g(o), y: g(s) },
                        skew: { x: g(a), y: 0 },
                        rotate: g(l),
                      }
                    );
                  },
                },
                {
                  key: "clone",
                  value: function () {
                    var t = this.m;
                    return new this.constructor(
                      t[0],
                      t[1],
                      t[2],
                      t[3],
                      t[4],
                      t[5]
                    );
                  },
                },
                {
                  key: "toString",
                  value: function () {
                    var t =
                      arguments.length > 0 && void 0 !== arguments[0]
                        ? arguments[0]
                        : " ";
                    if (null === this.s) {
                      var e = this.m.map(function (t) {
                        return g(t);
                      });
                      1 === e[0] && 0 === e[1] && 0 === e[2] && 1 === e[3]
                        ? (this.s = "translate(" + e[4] + t + e[5] + ")")
                        : (this.s = "matrix(" + e.join(t) + ")");
                    }
                    return this.s;
                  },
                },
              ],
              [
                {
                  key: "create",
                  value: function (t) {
                    return t
                      ? Array.isArray(t)
                        ? f(this, v(t))
                        : t instanceof this
                        ? t.clone()
                        : new this().recomposeSelf(
                            t.origin,
                            t.rotate,
                            t.skew,
                            t.scale,
                            t.translate
                          )
                      : new this();
                  },
                },
              ]
            ),
            t
          );
        })();
      function N(t, e, n) {
        return t >= 0.5 ? n : e;
      }
      function F(t, e, n) {
        return 0 === t || e === n ? e : t * (n - e) + e;
      }
      function C(t, e, n) {
        var r = F(t, e, n);
        return r <= 0 ? 0 : r;
      }
      function D(t, e, n) {
        var r = F(t, e, n);
        return r <= 0 ? 0 : r >= 1 ? 1 : r;
      }
      function L(t, e, n) {
        return 0 === t
          ? e
          : 1 === t
          ? n
          : { x: F(t, e.x, n.x), y: F(t, e.y, n.y) };
      }
      function V(t, e, n) {
        return 0 === t
          ? e
          : 1 === t
          ? n
          : { x: C(t, e.x, n.x), y: C(t, e.y, n.y) };
      }
      function q(t, e, n) {
        var r = (function (t, e, n) {
          return Math.round(F(t, e, n));
        })(t, e, n);
        return r <= 0 ? 0 : r >= 255 ? 255 : r;
      }
      function G(t, e, n) {
        return 0 === t
          ? e
          : 1 === t
          ? n
          : {
              r: q(t, e.r, n.r),
              g: q(t, e.g, n.g),
              b: q(t, e.b, n.b),
              a: F(t, null == e.a ? 1 : e.a, null == n.a ? 1 : n.a),
            };
      }
      function z(t, e, n) {
        var r = e.length;
        if (r !== n.length) return N(t, e, n);
        for (var i = new Array(r), o = 0; o < r; o++) i[o] = F(t, e[o], n[o]);
        return i;
      }
      function Y(t, e) {
        for (var n = [], r = 0; r < t; r++) n.push(e);
        return n;
      }
      function U(t, e) {
        if (--e <= 0) return t;
        var n = (t = Object.assign([], t)).length;
        do {
          for (var r = 0; r < n; r++) t.push(t[r]);
        } while (--e > 0);
        return t;
      }
      var W,
        $ = (function () {
          function t(e) {
            r(this, t), (this.list = e), (this.length = e.length);
          }
          return (
            o(t, [
              {
                key: "setAttribute",
                value: function (t, e) {
                  for (var n = this.list, r = 0; r < this.length; r++)
                    n[r].setAttribute(t, e);
                },
              },
              {
                key: "removeAttribute",
                value: function (t) {
                  for (var e = this.list, n = 0; n < this.length; n++)
                    e[n].removeAttribute(t);
                },
              },
              {
                key: "style",
                value: function (t, e) {
                  for (var n = this.list, r = 0; r < this.length; r++)
                    n[r].style[t] = e;
                },
              },
            ]),
            t
          );
        })(),
        H = /-./g,
        Q = function (t, e) {
          return e.toUpperCase();
        };
      function X(t) {
        return "function" == typeof t ? t : N;
      }
      function J(t) {
        return t
          ? "function" == typeof t
            ? t
            : Array.isArray(t)
            ? (function (t) {
                var e =
                  arguments.length > 1 && void 0 !== arguments[1]
                    ? arguments[1]
                    : b;
                if (!Array.isArray(t)) return e;
                switch (t.length) {
                  case 1:
                    return x(t[0]) || e;
                  case 2:
                    return x(t[0], t[1]) || e;
                  case 4:
                    return k(t[0], t[1], t[2], t[3]) || e;
                }
                return e;
              })(t, null)
            : (function (t, e) {
                var n =
                  arguments.length > 2 && void 0 !== arguments[2]
                    ? arguments[2]
                    : b;
                switch (t) {
                  case "linear":
                    return b;
                  case "steps":
                    return x(e.steps || 1, e.jump || 0) || n;
                  case "bezier":
                  case "cubic-bezier":
                    return k(e.x1 || 0, e.y1 || 0, e.x2 || 0, e.y2 || 0) || n;
                }
                return n;
              })(t.type, t.value, null)
          : null;
      }
      function K(t, e, n) {
        var r = arguments.length > 3 && void 0 !== arguments[3] && arguments[3],
          i = e.length - 1;
        if (t <= e[0].t) return r ? [0, 0, e[0].v] : e[0].v;
        if (t >= e[i].t) return r ? [i, 1, e[i].v] : e[i].v;
        var o,
          u = e[0],
          a = null;
        for (o = 1; o <= i; o++) {
          if (!(t > e[o].t)) {
            a = e[o];
            break;
          }
          u = e[o];
        }
        return null == a
          ? r
            ? [i, 1, e[i].v]
            : e[i].v
          : u.t === a.t
          ? r
            ? [o, 1, a.v]
            : a.v
          : ((t = (t - u.t) / (a.t - u.t)),
            u.e && (t = u.e(t)),
            r ? [o, t, n(t, u.v, a.v)] : n(t, u.v, a.v));
      }
      function Z(t, e) {
        var n =
          arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null;
        return t && t.length
          ? "function" != typeof e
            ? null
            : ("function" != typeof n && (n = null),
              function (r) {
                var i = K(r, t, e);
                return null != i && n && (i = n(i)), i;
              })
          : null;
      }
      function tt(t, e) {
        return t.t - e.t;
      }
      function et(t, e, r, i, o) {
        var u,
          a = "@" === r[0],
          s = "#" === r[0],
          l = W[r],
          f = N;
        switch (
          (a
            ? ((u = r.substr(1)), (r = u.replace(H, Q)))
            : s && (r = r.substr(1)),
          n(l))
        ) {
          case "function":
            if (((f = l(i, o, K, J, r, a, e, t)), s)) return f;
            break;
          case "string":
            f = Z(i, X(l));
            break;
          case "object":
            if ((f = Z(i, X(l.i), l.f)) && "function" == typeof l.u)
              return l.u(e, f, r, a, t);
        }
        return f
          ? (function (t, e, n) {
              if (
                arguments.length > 3 &&
                void 0 !== arguments[3] &&
                arguments[3]
              )
                return t instanceof $
                  ? function (r) {
                      return t.style(e, n(r));
                    }
                  : function (r) {
                      return (t.style[e] = n(r));
                    };
              if (Array.isArray(e)) {
                var r = e.length;
                return function (i) {
                  var o = n(i);
                  if (null == o)
                    for (var u = 0; u < r; u++) t[u].removeAttribute(e);
                  else for (var a = 0; a < r; a++) t[a].setAttribute(e, o);
                };
              }
              return function (r) {
                var i = n(r);
                null == i ? t.removeAttribute(e) : t.setAttribute(e, i);
              };
            })(e, r, f, a)
          : null;
      }
      function nt(t, e, r, i) {
        if (!i || "object" !== n(i)) return null;
        var o = null,
          u = null;
        return (
          Array.isArray(i)
            ? (u = (function (t) {
                if (!t || !t.length) return null;
                for (var e = 0; e < t.length; e++)
                  t[e].e && (t[e].e = J(t[e].e));
                return t.sort(tt);
              })(i))
            : ((u = i.keys), (o = i.data || null)),
          u ? et(t, e, r, u, o) : null
        );
      }
      function rt(t, e, n) {
        if (!n) return null;
        var r = [];
        for (var i in n)
          if (n.hasOwnProperty(i)) {
            var o = nt(t, e, i, n[i]);
            o && r.push(o);
          }
        return r.length ? r : null;
      }
      function it(t, e) {
        if (!e.settings.duration || e.settings.duration < 0) return null;
        var n,
          r,
          i,
          o,
          u,
          a = (function (t, e) {
            if (!e) return null;
            var n = [];
            if (Array.isArray(e))
              for (var r = e.length, i = 0; i < r; i++) {
                var o = e[i];
                if (2 === o.length) {
                  var u = null;
                  if ("string" == typeof o[0]) u = t.getElementById(o[0]);
                  else if (Array.isArray(o[0])) {
                    u = [];
                    for (var a = 0; a < o[0].length; a++)
                      if ("string" == typeof o[0][a]) {
                        var s = t.getElementById(o[0][a]);
                        s && u.push(s);
                      }
                    u = u.length ? (1 === u.length ? u[0] : new $(u)) : null;
                  }
                  if (u) {
                    var l = rt(t, u, o[1]);
                    l && (n = n.concat(l));
                  }
                }
              }
            else
              for (var f in e)
                if (e.hasOwnProperty(f)) {
                  var c = t.getElementById(f);
                  if (c) {
                    var h = rt(t, c, e[f]);
                    h && (n = n.concat(h));
                  }
                }
            return n.length ? n : null;
          })(t, e.elements);
        return a
          ? ((n = a),
            (r = e.settings),
            (i = r.duration),
            (o = n.length),
            (u = null),
            function (t, e) {
              var a = r.iterations || 1 / 0,
                s = (r.alternate && a % 2 == 0) ^ (r.direction > 0) ? i : 0,
                l = t % i,
                f = 1 + (t - l) / i;
              (e *= r.direction), r.alternate && f % 2 == 0 && (e = -e);
              var c = !1;
              if (f > a)
                (l = s),
                  (c = !0),
                  -1 === r.fill && (l = r.direction > 0 ? 0 : i);
              else if ((e < 0 && (l = i - l), l === u)) return !1;
              u = l;
              for (var h = 0; h < o; h++) n[h](l);
              return c;
            })
          : null;
      }
      function ot(t, e) {
        if (((W = e), !t || !t.root || !Array.isArray(t.animations)))
          return null;
        var n = (function (t) {
          for (
            var e = document.getElementsByTagName("svg"), n = 0;
            n < e.length;
            n++
          )
            if (e[n].id === t.root && !e[n].svgatorAnimation)
              return (e[n].svgatorAnimation = !0), e[n];
          return null;
        })(t);
        if (!n) return null;
        var r = t.animations
          .map(function (t) {
            return it(n, t);
          })
          .filter(function (t) {
            return !!t;
          });
        return r.length
          ? {
              svg: n,
              animations: r,
              animationSettings: t.animationSettings,
              options: t.options || void 0,
            }
          : null;
      }
      function ut(t) {
        var e =
            arguments.length > 1 && void 0 !== arguments[1]
              ? arguments[1]
              : null,
          n =
            arguments.length > 2 && void 0 !== arguments[2]
              ? arguments[2]
              : Number,
          r =
            arguments.length > 3 && void 0 !== arguments[3]
              ? arguments[3]
              : "undefined" != typeof BigInt && BigInt,
          i = "0x" + (t.replace(/[^0-9a-fA-F]+/g, "") || 27);
        return e && r && n.isSafeInteger && !n.isSafeInteger(+i)
          ? (n(r(i)) % e) + e
          : +i;
      }
      function at(t, e, n) {
        return !t || !n || e > t.length
          ? t
          : t.substring(0, e) + at(t.substring(e + 1), n, n);
      }
      function st(t) {
        var e =
          arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 27;
        return !t || t % e ? t % e : [0, 1].includes(e) ? e : st(t / e, e);
      }
      function lt(t, e, n) {
        if (t && t.length) {
          var r = ut(n),
            i = st(r) + 5,
            o = at(t, st(r, 5), i);
          return (
            (o = o.replace(/\x7c$/g, "==").replace(/\x2f$/g, "=")),
            (o = (function (t, e, n) {
              var r = +("0x" + t.substring(0, 4));
              t = t.substring(4);
              for (
                var i = (ut(e, r) % r) + (n % 27), o = [], u = 0;
                u < t.length;
                u += 2
              )
                if ("|" !== t[u]) {
                  var a = +("0x" + t[u] + t[u + 1]) - i;
                  o.push(a);
                } else {
                  var s = +("0x" + t.substring(u + 1, u + 1 + 4)) - i;
                  (u += 3), o.push(s);
                }
              return String.fromCharCode.apply(String, o);
            })((o = (o = atob(o)).replace(/[\x41-\x5A]/g, "")), e, r)),
            (o = JSON.parse(o))
          );
        }
      }
      var ft = [
          { key: "alternate", def: !1 },
          { key: "fill", def: 1 },
          { key: "iterations", def: 0 },
          { key: "direction", def: 1 },
          { key: "speed", def: 1 },
          { key: "fps", def: 100 },
        ],
        ct = (function () {
          function t(e, n) {
            var i = this,
              o =
                arguments.length > 2 && void 0 !== arguments[2]
                  ? arguments[2]
                  : null;
            r(this, t),
              (this._id = 0),
              (this._running = !1),
              (this._rollingBack = !1),
              (this._animations = e),
              (this._settings = n),
              (!o || o < "2022-05-02") && delete this._settings.speed,
              ft.forEach(function (t) {
                i._settings[t.key] = i._settings[t.key] || t.def;
              }),
              (this.duration = n.duration),
              (this.offset = n.offset || 0),
              (this.rollbackStartOffset = 0);
          }
          return (
            o(
              t,
              [
                {
                  key: "alternate",
                  get: function () {
                    return this._settings.alternate;
                  },
                },
                {
                  key: "fill",
                  get: function () {
                    return this._settings.fill;
                  },
                },
                {
                  key: "iterations",
                  get: function () {
                    return this._settings.iterations;
                  },
                },
                {
                  key: "direction",
                  get: function () {
                    return this._settings.direction;
                  },
                },
                {
                  key: "speed",
                  get: function () {
                    return this._settings.speed;
                  },
                },
                {
                  key: "fps",
                  get: function () {
                    return this._settings.fps;
                  },
                },
                {
                  key: "maxFiniteDuration",
                  get: function () {
                    return this.iterations > 0
                      ? this.iterations * this.duration
                      : this.duration;
                  },
                },
                {
                  key: "_apply",
                  value: function (t) {
                    for (
                      var e =
                          arguments.length > 1 && void 0 !== arguments[1]
                            ? arguments[1]
                            : {},
                        n = this._animations,
                        r = n.length,
                        i = 0,
                        o = 0;
                      o < r;
                      o++
                    )
                      e[o] ? i++ : ((e[o] = n[o](t, 1)), e[o] && i++);
                    return i;
                  },
                },
                {
                  key: "_rollback",
                  value: function (t) {
                    var e = this,
                      n = 1 / 0,
                      r = null;
                    (this.rollbackStartOffset = t),
                      (this._rollingBack = !0),
                      (this._running = !0);
                    this._id = window.requestAnimationFrame(function i(o) {
                      if (e._rollingBack) {
                        null == r && (r = o);
                        var u = Math.round(t - (o - r) * e.speed);
                        if (u > e.duration && n !== 1 / 0) {
                          var a = !!e.alternate && (u / e.duration) % 2 > 1,
                            s = u % e.duration;
                          u = (s += a ? e.duration : 0) || e.duration;
                        }
                        var l = (e.fps ? 1e3 / e.fps : 0) * e.speed,
                          f = Math.max(0, u);
                        f <= n - l && ((e.offset = f), (n = f), e._apply(f));
                        var c =
                          e.iterations > 0 &&
                          -1 === e.fill &&
                          u >= e.maxFiniteDuration;
                        (u <= 0 || e.offset < u || c) && e.stop(),
                          (e._id = window.requestAnimationFrame(i));
                      }
                    });
                  },
                },
                {
                  key: "_start",
                  value: function () {
                    var t = this,
                      e =
                        arguments.length > 0 && void 0 !== arguments[0]
                          ? arguments[0]
                          : 0,
                      n = -1 / 0,
                      r = null,
                      i = {};
                    this._running = !0;
                    var o = function o(u) {
                      null == r && (r = u);
                      var a = Math.round((u - r) * t.speed + e),
                        s = (t.fps ? 1e3 / t.fps : 0) * t.speed;
                      if (
                        a >= n + s &&
                        !t._rollingBack &&
                        ((t.offset = a),
                        (n = a),
                        t._apply(a, i) === t._animations.length)
                      )
                        return void t.pause(!0);
                      t._id = window.requestAnimationFrame(o);
                    };
                    this._id = window.requestAnimationFrame(o);
                  },
                },
                {
                  key: "_pause",
                  value: function () {
                    this._id && window.cancelAnimationFrame(this._id),
                      (this._running = !1);
                  },
                },
                {
                  key: "play",
                  value: function () {
                    if (!this._running)
                      return this._rollingBack
                        ? this._rollback(this.offset)
                        : this._start(this.offset);
                  },
                },
                {
                  key: "stop",
                  value: function () {
                    this._pause(),
                      (this.offset = 0),
                      (this.rollbackStartOffset = 0),
                      (this._rollingBack = !1),
                      this._apply(0);
                  },
                },
                {
                  key: "reachedToEnd",
                  value: function () {
                    return (
                      this.iterations > 0 &&
                      this.offset >= this.iterations * this.duration
                    );
                  },
                },
                {
                  key: "restart",
                  value: function () {
                    var t =
                      arguments.length > 0 &&
                      void 0 !== arguments[0] &&
                      arguments[0];
                    this.stop(t), this.play(t);
                  },
                },
                {
                  key: "pause",
                  value: function () {
                    this._pause();
                  },
                },
                {
                  key: "reverse",
                  value: function () {
                    this.direction = -this.direction;
                  },
                },
              ],
              [
                {
                  key: "build",
                  value: function (t, e) {
                    delete t.animationSettings,
                      (t.options = lt(t.options, t.root, "91c80d77")),
                      t.animations.map(function (e) {
                        (e.settings = lt(e.s, t.root, "91c80d77")),
                          delete e.s,
                          t.animationSettings ||
                            (t.animationSettings = e.settings);
                      });
                    var n = t.version;
                    if (!(t = ot(t, e))) return null;
                    var r = t.options || {},
                      i = new this(t.animations, t.animationSettings, n);
                    return { el: t.svg, options: r, player: i };
                  },
                },
                {
                  key: "push",
                  value: function (t) {
                    return this.build(t);
                  },
                },
                {
                  key: "init",
                  value: function () {
                    var t = this,
                      e =
                        window.__SVGATOR_PLAYER__ &&
                        window.__SVGATOR_PLAYER__["91c80d77"];
                    Array.isArray(e) &&
                      e.splice(0).forEach(function (e) {
                        return t.build(e);
                      });
                  },
                },
              ]
            ),
            t
          );
        })();
      !(function () {
        for (
          var t = 0, e = ["ms", "moz", "webkit", "o"], n = 0;
          n < e.length && !window.requestAnimationFrame;
          ++n
        )
          (window.requestAnimationFrame =
            window[e[n] + "RequestAnimationFrame"]),
            (window.cancelAnimationFrame =
              window[e[n] + "CancelAnimationFrame"] ||
              window[e[n] + "CancelRequestAnimationFrame"]);
        window.requestAnimationFrame ||
          ((window.requestAnimationFrame = function (e) {
            var n = Date.now(),
              r = Math.max(0, 16 - (n - t)),
              i = window.setTimeout(function () {
                e(n + r);
              }, r);
            return (t = n + r), i;
          }),
          (window.cancelAnimationFrame = window.clearTimeout));
      })();
      var ht = (function () {
        function t(e, n, i) {
          r(this, t);
          var o = (function (t) {
            var e,
              n,
              r,
              i =
                t &&
                1 ===
                  (null === (e = t.ownerDocument) ||
                  void 0 === e ||
                  null === (n = e.childNodes) ||
                  void 0 === n
                    ? void 0
                    : n.length) &&
                window.parent !== window,
              o = { el: t, window: window };
            if (!i) return o;
            try {
              r = window.parent.document;
            } catch (t) {
              return o;
            }
            return (
              (o.window = window.parent),
              (o.el =
                Array.from(r.querySelectorAll("iframe,object")).filter(
                  function (t) {
                    return t.contentWindow === window;
                  }
                )[0] || o.el),
              o
            );
          })(e);
          (n = Math.max(1, n || 1)),
            (n = Math.min(n, 100)),
            (this.el = o.el),
            (this._handlers = []),
            (this.onThresholdChange = i && i.call ? i : function () {}),
            (this.thresholdPercent = n || 1),
            (this.currentVisibility = null),
            (this.visibilityCalculator = (function (t, e) {
              var n =
                  arguments.length > 2 && void 0 !== arguments[2]
                    ? arguments[2]
                    : n,
                r = !1,
                i = null,
                o = function () {
                  for (
                    var o = 0,
                      u = n.innerHeight,
                      a = 0,
                      s = n.innerWidth,
                      l = t.parentNode;
                    l instanceof Element;

                  ) {
                    var f = n.getComputedStyle(l);
                    if (
                      "visible" !== f.overflowY ||
                      "visible" !== f.overflowX
                    ) {
                      var c = l.getBoundingClientRect();
                      "visible" !== f.overflowY &&
                        ((o = Math.max(o, c.top)), (u = Math.min(u, c.bottom))),
                        "visible" !== f.overflowX &&
                          ((a = Math.max(a, c.left)),
                          (s = Math.min(s, c.right)));
                    }
                    if (l === l.parentNode) break;
                    l = l.parentNode;
                  }
                  r = !1;
                  var h = t.getBoundingClientRect(),
                    v = Math.min(h.height, Math.max(0, o - h.top)),
                    d = Math.min(h.height, Math.max(0, h.bottom - u)),
                    y = Math.min(h.width, Math.max(0, a - h.left)),
                    g = Math.min(h.width, Math.max(0, h.right - s)),
                    p = (h.height - v - d) / h.height,
                    m = (h.width - y - g) / h.width,
                    b = Math.round(p * m * 100);
                  (null !== i && i === b) || ((i = b), e(b));
                };
              return function (t) {
                r && clearTimeout(r),
                  (r = setTimeout(function () {
                    return o();
                  }, 100));
              };
            })(this.el, this.onVisibilityUpdate.bind(this), o.window)),
            this.bindScrollWatchers(),
            this.visibilityCalculator();
        }
        return (
          o(t, [
            {
              key: "bindScrollWatchers",
              value: function () {
                for (
                  var t = this.el.parentNode;
                  t &&
                  (this._handlers.push({
                    element: t,
                    event: "scroll",
                    handler: this.visibilityCalculator,
                  }),
                  t.addEventListener("scroll", this.visibilityCalculator),
                  t !== t.parentNode && t !== document);

                )
                  t = t.parentNode;
              },
            },
            {
              key: "onVisibilityUpdate",
              value: function (t) {
                var e = this.currentVisibility >= this.thresholdPercent,
                  n = t >= this.thresholdPercent;
                if (null === this.currentVisibility || e !== n)
                  return (
                    (this.currentVisibility = t), void this.onThresholdChange(n)
                  );
                this.currentVisibility = t;
              },
            },
            {
              key: "destruct",
              value: function () {
                this._handlers.forEach(function (t) {
                  t.element.removeEventListener(t.event, t.handler);
                });
              },
            },
          ]),
          t
        );
      })();
      function vt(t) {
        return g(t) + "";
      }
      function dt(t) {
        var e =
          arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : " ";
        return t && t.length ? t.map(vt).join(e) : "";
      }
      function yt(t) {
        return vt(t.x) + "," + vt(t.y);
      }
      function gt(t) {
        if (!t) return "transparent";
        if (null == t.a || t.a >= 1) {
          var e = function (t) {
              return 1 === (t = parseInt(t).toString(16)).length ? "0" + t : t;
            },
            n = function (t) {
              return t.charAt(0) === t.charAt(1);
            },
            r = e(t.r),
            i = e(t.g),
            o = e(t.b);
          return (
            n(r) &&
              n(i) &&
              n(o) &&
              ((r = r.charAt(0)), (i = i.charAt(0)), (o = o.charAt(0))),
            "#" + r + i + o
          );
        }
        return "rgba(" + t.r + "," + t.g + "," + t.b + "," + t.a + ")";
      }
      function pt(t) {
        return t ? "url(#" + t + ")" : "none";
      }
      var mt = {
          f: null,
          i: V,
          u: function (t, e) {
            return function (n) {
              var r = e(n);
              t.setAttribute("rx", vt(r.x)), t.setAttribute("ry", vt(r.y));
            };
          },
        },
        bt = {
          f: null,
          i: function (t, e, n) {
            return 0 === t
              ? e
              : 1 === t
              ? n
              : {
                  width: C(t, e.width, n.width),
                  height: C(t, e.height, n.height),
                };
          },
          u: function (t, e) {
            return function (n) {
              var r = e(n);
              t.setAttribute("width", vt(r.width)),
                t.setAttribute("height", vt(r.height));
            };
          },
        };
      Object.freeze({
        M: 2,
        L: 2,
        Z: 0,
        H: 1,
        V: 1,
        C: 6,
        Q: 4,
        T: 2,
        S: 4,
        A: 7,
      });
      var wt = {},
        kt = null;
      function _t(t) {
        var e = (function () {
          if (kt) return kt;
          if (
            "object" !==
              ("undefined" == typeof document ? "undefined" : n(document)) ||
            !document.createElementNS
          )
            return {};
          var t = document.createElementNS("http://www.w3.org/2000/svg", "svg");
          return t && t.style
            ? ((t.style.position = "absolute"),
              (t.style.opacity = "0.01"),
              (t.style.zIndex = "-9999"),
              (t.style.left = "-9999px"),
              (t.style.width = "1px"),
              (t.style.height = "1px"),
              (kt = { svg: t }))
            : {};
        })().svg;
        if (!e)
          return function (t) {
            return null;
          };
        var r = document.createElementNS(e.namespaceURI, "path");
        r.setAttributeNS(null, "d", t),
          r.setAttributeNS(null, "fill", "none"),
          r.setAttributeNS(null, "stroke", "none"),
          e.appendChild(r);
        var i = r.getTotalLength();
        return function (t) {
          var e = r.getPointAtLength(i * t);
          return { x: e.x, y: e.y };
        };
      }
      function At(t) {
        return wt[t] ? wt[t] : (wt[t] = _t(t));
      }
      function xt(t, e, n, r) {
        if (!t || !r) return !1;
        var i = ["M", t.x, t.y];
        if (
          (e &&
            n &&
            (i.push("C"), i.push(e.x), i.push(e.y), i.push(n.x), i.push(n.y)),
          e ? !n : n)
        ) {
          var o = e || n;
          i.push("Q"), i.push(o.x), i.push(o.y);
        }
        return e || n || i.push("L"), i.push(r.x), i.push(r.y), i.join(" ");
      }
      function Ot(t, e, n, r) {
        var i =
            arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 1,
          o = xt(t, e, n, r),
          u = At(o);
        try {
          return u(i);
        } catch (t) {
          return null;
        }
      }
      function St(t, e, n) {
        return t + (e - t) * n;
      }
      function Et(t, e, n) {
        var r = arguments.length > 3 && void 0 !== arguments[3] && arguments[3],
          i = { x: St(t.x, e.x, n), y: St(t.y, e.y, n) };
        return r && (i.a = Pt(t, e)), i;
      }
      function Pt(t, e) {
        return Math.atan2(e.y - t.y, e.x - t.x);
      }
      function jt(t, e, n, r) {
        var i = 1 - r;
        return i * i * t + 2 * i * r * e + r * r * n;
      }
      function Mt(t, e, n, r) {
        return 2 * (1 - r) * (e - t) + 2 * r * (n - e);
      }
      function Bt(t, e, n, r) {
        var i = arguments.length > 4 && void 0 !== arguments[4] && arguments[4],
          o = Ot(t, e, null, n, r);
        return (
          o || (o = { x: jt(t.x, e.x, n.x, r), y: jt(t.y, e.y, n.y, r) }),
          i && (o.a = It(t, e, n, r)),
          o
        );
      }
      function It(t, e, n, r) {
        return Math.atan2(Mt(t.y, e.y, n.y, r), Mt(t.x, e.x, n.x, r));
      }
      function Tt(t, e, n, r, i) {
        var o = i * i;
        return (
          i * o * (r - t + 3 * (e - n)) +
          3 * o * (t + n - 2 * e) +
          3 * i * (e - t) +
          t
        );
      }
      function Rt(t, e, n, r, i) {
        var o = 1 - i;
        return 3 * (o * o * (e - t) + 2 * o * i * (n - e) + i * i * (r - n));
      }
      function Nt(t, e, n, r, i) {
        var o = arguments.length > 5 && void 0 !== arguments[5] && arguments[5],
          u = Ot(t, e, n, r, i);
        return (
          u ||
            (u = {
              x: Tt(t.x, e.x, n.x, r.x, i),
              y: Tt(t.y, e.y, n.y, r.y, i),
            }),
          o && (u.a = Ft(t, e, n, r, i)),
          u
        );
      }
      function Ft(t, e, n, r, i) {
        return Math.atan2(Rt(t.y, e.y, n.y, r.y, i), Rt(t.x, e.x, n.x, r.x, i));
      }
      function Ct(t, e, n) {
        var r = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];
        if (Lt(e)) {
          if (Vt(n)) return Bt(e, n.start, n, t, r);
        } else if (Lt(n)) {
          if (qt(e)) return Bt(e, e.end, n, t, r);
        } else {
          if (qt(e))
            return Vt(n)
              ? Nt(e, e.end, n.start, n, t, r)
              : Bt(e, e.end, n, t, r);
          if (Vt(n)) return Bt(e, n.start, n, t, r);
        }
        return Et(e, n, t, r);
      }
      function Dt(t, e, n) {
        var r = Ct(t, e, n, !0);
        return (
          (r.a =
            (function (t) {
              return arguments.length > 1 &&
                void 0 !== arguments[1] &&
                arguments[1]
                ? t + Math.PI
                : t;
            })(r.a) / m),
          r
        );
      }
      function Lt(t) {
        return !t.type || "corner" === t.type;
      }
      function Vt(t) {
        return null != t.start && !Lt(t);
      }
      function qt(t) {
        return null != t.end && !Lt(t);
      }
      var Gt = new R();
      var zt = {
          f: function (t) {
            return t ? t.join(" ") : "";
          },
          i: function (t, e, r) {
            if (0 === t) return e;
            if (1 === t) return r;
            var i = e.length;
            if (i !== r.length) return N(t, e, r);
            for (var o, u = new Array(i), a = 0; a < i; a++) {
              if ((o = n(e[a])) !== n(r[a])) return N(t, e, r);
              if ("number" === o) u[a] = F(t, e[a], r[a]);
              else {
                if (e[a] !== r[a]) return N(t, e, r);
                u[a] = e[a];
              }
            }
            return u;
          },
        },
        Yt = {
          f: null,
          i: z,
          u: function (t, e) {
            return function (n) {
              var r = e(n);
              t.setAttribute("x1", vt(r[0])),
                t.setAttribute("y1", vt(r[1])),
                t.setAttribute("x2", vt(r[2])),
                t.setAttribute("y2", vt(r[3]));
            };
          },
        },
        Ut = { f: vt, i: F },
        Wt = { f: vt, i: D },
        $t = {
          f: function (t) {
            var e =
              arguments.length > 1 && void 0 !== arguments[1]
                ? arguments[1]
                : " ";
            return (
              t &&
                t.length > 0 &&
                (t = t.map(function (t) {
                  return g(t, 4);
                })),
              dt(t, e)
            );
          },
          i: function (t, e, n) {
            var r,
              i,
              o,
              u = e.length,
              a = n.length;
            if (u !== a)
              if (0 === u) e = Y((u = a), 0);
              else if (0 === a) (a = u), (n = Y(u, 0));
              else {
                var s =
                  (o =
                    ((r = u) * (i = a)) /
                    (function (t, e) {
                      for (var n; e; ) (n = e), (e = t % e), (t = n);
                      return t || 1;
                    })(r, i)) < 0
                    ? -o
                    : o;
                (e = U(e, Math.floor(s / u))),
                  (n = U(n, Math.floor(s / a))),
                  (u = a = s);
              }
            for (var l = [], f = 0; f < u; f++) l.push(g(C(t, e[f], n[f])));
            return l;
          },
        };
      function Ht(t, e, n) {
        return t.map(function (t) {
          return (function (t, e, n) {
            var r = t.v;
            if (!r || "g" !== r.t || r.s || !r.v || !r.r) return t;
            var i = n.getElementById(r.r),
              o = (i && i.querySelectorAll("stop")) || [];
            return (
              (r.s = r.v.map(function (t, e) {
                var n = o[e] && o[e].getAttribute("offset");
                return { c: t, o: (n = g(parseInt(n) / 100)) };
              })),
              delete r.v,
              t
            );
          })(t, 0, n);
        });
      }
      var Qt = {
        gt: "gradientTransform",
        c: { x: "cx", y: "cy" },
        rd: "r",
        f: { x: "x1", y: "y1" },
        to: { x: "x2", y: "y2" },
      };
      function Xt(t, e, r, i, o, u, a, s) {
        return (
          Ht(t, 0, s),
          (e = (function (t, e, n) {
            for (var r, i, o, u = t.length - 1, a = {}, s = 0; s <= u; s++)
              (r = t[s]).e && (r.e = e(r.e)),
                r.v &&
                  "g" === (i = r.v).t &&
                  i.r &&
                  (o = n.getElementById(i.r)) &&
                  (a[i.r] = { e: o, s: o.querySelectorAll("stop") });
            return a;
          })(t, i, s)),
          function (i) {
            var o = r(i, t, Jt);
            if (!o) return "none";
            if ("c" === o.t) return gt(o.v);
            if ("g" === o.t) {
              if (!e[o.r]) return pt(o.r);
              var u = e[o.r];
              return (
                (function (t, e) {
                  for (var n = t.s, r = n.length; r < e.length; r++) {
                    var i = n[n.length - 1].cloneNode();
                    (i.id = te(i.id)),
                      t.e.appendChild(i),
                      (n = t.s = t.e.querySelectorAll("stop"));
                  }
                  for (var o = 0, u = n.length, a = e.length - 1; o < u; o++)
                    n[o].setAttribute("stop-color", gt(e[Math.min(o, a)].c)),
                      n[o].setAttribute("offset", e[Math.min(o, a)].o);
                })(u, o.s),
                Object.keys(Qt).forEach(function (t) {
                  if (void 0 !== o[t])
                    if ("object" !== n(Qt[t])) {
                      var e,
                        r =
                          "gt" === t
                            ? ((e = o[t]),
                              Array.isArray(e)
                                ? "matrix(" + e.join(" ") + ")"
                                : "")
                            : o[t],
                        i = Qt[t];
                      u.e.setAttribute(i, r);
                    } else
                      Object.keys(Qt[t]).forEach(function (e) {
                        if (void 0 !== o[t][e]) {
                          var n = o[t][e],
                            r = Qt[t][e];
                          u.e.setAttribute(r, n);
                        }
                      });
                }),
                pt(o.r)
              );
            }
            return "none";
          }
        );
      }
      function Jt(t, n, r) {
        if (0 === t) return n;
        if (1 === t) return r;
        if (n && r) {
          var i = n.t;
          if (i === r.t)
            switch (n.t) {
              case "c":
                return { t: i, v: G(t, n.v, r.v) };
              case "g":
                if (n.r === r.r) {
                  var o = { t: i, s: Kt(t, n.s, r.s), r: n.r };
                  return (
                    n.gt && r.gt && (o.gt = z(t, n.gt, r.gt)),
                    n.c
                      ? ((o.c = L(t, n.c, r.c)), (o.rd = C(t, n.rd, r.rd)))
                      : n.f &&
                        ((o.f = L(t, n.f, r.f)), (o.to = L(t, n.to, r.to))),
                    o
                  );
                }
            }
          if (("c" === n.t && "g" === r.t) || ("c" === r.t && "g" === n.t)) {
            var u = "c" === n.t ? n : r,
              a = "g" === n.t ? e({}, n) : e({}, r),
              s = a.s.map(function (t) {
                return { c: u.v, o: t.o };
              });
            return (a.s = "c" === n.t ? Kt(t, s, a.s) : Kt(t, a.s, s)), a;
          }
        }
        return N(t, n, r);
      }
      function Kt(t, e, n) {
        if (e.length === n.length)
          return e.map(function (e, r) {
            return Zt(t, e, n[r]);
          });
        for (var r = Math.max(e.length, n.length), i = [], o = 0; o < r; o++) {
          var u = Zt(
            t,
            e[Math.min(o, e.length - 1)],
            n[Math.min(o, n.length - 1)]
          );
          i.push(u);
        }
        return i;
      }
      function Zt(t, e, n) {
        return { o: D(t, e.o, n.o || 0), c: G(t, e.c, n.c || {}) };
      }
      function te(t) {
        return t.replace(/-fill-([0-9]+)$/, function (t, e) {
          return "-fill-" + (+e + 1);
        });
      }
      var ee = {
        blur: V,
        brightness: C,
        contrast: C,
        "drop-shadow": function (t, e, n) {
          return 0 === t
            ? e
            : 1 === t
            ? n
            : {
                blur: V(t, e.blur, n.blur),
                offset: L(t, e.offset, n.offset),
                color: G(t, e.color, n.color),
              };
        },
        grayscale: C,
        "hue-rotate": F,
        invert: C,
        opacity: C,
        saturate: C,
        sepia: C,
      };
      function ne(t, e, n) {
        if (0 === t) return e;
        if (1 === t) return n;
        var r = e.length;
        if (r !== n.length) return N(t, e, n);
        for (var i, o = [], u = 0; u < r; u++) {
          if (e[u].type !== n[u].type) return e;
          if (!(i = ee[e[u].type])) return N(t, e, n);
          o.push({ type: e.type, value: i(t, e[u].value, n[u].value) });
        }
        return o;
      }
      var re = {
        blur: function (t) {
          return t
            ? function (e) {
                t.setAttribute("stdDeviation", yt(e));
              }
            : null;
        },
        brightness: function (t, e, n) {
          return (t = oe(n, e))
            ? function (e) {
                (e = vt(e)),
                  t.map(function (t) {
                    return t.setAttribute("slope", e);
                  });
              }
            : null;
        },
        contrast: function (t, e, n) {
          return (t = oe(n, e))
            ? function (e) {
                var n = vt((1 - e) / 2);
                (e = vt(e)),
                  t.map(function (t) {
                    t.setAttribute("slope", e), t.setAttribute("intercept", n);
                  });
              }
            : null;
        },
        "drop-shadow": function (t, e, n) {
          var r = n.getElementById(e + "-blur");
          if (!r) return null;
          var i = n.getElementById(e + "-offset");
          if (!i) return null;
          var o = n.getElementById(e + "-flood");
          return o
            ? function (t) {
                r.setAttribute("stdDeviation", yt(t.blur)),
                  i.setAttribute("dx", vt(t.offset.x)),
                  i.setAttribute("dy", vt(t.offset.y)),
                  o.setAttribute("flood-color", gt(t.color));
              }
            : null;
        },
        grayscale: function (t) {
          return t
            ? function (e) {
                t.setAttribute(
                  "values",
                  dt(
                    (function (t) {
                      return [
                        0.2126 + 0.7874 * (t = 1 - t),
                        0.7152 - 0.7152 * t,
                        0.0722 - 0.0722 * t,
                        0,
                        0,
                        0.2126 - 0.2126 * t,
                        0.7152 + 0.2848 * t,
                        0.0722 - 0.0722 * t,
                        0,
                        0,
                        0.2126 - 0.2126 * t,
                        0.7152 - 0.7152 * t,
                        0.0722 + 0.9278 * t,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0,
                      ];
                    })(e)
                  )
                );
              }
            : null;
        },
        "hue-rotate": function (t) {
          return t
            ? function (e) {
                return t.setAttribute("values", vt(e));
              }
            : null;
        },
        invert: function (t, e, n) {
          return (t = oe(n, e))
            ? function (e) {
                (e = vt(e) + " " + vt(1 - e)),
                  t.map(function (t) {
                    return t.setAttribute("tableValues", e);
                  });
              }
            : null;
        },
        opacity: function (t, e, n) {
          return (t = n.getElementById(e + "-A"))
            ? function (e) {
                return t.setAttribute("tableValues", "0 " + vt(e));
              }
            : null;
        },
        saturate: function (t) {
          return t
            ? function (e) {
                return t.setAttribute("values", vt(e));
              }
            : null;
        },
        sepia: function (t) {
          return t
            ? function (e) {
                return t.setAttribute(
                  "values",
                  dt(
                    (function (t) {
                      return [
                        0.393 + 0.607 * (t = 1 - t),
                        0.769 - 0.769 * t,
                        0.189 - 0.189 * t,
                        0,
                        0,
                        0.349 - 0.349 * t,
                        0.686 + 0.314 * t,
                        0.168 - 0.168 * t,
                        0,
                        0,
                        0.272 - 0.272 * t,
                        0.534 - 0.534 * t,
                        0.131 + 0.869 * t,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0,
                      ];
                    })(e)
                  )
                );
              }
            : null;
        },
      };
      var ie = ["R", "G", "B"];
      function oe(t, e) {
        var n = ie.map(function (n) {
          return t.getElementById(e + "-" + n) || null;
        });
        return -1 !== n.indexOf(null) ? null : n;
      }
      var ue = {
          fill: Xt,
          "fill-opacity": Wt,
          stroke: Xt,
          "stroke-opacity": Wt,
          "stroke-width": Ut,
          "stroke-dashoffset": { f: vt, i: F },
          "stroke-dasharray": $t,
          opacity: Wt,
          transform: function (t, e, r, i) {
            if (
              !(t = (function (t, e) {
                if (!t || "object" !== n(t)) return null;
                var r = !1;
                for (var i in t)
                  t.hasOwnProperty(i) &&
                    (t[i] && t[i].length
                      ? (t[i].forEach(function (t) {
                          t.e && (t.e = e(t.e));
                        }),
                        (r = !0))
                      : delete t[i]);
                return r ? t : null;
              })(t, i))
            )
              return null;
            var o = function (n, i, o) {
              var u =
                arguments.length > 3 && void 0 !== arguments[3]
                  ? arguments[3]
                  : null;
              return t[n] ? r(i, t[n], o) : e && e[n] ? e[n] : u;
            };
            return e && e.a && t.o
              ? function (e) {
                  var n = r(e, t.o, Dt);
                  return Gt.recomposeSelf(
                    n,
                    o("r", e, F, 0) + n.a,
                    o("k", e, L),
                    o("s", e, L),
                    o("t", e, L)
                  ).toString();
                }
              : function (t) {
                  return Gt.recomposeSelf(
                    o("o", t, Ct, null),
                    o("r", t, F, 0),
                    o("k", t, L),
                    o("s", t, L),
                    o("t", t, L)
                  ).toString();
                };
          },
          "#filter": function (t, e, n, r, i, o, u, a) {
            if (!e.items || !t || !t.length) return null;
            var s = (function (t, e) {
              var n = (t = t.map(function (t) {
                return t && re[t[0]]
                  ? (e.getElementById(t[1]),
                    re[t[0]](e.getElementById(t[1]), t[1], e))
                  : null;
              })).length;
              return function (e) {
                for (var r = 0; r < n; r++) t[r] && t[r](e[r].value);
              };
            })(e.items, a);
            return s
              ? ((t = (function (t, e) {
                  return t.map(function (t) {
                    return (t.e = e(t.e)), t;
                  });
                })(t, r)),
                function (e) {
                  s(n(e, t, ne));
                })
              : null;
          },
          "#line": Yt,
          points: { f: dt, i: z },
          d: zt,
          r: Ut,
          "#size": bt,
          "#radius": mt,
          _: function (t, e) {
            if (Array.isArray(t))
              for (var n = 0; n < t.length; n++) this[t[n]] = e;
            else this[t] = e;
          },
        },
        ae = {
          currentTime: "offset",
          duration: "duration",
          hasEnded: function () {
            return this.reachedToEnd();
          },
          isAlternate: "alternate",
          isPlaying: "_running",
          isRollingBack: "_rollingBack",
          state: function (t, e) {
            return e.isPlaying
              ? e.isRollingBack
                ? "rollback"
                : "playing"
              : e.hasEnded
              ? "ended"
              : "paused";
          },
          totalTime: "maxFiniteDuration",
          iterations: "iterations",
          direction: "direction",
          fill: "fill",
          isReversed: function (t, e) {
            return -1 === e.direction;
          },
          isBackwards: function (t, e) {
            return -1 === e.fill;
          },
          isInfinite: function (t, e) {
            return 0 === e.iterations;
          },
          speed: "speed",
          fps: "fps",
        },
        se = {
          destruct: "destruct",
          pause: "pause",
          play: function (t, e) {
            return le(t, e.hasEnded ? "restart" : "play", e);
          },
          restart: "restart",
          reverse: function (t, e) {
            return le(t, "reverse", e, [!0]);
          },
          seek: "seek",
          seekBy: "seekBy",
          seekTo: "seekTo",
          stop: "stop",
          toggle: "toggle",
          togglePlay: "toggle",
          set: "set",
        };
      function le(t, e, n) {
        var r =
          arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : [];
        return function () {
          var i,
            o = Array.prototype.slice.call(arguments);
          return (
            o.unshift.apply(o, v(r)),
            (i = t[e]).call.apply(i, [t].concat(v(o))),
            n
          );
        };
      }
      var fe = function t(e) {
        r(this, t);
        var n = {},
          i = ["on", "off"],
          o = {
            get: function (t, e, r) {
              return ae[e]
                ? "function" == typeof ae[e]
                  ? ae[e].call(t, t, r)
                  : t[ae[e]]
                : se[e]
                ? "function" == typeof se[e]
                  ? se[e].call(t, t, r)
                  : le(t, se[e], r)
                : -1 !== i.indexOf(e)
                ? n[e]
                : "ready" === e
                ? function (t) {
                    return t && t.call(r, r), r;
                  }
                : void 0;
            },
            set: function (t, e, r) {
              return -1 !== i.indexOf(e) && (n[e] = r);
            },
            ownKeys: function (t) {
              return Object.keys(ae);
            },
            has: function (t, e) {
              return void 0 !== ae[e];
            },
          };
        if ("function" == typeof Proxy) return new Proxy(e, o);
        var u = Object.keys(ae).concat(Object.keys(se)).concat(i),
          a = {};
        return (
          u.forEach(function (t) {
            var n = {
              enumerable: !1,
              configurable: !1,
              get: function () {
                return o.get(e, t, a);
              },
            };
            -1 !== i.indexOf(t) &&
              (n.set = function (n) {
                return o.set(e, t, n);
              }),
              Object.defineProperty(a, t, n);
          }),
          a
        );
      };
      function ce(t) {
        t || (t = this);
        var e = {};
        (this.on = function (t, n) {
          var r =
            arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
          return (
            "function" == typeof n &&
            (t.split(/[, ]+/g).forEach(function (t) {
              return (e[t] = e[t] || []), r ? e[t].unshift(n) : e[t].push(n);
            }),
            !0)
          );
        }),
          (this.off = function (t, n) {
            for (var r in e)
              if (e.hasOwnProperty(r) && r.substr(0, t.length) === t)
                if (n)
                  for (var i = 0; i < e[r].length; i++)
                    e[r][i] === n && (e[r][i] = null);
                else e[r] = null;
          }),
          (this.trigger = function () {
            var n,
              r = Array.prototype.slice.call(arguments),
              i = r[0],
              o = r.slice(1);
            t: for (var u in e)
              if (
                e.hasOwnProperty(u) &&
                e[u] &&
                (u === i || u.substr(0, i.length + 1) === i + ".")
              )
                for (var a = 0; a < (e[u] || []).length; a++)
                  if (e[u][a] && !1 === (n = e[u][a].apply(t, o))) break t;
            return n;
          });
      }
      var he = !0,
        ve = ["iterations", "speed", "fps", "direction", "fill", "alternate"],
        de = (function (t) {
          !(function (t, e) {
            if ("function" != typeof e && null !== e)
              throw new TypeError(
                "Super expression must either be null or a function"
              );
            (t.prototype = Object.create(e && e.prototype, {
              constructor: { value: t, writable: !0, configurable: !0 },
            })),
              e && s(t, e);
          })(u, t);
          var e,
            n,
            i =
              ((e = u),
              (n = l()),
              function () {
                var t,
                  r = a(e);
                if (n) {
                  var i = a(this).constructor;
                  t = Reflect.construct(r, arguments, i);
                } else t = r.apply(this, arguments);
                return c(this, t);
              });
          function u(t, e) {
            var n,
              o =
                arguments.length > 2 && void 0 !== arguments[2]
                  ? arguments[2]
                  : null;
            return r(this, u), ((n = i.call(this, t, e, o))._handlers = []), n;
          }
          return (
            o(
              u,
              [
                {
                  key: "_adjustOffset",
                  value: function () {
                    var t =
                        arguments.length > 0 &&
                        void 0 !== arguments[0] &&
                        arguments[0],
                      e = this.alternate ? 2 * this.duration : this.duration;
                    if (t) {
                      if (!this._rollingBack && 0 === this.offset)
                        return void (this.offset = e);
                      this._rollingBack &&
                        (this.offset, this.maxFiniteDuration);
                    }
                    !this._rollingBack ||
                    this.rollbackStartOffset <= this.duration
                      ? 0 !== this.iterations &&
                        (this.offset = Math.min(
                          this.offset,
                          this.maxFiniteDuration
                        ))
                      : ((this.offset =
                          this.rollbackStartOffset -
                          ((this.rollbackStartOffset - this.offset) % e)),
                        (this.rollbackStartOffset = 0));
                  },
                },
                {
                  key: "reverse",
                  value: function () {
                    var t =
                      arguments.length > 0 &&
                      void 0 !== arguments[0] &&
                      arguments[0];
                    if (!this._running)
                      return (
                        this._adjustOffset(t),
                        (this._rollingBack = !this._rollingBack),
                        t && this.play(!1),
                        void this.trigger("reverse", this.offset)
                      );
                    this.pause(!1, !1),
                      this._adjustOffset(),
                      (this._rollingBack = !this._rollingBack),
                      this.play(!1),
                      this.trigger("reverse", this.offset);
                  },
                },
                {
                  key: "play",
                  value: function () {
                    var t =
                        arguments.length > 0 && void 0 !== arguments[0]
                          ? arguments[0]
                          : he,
                      e = h(a(u.prototype), "play", this).call(this);
                    return t === he && this.trigger("play", this.offset), e;
                  },
                },
                {
                  key: "pause",
                  value: function () {
                    var t =
                        arguments.length > 0 &&
                        void 0 !== arguments[0] &&
                        arguments[0],
                      e =
                        arguments.length > 1 && void 0 !== arguments[1]
                          ? arguments[1]
                          : he,
                      n = h(a(u.prototype), "pause", this).call(this);
                    return (
                      e === he &&
                        this.trigger(t ? "end" : "pause", this.offset),
                      n
                    );
                  },
                },
                {
                  key: "restart",
                  value: function () {
                    var t = h(a(u.prototype), "restart", this).call(this, !1);
                    return this.trigger("restart", this.offset), t;
                  },
                },
                {
                  key: "stop",
                  value: function () {
                    var t =
                        arguments.length > 0 && void 0 !== arguments[0]
                          ? arguments[0]
                          : he,
                      e = h(a(u.prototype), "stop", this).call(this);
                    return t === he && this.trigger("stop", this.offset), e;
                  },
                },
                {
                  key: "_apply",
                  value: function (t) {
                    var e = this,
                      n =
                        arguments.length > 2 && void 0 !== arguments[2]
                          ? arguments[2]
                          : he,
                      r = h(a(u.prototype), "_apply", this).call(this, t);
                    if (n === he) {
                      var i = function () {
                        return e.trigger("keyframe", t);
                      };
                      window.requestAnimationFrame(i);
                    }
                    return r;
                  },
                },
                {
                  key: "seekTo",
                  value: function (t) {
                    var e,
                      n,
                      r,
                      i = this._running;
                    i && this.pause(!1, !1),
                      (this.offset =
                        this.iterations > 0
                          ? ((e = t),
                            (n = 0),
                            (r = this.maxFiniteDuration),
                            e < n ? n : e > r ? r : e)
                          : Math.max(t, 0)),
                      this._apply(this.offset),
                      i && this.play(!1);
                  },
                },
                {
                  key: "seek",
                  value: function (t) {
                    return this.seekTo(
                      Math.round((t / 100) * this.maxFiniteDuration)
                    );
                  },
                },
                {
                  key: "seekBy",
                  value: function (t) {
                    return this.seekTo(this.offset + t);
                  },
                },
                {
                  key: "toggle",
                  value: function () {
                    return this._running
                      ? this.pause()
                      : this.reachedToEnd()
                      ? this.restart()
                      : this.play();
                  },
                },
                {
                  key: "set",
                  value: function (t, e) {
                    if (ve.includes(t)) {
                      var n = this._running;
                      n && this.pause(!1, !1),
                        (this._settings[t] = e),
                        n ? this.play(!1) : this._apply(this.offset, {}, !1);
                    }
                  },
                },
                {
                  key: "destruct",
                  value: function () {
                    var t = this;
                    this.stop(),
                      this._handlers.forEach(function (t) {
                        t.element
                          ? t.element.removeEventListener(t.event, t.handler)
                          : t.callback && t.callback.call && t.callback.call();
                      });
                    var e = function () {},
                      n = Object.getOwnPropertyNames(
                        Object.getPrototypeOf(this)
                      );
                    n.push.apply(n, v(Object.getOwnPropertyNames(this))),
                      n.forEach(function (n) {
                        "function" == typeof t[n] ? (t[n] = e) : delete t[n];
                      });
                  },
                },
              ],
              [
                {
                  key: "build",
                  value: function (t) {
                    var e = h(a(u), "build", this).call(this, t, ue);
                    if (!e) return null;
                    var n = e.el,
                      r = e.options,
                      i = e.player,
                      o = new fe(i),
                      s = new ce(o);
                    (o.on = s.on), (o.off = s.off), (i.trigger = s.trigger);
                    var l =
                      n.svgatorPlayer &&
                      n.svgatorPlayer.ready &&
                      n.svgatorPlayer.ready.call &&
                      n.svgatorPlayer.ready.call();
                    (n.svgatorPlayer = o),
                      (function (t, e, n) {
                        if ("click" === n.start) {
                          var r = function () {
                            switch (n.click) {
                              case "freeze":
                                return !t._running && t.reachedToEnd()
                                  ? t.restart()
                                  : t.toggle();
                              case "restart":
                                return t.offset > 0 ? t.restart() : t.play();
                              case "reverse":
                                return t._running
                                  ? t.reverse()
                                  : t.reachedToEnd()
                                  ? 1 === t.fill
                                    ? t.reverse(!0)
                                    : t.restart()
                                  : t.play();
                              case "none":
                              default:
                                if (t._running) return;
                                return t.reachedToEnd()
                                  ? t.restart()
                                  : t.play();
                            }
                          };
                          return (
                            t._handlers.push({
                              element: e,
                              event: "click",
                              handler: r,
                            }),
                            void e.addEventListener("click", r)
                          );
                        }
                        if ("hover" === n.start) {
                          var i = function () {
                            return t.reachedToEnd()
                              ? t.restart()
                              : t._rollingBack
                              ? t.reverse()
                              : t.play();
                          };
                          t._handlers.push({
                            element: e,
                            event: "mouseenter",
                            handler: i,
                          }),
                            e.addEventListener("mouseenter", i);
                          var o = function () {
                            switch (n.hover) {
                              case "freeze":
                                return t.pause();
                              case "reset":
                                return t.stop();
                              case "reverse":
                                if ((t.reverse(), t._running)) return;
                                return t.play();
                              case "none":
                              default:
                                return;
                            }
                          };
                          return (
                            t._handlers.push({
                              element: e,
                              event: "mouseleave",
                              handler: o,
                            }),
                            void e.addEventListener("mouseleave", o)
                          );
                        }
                        if ("scroll" === n.start) {
                          var u = new ht(e, n.scroll || 25, function (e) {
                            e
                              ? t.reachedToEnd()
                                ? t.restart()
                                : t.play()
                              : t.pause();
                          });
                          return void t._handlers.push({
                            callback: function () {
                              return u.destruct();
                            },
                          });
                        }
                        if ("programmatic" === n.start) return;
                        t.play();
                      })(i, n, r),
                      (function (t, e, n) {
                        var r;
                        "function" == typeof Event
                          ? (r = new Event("ready"))
                          : (r = document.createEvent("Event")).initEvent(
                              "ready",
                              !0,
                              !0
                            );
                        if ((t.dispatchEvent(r), !n || !n.length)) return;
                        n.forEach(function (t) {
                          return e.ready(t);
                        });
                      })(n, n.svgatorPlayer, l);
                  },
                },
              ]
            ),
            u
          );
        })(ct);
      return de.init(), de;
    });
    (function (s, i, o, w, d, a, b) {
      (a =
        Array.from(d.querySelectorAll("svg#" + i.root)).filter(
          (n) => !n.svgatorPlayer
        )[0] || {}).svgatorPlayer = {
        ready: (function (a) {
          b = [];
          return function (c) {
            return c ? (b.push(c), a.svgatorPlayer) : b;
          };
        })(a),
      };
      w[o] = w[o] || {};
      w[o][s] = w[o][s] || [];
      w[o][s].push(i);
    })(
      "91c80d77",
      {
        root: "exIqo09Fmte1",
        version: "2022-05-04",
        animations: [
          {
            elements: {
              exIqo09Fmte4: {
                opacity: [
                  { t: 480, v: 1 },
                  { t: 490, v: 0 },
                ],
              },
              exIqo09Fmte21: {
                opacity: [
                  { t: 480, v: 0 },
                  { t: 490, v: 1 },
                  { t: 560, v: 1 },
                  { t: 570, v: 0 },
                  { t: 1420, v: 0 },
                  { t: 1430, v: 1 },
                  { t: 1500, v: 1 },
                  { t: 1510, v: 0 },
                  { t: 2440, v: 0 },
                  { t: 2450, v: 1 },
                  { t: 2470, v: 1 },
                  { t: 2480, v: 0 },
                ],
              },
              exIqo09Fmte30: {
                opacity: [
                  { t: 560, v: 0 },
                  { t: 570, v: 1 },
                  { t: 650, v: 1 },
                  { t: 660, v: 0 },
                  { t: 1500, v: 0 },
                  { t: 1510, v: 1 },
                  { t: 1590, v: 1 },
                  { t: 1600, v: 0 },
                  { t: 2470, v: 0 },
                  { t: 2480, v: 1 },
                  { t: 2510, v: 1 },
                  { t: 2520, v: 0 },
                ],
              },
              exIqo09Fmte78: {
                opacity: [
                  { t: 650, v: 0 },
                  { t: 660, v: 1 },
                  { t: 730, v: 1 },
                  { t: 740, v: 0 },
                  { t: 1590, v: 0 },
                  { t: 1600, v: 1 },
                  { t: 1690, v: 1 },
                  { t: 1700, v: 0 },
                  { t: 2510, v: 0 },
                  { t: 2520, v: 1 },
                  { t: 2560, v: 1 },
                  { t: 2570, v: 0 },
                ],
              },
              exIqo09Fmte85: {
                opacity: [
                  { t: 730, v: 0 },
                  { t: 740, v: 1 },
                  { t: 810, v: 1 },
                  { t: 820, v: 0 },
                  { t: 1690, v: 0 },
                  { t: 1700, v: 1 },
                  { t: 1790, v: 1 },
                  { t: 1800, v: 0 },
                  { t: 2560, v: 0 },
                  { t: 2570, v: 1 },
                  { t: 2620, v: 1 },
                  { t: 2630, v: 0 },
                ],
              },
              exIqo09Fmte163: {
                opacity: [
                  { t: 810, v: 0 },
                  { t: 820, v: 1 },
                  { t: 880, v: 1 },
                  { t: 890, v: 0 },
                  { t: 1790, v: 0 },
                  { t: 1800, v: 1 },
                  { t: 1880, v: 1 },
                  { t: 1890, v: 0 },
                  { t: 2620, v: 0 },
                  { t: 2630, v: 1 },
                  { t: 2670, v: 1 },
                  { t: 2680, v: 0 },
                ],
              },
              exIqo09Fmte172: {
                opacity: [
                  { t: 880, v: 0 },
                  { t: 890, v: 1 },
                  { t: 970, v: 1 },
                  { t: 980, v: 0 },
                  { t: 1880, v: 0 },
                  { t: 1890, v: 1 },
                  { t: 1970, v: 1 },
                  { t: 1980, v: 0 },
                  { t: 2680, v: 0 },
                  { t: 2690, v: 1 },
                  { t: 2730, v: 1 },
                  { t: 2740, v: 0 },
                ],
              },
              exIqo09Fmte182: {
                opacity: [
                  { t: 970, v: 0 },
                  { t: 980, v: 1 },
                  { t: 1050, v: 1 },
                  { t: 1060, v: 0 },
                  { t: 1970, v: 0 },
                  { t: 1980, v: 1 },
                  { t: 2050, v: 1 },
                  { t: 2060, v: 0 },
                  { t: 2740, v: 0 },
                  { t: 2760, v: 1 },
                  { t: 2800, v: 1 },
                  { t: 2820, v: 0 },
                ],
              },
              exIqo09Fmte196: {
                opacity: [
                  { t: 1050, v: 0 },
                  { t: 1060, v: 1 },
                  { t: 1140, v: 1 },
                  { t: 1150, v: 0 },
                  { t: 2050, v: 0 },
                  { t: 2060, v: 1 },
                  { t: 2130, v: 1 },
                  { t: 2140, v: 0 },
                  { t: 2800, v: 0 },
                  { t: 2820, v: 1 },
                  { t: 2880, v: 1 },
                  { t: 2900, v: 0 },
                ],
              },
              exIqo09Fmte276: {
                opacity: [
                  { t: 1140, v: 0 },
                  { t: 1150, v: 1 },
                  { t: 1220, v: 1 },
                  { t: 1230, v: 0 },
                  { t: 2130, v: 0 },
                  { t: 2140, v: 1 },
                  { t: 2220, v: 1 },
                  { t: 2230, v: 0 },
                  { t: 2880, v: 0 },
                  { t: 2900, v: 1 },
                  { t: 2950, v: 1 },
                  { t: 2970, v: 0 },
                ],
              },
              exIqo09Fmte292: {
                opacity: [
                  { t: 1220, v: 0 },
                  { t: 1230, v: 1 },
                  { t: 1290, v: 1 },
                  { t: 1300, v: 0 },
                  { t: 2220, v: 0 },
                  { t: 2230, v: 1 },
                  { t: 2300, v: 1 },
                  { t: 2310, v: 0 },
                  { t: 2950, v: 0 },
                  { t: 2970, v: 1 },
                  { t: 3030, v: 1 },
                  { t: 3050, v: 0 },
                ],
              },
              exIqo09Fmte298: {
                opacity: [
                  { t: 1290, v: 0 },
                  { t: 1300, v: 1 },
                  { t: 1360, v: 1 },
                  { t: 1370, v: 0 },
                  { t: 2300, v: 0 },
                  { t: 2310, v: 1 },
                  { t: 2370, v: 1 },
                  { t: 2380, v: 0 },
                  { t: 3030, v: 0 },
                  { t: 3050, v: 1 },
                  { t: 3120, v: 1 },
                  { t: 3140, v: 0 },
                ],
              },
              exIqo09Fmte305: {
                opacity: [
                  { t: 2370, v: 0 },
                  { t: 2380, v: 1 },
                  { t: 2440, v: 1 },
                  { t: 2450, v: 0 },
                  { t: 3120, v: 0 },
                  { t: 3140, v: 1 },
                  { t: 3190, v: 1 },
                  { t: 3210, v: 0 },
                ],
              },
              exIqo09Fmte311: {
                opacity: [
                  { t: 3200, v: 0 },
                  { t: 3220, v: 1 },
                ],
              },
            },
            s: "MDGA1ZFM5ODNmOWDE5MjhmN2U5VMTg2OGM4YjNUmNTc1MTRkNGIQ0ZFA0OTNmRBDgxODY4ZjgyPVjgwOTE4NjhMjVThiM2Y1NzVRlNDlWM2Y4NOjkxODI4ZjdlFOTE4Nk44YzhEiOTAzZjU3NGUU0OTNmODM4NJjg5ODkzZjU3PNGU0OTNmN2UP4OTkxODI4ZjIhiN2U5MTgyME2Y1NzgzN2VPWODk5MDgyNDlDIM2Y5MDhkODDI4MjgxM2ZFNQTc0ZTQ5M2Y4WMzhkUDkwM2ZNRNTc0ZTRkUjDRkOWE/",
          },
        ],
        options: "MDCAxMDgyMjlMNB2E3YjY4Nzk3BYjI5NDEyOTcOzNzY2ODZiMjWk4NA|",
      },
      "__SVGATOR_PLAYER__",
      window,
      document
    );
  },
};
</script>

<style lang="scss">
.loading-container {
  #exIqo09Fmte1 {
    max-width: 600px;
    margin: 0 auto;
    display: block;
  }
}
</style>